import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Timestamp: any;
  bigint: any;
  citext: any;
  date: any;
  daterange: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type MbcScoresByClientSessionOutput = {
  __typename?: 'MbcScoresByClientSessionOutput';
  alliance_id?: Maybe<Scalars['String']>;
  alliance_status?: Maybe<Scalars['String']>;
  alliance_value?: Maybe<Scalars['Float']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  event_id: Scalars['uuid'];
  gad7_endorsed_si?: Maybe<Scalars['Boolean']>;
  gad7_first_score?: Maybe<Scalars['Float']>;
  gad7_id?: Maybe<Scalars['String']>;
  gad7_range?: Maybe<Scalars['String']>;
  gad7_status?: Maybe<Scalars['String']>;
  gad7_value?: Maybe<Scalars['Float']>;
  mbc_submitted_at?: Maybe<Scalars['String']>;
  mhqol_id?: Maybe<Scalars['String']>;
  mhqol_value?: Maybe<Scalars['Float']>;
  phq9_endorsed_si?: Maybe<Scalars['Boolean']>;
  phq9_first_score?: Maybe<Scalars['Float']>;
  phq9_id?: Maybe<Scalars['String']>;
  phq9_range?: Maybe<Scalars['String']>;
  phq9_status?: Maybe<Scalars['String']>;
  phq9_value?: Maybe<Scalars['Float']>;
  questions: Array<Mbc_Assessment_Question_Scores>;
  service_type?: Maybe<Scalars['String']>;
  session_number?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['String']>;
  swls_id?: Maybe<Scalars['String']>;
  swls_value?: Maybe<Scalars['Float']>;
};


export type MbcScoresByClientSessionOutputQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Timestamp']>;
  _gt?: InputMaybe<Scalars['Timestamp']>;
  _gte?: InputMaybe<Scalars['Timestamp']>;
  _in?: InputMaybe<Array<Scalars['Timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Timestamp']>;
  _lte?: InputMaybe<Scalars['Timestamp']>;
  _neq?: InputMaybe<Scalars['Timestamp']>;
  _nin?: InputMaybe<Array<Scalars['Timestamp']>>;
};

/** columns and relationships of "auth_group" */
export type Auth_Group = {
  __typename?: 'auth_group';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Boolean expression to filter rows from the table "auth_group". All fields are combined with a logical 'AND'. */
export type Auth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "auth_group". */
export type Auth_Group_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "auth_group" */
export enum Auth_Group_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "auth_group" */
export type Auth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "auth_user" */
export type Auth_User = {
  __typename?: 'auth_user';
  /** An array relationship */
  auth_user_groups: Array<Auth_User_Groups>;
  /** An object relationship */
  ehr_clinician?: Maybe<Ehr_Clinician>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  last_name: Scalars['String'];
};


/** columns and relationships of "auth_user" */
export type Auth_UserAuth_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Groups_Order_By>>;
  where?: InputMaybe<Auth_User_Groups_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "auth_user". All fields are combined with a logical 'AND'. */
export type Auth_User_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  auth_user_groups?: InputMaybe<Auth_User_Groups_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "auth_user_groups" */
export type Auth_User_Groups = {
  __typename?: 'auth_user_groups';
  /** An object relationship */
  auth_group: Auth_Group;
  group_id: Scalars['Int'];
};

/** order by aggregate values of table "auth_user_groups" */
export type Auth_User_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_User_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_User_Groups_Max_Order_By>;
  min?: InputMaybe<Auth_User_Groups_Min_Order_By>;
  stddev?: InputMaybe<Auth_User_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_User_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_User_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_User_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_User_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_User_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_User_Groups_Variance_Order_By>;
};

/** order by avg() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth_user_groups". All fields are combined with a logical 'AND'. */
export type Auth_User_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_User_Groups_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Groups_Bool_Exp>>;
  auth_group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "auth_user_groups". */
export type Auth_User_Groups_Order_By = {
  auth_group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** select columns of table "auth_user_groups" */
export enum Auth_User_Groups_Select_Column {
  /** column name */
  GroupId = 'group_id'
}

/** order by stddev() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_user_groups" */
export type Auth_User_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Groups_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "auth_user_groups" */
export type Auth_User_Groups_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "auth_user". */
export type Auth_User_Order_By = {
  auth_user_groups_aggregate?: InputMaybe<Auth_User_Groups_Aggregate_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** select columns of table "auth_user" */
export enum Auth_User_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name'
}

/** Streaming cursor of the table "auth_user" */
export type Auth_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']>;
  _gt?: InputMaybe<Scalars['citext']>;
  _gte?: InputMaybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']>;
  _in?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']>;
  _lt?: InputMaybe<Scalars['citext']>;
  _lte?: InputMaybe<Scalars['citext']>;
  _neq?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']>;
  _nin?: InputMaybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician = {
  __typename?: 'cwa_active_clients_by_clinician';
  /** An object relationship */
  client?: Maybe<Ehr_Client>;
  client_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  clinician?: Maybe<Ehr_Clinician>;
  clinician_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  mv_latest_client_scores_with_status?: Maybe<Mv_Latest_Client_Scores_With_Status>;
  sources?: Maybe<Array<Scalars['String']>>;
};

/** order by aggregate values of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Aggregate_Order_By = {
  avg?: InputMaybe<Cwa_Active_Clients_By_Clinician_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cwa_Active_Clients_By_Clinician_Max_Order_By>;
  min?: InputMaybe<Cwa_Active_Clients_By_Clinician_Min_Order_By>;
  stddev?: InputMaybe<Cwa_Active_Clients_By_Clinician_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cwa_Active_Clients_By_Clinician_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cwa_Active_Clients_By_Clinician_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cwa_Active_Clients_By_Clinician_Sum_Order_By>;
  var_pop?: InputMaybe<Cwa_Active_Clients_By_Clinician_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cwa_Active_Clients_By_Clinician_Var_Samp_Order_By>;
  variance?: InputMaybe<Cwa_Active_Clients_By_Clinician_Variance_Order_By>;
};

/** order by avg() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cwa_active_clients_by_clinician". All fields are combined with a logical 'AND'. */
export type Cwa_Active_Clients_By_Clinician_Bool_Exp = {
  _and?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Bool_Exp>>;
  _not?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
  _or?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Bool_Exp>>;
  client?: InputMaybe<Ehr_Client_Bool_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  mv_latest_client_scores_with_status?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
  sources?: InputMaybe<String_Array_Comparison_Exp>;
};

/** order by max() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Max_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  sources?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Min_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  sources?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "cwa_active_clients_by_clinician". */
export type Cwa_Active_Clients_By_Clinician_Order_By = {
  client?: InputMaybe<Ehr_Client_Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  mv_latest_client_scores_with_status?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Order_By>;
  sources?: InputMaybe<Order_By>;
};

/** select columns of table "cwa_active_clients_by_clinician" */
export enum Cwa_Active_Clients_By_Clinician_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Sources = 'sources'
}

/** order by stddev() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cwa_Active_Clients_By_Clinician_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cwa_Active_Clients_By_Clinician_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  sources?: InputMaybe<Array<Scalars['String']>>;
};

/** order by sum() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cwa_active_clients_by_clinician" */
export type Cwa_Active_Clients_By_Clinician_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to compare columns of type "daterange". All fields are combined with logical 'AND'. */
export type Daterange_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['daterange']>;
  _gt?: InputMaybe<Scalars['daterange']>;
  _gte?: InputMaybe<Scalars['daterange']>;
  _in?: InputMaybe<Array<Scalars['daterange']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['daterange']>;
  _lte?: InputMaybe<Scalars['daterange']>;
  _neq?: InputMaybe<Scalars['daterange']>;
  _nin?: InputMaybe<Array<Scalars['daterange']>>;
};

/** columns and relationships of "dw_export.episode_of_care" */
export type Dw_Export_Episode_Of_Care = {
  __typename?: 'dw_export_episode_of_care';
  alliance?: Maybe<Scalars['Float']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  client_first_name?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  client_last_name?: Maybe<Scalars['String']>;
  client_session_number?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_session_number?: Maybe<Scalars['Int']>;
  episode?: Maybe<Scalars['Int']>;
  event_id?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  gad?: Maybe<Scalars['Float']>;
  insert_ts?: Maybe<Scalars['Timestamp']>;
  is_baseline?: Maybe<Scalars['Int']>;
  is_latest?: Maybe<Scalars['Int']>;
  is_latest_clinician_in_episode?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  payer_acronym?: Maybe<Scalars['String']>;
  payer_name?: Maybe<Scalars['String']>;
  phq?: Maybe<Scalars['Float']>;
  reason_for_new_episode?: Maybe<Scalars['String']>;
  same_clinician_over_60_days_last_session?: Maybe<Scalars['Int']>;
  service_type?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['Timestamp']>;
  track_primary_assessment?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dw_export.episode_of_care". All fields are combined with a logical 'AND'. */
export type Dw_Export_Episode_Of_Care_Bool_Exp = {
  _and?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Bool_Exp>>;
  _not?: InputMaybe<Dw_Export_Episode_Of_Care_Bool_Exp>;
  _or?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Bool_Exp>>;
  alliance?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  appointment_status?: InputMaybe<String_BigQuery_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_BigQuery_Comparison_Exp>;
  cancellation_type?: InputMaybe<String_BigQuery_Comparison_Exp>;
  client_first_name?: InputMaybe<String_BigQuery_Comparison_Exp>;
  client_id?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  client_last_name?: InputMaybe<String_BigQuery_Comparison_Exp>;
  client_session_number?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  clinician_session_number?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  episode?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  event_id?: InputMaybe<String_BigQuery_Comparison_Exp>;
  full_name?: InputMaybe<String_BigQuery_Comparison_Exp>;
  gad?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  insert_ts?: InputMaybe<Timestamp_BigQuery_Comparison_Exp>;
  is_baseline?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  is_latest?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  is_latest_clinician_in_episode?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  last_name?: InputMaybe<String_BigQuery_Comparison_Exp>;
  payer_acronym?: InputMaybe<String_BigQuery_Comparison_Exp>;
  payer_name?: InputMaybe<String_BigQuery_Comparison_Exp>;
  phq?: InputMaybe<Float_BigQuery_Comparison_Exp>;
  reason_for_new_episode?: InputMaybe<String_BigQuery_Comparison_Exp>;
  same_clinician_over_60_days_last_session?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  service_type?: InputMaybe<String_BigQuery_Comparison_Exp>;
  start_time?: InputMaybe<Timestamp_BigQuery_Comparison_Exp>;
  track_primary_assessment?: InputMaybe<String_BigQuery_Comparison_Exp>;
};

/** Ordering options when selecting data from "dw_export.episode_of_care". */
export type Dw_Export_Episode_Of_Care_Order_By = {
  alliance?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  client_first_name?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_last_name?: InputMaybe<Order_By>;
  client_session_number?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_session_number?: InputMaybe<Order_By>;
  episode?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gad?: InputMaybe<Order_By>;
  insert_ts?: InputMaybe<Order_By>;
  is_baseline?: InputMaybe<Order_By>;
  is_latest?: InputMaybe<Order_By>;
  is_latest_clinician_in_episode?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  payer_acronym?: InputMaybe<Order_By>;
  payer_name?: InputMaybe<Order_By>;
  phq?: InputMaybe<Order_By>;
  reason_for_new_episode?: InputMaybe<Order_By>;
  same_clinician_over_60_days_last_session?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  track_primary_assessment?: InputMaybe<Order_By>;
};

/** select columns of table "dw_export.episode_of_care" */
export enum Dw_Export_Episode_Of_Care_Select_Column {
  /** column name */
  Alliance = 'alliance',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CancellationType = 'cancellation_type',
  /** column name */
  ClientFirstName = 'client_first_name',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientLastName = 'client_last_name',
  /** column name */
  ClientSessionNumber = 'client_session_number',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ClinicianSessionNumber = 'clinician_session_number',
  /** column name */
  Episode = 'episode',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gad = 'gad',
  /** column name */
  InsertTs = 'insert_ts',
  /** column name */
  IsBaseline = 'is_baseline',
  /** column name */
  IsLatest = 'is_latest',
  /** column name */
  IsLatestClinicianInEpisode = 'is_latest_clinician_in_episode',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PayerAcronym = 'payer_acronym',
  /** column name */
  PayerName = 'payer_name',
  /** column name */
  Phq = 'phq',
  /** column name */
  ReasonForNewEpisode = 'reason_for_new_episode',
  /** column name */
  SameClinicianOver_60DaysLastSession = 'same_clinician_over_60_days_last_session',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TrackPrimaryAssessment = 'track_primary_assessment'
}

/** columns and relationships of "dwe_client_metrics" */
export type Dwe_Client_Metrics = {
  __typename?: 'dwe_client_metrics';
  client_id: Scalars['Int'];
  client_psychiatry_assessment_session_count?: Maybe<Scalars['Int']>;
  client_psychiatry_ongoing_session_count?: Maybe<Scalars['Int']>;
  client_psychiatry_session_count?: Maybe<Scalars['Int']>;
  client_session_number?: Maybe<Scalars['Int']>;
  clinician_session_number?: Maybe<Scalars['Int']>;
  episode_number?: Maybe<Scalars['Int']>;
  insert_ts?: Maybe<Scalars['timestamp']>;
  mbc_history?: Maybe<Scalars['json']>;
};


/** columns and relationships of "dwe_client_metrics" */
export type Dwe_Client_MetricsMbc_HistoryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dwe_client_metrics". All fields are combined with a logical 'AND'. */
export type Dwe_Client_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Dwe_Client_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Dwe_Client_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Dwe_Client_Metrics_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_psychiatry_assessment_session_count?: InputMaybe<Int_Comparison_Exp>;
  client_psychiatry_ongoing_session_count?: InputMaybe<Int_Comparison_Exp>;
  client_psychiatry_session_count?: InputMaybe<Int_Comparison_Exp>;
  client_session_number?: InputMaybe<Int_Comparison_Exp>;
  clinician_session_number?: InputMaybe<Int_Comparison_Exp>;
  episode_number?: InputMaybe<Int_Comparison_Exp>;
  insert_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  mbc_history?: InputMaybe<Json_Comparison_Exp>;
};

/** Ordering options when selecting data from "dwe_client_metrics". */
export type Dwe_Client_Metrics_Order_By = {
  client_id?: InputMaybe<Order_By>;
  client_psychiatry_assessment_session_count?: InputMaybe<Order_By>;
  client_psychiatry_ongoing_session_count?: InputMaybe<Order_By>;
  client_psychiatry_session_count?: InputMaybe<Order_By>;
  client_session_number?: InputMaybe<Order_By>;
  clinician_session_number?: InputMaybe<Order_By>;
  episode_number?: InputMaybe<Order_By>;
  insert_ts?: InputMaybe<Order_By>;
  mbc_history?: InputMaybe<Order_By>;
};

/** select columns of table "dwe_client_metrics" */
export enum Dwe_Client_Metrics_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientPsychiatryAssessmentSessionCount = 'client_psychiatry_assessment_session_count',
  /** column name */
  ClientPsychiatryOngoingSessionCount = 'client_psychiatry_ongoing_session_count',
  /** column name */
  ClientPsychiatrySessionCount = 'client_psychiatry_session_count',
  /** column name */
  ClientSessionNumber = 'client_session_number',
  /** column name */
  ClinicianSessionNumber = 'clinician_session_number',
  /** column name */
  EpisodeNumber = 'episode_number',
  /** column name */
  InsertTs = 'insert_ts',
  /** column name */
  MbcHistory = 'mbc_history'
}

/** Streaming cursor of the table "dwe_client_metrics" */
export type Dwe_Client_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dwe_Client_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dwe_Client_Metrics_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  client_psychiatry_assessment_session_count?: InputMaybe<Scalars['Int']>;
  client_psychiatry_ongoing_session_count?: InputMaybe<Scalars['Int']>;
  client_psychiatry_session_count?: InputMaybe<Scalars['Int']>;
  client_session_number?: InputMaybe<Scalars['Int']>;
  clinician_session_number?: InputMaybe<Scalars['Int']>;
  episode_number?: InputMaybe<Scalars['Int']>;
  insert_ts?: InputMaybe<Scalars['timestamp']>;
  mbc_history?: InputMaybe<Scalars['json']>;
};

/** columns and relationships of "dwe_clinician_metrics" */
export type Dwe_Clinician_Metrics = {
  __typename?: 'dwe_clinician_metrics';
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_is_ramping?: Maybe<Scalars['Boolean']>;
  employment_type?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insert_ts?: Maybe<Scalars['timestamp']>;
  is_on_leave?: Maybe<Scalars['Boolean']>;
  leave_end_dt?: Maybe<Scalars['date']>;
  leave_start_dt?: Maybe<Scalars['date']>;
  metrics_blob?: Maybe<Scalars['String']>;
  timeframe?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dwe_clinician_metrics". All fields are combined with a logical 'AND'. */
export type Dwe_Clinician_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Dwe_Clinician_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Dwe_Clinician_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Dwe_Clinician_Metrics_Bool_Exp>>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_is_ramping?: InputMaybe<Boolean_Comparison_Exp>;
  employment_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  insert_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  is_on_leave?: InputMaybe<Boolean_Comparison_Exp>;
  leave_end_dt?: InputMaybe<Date_Comparison_Exp>;
  leave_start_dt?: InputMaybe<Date_Comparison_Exp>;
  metrics_blob?: InputMaybe<String_Comparison_Exp>;
  timeframe?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "dwe_clinician_metrics". */
export type Dwe_Clinician_Metrics_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  clinician_is_ramping?: InputMaybe<Order_By>;
  employment_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insert_ts?: InputMaybe<Order_By>;
  is_on_leave?: InputMaybe<Order_By>;
  leave_end_dt?: InputMaybe<Order_By>;
  leave_start_dt?: InputMaybe<Order_By>;
  metrics_blob?: InputMaybe<Order_By>;
  timeframe?: InputMaybe<Order_By>;
};

/** select columns of table "dwe_clinician_metrics" */
export enum Dwe_Clinician_Metrics_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ClinicianIsRamping = 'clinician_is_ramping',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  Id = 'id',
  /** column name */
  InsertTs = 'insert_ts',
  /** column name */
  IsOnLeave = 'is_on_leave',
  /** column name */
  LeaveEndDt = 'leave_end_dt',
  /** column name */
  LeaveStartDt = 'leave_start_dt',
  /** column name */
  MetricsBlob = 'metrics_blob',
  /** column name */
  Timeframe = 'timeframe'
}

/** Streaming cursor of the table "dwe_clinician_metrics" */
export type Dwe_Clinician_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dwe_Clinician_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dwe_Clinician_Metrics_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['Int']>;
  clinician_is_ramping?: InputMaybe<Scalars['Boolean']>;
  employment_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  insert_ts?: InputMaybe<Scalars['timestamp']>;
  is_on_leave?: InputMaybe<Scalars['Boolean']>;
  leave_end_dt?: InputMaybe<Scalars['date']>;
  leave_start_dt?: InputMaybe<Scalars['date']>;
  metrics_blob?: InputMaybe<Scalars['String']>;
  timeframe?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_aitask" */
export type Ehr_Aitask = {
  __typename?: 'ehr_aitask';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  model_used: Scalars['String'];
  prompt: Scalars['String'];
  response?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "ehr_aitask" */
export type Ehr_AitaskMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_aitask" */
export type Ehr_AitaskResponseArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_aitask". All fields are combined with a logical 'AND'. */
export type Ehr_Aitask_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Aitask_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Aitask_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Aitask_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  model_used?: InputMaybe<String_Comparison_Exp>;
  prompt?: InputMaybe<String_Comparison_Exp>;
  response?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_aitask". */
export type Ehr_Aitask_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  model_used?: InputMaybe<Order_By>;
  prompt?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_aitask" */
export enum Ehr_Aitask_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModelUsed = 'model_used',
  /** column name */
  Prompt = 'prompt',
  /** column name */
  Response = 'response'
}

/** Streaming cursor of the table "ehr_aitask" */
export type Ehr_Aitask_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Aitask_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Aitask_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  model_used?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "ehr_assessmentscore" */
export type Ehr_Assessmentscore = {
  __typename?: 'ehr_assessmentscore';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehr_eventmbcstatus: Ehr_Eventmbcstatus;
  /** An object relationship */
  ehr_generalsurveyresponse?: Maybe<Ehr_Generalsurveyresponse>;
  ems_id: Scalars['uuid'];
  endorsed_si?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  normalized_value?: Maybe<Scalars['float8']>;
  score_name: Scalars['String'];
  survey_response_id?: Maybe<Scalars['uuid']>;
  value: Scalars['float8'];
};

/** order by aggregate values of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Assessmentscore_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Assessmentscore_Max_Order_By>;
  min?: InputMaybe<Ehr_Assessmentscore_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Assessmentscore_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Assessmentscore_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Assessmentscore_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Assessmentscore_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Assessmentscore_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Assessmentscore_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Assessmentscore_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Avg_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_assessmentscore". All fields are combined with a logical 'AND'. */
export type Ehr_Assessmentscore_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Assessmentscore_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Assessmentscore_Bool_Exp>>;
  ehr_eventmbcstatus?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
  ehr_generalsurveyresponse?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
  ems_id?: InputMaybe<Uuid_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  normalized_value?: InputMaybe<Float8_Comparison_Exp>;
  score_name?: InputMaybe<String_Comparison_Exp>;
  survey_response_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  normalized_value?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  survey_response_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  normalized_value?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  survey_response_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_assessmentscore". */
export type Ehr_Assessmentscore_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  ehr_eventmbcstatus?: InputMaybe<Ehr_Eventmbcstatus_Order_By>;
  ehr_generalsurveyresponse?: InputMaybe<Ehr_Generalsurveyresponse_Order_By>;
  ems_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  normalized_value?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  survey_response_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_assessmentscore" */
export enum Ehr_Assessmentscore_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  EmsId = 'ems_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  Id = 'id',
  /** column name */
  NormalizedValue = 'normalized_value',
  /** column name */
  ScoreName = 'score_name',
  /** column name */
  SurveyResponseId = 'survey_response_id',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Stddev_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Stddev_Pop_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Stddev_Samp_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Assessmentscore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Assessmentscore_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  ems_id?: InputMaybe<Scalars['uuid']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  normalized_value?: InputMaybe<Scalars['float8']>;
  score_name?: InputMaybe<Scalars['String']>;
  survey_response_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** order by sum() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Sum_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Var_Pop_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Var_Samp_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_assessmentscore" */
export type Ehr_Assessmentscore_Variance_Order_By = {
  normalized_value?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_booking" */
export type Ehr_Booking = {
  __typename?: 'ehr_booking';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  appointment_type: Scalars['String'];
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  couple_id?: Maybe<Scalars['uuid']>;
  coupon_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  /** An object relationship */
  ehr_booking_referral?: Maybe<Ehr_Referral>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An array relationship */
  ehr_clientprofile: Array<Ehr_Clientprofile>;
  /** An array relationship */
  ehr_clientscreeningquestions: Array<Ehr_Clientscreeningquestions>;
  /** An object relationship */
  ehr_event?: Maybe<Ehr_Event>;
  email: Scalars['citext'];
  end_time: Scalars['timestamptz'];
  event_id?: Maybe<Scalars['uuid']>;
  first_name: Scalars['String'];
  has_accepted_informed_consent?: Maybe<Scalars['Boolean']>;
  has_accepted_practice_policy: Scalars['Boolean'];
  has_accepted_privacy_policy: Scalars['Boolean'];
  id: Scalars['uuid'];
  identity_token_id?: Maybe<Scalars['uuid']>;
  insurance_company_id?: Maybe<Scalars['uuid']>;
  is_california_resident: Scalars['Boolean'];
  is_kp_referral: Scalars['Boolean'];
  is_medical: Scalars['Boolean'];
  is_medicare: Scalars['Boolean'];
  is_test_data: Scalars['Boolean'];
  is_triage: Scalars['Boolean'];
  last_name: Scalars['String'];
  manual_slot_reservation_id?: Maybe<Scalars['uuid']>;
  marketing_metadata?: Maybe<Scalars['jsonb']>;
  match_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  mbc_assessment_question_scores: Array<Mbc_Assessment_Question_Scores>;
  metadata?: Maybe<Scalars['jsonb']>;
  payer_id?: Maybe<Scalars['uuid']>;
  phone_number?: Maybe<Scalars['String']>;
  service_line_preferences?: Maybe<Array<Scalars['String']>>;
  service_state?: Maybe<Scalars['String']>;
  start_time: Scalars['timestamptz'];
  status: Scalars['String'];
  status_reason?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_booking" */
export type Ehr_BookingEhr_ClientprofileArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientprofile_Order_By>>;
  where?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
};


/** columns and relationships of "ehr_booking" */
export type Ehr_BookingEhr_ClientscreeningquestionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientscreeningquestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientscreeningquestions_Order_By>>;
  where?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
};


/** columns and relationships of "ehr_booking" */
export type Ehr_BookingMarketing_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_booking" */
export type Ehr_BookingMbc_Assessment_Question_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


/** columns and relationships of "ehr_booking" */
export type Ehr_BookingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_booking" */
export type Ehr_Booking_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Booking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Booking_Max_Order_By>;
  min?: InputMaybe<Ehr_Booking_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Booking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Booking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Booking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Booking_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Booking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Booking_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Booking_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_booking" */
export type Ehr_Booking_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_booking". All fields are combined with a logical 'AND'. */
export type Ehr_Booking_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Booking_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Booking_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Booking_Bool_Exp>>;
  appointment_type?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  coupon_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  ehr_booking_referral?: InputMaybe<Ehr_Referral_Bool_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clientprofile?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
  ehr_clientscreeningquestions?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
  ehr_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  has_accepted_informed_consent?: InputMaybe<Boolean_Comparison_Exp>;
  has_accepted_practice_policy?: InputMaybe<Boolean_Comparison_Exp>;
  has_accepted_privacy_policy?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity_token_id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_california_resident?: InputMaybe<Boolean_Comparison_Exp>;
  is_kp_referral?: InputMaybe<Boolean_Comparison_Exp>;
  is_medical?: InputMaybe<Boolean_Comparison_Exp>;
  is_medicare?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  is_triage?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  manual_slot_reservation_id?: InputMaybe<Uuid_Comparison_Exp>;
  marketing_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  mbc_assessment_question_scores?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  service_line_preferences?: InputMaybe<String_Array_Comparison_Exp>;
  service_state?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_reason?: InputMaybe<String_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_booking" */
export type Ehr_Booking_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  coupon_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_token_id?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  manual_slot_reservation_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  service_line_preferences?: InputMaybe<Order_By>;
  service_state?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_reason?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_booking" */
export type Ehr_Booking_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  coupon_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_token_id?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  manual_slot_reservation_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  service_line_preferences?: InputMaybe<Order_By>;
  service_state?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_reason?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_booking". */
export type Ehr_Booking_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  coupon_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  ehr_booking_referral?: InputMaybe<Ehr_Referral_Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clientprofile_aggregate?: InputMaybe<Ehr_Clientprofile_Aggregate_Order_By>;
  ehr_clientscreeningquestions_aggregate?: InputMaybe<Ehr_Clientscreeningquestions_Aggregate_Order_By>;
  ehr_event?: InputMaybe<Ehr_Event_Order_By>;
  email?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  has_accepted_informed_consent?: InputMaybe<Order_By>;
  has_accepted_practice_policy?: InputMaybe<Order_By>;
  has_accepted_privacy_policy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_token_id?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  is_california_resident?: InputMaybe<Order_By>;
  is_kp_referral?: InputMaybe<Order_By>;
  is_medical?: InputMaybe<Order_By>;
  is_medicare?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  is_triage?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  manual_slot_reservation_id?: InputMaybe<Order_By>;
  marketing_metadata?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  mbc_assessment_question_scores_aggregate?: InputMaybe<Mbc_Assessment_Question_Scores_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  service_line_preferences?: InputMaybe<Order_By>;
  service_state?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_reason?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_booking" */
export enum Ehr_Booking_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AppointmentType = 'appointment_type',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  CouponCode = 'coupon_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasAcceptedInformedConsent = 'has_accepted_informed_consent',
  /** column name */
  HasAcceptedPracticePolicy = 'has_accepted_practice_policy',
  /** column name */
  HasAcceptedPrivacyPolicy = 'has_accepted_privacy_policy',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityTokenId = 'identity_token_id',
  /** column name */
  InsuranceCompanyId = 'insurance_company_id',
  /** column name */
  IsCaliforniaResident = 'is_california_resident',
  /** column name */
  IsKpReferral = 'is_kp_referral',
  /** column name */
  IsMedical = 'is_medical',
  /** column name */
  IsMedicare = 'is_medicare',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  IsTriage = 'is_triage',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ManualSlotReservationId = 'manual_slot_reservation_id',
  /** column name */
  MarketingMetadata = 'marketing_metadata',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  ServiceLinePreferences = 'service_line_preferences',
  /** column name */
  ServiceState = 'service_state',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  StatusReason = 'status_reason',
  /** column name */
  StripeCustomerId = 'stripe_customer_id'
}

/** order by stddev() on columns of table "ehr_booking" */
export type Ehr_Booking_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_booking" */
export type Ehr_Booking_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_booking" */
export type Ehr_Booking_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_booking" */
export type Ehr_Booking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Booking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Booking_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  appointment_type?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  coupon_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['citext']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  first_name?: InputMaybe<Scalars['String']>;
  has_accepted_informed_consent?: InputMaybe<Scalars['Boolean']>;
  has_accepted_practice_policy?: InputMaybe<Scalars['Boolean']>;
  has_accepted_privacy_policy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_token_id?: InputMaybe<Scalars['uuid']>;
  insurance_company_id?: InputMaybe<Scalars['uuid']>;
  is_california_resident?: InputMaybe<Scalars['Boolean']>;
  is_kp_referral?: InputMaybe<Scalars['Boolean']>;
  is_medical?: InputMaybe<Scalars['Boolean']>;
  is_medicare?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  is_triage?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  manual_slot_reservation_id?: InputMaybe<Scalars['uuid']>;
  marketing_metadata?: InputMaybe<Scalars['jsonb']>;
  match_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  phone_number?: InputMaybe<Scalars['String']>;
  service_line_preferences?: InputMaybe<Array<Scalars['String']>>;
  service_state?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  status_reason?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_booking" */
export type Ehr_Booking_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_booking" */
export type Ehr_Booking_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_booking" */
export type Ehr_Booking_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_booking" */
export type Ehr_Booking_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_client" */
export type Ehr_Client = {
  __typename?: 'ehr_client';
  /** An array relationship */
  active_clinicians: Array<Cwa_Active_Clients_By_Clinician>;
  /** An array relationship */
  client_group_events: Array<Ehr_Clientgroupevent>;
  /** An array relationship */
  client_payer_service_records: Array<Ehr_Clientpayerservicerecord>;
  conferencing_provider_override?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  diagnosis_records: Array<Ehr_Diagnosisrecord>;
  dob?: Maybe<Scalars['date']>;
  /** An array relationship */
  ehr_booking: Array<Ehr_Booking>;
  /** An array relationship */
  ehr_clientaddresses: Array<Ehr_Clientaddress>;
  /** An array relationship */
  ehr_clientemergencycontacts: Array<Ehr_Clientemergencycontact>;
  /** An array relationship */
  ehr_clientgroupbookings: Array<Ehr_Clientgroupbooking>;
  /** An array relationship */
  ehr_clientgroups: Array<Ehr_Clientgroup>;
  /** An array relationship */
  ehr_insurancerecords: Array<Ehr_Insurancerecord>;
  /** An array relationship */
  ehr_progressreviews: Array<Ehr_Progressreview>;
  /** An array relationship */
  ehr_referralauthorizations: Array<Ehr_Referralauthorization>;
  /** An array relationship */
  ehr_referrals: Array<Ehr_Referral>;
  email?: Maybe<Scalars['citext']>;
  /** An array relationship */
  events: Array<Ehr_Event>;
  /** An aggregate relationship */
  events_aggregate: Ehr_Event_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  healthie_id?: Maybe<Scalars['String']>;
  hybrid_preference: Scalars['String'];
  id: Scalars['Int'];
  integration_test_enabled: Scalars['Boolean'];
  is_claim_submission_enabled: Scalars['Boolean'];
  is_kp_referral: Scalars['Boolean'];
  is_superbill_enabled: Scalars['Boolean'];
  is_test_client: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  leadsquared_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  manual_slot_reservations: Array<Hasura_Cwa__Manual_Slot_Reservations>;
  /** An array relationship */
  matches: Array<Ehr_Match>;
  /** An array relationship */
  mbc_assessment_scores: Array<Mbc_Assessment_Question_Scores>;
  /** An array relationship */
  mbc_partitioned_scores: Array<Mbc_Partitioned_Scores_By_Client>;
  /** An array relationship */
  mbc_score_summary: Array<Mbc_Ems_Joined_With_Scores>;
  /** An array relationship */
  mbc_scores: Array<Mbc_Distinct_Scores_By_Client>;
  /** An array relationship */
  mbc_tracks: Array<Ehr_Mbctrack>;
  modified_at: Scalars['timestamptz'];
  /** An object relationship */
  mv_latest_client_scores_with_status?: Maybe<Mv_Latest_Client_Scores_With_Status>;
  /** An object relationship */
  my_clients_overview?: Maybe<My_Clients_Overview>;
  /** An object relationship */
  my_clients_overview_reliable_change?: Maybe<My_Clients_Overview_Reliable_Change>;
  notes: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  primary_timezone: Scalars['String'];
  reconciled_at?: Maybe<Scalars['timestamptz']>;
  service_state?: Maybe<Scalars['String']>;
  suspend_billing: Scalars['Boolean'];
  welkin8_id?: Maybe<Scalars['String']>;
  welkin_patient_id?: Maybe<Scalars['String']>;
  welkin_tombstone_id?: Maybe<Scalars['uuid']>;
  welkin_tombstone_timestamp?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientActive_CliniciansArgs = {
  distinct_on?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Order_By>>;
  where?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientClient_Group_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupevent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupevent_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientClient_Payer_Service_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Order_By>>;
  where?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientDiagnosis_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Diagnosisrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Diagnosisrecord_Order_By>>;
  where?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_BookingArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Booking_Order_By>>;
  where?: InputMaybe<Ehr_Booking_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ClientaddressesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientaddress_Order_By>>;
  where?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ClientemergencycontactsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientemergencycontact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientemergencycontact_Order_By>>;
  where?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ClientgroupbookingsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupbooking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupbooking_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ClientgroupsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroup_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_InsurancerecordsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Insurancerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Insurancerecord_Order_By>>;
  where?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ProgressreviewsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreview_Order_By>>;
  where?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ReferralauthorizationsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referralauthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referralauthorization_Order_By>>;
  where?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEhr_ReferralsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referral_Order_By>>;
  where?: InputMaybe<Ehr_Referral_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEventsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientManual_Slot_ReservationsArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMatchesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Order_By>>;
  where?: InputMaybe<Ehr_Match_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMbc_Assessment_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMbc_Partitioned_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMbc_Score_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMbc_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
};


/** columns and relationships of "ehr_client" */
export type Ehr_ClientMbc_TracksArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Mbctrack_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Mbctrack_Order_By>>;
  where?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ehr_client". All fields are combined with a logical 'AND'. */
export type Ehr_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Client_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Client_Bool_Exp>>;
  active_clinicians?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
  client_group_events?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
  client_payer_service_records?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
  conferencing_provider_override?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  diagnosis_records?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  ehr_booking?: InputMaybe<Ehr_Booking_Bool_Exp>;
  ehr_clientaddresses?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
  ehr_clientemergencycontacts?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
  ehr_clientgroupbookings?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
  ehr_clientgroups?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
  ehr_insurancerecords?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
  ehr_progressreviews?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
  ehr_referralauthorizations?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
  ehr_referrals?: InputMaybe<Ehr_Referral_Bool_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  events?: InputMaybe<Ehr_Event_Bool_Exp>;
  events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  healthie_id?: InputMaybe<String_Comparison_Exp>;
  hybrid_preference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  integration_test_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_claim_submission_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_kp_referral?: InputMaybe<Boolean_Comparison_Exp>;
  is_superbill_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_client?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  leadsquared_id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_slot_reservations?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
  matches?: InputMaybe<Ehr_Match_Bool_Exp>;
  mbc_assessment_scores?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
  mbc_partitioned_scores?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
  mbc_score_summary?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
  mbc_scores?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
  mbc_tracks?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  mv_latest_client_scores_with_status?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
  my_clients_overview?: InputMaybe<My_Clients_Overview_Bool_Exp>;
  my_clients_overview_reliable_change?: InputMaybe<My_Clients_Overview_Reliable_Change_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  preferred_name?: InputMaybe<String_Comparison_Exp>;
  primary_timezone?: InputMaybe<String_Comparison_Exp>;
  reconciled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  service_state?: InputMaybe<String_Comparison_Exp>;
  suspend_billing?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_id?: InputMaybe<String_Comparison_Exp>;
  welkin_patient_id?: InputMaybe<String_Comparison_Exp>;
  welkin_tombstone_id?: InputMaybe<Uuid_Comparison_Exp>;
  welkin_tombstone_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_client". */
export type Ehr_Client_Order_By = {
  active_clinicians_aggregate?: InputMaybe<Cwa_Active_Clients_By_Clinician_Aggregate_Order_By>;
  client_group_events_aggregate?: InputMaybe<Ehr_Clientgroupevent_Aggregate_Order_By>;
  client_payer_service_records_aggregate?: InputMaybe<Ehr_Clientpayerservicerecord_Aggregate_Order_By>;
  conferencing_provider_override?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  diagnosis_records_aggregate?: InputMaybe<Ehr_Diagnosisrecord_Aggregate_Order_By>;
  dob?: InputMaybe<Order_By>;
  ehr_booking_aggregate?: InputMaybe<Ehr_Booking_Aggregate_Order_By>;
  ehr_clientaddresses_aggregate?: InputMaybe<Ehr_Clientaddress_Aggregate_Order_By>;
  ehr_clientemergencycontacts_aggregate?: InputMaybe<Ehr_Clientemergencycontact_Aggregate_Order_By>;
  ehr_clientgroupbookings_aggregate?: InputMaybe<Ehr_Clientgroupbooking_Aggregate_Order_By>;
  ehr_clientgroups_aggregate?: InputMaybe<Ehr_Clientgroup_Aggregate_Order_By>;
  ehr_insurancerecords_aggregate?: InputMaybe<Ehr_Insurancerecord_Aggregate_Order_By>;
  ehr_progressreviews_aggregate?: InputMaybe<Ehr_Progressreview_Aggregate_Order_By>;
  ehr_referralauthorizations_aggregate?: InputMaybe<Ehr_Referralauthorization_Aggregate_Order_By>;
  ehr_referrals_aggregate?: InputMaybe<Ehr_Referral_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  healthie_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_test_enabled?: InputMaybe<Order_By>;
  is_claim_submission_enabled?: InputMaybe<Order_By>;
  is_kp_referral?: InputMaybe<Order_By>;
  is_superbill_enabled?: InputMaybe<Order_By>;
  is_test_client?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  leadsquared_id?: InputMaybe<Order_By>;
  manual_slot_reservations_aggregate?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Aggregate_Order_By>;
  matches_aggregate?: InputMaybe<Ehr_Match_Aggregate_Order_By>;
  mbc_assessment_scores_aggregate?: InputMaybe<Mbc_Assessment_Question_Scores_Aggregate_Order_By>;
  mbc_partitioned_scores_aggregate?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Aggregate_Order_By>;
  mbc_score_summary_aggregate?: InputMaybe<Mbc_Ems_Joined_With_Scores_Aggregate_Order_By>;
  mbc_scores_aggregate?: InputMaybe<Mbc_Distinct_Scores_By_Client_Aggregate_Order_By>;
  mbc_tracks_aggregate?: InputMaybe<Ehr_Mbctrack_Aggregate_Order_By>;
  modified_at?: InputMaybe<Order_By>;
  mv_latest_client_scores_with_status?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Order_By>;
  my_clients_overview?: InputMaybe<My_Clients_Overview_Order_By>;
  my_clients_overview_reliable_change?: InputMaybe<My_Clients_Overview_Reliable_Change_Order_By>;
  notes?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  primary_timezone?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  service_state?: InputMaybe<Order_By>;
  suspend_billing?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_patient_id?: InputMaybe<Order_By>;
  welkin_tombstone_id?: InputMaybe<Order_By>;
  welkin_tombstone_timestamp?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_client" */
export enum Ehr_Client_Select_Column {
  /** column name */
  ConferencingProviderOverride = 'conferencing_provider_override',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HealthieId = 'healthie_id',
  /** column name */
  HybridPreference = 'hybrid_preference',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationTestEnabled = 'integration_test_enabled',
  /** column name */
  IsClaimSubmissionEnabled = 'is_claim_submission_enabled',
  /** column name */
  IsKpReferral = 'is_kp_referral',
  /** column name */
  IsSuperbillEnabled = 'is_superbill_enabled',
  /** column name */
  IsTestClient = 'is_test_client',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LeadsquaredId = 'leadsquared_id',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  PrimaryTimezone = 'primary_timezone',
  /** column name */
  ReconciledAt = 'reconciled_at',
  /** column name */
  ServiceState = 'service_state',
  /** column name */
  SuspendBilling = 'suspend_billing',
  /** column name */
  Welkin8Id = 'welkin8_id',
  /** column name */
  WelkinPatientId = 'welkin_patient_id',
  /** column name */
  WelkinTombstoneId = 'welkin_tombstone_id',
  /** column name */
  WelkinTombstoneTimestamp = 'welkin_tombstone_timestamp'
}

/** Streaming cursor of the table "ehr_client" */
export type Ehr_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Client_Stream_Cursor_Value_Input = {
  conferencing_provider_override?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['citext']>;
  first_name?: InputMaybe<Scalars['String']>;
  healthie_id?: InputMaybe<Scalars['String']>;
  hybrid_preference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  integration_test_enabled?: InputMaybe<Scalars['Boolean']>;
  is_claim_submission_enabled?: InputMaybe<Scalars['Boolean']>;
  is_kp_referral?: InputMaybe<Scalars['Boolean']>;
  is_superbill_enabled?: InputMaybe<Scalars['Boolean']>;
  is_test_client?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  leadsquared_id?: InputMaybe<Scalars['uuid']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  notes?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  preferred_name?: InputMaybe<Scalars['String']>;
  primary_timezone?: InputMaybe<Scalars['String']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']>;
  service_state?: InputMaybe<Scalars['String']>;
  suspend_billing?: InputMaybe<Scalars['Boolean']>;
  welkin8_id?: InputMaybe<Scalars['String']>;
  welkin_patient_id?: InputMaybe<Scalars['String']>;
  welkin_tombstone_id?: InputMaybe<Scalars['uuid']>;
  welkin_tombstone_timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "ehr_clientaddress" */
export type Ehr_Clientaddress = {
  __typename?: 'ehr_clientaddress';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id: Scalars['Int'];
  couple_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehr_client: Ehr_Client;
  formatted_address?: Maybe<Scalars['String']>;
  geocode_city?: Maybe<Scalars['String']>;
  geocode_latitude?: Maybe<Scalars['float8']>;
  geocode_longitude?: Maybe<Scalars['float8']>;
  geocode_neighborhood?: Maybe<Scalars['String']>;
  geocode_postal_code?: Maybe<Scalars['String']>;
  geocode_postal_code_suffix?: Maybe<Scalars['String']>;
  geocode_road?: Maybe<Scalars['String']>;
  geocode_state?: Maybe<Scalars['String']>;
  geocode_street_number?: Maybe<Scalars['String']>;
  geocode_subpremise?: Maybe<Scalars['String']>;
  google_geocode_blob?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  input_address: Scalars['citext'];
  input_address_line_1?: Maybe<Scalars['String']>;
  input_address_line_2?: Maybe<Scalars['String']>;
  input_city?: Maybe<Scalars['String']>;
  input_state?: Maybe<Scalars['String']>;
  input_zipcode?: Maybe<Scalars['String']>;
  is_primary: Scalars['Boolean'];
  welkin8_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_clientaddress" */
export type Ehr_ClientaddressGoogle_Geocode_BlobArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientaddress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientaddress_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientaddress_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientaddress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientaddress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientaddress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientaddress_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientaddress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientaddress_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientaddress_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientaddress". All fields are combined with a logical 'AND'. */
export type Ehr_Clientaddress_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientaddress_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientaddress_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  geocode_city?: InputMaybe<String_Comparison_Exp>;
  geocode_latitude?: InputMaybe<Float8_Comparison_Exp>;
  geocode_longitude?: InputMaybe<Float8_Comparison_Exp>;
  geocode_neighborhood?: InputMaybe<String_Comparison_Exp>;
  geocode_postal_code?: InputMaybe<String_Comparison_Exp>;
  geocode_postal_code_suffix?: InputMaybe<String_Comparison_Exp>;
  geocode_road?: InputMaybe<String_Comparison_Exp>;
  geocode_state?: InputMaybe<String_Comparison_Exp>;
  geocode_street_number?: InputMaybe<String_Comparison_Exp>;
  geocode_subpremise?: InputMaybe<String_Comparison_Exp>;
  google_geocode_blob?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  input_address?: InputMaybe<Citext_Comparison_Exp>;
  input_address_line_1?: InputMaybe<String_Comparison_Exp>;
  input_address_line_2?: InputMaybe<String_Comparison_Exp>;
  input_city?: InputMaybe<String_Comparison_Exp>;
  input_state?: InputMaybe<String_Comparison_Exp>;
  input_zipcode?: InputMaybe<String_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  geocode_city?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
  geocode_neighborhood?: InputMaybe<Order_By>;
  geocode_postal_code?: InputMaybe<Order_By>;
  geocode_postal_code_suffix?: InputMaybe<Order_By>;
  geocode_road?: InputMaybe<Order_By>;
  geocode_state?: InputMaybe<Order_By>;
  geocode_street_number?: InputMaybe<Order_By>;
  geocode_subpremise?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_address?: InputMaybe<Order_By>;
  input_address_line_1?: InputMaybe<Order_By>;
  input_address_line_2?: InputMaybe<Order_By>;
  input_city?: InputMaybe<Order_By>;
  input_state?: InputMaybe<Order_By>;
  input_zipcode?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  geocode_city?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
  geocode_neighborhood?: InputMaybe<Order_By>;
  geocode_postal_code?: InputMaybe<Order_By>;
  geocode_postal_code_suffix?: InputMaybe<Order_By>;
  geocode_road?: InputMaybe<Order_By>;
  geocode_state?: InputMaybe<Order_By>;
  geocode_street_number?: InputMaybe<Order_By>;
  geocode_subpremise?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_address?: InputMaybe<Order_By>;
  input_address_line_1?: InputMaybe<Order_By>;
  input_address_line_2?: InputMaybe<Order_By>;
  input_city?: InputMaybe<Order_By>;
  input_state?: InputMaybe<Order_By>;
  input_zipcode?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientaddress". */
export type Ehr_Clientaddress_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  geocode_city?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
  geocode_neighborhood?: InputMaybe<Order_By>;
  geocode_postal_code?: InputMaybe<Order_By>;
  geocode_postal_code_suffix?: InputMaybe<Order_By>;
  geocode_road?: InputMaybe<Order_By>;
  geocode_state?: InputMaybe<Order_By>;
  geocode_street_number?: InputMaybe<Order_By>;
  geocode_subpremise?: InputMaybe<Order_By>;
  google_geocode_blob?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_address?: InputMaybe<Order_By>;
  input_address_line_1?: InputMaybe<Order_By>;
  input_address_line_2?: InputMaybe<Order_By>;
  input_city?: InputMaybe<Order_By>;
  input_state?: InputMaybe<Order_By>;
  input_zipcode?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientaddress" */
export enum Ehr_Clientaddress_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GeocodeCity = 'geocode_city',
  /** column name */
  GeocodeLatitude = 'geocode_latitude',
  /** column name */
  GeocodeLongitude = 'geocode_longitude',
  /** column name */
  GeocodeNeighborhood = 'geocode_neighborhood',
  /** column name */
  GeocodePostalCode = 'geocode_postal_code',
  /** column name */
  GeocodePostalCodeSuffix = 'geocode_postal_code_suffix',
  /** column name */
  GeocodeRoad = 'geocode_road',
  /** column name */
  GeocodeState = 'geocode_state',
  /** column name */
  GeocodeStreetNumber = 'geocode_street_number',
  /** column name */
  GeocodeSubpremise = 'geocode_subpremise',
  /** column name */
  GoogleGeocodeBlob = 'google_geocode_blob',
  /** column name */
  Id = 'id',
  /** column name */
  InputAddress = 'input_address',
  /** column name */
  InputAddressLine_1 = 'input_address_line_1',
  /** column name */
  InputAddressLine_2 = 'input_address_line_2',
  /** column name */
  InputCity = 'input_city',
  /** column name */
  InputState = 'input_state',
  /** column name */
  InputZipcode = 'input_zipcode',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  Welkin8Id = 'welkin8_id'
}

/** order by stddev() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientaddress" */
export type Ehr_Clientaddress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientaddress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientaddress_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  formatted_address?: InputMaybe<Scalars['String']>;
  geocode_city?: InputMaybe<Scalars['String']>;
  geocode_latitude?: InputMaybe<Scalars['float8']>;
  geocode_longitude?: InputMaybe<Scalars['float8']>;
  geocode_neighborhood?: InputMaybe<Scalars['String']>;
  geocode_postal_code?: InputMaybe<Scalars['String']>;
  geocode_postal_code_suffix?: InputMaybe<Scalars['String']>;
  geocode_road?: InputMaybe<Scalars['String']>;
  geocode_state?: InputMaybe<Scalars['String']>;
  geocode_street_number?: InputMaybe<Scalars['String']>;
  geocode_subpremise?: InputMaybe<Scalars['String']>;
  google_geocode_blob?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  input_address?: InputMaybe<Scalars['citext']>;
  input_address_line_1?: InputMaybe<Scalars['String']>;
  input_address_line_2?: InputMaybe<Scalars['String']>;
  input_city?: InputMaybe<Scalars['String']>;
  input_state?: InputMaybe<Scalars['String']>;
  input_zipcode?: InputMaybe<Scalars['String']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  welkin8_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientaddress" */
export type Ehr_Clientaddress_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  geocode_latitude?: InputMaybe<Order_By>;
  geocode_longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientdocument" */
export type Ehr_Clientdocument = {
  __typename?: 'ehr_clientdocument';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  artifacts?: Maybe<Scalars['jsonb']>;
  client_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  document_type: Scalars['String'];
  id: Scalars['uuid'];
  mime_type: Scalars['String'];
  modified_at: Scalars['timestamptz'];
  modified_user_id?: Maybe<Scalars['Int']>;
  modified_user_type?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  status: Scalars['String'];
  storage_bucket_name: Scalars['String'];
  storage_object_name: Scalars['String'];
  uploaded_at: Scalars['timestamptz'];
};


/** columns and relationships of "ehr_clientdocument" */
export type Ehr_ClientdocumentArtifactsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_clientdocument". All fields are combined with a logical 'AND'. */
export type Ehr_Clientdocument_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientdocument_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientdocument_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientdocument_Bool_Exp>>;
  artifacts?: InputMaybe<Jsonb_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  modified_user_id?: InputMaybe<Int_Comparison_Exp>;
  modified_user_type?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  storage_bucket_name?: InputMaybe<String_Comparison_Exp>;
  storage_object_name?: InputMaybe<String_Comparison_Exp>;
  uploaded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_clientdocument". */
export type Ehr_Clientdocument_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  artifacts?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  modified_user_id?: InputMaybe<Order_By>;
  modified_user_type?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  storage_bucket_name?: InputMaybe<Order_By>;
  storage_object_name?: InputMaybe<Order_By>;
  uploaded_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientdocument" */
export enum Ehr_Clientdocument_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  Artifacts = 'artifacts',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  ModifiedUserId = 'modified_user_id',
  /** column name */
  ModifiedUserType = 'modified_user_type',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  StorageBucketName = 'storage_bucket_name',
  /** column name */
  StorageObjectName = 'storage_object_name',
  /** column name */
  UploadedAt = 'uploaded_at'
}

/** Streaming cursor of the table "ehr_clientdocument" */
export type Ehr_Clientdocument_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientdocument_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientdocument_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  artifacts?: InputMaybe<Scalars['jsonb']>;
  client_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  mime_type?: InputMaybe<Scalars['String']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  modified_user_id?: InputMaybe<Scalars['Int']>;
  modified_user_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  storage_bucket_name?: InputMaybe<Scalars['String']>;
  storage_object_name?: InputMaybe<Scalars['String']>;
  uploaded_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact = {
  __typename?: 'ehr_clientemergencycontact';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id: Scalars['Int'];
  couple_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehr_client: Ehr_Client;
  email?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_acuity: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  origin_acuity_event_id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
  welkin8_id?: Maybe<Scalars['String']>;
  welkin_cdt_id?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientemergencycontact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientemergencycontact_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientemergencycontact_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientemergencycontact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientemergencycontact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientemergencycontact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientemergencycontact_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientemergencycontact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientemergencycontact_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientemergencycontact_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientemergencycontact". All fields are combined with a logical 'AND'. */
export type Ehr_Clientemergencycontact_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientemergencycontact_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientemergencycontact_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_acuity?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  origin_acuity_event_id?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  relationship?: InputMaybe<String_Comparison_Exp>;
  welkin8_id?: InputMaybe<String_Comparison_Exp>;
  welkin_cdt_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientemergencycontact". */
export type Ehr_Clientemergencycontact_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_acuity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientemergencycontact" */
export enum Ehr_Clientemergencycontact_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsAcuity = 'is_acuity',
  /** column name */
  Name = 'name',
  /** column name */
  OriginAcuityEventId = 'origin_acuity_event_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  Welkin8Id = 'welkin8_id',
  /** column name */
  WelkinCdtId = 'welkin_cdt_id'
}

/** order by stddev() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientemergencycontact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientemergencycontact_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_acuity?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  origin_acuity_event_id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
  welkin8_id?: InputMaybe<Scalars['String']>;
  welkin_cdt_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientemergencycontact" */
export type Ehr_Clientemergencycontact_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  origin_acuity_event_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientgroup" */
export type Ehr_Clientgroup = {
  __typename?: 'ehr_clientgroup';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  client_id: Scalars['Int'];
  date_joined?: Maybe<Scalars['date']>;
  /** An object relationship */
  ehr_client: Ehr_Client;
  /** An object relationship */
  ehr_group: Ehr_Group;
  group_id: Scalars['uuid'];
  id: Scalars['uuid'];
  unenrolled_date?: Maybe<Scalars['date']>;
  unenrolled_reason?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientgroup_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientgroup_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientgroup_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientgroup_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientgroup_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientgroup_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientgroup_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientgroup_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientgroup_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientgroup_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientgroup". All fields are combined with a logical 'AND'. */
export type Ehr_Clientgroup_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientgroup_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientgroup_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Date_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_group?: InputMaybe<Ehr_Group_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  unenrolled_date?: InputMaybe<Date_Comparison_Exp>;
  unenrolled_reason?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unenrolled_date?: InputMaybe<Order_By>;
  unenrolled_reason?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unenrolled_date?: InputMaybe<Order_By>;
  unenrolled_reason?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientgroup". */
export type Ehr_Clientgroup_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_group?: InputMaybe<Ehr_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unenrolled_date?: InputMaybe<Order_By>;
  unenrolled_reason?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientgroup" */
export enum Ehr_Clientgroup_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  UnenrolledDate = 'unenrolled_date',
  /** column name */
  UnenrolledReason = 'unenrolled_reason'
}

/** order by stddev() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientgroup" */
export type Ehr_Clientgroup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientgroup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientgroup_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['date']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  unenrolled_date?: InputMaybe<Scalars['date']>;
  unenrolled_reason?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientgroup" */
export type Ehr_Clientgroup_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking = {
  __typename?: 'ehr_clientgroupbooking';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  client_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  ehr_client: Ehr_Client;
  /** An object relationship */
  ehr_group: Ehr_Group;
  group_id: Scalars['uuid'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "ehr_clientgroupbooking" */
export type Ehr_ClientgroupbookingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientgroupbooking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientgroupbooking_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientgroupbooking_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientgroupbooking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientgroupbooking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientgroupbooking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientgroupbooking_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientgroupbooking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientgroupbooking_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientgroupbooking_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientgroupbooking". All fields are combined with a logical 'AND'. */
export type Ehr_Clientgroupbooking_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientgroupbooking_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientgroupbooking_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_group?: InputMaybe<Ehr_Group_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientgroupbooking". */
export type Ehr_Clientgroupbooking_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_group?: InputMaybe<Ehr_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientgroupbooking" */
export enum Ehr_Clientgroupbooking_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata'
}

/** order by stddev() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientgroupbooking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientgroupbooking_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** order by sum() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientgroupbooking" */
export type Ehr_Clientgroupbooking_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent = {
  __typename?: 'ehr_clientgroupevent';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  client_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_client: Ehr_Client;
  /** An object relationship */
  ehr_clientgroupeventmeta?: Maybe<Ehr_Clientgroupeventmeta>;
  /** An object relationship */
  ehr_event?: Maybe<Ehr_Event>;
  /** An array relationship */
  ehr_eventmbcstatuses: Array<Ehr_Eventmbcstatus>;
  event_id?: Maybe<Scalars['uuid']>;
  healthie_note_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  modified_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ehr_clientgroupevent" */
export type Ehr_ClientgroupeventEhr_EventmbcstatusesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmbcstatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmbcstatus_Order_By>>;
  where?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
};

/** order by aggregate values of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientgroupevent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientgroupevent_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientgroupevent_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientgroupevent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientgroupevent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientgroupevent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientgroupevent_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientgroupevent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientgroupevent_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientgroupevent_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientgroupevent". All fields are combined with a logical 'AND'. */
export type Ehr_Clientgroupevent_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientgroupevent_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientgroupevent_Bool_Exp>>;
  appointment_status?: InputMaybe<String_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_Comparison_Exp>;
  cancellation_type?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clientgroupeventmeta?: InputMaybe<Ehr_Clientgroupeventmeta_Bool_Exp>;
  ehr_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  ehr_eventmbcstatuses?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  healthie_note_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientgroupevent". */
export type Ehr_Clientgroupevent_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clientgroupeventmeta?: InputMaybe<Ehr_Clientgroupeventmeta_Order_By>;
  ehr_event?: InputMaybe<Ehr_Event_Order_By>;
  ehr_eventmbcstatuses_aggregate?: InputMaybe<Ehr_Eventmbcstatus_Aggregate_Order_By>;
  event_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientgroupevent" */
export enum Ehr_Clientgroupevent_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CancellationType = 'cancellation_type',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  HealthieNoteId = 'healthie_note_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at'
}

/** order by stddev() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientgroupevent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientgroupevent_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  appointment_status?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  cancellation_type?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  healthie_note_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientgroupevent" */
export type Ehr_Clientgroupevent_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientgroupeventmeta" */
export type Ehr_Clientgroupeventmeta = {
  __typename?: 'ehr_clientgroupeventmeta';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  attendance_note?: Maybe<Scalars['String']>;
  client_group_event_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_clientgroupevent: Ehr_Clientgroupevent;
  id: Scalars['Int'];
  modified_at: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "ehr_clientgroupeventmeta". All fields are combined with a logical 'AND'. */
export type Ehr_Clientgroupeventmeta_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientgroupeventmeta_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Bool_Exp>>;
  attendance_note?: InputMaybe<String_Comparison_Exp>;
  client_group_event_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_clientgroupevent?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_clientgroupeventmeta". */
export type Ehr_Clientgroupeventmeta_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  attendance_note?: InputMaybe<Order_By>;
  client_group_event_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_clientgroupevent?: InputMaybe<Ehr_Clientgroupevent_Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientgroupeventmeta" */
export enum Ehr_Clientgroupeventmeta_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  AttendanceNote = 'attendance_note',
  /** column name */
  ClientGroupEventId = 'client_group_event_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at'
}

/** Streaming cursor of the table "ehr_clientgroupeventmeta" */
export type Ehr_Clientgroupeventmeta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientgroupeventmeta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientgroupeventmeta_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  attendance_note?: InputMaybe<Scalars['String']>;
  client_group_event_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord = {
  __typename?: 'ehr_clientpayerservicerecord';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  coverage_start_date: Scalars['timestamptz'];
  coverage_termination_date?: Maybe<Scalars['timestamptz']>;
  expected_coverage_termination_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  payer?: Maybe<Ehr_Payer>;
  payer_id?: Maybe<Scalars['uuid']>;
  service_type?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientpayerservicerecord_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientpayerservicerecord_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientpayerservicerecord_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientpayerservicerecord_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientpayerservicerecord_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientpayerservicerecord_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientpayerservicerecord_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientpayerservicerecord_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientpayerservicerecord_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientpayerservicerecord_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientpayerservicerecord". All fields are combined with a logical 'AND'. */
export type Ehr_Clientpayerservicerecord_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  coverage_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  coverage_termination_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  expected_coverage_termination_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payer?: InputMaybe<Ehr_Payer_Bool_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  coverage_start_date?: InputMaybe<Order_By>;
  coverage_termination_date?: InputMaybe<Order_By>;
  expected_coverage_termination_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  coverage_start_date?: InputMaybe<Order_By>;
  coverage_termination_date?: InputMaybe<Order_By>;
  expected_coverage_termination_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientpayerservicerecord". */
export type Ehr_Clientpayerservicerecord_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  coverage_start_date?: InputMaybe<Order_By>;
  coverage_termination_date?: InputMaybe<Order_By>;
  expected_coverage_termination_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer?: InputMaybe<Ehr_Payer_Order_By>;
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientpayerservicerecord" */
export enum Ehr_Clientpayerservicerecord_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CoverageStartDate = 'coverage_start_date',
  /** column name */
  CoverageTerminationDate = 'coverage_termination_date',
  /** column name */
  ExpectedCoverageTerminationDate = 'expected_coverage_termination_date',
  /** column name */
  Id = 'id',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  ServiceType = 'service_type'
}

/** order by stddev() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientpayerservicerecord_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientpayerservicerecord_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  coverage_start_date?: InputMaybe<Scalars['timestamptz']>;
  coverage_termination_date?: InputMaybe<Scalars['timestamptz']>;
  expected_coverage_termination_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  service_type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientpayerservicerecord" */
export type Ehr_Clientpayerservicerecord_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientprofile" */
export type Ehr_Clientprofile = {
  __typename?: 'ehr_clientprofile';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  accessibility_needs?: Maybe<Array<Scalars['String']>>;
  accessibility_needs_other?: Maybe<Scalars['String']>;
  additional_racial_background?: Maybe<Scalars['String']>;
  allergies?: Maybe<Array<Scalars['jsonb']>>;
  /** An object relationship */
  booking_info?: Maybe<Ehr_Booking>;
  client_id: Scalars['Int'];
  concerns_starting_therapy?: Maybe<Array<Scalars['String']>>;
  concerns_starting_therapy_other?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_status?: Maybe<Scalars['String']>;
  employment_status_other?: Maybe<Scalars['String']>;
  family_history_mental_illness?: Maybe<Scalars['Boolean']>;
  gender_identity?: Maybe<Scalars['String']>;
  gender_identity_other?: Maybe<Scalars['String']>;
  gender_pronouns?: Maybe<Scalars['String']>;
  gender_pronouns_other?: Maybe<Scalars['String']>;
  have_primary_care_physician?: Maybe<Scalars['Boolean']>;
  health_conditions?: Maybe<Array<Scalars['String']>>;
  health_conditions_other?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_hispanic?: Maybe<Scalars['String']>;
  is_hispanic_detail?: Maybe<Scalars['String']>;
  is_hispanic_other?: Maybe<Scalars['String']>;
  medications?: Maybe<Array<Scalars['jsonb']>>;
  other_aspects_identity?: Maybe<Scalars['String']>;
  overall_health?: Maybe<Scalars['String']>;
  past_mental_health_care?: Maybe<Array<Scalars['String']>>;
  past_mental_health_care_other?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  primary_care_physician_email?: Maybe<Scalars['String']>;
  primary_care_physician_name?: Maybe<Scalars['String']>;
  primary_care_physician_phone?: Maybe<Scalars['String']>;
  race_self_identify?: Maybe<Array<Scalars['String']>>;
  race_self_identify_other?: Maybe<Scalars['String']>;
  racial_identity?: Maybe<Array<Scalars['String']>>;
  racial_identity_other?: Maybe<Scalars['String']>;
  receiving_mental_health_care?: Maybe<Scalars['Boolean']>;
  relationship_status?: Maybe<Scalars['String']>;
  relationship_status_other?: Maybe<Scalars['String']>;
  /** An object relationship */
  screening_info?: Maybe<Ehr_Clientscreeningquestions>;
  sexual_orientation?: Maybe<Scalars['String']>;
  sexual_orientation_other?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientprofile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientprofile_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientprofile_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientprofile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientprofile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientprofile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientprofile_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientprofile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientprofile_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientprofile_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientprofile". All fields are combined with a logical 'AND'. */
export type Ehr_Clientprofile_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientprofile_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientprofile_Bool_Exp>>;
  accessibility_needs?: InputMaybe<String_Array_Comparison_Exp>;
  accessibility_needs_other?: InputMaybe<String_Comparison_Exp>;
  additional_racial_background?: InputMaybe<String_Comparison_Exp>;
  allergies?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  booking_info?: InputMaybe<Ehr_Booking_Bool_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  concerns_starting_therapy?: InputMaybe<String_Array_Comparison_Exp>;
  concerns_starting_therapy_other?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employment_status?: InputMaybe<String_Comparison_Exp>;
  employment_status_other?: InputMaybe<String_Comparison_Exp>;
  family_history_mental_illness?: InputMaybe<Boolean_Comparison_Exp>;
  gender_identity?: InputMaybe<String_Comparison_Exp>;
  gender_identity_other?: InputMaybe<String_Comparison_Exp>;
  gender_pronouns?: InputMaybe<String_Comparison_Exp>;
  gender_pronouns_other?: InputMaybe<String_Comparison_Exp>;
  have_primary_care_physician?: InputMaybe<Boolean_Comparison_Exp>;
  health_conditions?: InputMaybe<String_Array_Comparison_Exp>;
  health_conditions_other?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_hispanic?: InputMaybe<String_Comparison_Exp>;
  is_hispanic_detail?: InputMaybe<String_Comparison_Exp>;
  is_hispanic_other?: InputMaybe<String_Comparison_Exp>;
  medications?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  other_aspects_identity?: InputMaybe<String_Comparison_Exp>;
  overall_health?: InputMaybe<String_Comparison_Exp>;
  past_mental_health_care?: InputMaybe<String_Array_Comparison_Exp>;
  past_mental_health_care_other?: InputMaybe<String_Comparison_Exp>;
  preferred_name?: InputMaybe<String_Comparison_Exp>;
  primary_care_physician_email?: InputMaybe<String_Comparison_Exp>;
  primary_care_physician_name?: InputMaybe<String_Comparison_Exp>;
  primary_care_physician_phone?: InputMaybe<String_Comparison_Exp>;
  race_self_identify?: InputMaybe<String_Array_Comparison_Exp>;
  race_self_identify_other?: InputMaybe<String_Comparison_Exp>;
  racial_identity?: InputMaybe<String_Array_Comparison_Exp>;
  racial_identity_other?: InputMaybe<String_Comparison_Exp>;
  receiving_mental_health_care?: InputMaybe<Boolean_Comparison_Exp>;
  relationship_status?: InputMaybe<String_Comparison_Exp>;
  relationship_status_other?: InputMaybe<String_Comparison_Exp>;
  screening_info?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
  sexual_orientation?: InputMaybe<String_Comparison_Exp>;
  sexual_orientation_other?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  accessibility_needs?: InputMaybe<Order_By>;
  accessibility_needs_other?: InputMaybe<Order_By>;
  additional_racial_background?: InputMaybe<Order_By>;
  allergies?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  concerns_starting_therapy?: InputMaybe<Order_By>;
  concerns_starting_therapy_other?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_other?: InputMaybe<Order_By>;
  gender_identity?: InputMaybe<Order_By>;
  gender_identity_other?: InputMaybe<Order_By>;
  gender_pronouns?: InputMaybe<Order_By>;
  gender_pronouns_other?: InputMaybe<Order_By>;
  health_conditions?: InputMaybe<Order_By>;
  health_conditions_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_hispanic?: InputMaybe<Order_By>;
  is_hispanic_detail?: InputMaybe<Order_By>;
  is_hispanic_other?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  other_aspects_identity?: InputMaybe<Order_By>;
  overall_health?: InputMaybe<Order_By>;
  past_mental_health_care?: InputMaybe<Order_By>;
  past_mental_health_care_other?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  primary_care_physician_email?: InputMaybe<Order_By>;
  primary_care_physician_name?: InputMaybe<Order_By>;
  primary_care_physician_phone?: InputMaybe<Order_By>;
  race_self_identify?: InputMaybe<Order_By>;
  race_self_identify_other?: InputMaybe<Order_By>;
  racial_identity?: InputMaybe<Order_By>;
  racial_identity_other?: InputMaybe<Order_By>;
  relationship_status?: InputMaybe<Order_By>;
  relationship_status_other?: InputMaybe<Order_By>;
  sexual_orientation?: InputMaybe<Order_By>;
  sexual_orientation_other?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  accessibility_needs?: InputMaybe<Order_By>;
  accessibility_needs_other?: InputMaybe<Order_By>;
  additional_racial_background?: InputMaybe<Order_By>;
  allergies?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  concerns_starting_therapy?: InputMaybe<Order_By>;
  concerns_starting_therapy_other?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_other?: InputMaybe<Order_By>;
  gender_identity?: InputMaybe<Order_By>;
  gender_identity_other?: InputMaybe<Order_By>;
  gender_pronouns?: InputMaybe<Order_By>;
  gender_pronouns_other?: InputMaybe<Order_By>;
  health_conditions?: InputMaybe<Order_By>;
  health_conditions_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_hispanic?: InputMaybe<Order_By>;
  is_hispanic_detail?: InputMaybe<Order_By>;
  is_hispanic_other?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  other_aspects_identity?: InputMaybe<Order_By>;
  overall_health?: InputMaybe<Order_By>;
  past_mental_health_care?: InputMaybe<Order_By>;
  past_mental_health_care_other?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  primary_care_physician_email?: InputMaybe<Order_By>;
  primary_care_physician_name?: InputMaybe<Order_By>;
  primary_care_physician_phone?: InputMaybe<Order_By>;
  race_self_identify?: InputMaybe<Order_By>;
  race_self_identify_other?: InputMaybe<Order_By>;
  racial_identity?: InputMaybe<Order_By>;
  racial_identity_other?: InputMaybe<Order_By>;
  relationship_status?: InputMaybe<Order_By>;
  relationship_status_other?: InputMaybe<Order_By>;
  sexual_orientation?: InputMaybe<Order_By>;
  sexual_orientation_other?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientprofile". */
export type Ehr_Clientprofile_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  accessibility_needs?: InputMaybe<Order_By>;
  accessibility_needs_other?: InputMaybe<Order_By>;
  additional_racial_background?: InputMaybe<Order_By>;
  allergies?: InputMaybe<Order_By>;
  booking_info?: InputMaybe<Ehr_Booking_Order_By>;
  client_id?: InputMaybe<Order_By>;
  concerns_starting_therapy?: InputMaybe<Order_By>;
  concerns_starting_therapy_other?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  employment_status?: InputMaybe<Order_By>;
  employment_status_other?: InputMaybe<Order_By>;
  family_history_mental_illness?: InputMaybe<Order_By>;
  gender_identity?: InputMaybe<Order_By>;
  gender_identity_other?: InputMaybe<Order_By>;
  gender_pronouns?: InputMaybe<Order_By>;
  gender_pronouns_other?: InputMaybe<Order_By>;
  have_primary_care_physician?: InputMaybe<Order_By>;
  health_conditions?: InputMaybe<Order_By>;
  health_conditions_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_hispanic?: InputMaybe<Order_By>;
  is_hispanic_detail?: InputMaybe<Order_By>;
  is_hispanic_other?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  other_aspects_identity?: InputMaybe<Order_By>;
  overall_health?: InputMaybe<Order_By>;
  past_mental_health_care?: InputMaybe<Order_By>;
  past_mental_health_care_other?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  primary_care_physician_email?: InputMaybe<Order_By>;
  primary_care_physician_name?: InputMaybe<Order_By>;
  primary_care_physician_phone?: InputMaybe<Order_By>;
  race_self_identify?: InputMaybe<Order_By>;
  race_self_identify_other?: InputMaybe<Order_By>;
  racial_identity?: InputMaybe<Order_By>;
  racial_identity_other?: InputMaybe<Order_By>;
  receiving_mental_health_care?: InputMaybe<Order_By>;
  relationship_status?: InputMaybe<Order_By>;
  relationship_status_other?: InputMaybe<Order_By>;
  screening_info?: InputMaybe<Ehr_Clientscreeningquestions_Order_By>;
  sexual_orientation?: InputMaybe<Order_By>;
  sexual_orientation_other?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientprofile" */
export enum Ehr_Clientprofile_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AccessibilityNeeds = 'accessibility_needs',
  /** column name */
  AccessibilityNeedsOther = 'accessibility_needs_other',
  /** column name */
  AdditionalRacialBackground = 'additional_racial_background',
  /** column name */
  Allergies = 'allergies',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ConcernsStartingTherapy = 'concerns_starting_therapy',
  /** column name */
  ConcernsStartingTherapyOther = 'concerns_starting_therapy_other',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmploymentStatus = 'employment_status',
  /** column name */
  EmploymentStatusOther = 'employment_status_other',
  /** column name */
  FamilyHistoryMentalIllness = 'family_history_mental_illness',
  /** column name */
  GenderIdentity = 'gender_identity',
  /** column name */
  GenderIdentityOther = 'gender_identity_other',
  /** column name */
  GenderPronouns = 'gender_pronouns',
  /** column name */
  GenderPronounsOther = 'gender_pronouns_other',
  /** column name */
  HavePrimaryCarePhysician = 'have_primary_care_physician',
  /** column name */
  HealthConditions = 'health_conditions',
  /** column name */
  HealthConditionsOther = 'health_conditions_other',
  /** column name */
  Id = 'id',
  /** column name */
  IsHispanic = 'is_hispanic',
  /** column name */
  IsHispanicDetail = 'is_hispanic_detail',
  /** column name */
  IsHispanicOther = 'is_hispanic_other',
  /** column name */
  Medications = 'medications',
  /** column name */
  OtherAspectsIdentity = 'other_aspects_identity',
  /** column name */
  OverallHealth = 'overall_health',
  /** column name */
  PastMentalHealthCare = 'past_mental_health_care',
  /** column name */
  PastMentalHealthCareOther = 'past_mental_health_care_other',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  PrimaryCarePhysicianEmail = 'primary_care_physician_email',
  /** column name */
  PrimaryCarePhysicianName = 'primary_care_physician_name',
  /** column name */
  PrimaryCarePhysicianPhone = 'primary_care_physician_phone',
  /** column name */
  RaceSelfIdentify = 'race_self_identify',
  /** column name */
  RaceSelfIdentifyOther = 'race_self_identify_other',
  /** column name */
  RacialIdentity = 'racial_identity',
  /** column name */
  RacialIdentityOther = 'racial_identity_other',
  /** column name */
  ReceivingMentalHealthCare = 'receiving_mental_health_care',
  /** column name */
  RelationshipStatus = 'relationship_status',
  /** column name */
  RelationshipStatusOther = 'relationship_status_other',
  /** column name */
  SexualOrientation = 'sexual_orientation',
  /** column name */
  SexualOrientationOther = 'sexual_orientation_other'
}

/** order by stddev() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientprofile" */
export type Ehr_Clientprofile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientprofile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientprofile_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  accessibility_needs?: InputMaybe<Array<Scalars['String']>>;
  accessibility_needs_other?: InputMaybe<Scalars['String']>;
  additional_racial_background?: InputMaybe<Scalars['String']>;
  allergies?: InputMaybe<Array<Scalars['jsonb']>>;
  client_id?: InputMaybe<Scalars['Int']>;
  concerns_starting_therapy?: InputMaybe<Array<Scalars['String']>>;
  concerns_starting_therapy_other?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  employment_status?: InputMaybe<Scalars['String']>;
  employment_status_other?: InputMaybe<Scalars['String']>;
  family_history_mental_illness?: InputMaybe<Scalars['Boolean']>;
  gender_identity?: InputMaybe<Scalars['String']>;
  gender_identity_other?: InputMaybe<Scalars['String']>;
  gender_pronouns?: InputMaybe<Scalars['String']>;
  gender_pronouns_other?: InputMaybe<Scalars['String']>;
  have_primary_care_physician?: InputMaybe<Scalars['Boolean']>;
  health_conditions?: InputMaybe<Array<Scalars['String']>>;
  health_conditions_other?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_hispanic?: InputMaybe<Scalars['String']>;
  is_hispanic_detail?: InputMaybe<Scalars['String']>;
  is_hispanic_other?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Array<Scalars['jsonb']>>;
  other_aspects_identity?: InputMaybe<Scalars['String']>;
  overall_health?: InputMaybe<Scalars['String']>;
  past_mental_health_care?: InputMaybe<Array<Scalars['String']>>;
  past_mental_health_care_other?: InputMaybe<Scalars['String']>;
  preferred_name?: InputMaybe<Scalars['String']>;
  primary_care_physician_email?: InputMaybe<Scalars['String']>;
  primary_care_physician_name?: InputMaybe<Scalars['String']>;
  primary_care_physician_phone?: InputMaybe<Scalars['String']>;
  race_self_identify?: InputMaybe<Array<Scalars['String']>>;
  race_self_identify_other?: InputMaybe<Scalars['String']>;
  racial_identity?: InputMaybe<Array<Scalars['String']>>;
  racial_identity_other?: InputMaybe<Scalars['String']>;
  receiving_mental_health_care?: InputMaybe<Scalars['Boolean']>;
  relationship_status?: InputMaybe<Scalars['String']>;
  relationship_status_other?: InputMaybe<Scalars['String']>;
  sexual_orientation?: InputMaybe<Scalars['String']>;
  sexual_orientation_other?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientprofile" */
export type Ehr_Clientprofile_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions = {
  __typename?: 'ehr_clientscreeningquestions';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_preference?: Maybe<Scalars['String']>;
  diagnosed_with_bipolar?: Maybe<Scalars['String']>;
  diagnosed_with_eating_disorder?: Maybe<Scalars['String']>;
  diagnosed_with_psychosis_or_schizophrenia?: Maybe<Scalars['String']>;
  diagnosed_with_ptsd?: Maybe<Scalars['String']>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: Maybe<Scalars['String']>;
  experienced_symptoms_of_self_harming?: Maybe<Scalars['String']>;
  has_been_hospitalized_in_last_6_months?: Maybe<Scalars['Boolean']>;
  how_hear_about_us?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_first_time_seeking_care?: Maybe<Scalars['Boolean']>;
  is_taking_medication_for_mental_health?: Maybe<Scalars['Boolean']>;
  referring_provider_name?: Maybe<Scalars['String']>;
  therapist_preferences?: Maybe<Array<Scalars['String']>>;
  time_availability_preference?: Maybe<Scalars['jsonb']>;
  welkin8_id?: Maybe<Scalars['String']>;
  what_brings_you_to_therapy?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_clientscreeningquestions" */
export type Ehr_ClientscreeningquestionsTime_Availability_PreferenceArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clientscreeningquestions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clientscreeningquestions_Max_Order_By>;
  min?: InputMaybe<Ehr_Clientscreeningquestions_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clientscreeningquestions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clientscreeningquestions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clientscreeningquestions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clientscreeningquestions_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clientscreeningquestions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clientscreeningquestions_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clientscreeningquestions_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clientscreeningquestions". All fields are combined with a logical 'AND'. */
export type Ehr_Clientscreeningquestions_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clientscreeningquestions_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clientscreeningquestions_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_preference?: InputMaybe<String_Comparison_Exp>;
  diagnosed_with_bipolar?: InputMaybe<String_Comparison_Exp>;
  diagnosed_with_eating_disorder?: InputMaybe<String_Comparison_Exp>;
  diagnosed_with_psychosis_or_schizophrenia?: InputMaybe<String_Comparison_Exp>;
  diagnosed_with_ptsd?: InputMaybe<String_Comparison_Exp>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: InputMaybe<String_Comparison_Exp>;
  experienced_symptoms_of_self_harming?: InputMaybe<String_Comparison_Exp>;
  has_been_hospitalized_in_last_6_months?: InputMaybe<Boolean_Comparison_Exp>;
  how_hear_about_us?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_first_time_seeking_care?: InputMaybe<Boolean_Comparison_Exp>;
  is_taking_medication_for_mental_health?: InputMaybe<Boolean_Comparison_Exp>;
  referring_provider_name?: InputMaybe<String_Comparison_Exp>;
  therapist_preferences?: InputMaybe<String_Array_Comparison_Exp>;
  time_availability_preference?: InputMaybe<Jsonb_Comparison_Exp>;
  welkin8_id?: InputMaybe<String_Comparison_Exp>;
  what_brings_you_to_therapy?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  diagnosed_with_bipolar?: InputMaybe<Order_By>;
  diagnosed_with_eating_disorder?: InputMaybe<Order_By>;
  diagnosed_with_psychosis_or_schizophrenia?: InputMaybe<Order_By>;
  diagnosed_with_ptsd?: InputMaybe<Order_By>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: InputMaybe<Order_By>;
  experienced_symptoms_of_self_harming?: InputMaybe<Order_By>;
  how_hear_about_us?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referring_provider_name?: InputMaybe<Order_By>;
  therapist_preferences?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  what_brings_you_to_therapy?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  diagnosed_with_bipolar?: InputMaybe<Order_By>;
  diagnosed_with_eating_disorder?: InputMaybe<Order_By>;
  diagnosed_with_psychosis_or_schizophrenia?: InputMaybe<Order_By>;
  diagnosed_with_ptsd?: InputMaybe<Order_By>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: InputMaybe<Order_By>;
  experienced_symptoms_of_self_harming?: InputMaybe<Order_By>;
  how_hear_about_us?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referring_provider_name?: InputMaybe<Order_By>;
  therapist_preferences?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  what_brings_you_to_therapy?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clientscreeningquestions". */
export type Ehr_Clientscreeningquestions_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  diagnosed_with_bipolar?: InputMaybe<Order_By>;
  diagnosed_with_eating_disorder?: InputMaybe<Order_By>;
  diagnosed_with_psychosis_or_schizophrenia?: InputMaybe<Order_By>;
  diagnosed_with_ptsd?: InputMaybe<Order_By>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: InputMaybe<Order_By>;
  experienced_symptoms_of_self_harming?: InputMaybe<Order_By>;
  has_been_hospitalized_in_last_6_months?: InputMaybe<Order_By>;
  how_hear_about_us?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_first_time_seeking_care?: InputMaybe<Order_By>;
  is_taking_medication_for_mental_health?: InputMaybe<Order_By>;
  referring_provider_name?: InputMaybe<Order_By>;
  therapist_preferences?: InputMaybe<Order_By>;
  time_availability_preference?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  what_brings_you_to_therapy?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clientscreeningquestions" */
export enum Ehr_Clientscreeningquestions_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryPreference = 'delivery_preference',
  /** column name */
  DiagnosedWithBipolar = 'diagnosed_with_bipolar',
  /** column name */
  DiagnosedWithEatingDisorder = 'diagnosed_with_eating_disorder',
  /** column name */
  DiagnosedWithPsychosisOrSchizophrenia = 'diagnosed_with_psychosis_or_schizophrenia',
  /** column name */
  DiagnosedWithPtsd = 'diagnosed_with_ptsd',
  /** column name */
  ExperiencedSymptomsOfDrugOrAlcoholAbuse = 'experienced_symptoms_of_drug_or_alcohol_abuse',
  /** column name */
  ExperiencedSymptomsOfSelfHarming = 'experienced_symptoms_of_self_harming',
  /** column name */
  HasBeenHospitalizedInLast_6Months = 'has_been_hospitalized_in_last_6_months',
  /** column name */
  HowHearAboutUs = 'how_hear_about_us',
  /** column name */
  Id = 'id',
  /** column name */
  IsFirstTimeSeekingCare = 'is_first_time_seeking_care',
  /** column name */
  IsTakingMedicationForMentalHealth = 'is_taking_medication_for_mental_health',
  /** column name */
  ReferringProviderName = 'referring_provider_name',
  /** column name */
  TherapistPreferences = 'therapist_preferences',
  /** column name */
  TimeAvailabilityPreference = 'time_availability_preference',
  /** column name */
  Welkin8Id = 'welkin8_id',
  /** column name */
  WhatBringsYouToTherapy = 'what_brings_you_to_therapy'
}

/** order by stddev() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clientscreeningquestions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clientscreeningquestions_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_preference?: InputMaybe<Scalars['String']>;
  diagnosed_with_bipolar?: InputMaybe<Scalars['String']>;
  diagnosed_with_eating_disorder?: InputMaybe<Scalars['String']>;
  diagnosed_with_psychosis_or_schizophrenia?: InputMaybe<Scalars['String']>;
  diagnosed_with_ptsd?: InputMaybe<Scalars['String']>;
  experienced_symptoms_of_drug_or_alcohol_abuse?: InputMaybe<Scalars['String']>;
  experienced_symptoms_of_self_harming?: InputMaybe<Scalars['String']>;
  has_been_hospitalized_in_last_6_months?: InputMaybe<Scalars['Boolean']>;
  how_hear_about_us?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_first_time_seeking_care?: InputMaybe<Scalars['Boolean']>;
  is_taking_medication_for_mental_health?: InputMaybe<Scalars['Boolean']>;
  referring_provider_name?: InputMaybe<Scalars['String']>;
  therapist_preferences?: InputMaybe<Array<Scalars['String']>>;
  time_availability_preference?: InputMaybe<Scalars['jsonb']>;
  welkin8_id?: InputMaybe<Scalars['String']>;
  what_brings_you_to_therapy?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clientscreeningquestions" */
export type Ehr_Clientscreeningquestions_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clinician" */
export type Ehr_Clinician = {
  __typename?: 'ehr_clinician';
  /** An array relationship */
  active_clients: Array<Cwa_Active_Clients_By_Clinician>;
  /** An object relationship */
  auth_user?: Maybe<Auth_User>;
  avatar_uri?: Maybe<Scalars['String']>;
  block_biweekly: Scalars['Boolean'];
  consult_cap: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  degree?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  director_of_id?: Maybe<Scalars['Int']>;
  dob?: Maybe<Scalars['date']>;
  /** An array relationship */
  ehr_clinicianconfigurations: Array<Ehr_Clinicianconfiguration>;
  email?: Maybe<Scalars['citext']>;
  enable_ot_matches: Scalars['Boolean'];
  /** An array relationship */
  events: Array<Ehr_Event>;
  /** An aggregate relationship */
  events_aggregate: Ehr_Event_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  gcal_sync_enabled: Scalars['Boolean'];
  healthie_id?: Maybe<Scalars['String']>;
  healthie_organization_member_id?: Maybe<Scalars['String']>;
  home_timezone?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integration_test_enabled: Scalars['Boolean'];
  is_in_zoom_pilot: Scalars['Boolean'];
  is_match_to_timeslot: Scalars['Boolean'];
  is_network: Scalars['Boolean'];
  is_remote: Scalars['Boolean'];
  is_test_data: Scalars['Boolean'];
  is_wheel: Scalars['Boolean'];
  kp_matching_start_date?: Maybe<Scalars['date']>;
  last_full_gcal_sync?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  license_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  manager?: Maybe<Ehr_Clinician>;
  /** An array relationship */
  manual_slot_reservations: Array<Hasura_Cwa__Manual_Slot_Reservations>;
  match_description?: Maybe<Scalars['String']>;
  /** An array relationship */
  matches: Array<Hasura_Cwa__Match_With_Status>;
  modified_at: Scalars['timestamptz'];
  next_full_gcal_sync?: Maybe<Scalars['timestamptz']>;
  npi?: Maybe<Scalars['String']>;
  people_manager_id?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  primary_timezone: Scalars['String'];
  /** An array relationship */
  reports: Array<Ehr_Clinician>;
  /** An array relationship */
  schedules: Array<Ehr_Clinicianschedule>;
  special_training?: Maybe<Scalars['String']>;
  style_description?: Maybe<Scalars['String']>;
  therapy_scheduling_description?: Maybe<Scalars['String']>;
  ui_flags?: Maybe<Scalars['jsonb']>;
  use_inhouse_therapy_scheduling: Scalars['Boolean'];
  user_id?: Maybe<Scalars['Int']>;
  welkin_worker_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianActive_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Order_By>>;
  where?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianEhr_ClinicianconfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianconfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianconfiguration_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianEventsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianManual_Slot_ReservationsArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianMatchesArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianReportsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinician_Order_By>>;
  where?: InputMaybe<Ehr_Clinician_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianschedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianschedule_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
};


/** columns and relationships of "ehr_clinician" */
export type Ehr_ClinicianUi_FlagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clinician" */
export type Ehr_Clinician_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clinician_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clinician_Max_Order_By>;
  min?: InputMaybe<Ehr_Clinician_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clinician_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clinician_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clinician_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clinician_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clinician_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clinician_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clinician_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Avg_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clinician". All fields are combined with a logical 'AND'. */
export type Ehr_Clinician_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clinician_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clinician_Bool_Exp>>;
  active_clients?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
  auth_user?: InputMaybe<Auth_User_Bool_Exp>;
  avatar_uri?: InputMaybe<String_Comparison_Exp>;
  block_biweekly?: InputMaybe<Boolean_Comparison_Exp>;
  consult_cap?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  degree?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  director_of_id?: InputMaybe<Int_Comparison_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  ehr_clinicianconfigurations?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  enable_ot_matches?: InputMaybe<Boolean_Comparison_Exp>;
  events?: InputMaybe<Ehr_Event_Bool_Exp>;
  events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gcal_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_id?: InputMaybe<String_Comparison_Exp>;
  healthie_organization_member_id?: InputMaybe<String_Comparison_Exp>;
  home_timezone?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  integration_test_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_zoom_pilot?: InputMaybe<Boolean_Comparison_Exp>;
  is_match_to_timeslot?: InputMaybe<Boolean_Comparison_Exp>;
  is_network?: InputMaybe<Boolean_Comparison_Exp>;
  is_remote?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheel?: InputMaybe<Boolean_Comparison_Exp>;
  kp_matching_start_date?: InputMaybe<Date_Comparison_Exp>;
  last_full_gcal_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  manager?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  manual_slot_reservations?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
  match_description?: InputMaybe<String_Comparison_Exp>;
  matches?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  next_full_gcal_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  people_manager_id?: InputMaybe<Int_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  primary_timezone?: InputMaybe<String_Comparison_Exp>;
  reports?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  schedules?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
  special_training?: InputMaybe<String_Comparison_Exp>;
  style_description?: InputMaybe<String_Comparison_Exp>;
  therapy_scheduling_description?: InputMaybe<String_Comparison_Exp>;
  ui_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  use_inhouse_therapy_scheduling?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  welkin_worker_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Max_Order_By = {
  avatar_uri?: InputMaybe<Order_By>;
  consult_cap?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  degree?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  healthie_id?: InputMaybe<Order_By>;
  healthie_organization_member_id?: InputMaybe<Order_By>;
  home_timezone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kp_matching_start_date?: InputMaybe<Order_By>;
  last_full_gcal_sync?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  match_description?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  next_full_gcal_sync?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_timezone?: InputMaybe<Order_By>;
  special_training?: InputMaybe<Order_By>;
  style_description?: InputMaybe<Order_By>;
  therapy_scheduling_description?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  welkin_worker_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Min_Order_By = {
  avatar_uri?: InputMaybe<Order_By>;
  consult_cap?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  degree?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  healthie_id?: InputMaybe<Order_By>;
  healthie_organization_member_id?: InputMaybe<Order_By>;
  home_timezone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kp_matching_start_date?: InputMaybe<Order_By>;
  last_full_gcal_sync?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  match_description?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  next_full_gcal_sync?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_timezone?: InputMaybe<Order_By>;
  special_training?: InputMaybe<Order_By>;
  style_description?: InputMaybe<Order_By>;
  therapy_scheduling_description?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  welkin_worker_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clinician". */
export type Ehr_Clinician_Order_By = {
  active_clients_aggregate?: InputMaybe<Cwa_Active_Clients_By_Clinician_Aggregate_Order_By>;
  auth_user?: InputMaybe<Auth_User_Order_By>;
  avatar_uri?: InputMaybe<Order_By>;
  block_biweekly?: InputMaybe<Order_By>;
  consult_cap?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  degree?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  ehr_clinicianconfigurations_aggregate?: InputMaybe<Ehr_Clinicianconfiguration_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  enable_ot_matches?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gcal_sync_enabled?: InputMaybe<Order_By>;
  healthie_id?: InputMaybe<Order_By>;
  healthie_organization_member_id?: InputMaybe<Order_By>;
  home_timezone?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_test_enabled?: InputMaybe<Order_By>;
  is_in_zoom_pilot?: InputMaybe<Order_By>;
  is_match_to_timeslot?: InputMaybe<Order_By>;
  is_network?: InputMaybe<Order_By>;
  is_remote?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  is_wheel?: InputMaybe<Order_By>;
  kp_matching_start_date?: InputMaybe<Order_By>;
  last_full_gcal_sync?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  manager?: InputMaybe<Ehr_Clinician_Order_By>;
  manual_slot_reservations_aggregate?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Aggregate_Order_By>;
  match_description?: InputMaybe<Order_By>;
  matches_aggregate?: InputMaybe<Hasura_Cwa__Match_With_Status_Aggregate_Order_By>;
  modified_at?: InputMaybe<Order_By>;
  next_full_gcal_sync?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  primary_timezone?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Ehr_Clinician_Aggregate_Order_By>;
  schedules_aggregate?: InputMaybe<Ehr_Clinicianschedule_Aggregate_Order_By>;
  special_training?: InputMaybe<Order_By>;
  style_description?: InputMaybe<Order_By>;
  therapy_scheduling_description?: InputMaybe<Order_By>;
  ui_flags?: InputMaybe<Order_By>;
  use_inhouse_therapy_scheduling?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  welkin_worker_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clinician" */
export enum Ehr_Clinician_Select_Column {
  /** column name */
  AvatarUri = 'avatar_uri',
  /** column name */
  BlockBiweekly = 'block_biweekly',
  /** column name */
  ConsultCap = 'consult_cap',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Degree = 'degree',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DirectorOfId = 'director_of_id',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  EnableOtMatches = 'enable_ot_matches',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  GcalSyncEnabled = 'gcal_sync_enabled',
  /** column name */
  HealthieId = 'healthie_id',
  /** column name */
  HealthieOrganizationMemberId = 'healthie_organization_member_id',
  /** column name */
  HomeTimezone = 'home_timezone',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationTestEnabled = 'integration_test_enabled',
  /** column name */
  IsInZoomPilot = 'is_in_zoom_pilot',
  /** column name */
  IsMatchToTimeslot = 'is_match_to_timeslot',
  /** column name */
  IsNetwork = 'is_network',
  /** column name */
  IsRemote = 'is_remote',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  IsWheel = 'is_wheel',
  /** column name */
  KpMatchingStartDate = 'kp_matching_start_date',
  /** column name */
  LastFullGcalSync = 'last_full_gcal_sync',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  MatchDescription = 'match_description',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  NextFullGcalSync = 'next_full_gcal_sync',
  /** column name */
  Npi = 'npi',
  /** column name */
  PeopleManagerId = 'people_manager_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PrimaryTimezone = 'primary_timezone',
  /** column name */
  SpecialTraining = 'special_training',
  /** column name */
  StyleDescription = 'style_description',
  /** column name */
  TherapySchedulingDescription = 'therapy_scheduling_description',
  /** column name */
  UiFlags = 'ui_flags',
  /** column name */
  UseInhouseTherapyScheduling = 'use_inhouse_therapy_scheduling',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WelkinWorkerId = 'welkin_worker_id'
}

/** order by stddev() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Stddev_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Stddev_Pop_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Stddev_Samp_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clinician" */
export type Ehr_Clinician_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clinician_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clinician_Stream_Cursor_Value_Input = {
  avatar_uri?: InputMaybe<Scalars['String']>;
  block_biweekly?: InputMaybe<Scalars['Boolean']>;
  consult_cap?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  degree?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  director_of_id?: InputMaybe<Scalars['Int']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['citext']>;
  enable_ot_matches?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  gcal_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  healthie_id?: InputMaybe<Scalars['String']>;
  healthie_organization_member_id?: InputMaybe<Scalars['String']>;
  home_timezone?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  integration_test_enabled?: InputMaybe<Scalars['Boolean']>;
  is_in_zoom_pilot?: InputMaybe<Scalars['Boolean']>;
  is_match_to_timeslot?: InputMaybe<Scalars['Boolean']>;
  is_network?: InputMaybe<Scalars['Boolean']>;
  is_remote?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  is_wheel?: InputMaybe<Scalars['Boolean']>;
  kp_matching_start_date?: InputMaybe<Scalars['date']>;
  last_full_gcal_sync?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  license_number?: InputMaybe<Scalars['String']>;
  match_description?: InputMaybe<Scalars['String']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  next_full_gcal_sync?: InputMaybe<Scalars['timestamptz']>;
  npi?: InputMaybe<Scalars['String']>;
  people_manager_id?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  primary_timezone?: InputMaybe<Scalars['String']>;
  special_training?: InputMaybe<Scalars['String']>;
  style_description?: InputMaybe<Scalars['String']>;
  therapy_scheduling_description?: InputMaybe<Scalars['String']>;
  ui_flags?: InputMaybe<Scalars['jsonb']>;
  use_inhouse_therapy_scheduling?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
  welkin_worker_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Sum_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Var_Pop_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Var_Samp_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clinician" */
export type Ehr_Clinician_Variance_Order_By = {
  consult_cap?: InputMaybe<Order_By>;
  director_of_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  people_manager_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clinicianclassification" */
export type Ehr_Clinicianclassification = {
  __typename?: 'ehr_clinicianclassification';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  employment_type: Scalars['String'];
  id: Scalars['Int'];
  modified_at: Scalars['timestamptz'];
  schedule_type: Scalars['String'];
  service_lines: Array<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_clinicianclassification". All fields are combined with a logical 'AND'. */
export type Ehr_Clinicianclassification_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clinicianclassification_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Clinicianclassification_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clinicianclassification_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  employment_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  schedule_type?: InputMaybe<String_Comparison_Exp>;
  service_lines?: InputMaybe<String_Array_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_clinicianclassification". */
export type Ehr_Clinicianclassification_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  employment_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  schedule_type?: InputMaybe<Order_By>;
  service_lines?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clinicianclassification" */
export enum Ehr_Clinicianclassification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  ScheduleType = 'schedule_type',
  /** column name */
  ServiceLines = 'service_lines'
}

/** Streaming cursor of the table "ehr_clinicianclassification" */
export type Ehr_Clinicianclassification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clinicianclassification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clinicianclassification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  employment_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  schedule_type?: InputMaybe<Scalars['String']>;
  service_lines?: InputMaybe<Array<Scalars['String']>>;
};

/** columns and relationships of "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration = {
  __typename?: 'ehr_clinicianconfiguration';
  classification_id: Scalars['Int'];
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  default_target_client_hours?: Maybe<Scalars['float8']>;
  /** An object relationship */
  ehr_clinicianclassification: Ehr_Clinicianclassification;
  id: Scalars['Int'];
  max_low_demand_hours?: Maybe<Scalars['Int']>;
  modified_at: Scalars['timestamptz'];
  ramp_schedule?: Maybe<Scalars['jsonb']>;
  utilization_expectation?: Maybe<Scalars['numeric']>;
  valid_from: Scalars['date'];
  valid_until?: Maybe<Scalars['date']>;
};


/** columns and relationships of "ehr_clinicianconfiguration" */
export type Ehr_ClinicianconfigurationRamp_ScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clinicianconfiguration_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clinicianconfiguration_Max_Order_By>;
  min?: InputMaybe<Ehr_Clinicianconfiguration_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clinicianconfiguration_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clinicianconfiguration_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clinicianconfiguration_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clinicianconfiguration_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clinicianconfiguration_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clinicianconfiguration_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clinicianconfiguration_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Avg_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clinicianconfiguration". All fields are combined with a logical 'AND'. */
export type Ehr_Clinicianconfiguration_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clinicianconfiguration_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clinicianconfiguration_Bool_Exp>>;
  classification_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_target_client_hours?: InputMaybe<Float8_Comparison_Exp>;
  ehr_clinicianclassification?: InputMaybe<Ehr_Clinicianclassification_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  max_low_demand_hours?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ramp_schedule?: InputMaybe<Jsonb_Comparison_Exp>;
  utilization_expectation?: InputMaybe<Numeric_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_until?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Max_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Min_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clinicianconfiguration". */
export type Ehr_Clinicianconfiguration_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  ehr_clinicianclassification?: InputMaybe<Ehr_Clinicianclassification_Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  ramp_schedule?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clinicianconfiguration" */
export enum Ehr_Clinicianconfiguration_Select_Column {
  /** column name */
  ClassificationId = 'classification_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultTargetClientHours = 'default_target_client_hours',
  /** column name */
  Id = 'id',
  /** column name */
  MaxLowDemandHours = 'max_low_demand_hours',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  RampSchedule = 'ramp_schedule',
  /** column name */
  UtilizationExpectation = 'utilization_expectation',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidUntil = 'valid_until'
}

/** order by stddev() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Stddev_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Stddev_Pop_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Stddev_Samp_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clinicianconfiguration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clinicianconfiguration_Stream_Cursor_Value_Input = {
  classification_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_target_client_hours?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  max_low_demand_hours?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  ramp_schedule?: InputMaybe<Scalars['jsonb']>;
  utilization_expectation?: InputMaybe<Scalars['numeric']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_until?: InputMaybe<Scalars['date']>;
};

/** order by sum() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Sum_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Var_Pop_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Var_Samp_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clinicianconfiguration" */
export type Ehr_Clinicianconfiguration_Variance_Order_By = {
  classification_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  default_target_client_hours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_low_demand_hours?: InputMaybe<Order_By>;
  utilization_expectation?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule = {
  __typename?: 'ehr_clinicianschedule';
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  day_of_week: Scalars['String'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  end_time: Scalars['time'];
  id: Scalars['Int'];
  is_clinical_time: Scalars['Boolean'];
  modified_at: Scalars['timestamptz'];
  room_number?: Maybe<Scalars['String']>;
  start_date: Scalars['date'];
  start_time: Scalars['time'];
  work_from_home: Scalars['Boolean'];
};

/** order by aggregate values of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Clinicianschedule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Clinicianschedule_Max_Order_By>;
  min?: InputMaybe<Ehr_Clinicianschedule_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Clinicianschedule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Clinicianschedule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Clinicianschedule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Clinicianschedule_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Clinicianschedule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Clinicianschedule_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Clinicianschedule_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Avg_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_clinicianschedule". All fields are combined with a logical 'AND'. */
export type Ehr_Clinicianschedule_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Clinicianschedule_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Clinicianschedule_Bool_Exp>>;
  clinic_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  day_of_week?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  end_time?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_clinical_time?: InputMaybe<Boolean_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  room_number?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  start_time?: InputMaybe<Time_Comparison_Exp>;
  work_from_home?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Max_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  room_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Min_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  room_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_clinicianschedule". */
export type Ehr_Clinicianschedule_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_clinical_time?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  room_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  work_from_home?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_clinicianschedule" */
export enum Ehr_Clinicianschedule_Select_Column {
  /** column name */
  ClinicId = 'clinic_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayOfWeek = 'day_of_week',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsClinicalTime = 'is_clinical_time',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  RoomNumber = 'room_number',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  WorkFromHome = 'work_from_home'
}

/** order by stddev() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Stddev_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Stddev_Pop_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Stddev_Samp_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Clinicianschedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Clinicianschedule_Stream_Cursor_Value_Input = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day_of_week?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  end_time?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['Int']>;
  is_clinical_time?: InputMaybe<Scalars['Boolean']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  room_number?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  start_time?: InputMaybe<Scalars['time']>;
  work_from_home?: InputMaybe<Scalars['Boolean']>;
};

/** order by sum() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Sum_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Var_Pop_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Var_Samp_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_clinicianschedule" */
export type Ehr_Clinicianschedule_Variance_Order_By = {
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_cliniciantag" */
export type Ehr_Cliniciantag = {
  __typename?: 'ehr_cliniciantag';
  _deleted: Scalars['Boolean'];
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_cliniciantag_ehr_clinician: Ehr_Clinician;
  /** An object relationship */
  ehr_cliniciantag_ehr_tag: Ehr_Tag;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  modified_at: Scalars['timestamptz'];
  prefer_not_to_treat: Scalars['Boolean'];
  tag_id: Scalars['Int'];
  version: Scalars['Int'];
  weight: Scalars['float8'];
};


/** columns and relationships of "ehr_cliniciantag" */
export type Ehr_CliniciantagMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_cliniciantag". All fields are combined with a logical 'AND'. */
export type Ehr_Cliniciantag_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Cliniciantag_Bool_Exp>>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Cliniciantag_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Cliniciantag_Bool_Exp>>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_cliniciantag_ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  ehr_cliniciantag_ehr_tag?: InputMaybe<Ehr_Tag_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  prefer_not_to_treat?: InputMaybe<Boolean_Comparison_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
  weight?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_cliniciantag". */
export type Ehr_Cliniciantag_Order_By = {
  _deleted?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_cliniciantag_ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  ehr_cliniciantag_ehr_tag?: InputMaybe<Ehr_Tag_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  prefer_not_to_treat?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_cliniciantag" */
export enum Ehr_Cliniciantag_Select_Column {
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  PreferNotToTreat = 'prefer_not_to_treat',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  Version = 'version',
  /** column name */
  Weight = 'weight'
}

/** Streaming cursor of the table "ehr_cliniciantag" */
export type Ehr_Cliniciantag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Cliniciantag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Cliniciantag_Stream_Cursor_Value_Input = {
  _deleted?: InputMaybe<Scalars['Boolean']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  prefer_not_to_treat?: InputMaybe<Scalars['Boolean']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "ehr_cliniciantask" */
export type Ehr_Cliniciantask = {
  __typename?: 'ehr_cliniciantask';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_clinician: Ehr_Clinician;
  event_id?: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  task_sub_type?: Maybe<Scalars['String']>;
  task_type: Scalars['String'];
};


/** columns and relationships of "ehr_cliniciantask" */
export type Ehr_CliniciantaskMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_cliniciantask". All fields are combined with a logical 'AND'. */
export type Ehr_Cliniciantask_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Cliniciantask_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Cliniciantask_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Cliniciantask_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  task_sub_type?: InputMaybe<String_Comparison_Exp>;
  task_type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_cliniciantask". */
export type Ehr_Cliniciantask_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_sub_type?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_cliniciantask" */
export enum Ehr_Cliniciantask_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Status = 'status',
  /** column name */
  TaskSubType = 'task_sub_type',
  /** column name */
  TaskType = 'task_type'
}

/** Streaming cursor of the table "ehr_cliniciantask" */
export type Ehr_Cliniciantask_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Cliniciantask_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Cliniciantask_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  task_sub_type?: InputMaybe<Scalars['String']>;
  task_type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_configuration" */
export type Ehr_Configuration = {
  __typename?: 'ehr_configuration';
  acuity_event_intake_enabled: Scalars['String'];
  acuity_event_outbound_enabled: Scalars['String'];
  aqm_iteration_chunk_size: Scalars['Int'];
  billing_insurance_hybrid_care_enabled: Scalars['Boolean'];
  billing_v2_parameters: Scalars['jsonb'];
  cfa_feature_flag: Scalars['jsonb'];
  client_broadcast_enabled: Scalars['Boolean'];
  client_timeline_enabled: Scalars['String'];
  confirmation_email_source: Scalars['String'];
  couples_booking_link_enabled: Scalars['Boolean'];
  couples_mbc_enabled: Scalars['String'];
  covid_force_teletherapy: Scalars['Boolean'];
  covid_gcal_teletherapy_cutoff_date?: Maybe<Scalars['date']>;
  covid_use_teletherapy_match_copy: Scalars['Boolean'];
  disable_client_emails_for_new_booking_flow: Scalars['Boolean'];
  event_broadcast_enabled: Scalars['Boolean'];
  event_reconciler_enabled: Scalars['String'];
  feature_flags: Scalars['jsonb'];
  freshpaint_to_leadsquared_enabled: Scalars['Boolean'];
  gcal_custodian_enabled: Scalars['String'];
  gcal_inbound_enabled: Scalars['String'];
  gcal_teletherapy_outbound_enabled: Scalars['String'];
  healthie_care_team_sync: Scalars['Boolean'];
  healthie_client_address_broadcast: Scalars['Boolean'];
  healthie_client_profile_broadcast: Scalars['Boolean'];
  healthie_clinician_incremental_sync_enabled: Scalars['Boolean'];
  healthie_disable_client_field_editing: Scalars['Boolean'];
  healthie_emergency_contact_broadcast: Scalars['Boolean'];
  healthie_patient_broadcast_enabled: Scalars['Boolean'];
  healthie_patient_incremental_sync_enabled: Scalars['Boolean'];
  healthie_send_clinician_tasks: Scalars['Boolean'];
  healthie_ui_enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  include_zoom_conferencing_enabled: Scalars['String'];
  insurance_based_cpsrs_enabled: Scalars['Boolean'];
  is_sending_group_enrollment_emails_with_mailgun: Scalars['Boolean'];
  is_sending_groups_intake_link_with_token: Scalars['Boolean'];
  is_using_is_triage_consults: Scalars['Boolean'];
  leadsquared_referral_outbound: Scalars['String'];
  mbc_2_consults_enabled: Scalars['String'];
  mbc_2_couples_enabled: Scalars['String'];
  mbc_2_group_enabled: Scalars['String'];
  mbc_2_individual_enabled: Scalars['String'];
  mhqol_enabled: Scalars['Boolean'];
  payment_manager_billing_dry_run_enabled: Scalars['Boolean'];
  payment_manager_calculate_charges_version: Scalars['String'];
  payment_manager_celery_job_enabled: Scalars['Boolean'];
  payment_manager_perform_qa_version: Scalars['String'];
  pricing_version: Scalars['String'];
  roofdog_enabled: Scalars['Boolean'];
  send_client_profile_reminder_emails: Scalars['Boolean'];
  send_pending_match_reminder_emails: Scalars['Boolean'];
  send_reminder_emails: Scalars['String'];
  swacc_event_intake_enabled: Scalars['String'];
  use_realtime_webhooks_for_cdts: Scalars['Boolean'];
  use_wheel_in_weekly_volumes: Scalars['Boolean'];
  use_zoom_for_consults: Scalars['Boolean'];
  welkin8_address_incremental_sync_enabled: Scalars['Boolean'];
  welkin8_broadcast_enabled: Scalars['Boolean'];
  welkin8_cdt_creation_enabled: Scalars['Boolean'];
  welkin8_client_screening_questions_incremental_sync_enabled: Scalars['Boolean'];
  welkin8_consult_note_sync_enabled: Scalars['Boolean'];
  welkin8_emergency_contact_incremental_sync_enabled: Scalars['Boolean'];
  welkin8_encounter_incremental_sync_enabled: Scalars['Boolean'];
  welkin8_group_encounter_incremental_sync_enabled: Scalars['Boolean'];
  welkin8_inbound_sync_enabled: Scalars['Boolean'];
  welkin8_integration_test_enabled: Scalars['Boolean'];
  welkin8_patient_incremental_sync_enabled: Scalars['Boolean'];
  welkin_assessment_intake_enabled: Scalars['String'];
  welkin_assessment_outbound_enabled: Scalars['String'];
  welkin_cdt_intake_enabled: Scalars['String'];
  welkin_cdt_outbound_enabled: Scalars['String'];
  welkin_cdt_process_recurrences_enabled: Scalars['String'];
  welkin_cdt_recurrences_sends_messages_to_ers_enabled: Scalars['String'];
  welkin_client_emergency_contact_outbound_enabled: Scalars['String'];
  welkin_conversation_intake_enabled: Scalars['String'];
  welkin_email_address_inbound_enabled: Scalars['String'];
  welkin_email_intake_enabled: Scalars['String'];
  welkin_event_intake_enabled: Scalars['String'];
  welkin_event_outbound_enabled: Scalars['String'];
  welkin_patient_inbound_enabled: Scalars['String'];
  welkin_phone_number_inbound_enabled: Scalars['String'];
  wheel_ers_post_update_enabled: Scalars['String'];
  wheel_parameters: Scalars['jsonb'];
};


/** columns and relationships of "ehr_configuration" */
export type Ehr_ConfigurationBilling_V2_ParametersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_configuration" */
export type Ehr_ConfigurationCfa_Feature_FlagArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_configuration" */
export type Ehr_ConfigurationFeature_FlagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_configuration" */
export type Ehr_ConfigurationWheel_ParametersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_configuration". All fields are combined with a logical 'AND'. */
export type Ehr_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Configuration_Bool_Exp>>;
  acuity_event_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  acuity_event_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  aqm_iteration_chunk_size?: InputMaybe<Int_Comparison_Exp>;
  billing_insurance_hybrid_care_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  billing_v2_parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  cfa_feature_flag?: InputMaybe<Jsonb_Comparison_Exp>;
  client_broadcast_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  client_timeline_enabled?: InputMaybe<String_Comparison_Exp>;
  confirmation_email_source?: InputMaybe<String_Comparison_Exp>;
  couples_booking_link_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  couples_mbc_enabled?: InputMaybe<String_Comparison_Exp>;
  covid_force_teletherapy?: InputMaybe<Boolean_Comparison_Exp>;
  covid_gcal_teletherapy_cutoff_date?: InputMaybe<Date_Comparison_Exp>;
  covid_use_teletherapy_match_copy?: InputMaybe<Boolean_Comparison_Exp>;
  disable_client_emails_for_new_booking_flow?: InputMaybe<Boolean_Comparison_Exp>;
  event_broadcast_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  event_reconciler_enabled?: InputMaybe<String_Comparison_Exp>;
  feature_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  freshpaint_to_leadsquared_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  gcal_custodian_enabled?: InputMaybe<String_Comparison_Exp>;
  gcal_inbound_enabled?: InputMaybe<String_Comparison_Exp>;
  gcal_teletherapy_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  healthie_care_team_sync?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_client_address_broadcast?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_client_profile_broadcast?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_clinician_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_disable_client_field_editing?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_emergency_contact_broadcast?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_patient_broadcast_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_patient_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_send_clinician_tasks?: InputMaybe<Boolean_Comparison_Exp>;
  healthie_ui_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_zoom_conferencing_enabled?: InputMaybe<String_Comparison_Exp>;
  insurance_based_cpsrs_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_sending_group_enrollment_emails_with_mailgun?: InputMaybe<Boolean_Comparison_Exp>;
  is_sending_groups_intake_link_with_token?: InputMaybe<Boolean_Comparison_Exp>;
  is_using_is_triage_consults?: InputMaybe<Boolean_Comparison_Exp>;
  leadsquared_referral_outbound?: InputMaybe<String_Comparison_Exp>;
  mbc_2_consults_enabled?: InputMaybe<String_Comparison_Exp>;
  mbc_2_couples_enabled?: InputMaybe<String_Comparison_Exp>;
  mbc_2_group_enabled?: InputMaybe<String_Comparison_Exp>;
  mbc_2_individual_enabled?: InputMaybe<String_Comparison_Exp>;
  mhqol_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  payment_manager_billing_dry_run_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  payment_manager_calculate_charges_version?: InputMaybe<String_Comparison_Exp>;
  payment_manager_celery_job_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  payment_manager_perform_qa_version?: InputMaybe<String_Comparison_Exp>;
  pricing_version?: InputMaybe<String_Comparison_Exp>;
  roofdog_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  send_client_profile_reminder_emails?: InputMaybe<Boolean_Comparison_Exp>;
  send_pending_match_reminder_emails?: InputMaybe<Boolean_Comparison_Exp>;
  send_reminder_emails?: InputMaybe<String_Comparison_Exp>;
  swacc_event_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  use_realtime_webhooks_for_cdts?: InputMaybe<Boolean_Comparison_Exp>;
  use_wheel_in_weekly_volumes?: InputMaybe<Boolean_Comparison_Exp>;
  use_zoom_for_consults?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_address_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_broadcast_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_cdt_creation_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_client_screening_questions_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_consult_note_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_emergency_contact_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_encounter_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_group_encounter_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_inbound_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_integration_test_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin8_patient_incremental_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  welkin_assessment_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_assessment_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_cdt_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_cdt_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_cdt_process_recurrences_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_cdt_recurrences_sends_messages_to_ers_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_client_emergency_contact_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_conversation_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_email_address_inbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_email_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_event_intake_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_event_outbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_patient_inbound_enabled?: InputMaybe<String_Comparison_Exp>;
  welkin_phone_number_inbound_enabled?: InputMaybe<String_Comparison_Exp>;
  wheel_ers_post_update_enabled?: InputMaybe<String_Comparison_Exp>;
  wheel_parameters?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_configuration". */
export type Ehr_Configuration_Order_By = {
  acuity_event_intake_enabled?: InputMaybe<Order_By>;
  acuity_event_outbound_enabled?: InputMaybe<Order_By>;
  aqm_iteration_chunk_size?: InputMaybe<Order_By>;
  billing_insurance_hybrid_care_enabled?: InputMaybe<Order_By>;
  billing_v2_parameters?: InputMaybe<Order_By>;
  cfa_feature_flag?: InputMaybe<Order_By>;
  client_broadcast_enabled?: InputMaybe<Order_By>;
  client_timeline_enabled?: InputMaybe<Order_By>;
  confirmation_email_source?: InputMaybe<Order_By>;
  couples_booking_link_enabled?: InputMaybe<Order_By>;
  couples_mbc_enabled?: InputMaybe<Order_By>;
  covid_force_teletherapy?: InputMaybe<Order_By>;
  covid_gcal_teletherapy_cutoff_date?: InputMaybe<Order_By>;
  covid_use_teletherapy_match_copy?: InputMaybe<Order_By>;
  disable_client_emails_for_new_booking_flow?: InputMaybe<Order_By>;
  event_broadcast_enabled?: InputMaybe<Order_By>;
  event_reconciler_enabled?: InputMaybe<Order_By>;
  feature_flags?: InputMaybe<Order_By>;
  freshpaint_to_leadsquared_enabled?: InputMaybe<Order_By>;
  gcal_custodian_enabled?: InputMaybe<Order_By>;
  gcal_inbound_enabled?: InputMaybe<Order_By>;
  gcal_teletherapy_outbound_enabled?: InputMaybe<Order_By>;
  healthie_care_team_sync?: InputMaybe<Order_By>;
  healthie_client_address_broadcast?: InputMaybe<Order_By>;
  healthie_client_profile_broadcast?: InputMaybe<Order_By>;
  healthie_clinician_incremental_sync_enabled?: InputMaybe<Order_By>;
  healthie_disable_client_field_editing?: InputMaybe<Order_By>;
  healthie_emergency_contact_broadcast?: InputMaybe<Order_By>;
  healthie_patient_broadcast_enabled?: InputMaybe<Order_By>;
  healthie_patient_incremental_sync_enabled?: InputMaybe<Order_By>;
  healthie_send_clinician_tasks?: InputMaybe<Order_By>;
  healthie_ui_enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_zoom_conferencing_enabled?: InputMaybe<Order_By>;
  insurance_based_cpsrs_enabled?: InputMaybe<Order_By>;
  is_sending_group_enrollment_emails_with_mailgun?: InputMaybe<Order_By>;
  is_sending_groups_intake_link_with_token?: InputMaybe<Order_By>;
  is_using_is_triage_consults?: InputMaybe<Order_By>;
  leadsquared_referral_outbound?: InputMaybe<Order_By>;
  mbc_2_consults_enabled?: InputMaybe<Order_By>;
  mbc_2_couples_enabled?: InputMaybe<Order_By>;
  mbc_2_group_enabled?: InputMaybe<Order_By>;
  mbc_2_individual_enabled?: InputMaybe<Order_By>;
  mhqol_enabled?: InputMaybe<Order_By>;
  payment_manager_billing_dry_run_enabled?: InputMaybe<Order_By>;
  payment_manager_calculate_charges_version?: InputMaybe<Order_By>;
  payment_manager_celery_job_enabled?: InputMaybe<Order_By>;
  payment_manager_perform_qa_version?: InputMaybe<Order_By>;
  pricing_version?: InputMaybe<Order_By>;
  roofdog_enabled?: InputMaybe<Order_By>;
  send_client_profile_reminder_emails?: InputMaybe<Order_By>;
  send_pending_match_reminder_emails?: InputMaybe<Order_By>;
  send_reminder_emails?: InputMaybe<Order_By>;
  swacc_event_intake_enabled?: InputMaybe<Order_By>;
  use_realtime_webhooks_for_cdts?: InputMaybe<Order_By>;
  use_wheel_in_weekly_volumes?: InputMaybe<Order_By>;
  use_zoom_for_consults?: InputMaybe<Order_By>;
  welkin8_address_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin8_broadcast_enabled?: InputMaybe<Order_By>;
  welkin8_cdt_creation_enabled?: InputMaybe<Order_By>;
  welkin8_client_screening_questions_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin8_consult_note_sync_enabled?: InputMaybe<Order_By>;
  welkin8_emergency_contact_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin8_encounter_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin8_group_encounter_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin8_inbound_sync_enabled?: InputMaybe<Order_By>;
  welkin8_integration_test_enabled?: InputMaybe<Order_By>;
  welkin8_patient_incremental_sync_enabled?: InputMaybe<Order_By>;
  welkin_assessment_intake_enabled?: InputMaybe<Order_By>;
  welkin_assessment_outbound_enabled?: InputMaybe<Order_By>;
  welkin_cdt_intake_enabled?: InputMaybe<Order_By>;
  welkin_cdt_outbound_enabled?: InputMaybe<Order_By>;
  welkin_cdt_process_recurrences_enabled?: InputMaybe<Order_By>;
  welkin_cdt_recurrences_sends_messages_to_ers_enabled?: InputMaybe<Order_By>;
  welkin_client_emergency_contact_outbound_enabled?: InputMaybe<Order_By>;
  welkin_conversation_intake_enabled?: InputMaybe<Order_By>;
  welkin_email_address_inbound_enabled?: InputMaybe<Order_By>;
  welkin_email_intake_enabled?: InputMaybe<Order_By>;
  welkin_event_intake_enabled?: InputMaybe<Order_By>;
  welkin_event_outbound_enabled?: InputMaybe<Order_By>;
  welkin_patient_inbound_enabled?: InputMaybe<Order_By>;
  welkin_phone_number_inbound_enabled?: InputMaybe<Order_By>;
  wheel_ers_post_update_enabled?: InputMaybe<Order_By>;
  wheel_parameters?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_configuration" */
export enum Ehr_Configuration_Select_Column {
  /** column name */
  AcuityEventIntakeEnabled = 'acuity_event_intake_enabled',
  /** column name */
  AcuityEventOutboundEnabled = 'acuity_event_outbound_enabled',
  /** column name */
  AqmIterationChunkSize = 'aqm_iteration_chunk_size',
  /** column name */
  BillingInsuranceHybridCareEnabled = 'billing_insurance_hybrid_care_enabled',
  /** column name */
  BillingV2Parameters = 'billing_v2_parameters',
  /** column name */
  CfaFeatureFlag = 'cfa_feature_flag',
  /** column name */
  ClientBroadcastEnabled = 'client_broadcast_enabled',
  /** column name */
  ClientTimelineEnabled = 'client_timeline_enabled',
  /** column name */
  ConfirmationEmailSource = 'confirmation_email_source',
  /** column name */
  CouplesBookingLinkEnabled = 'couples_booking_link_enabled',
  /** column name */
  CouplesMbcEnabled = 'couples_mbc_enabled',
  /** column name */
  CovidForceTeletherapy = 'covid_force_teletherapy',
  /** column name */
  CovidGcalTeletherapyCutoffDate = 'covid_gcal_teletherapy_cutoff_date',
  /** column name */
  CovidUseTeletherapyMatchCopy = 'covid_use_teletherapy_match_copy',
  /** column name */
  DisableClientEmailsForNewBookingFlow = 'disable_client_emails_for_new_booking_flow',
  /** column name */
  EventBroadcastEnabled = 'event_broadcast_enabled',
  /** column name */
  EventReconcilerEnabled = 'event_reconciler_enabled',
  /** column name */
  FeatureFlags = 'feature_flags',
  /** column name */
  FreshpaintToLeadsquaredEnabled = 'freshpaint_to_leadsquared_enabled',
  /** column name */
  GcalCustodianEnabled = 'gcal_custodian_enabled',
  /** column name */
  GcalInboundEnabled = 'gcal_inbound_enabled',
  /** column name */
  GcalTeletherapyOutboundEnabled = 'gcal_teletherapy_outbound_enabled',
  /** column name */
  HealthieCareTeamSync = 'healthie_care_team_sync',
  /** column name */
  HealthieClientAddressBroadcast = 'healthie_client_address_broadcast',
  /** column name */
  HealthieClientProfileBroadcast = 'healthie_client_profile_broadcast',
  /** column name */
  HealthieClinicianIncrementalSyncEnabled = 'healthie_clinician_incremental_sync_enabled',
  /** column name */
  HealthieDisableClientFieldEditing = 'healthie_disable_client_field_editing',
  /** column name */
  HealthieEmergencyContactBroadcast = 'healthie_emergency_contact_broadcast',
  /** column name */
  HealthiePatientBroadcastEnabled = 'healthie_patient_broadcast_enabled',
  /** column name */
  HealthiePatientIncrementalSyncEnabled = 'healthie_patient_incremental_sync_enabled',
  /** column name */
  HealthieSendClinicianTasks = 'healthie_send_clinician_tasks',
  /** column name */
  HealthieUiEnabled = 'healthie_ui_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeZoomConferencingEnabled = 'include_zoom_conferencing_enabled',
  /** column name */
  InsuranceBasedCpsrsEnabled = 'insurance_based_cpsrs_enabled',
  /** column name */
  IsSendingGroupEnrollmentEmailsWithMailgun = 'is_sending_group_enrollment_emails_with_mailgun',
  /** column name */
  IsSendingGroupsIntakeLinkWithToken = 'is_sending_groups_intake_link_with_token',
  /** column name */
  IsUsingIsTriageConsults = 'is_using_is_triage_consults',
  /** column name */
  LeadsquaredReferralOutbound = 'leadsquared_referral_outbound',
  /** column name */
  Mbc_2ConsultsEnabled = 'mbc_2_consults_enabled',
  /** column name */
  Mbc_2CouplesEnabled = 'mbc_2_couples_enabled',
  /** column name */
  Mbc_2GroupEnabled = 'mbc_2_group_enabled',
  /** column name */
  Mbc_2IndividualEnabled = 'mbc_2_individual_enabled',
  /** column name */
  MhqolEnabled = 'mhqol_enabled',
  /** column name */
  PaymentManagerBillingDryRunEnabled = 'payment_manager_billing_dry_run_enabled',
  /** column name */
  PaymentManagerCalculateChargesVersion = 'payment_manager_calculate_charges_version',
  /** column name */
  PaymentManagerCeleryJobEnabled = 'payment_manager_celery_job_enabled',
  /** column name */
  PaymentManagerPerformQaVersion = 'payment_manager_perform_qa_version',
  /** column name */
  PricingVersion = 'pricing_version',
  /** column name */
  RoofdogEnabled = 'roofdog_enabled',
  /** column name */
  SendClientProfileReminderEmails = 'send_client_profile_reminder_emails',
  /** column name */
  SendPendingMatchReminderEmails = 'send_pending_match_reminder_emails',
  /** column name */
  SendReminderEmails = 'send_reminder_emails',
  /** column name */
  SwaccEventIntakeEnabled = 'swacc_event_intake_enabled',
  /** column name */
  UseRealtimeWebhooksForCdts = 'use_realtime_webhooks_for_cdts',
  /** column name */
  UseWheelInWeeklyVolumes = 'use_wheel_in_weekly_volumes',
  /** column name */
  UseZoomForConsults = 'use_zoom_for_consults',
  /** column name */
  Welkin8AddressIncrementalSyncEnabled = 'welkin8_address_incremental_sync_enabled',
  /** column name */
  Welkin8BroadcastEnabled = 'welkin8_broadcast_enabled',
  /** column name */
  Welkin8CdtCreationEnabled = 'welkin8_cdt_creation_enabled',
  /** column name */
  Welkin8ClientScreeningQuestionsIncrementalSyncEnabled = 'welkin8_client_screening_questions_incremental_sync_enabled',
  /** column name */
  Welkin8ConsultNoteSyncEnabled = 'welkin8_consult_note_sync_enabled',
  /** column name */
  Welkin8EmergencyContactIncrementalSyncEnabled = 'welkin8_emergency_contact_incremental_sync_enabled',
  /** column name */
  Welkin8EncounterIncrementalSyncEnabled = 'welkin8_encounter_incremental_sync_enabled',
  /** column name */
  Welkin8GroupEncounterIncrementalSyncEnabled = 'welkin8_group_encounter_incremental_sync_enabled',
  /** column name */
  Welkin8InboundSyncEnabled = 'welkin8_inbound_sync_enabled',
  /** column name */
  Welkin8IntegrationTestEnabled = 'welkin8_integration_test_enabled',
  /** column name */
  Welkin8PatientIncrementalSyncEnabled = 'welkin8_patient_incremental_sync_enabled',
  /** column name */
  WelkinAssessmentIntakeEnabled = 'welkin_assessment_intake_enabled',
  /** column name */
  WelkinAssessmentOutboundEnabled = 'welkin_assessment_outbound_enabled',
  /** column name */
  WelkinCdtIntakeEnabled = 'welkin_cdt_intake_enabled',
  /** column name */
  WelkinCdtOutboundEnabled = 'welkin_cdt_outbound_enabled',
  /** column name */
  WelkinCdtProcessRecurrencesEnabled = 'welkin_cdt_process_recurrences_enabled',
  /** column name */
  WelkinCdtRecurrencesSendsMessagesToErsEnabled = 'welkin_cdt_recurrences_sends_messages_to_ers_enabled',
  /** column name */
  WelkinClientEmergencyContactOutboundEnabled = 'welkin_client_emergency_contact_outbound_enabled',
  /** column name */
  WelkinConversationIntakeEnabled = 'welkin_conversation_intake_enabled',
  /** column name */
  WelkinEmailAddressInboundEnabled = 'welkin_email_address_inbound_enabled',
  /** column name */
  WelkinEmailIntakeEnabled = 'welkin_email_intake_enabled',
  /** column name */
  WelkinEventIntakeEnabled = 'welkin_event_intake_enabled',
  /** column name */
  WelkinEventOutboundEnabled = 'welkin_event_outbound_enabled',
  /** column name */
  WelkinPatientInboundEnabled = 'welkin_patient_inbound_enabled',
  /** column name */
  WelkinPhoneNumberInboundEnabled = 'welkin_phone_number_inbound_enabled',
  /** column name */
  WheelErsPostUpdateEnabled = 'wheel_ers_post_update_enabled',
  /** column name */
  WheelParameters = 'wheel_parameters'
}

/** Streaming cursor of the table "ehr_configuration" */
export type Ehr_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Configuration_Stream_Cursor_Value_Input = {
  acuity_event_intake_enabled?: InputMaybe<Scalars['String']>;
  acuity_event_outbound_enabled?: InputMaybe<Scalars['String']>;
  aqm_iteration_chunk_size?: InputMaybe<Scalars['Int']>;
  billing_insurance_hybrid_care_enabled?: InputMaybe<Scalars['Boolean']>;
  billing_v2_parameters?: InputMaybe<Scalars['jsonb']>;
  cfa_feature_flag?: InputMaybe<Scalars['jsonb']>;
  client_broadcast_enabled?: InputMaybe<Scalars['Boolean']>;
  client_timeline_enabled?: InputMaybe<Scalars['String']>;
  confirmation_email_source?: InputMaybe<Scalars['String']>;
  couples_booking_link_enabled?: InputMaybe<Scalars['Boolean']>;
  couples_mbc_enabled?: InputMaybe<Scalars['String']>;
  covid_force_teletherapy?: InputMaybe<Scalars['Boolean']>;
  covid_gcal_teletherapy_cutoff_date?: InputMaybe<Scalars['date']>;
  covid_use_teletherapy_match_copy?: InputMaybe<Scalars['Boolean']>;
  disable_client_emails_for_new_booking_flow?: InputMaybe<Scalars['Boolean']>;
  event_broadcast_enabled?: InputMaybe<Scalars['Boolean']>;
  event_reconciler_enabled?: InputMaybe<Scalars['String']>;
  feature_flags?: InputMaybe<Scalars['jsonb']>;
  freshpaint_to_leadsquared_enabled?: InputMaybe<Scalars['Boolean']>;
  gcal_custodian_enabled?: InputMaybe<Scalars['String']>;
  gcal_inbound_enabled?: InputMaybe<Scalars['String']>;
  gcal_teletherapy_outbound_enabled?: InputMaybe<Scalars['String']>;
  healthie_care_team_sync?: InputMaybe<Scalars['Boolean']>;
  healthie_client_address_broadcast?: InputMaybe<Scalars['Boolean']>;
  healthie_client_profile_broadcast?: InputMaybe<Scalars['Boolean']>;
  healthie_clinician_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  healthie_disable_client_field_editing?: InputMaybe<Scalars['Boolean']>;
  healthie_emergency_contact_broadcast?: InputMaybe<Scalars['Boolean']>;
  healthie_patient_broadcast_enabled?: InputMaybe<Scalars['Boolean']>;
  healthie_patient_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  healthie_send_clinician_tasks?: InputMaybe<Scalars['Boolean']>;
  healthie_ui_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_zoom_conferencing_enabled?: InputMaybe<Scalars['String']>;
  insurance_based_cpsrs_enabled?: InputMaybe<Scalars['Boolean']>;
  is_sending_group_enrollment_emails_with_mailgun?: InputMaybe<Scalars['Boolean']>;
  is_sending_groups_intake_link_with_token?: InputMaybe<Scalars['Boolean']>;
  is_using_is_triage_consults?: InputMaybe<Scalars['Boolean']>;
  leadsquared_referral_outbound?: InputMaybe<Scalars['String']>;
  mbc_2_consults_enabled?: InputMaybe<Scalars['String']>;
  mbc_2_couples_enabled?: InputMaybe<Scalars['String']>;
  mbc_2_group_enabled?: InputMaybe<Scalars['String']>;
  mbc_2_individual_enabled?: InputMaybe<Scalars['String']>;
  mhqol_enabled?: InputMaybe<Scalars['Boolean']>;
  payment_manager_billing_dry_run_enabled?: InputMaybe<Scalars['Boolean']>;
  payment_manager_calculate_charges_version?: InputMaybe<Scalars['String']>;
  payment_manager_celery_job_enabled?: InputMaybe<Scalars['Boolean']>;
  payment_manager_perform_qa_version?: InputMaybe<Scalars['String']>;
  pricing_version?: InputMaybe<Scalars['String']>;
  roofdog_enabled?: InputMaybe<Scalars['Boolean']>;
  send_client_profile_reminder_emails?: InputMaybe<Scalars['Boolean']>;
  send_pending_match_reminder_emails?: InputMaybe<Scalars['Boolean']>;
  send_reminder_emails?: InputMaybe<Scalars['String']>;
  swacc_event_intake_enabled?: InputMaybe<Scalars['String']>;
  use_realtime_webhooks_for_cdts?: InputMaybe<Scalars['Boolean']>;
  use_wheel_in_weekly_volumes?: InputMaybe<Scalars['Boolean']>;
  use_zoom_for_consults?: InputMaybe<Scalars['Boolean']>;
  welkin8_address_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_broadcast_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_cdt_creation_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_client_screening_questions_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_consult_note_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_emergency_contact_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_encounter_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_group_encounter_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_inbound_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_integration_test_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin8_patient_incremental_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  welkin_assessment_intake_enabled?: InputMaybe<Scalars['String']>;
  welkin_assessment_outbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_cdt_intake_enabled?: InputMaybe<Scalars['String']>;
  welkin_cdt_outbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_cdt_process_recurrences_enabled?: InputMaybe<Scalars['String']>;
  welkin_cdt_recurrences_sends_messages_to_ers_enabled?: InputMaybe<Scalars['String']>;
  welkin_client_emergency_contact_outbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_conversation_intake_enabled?: InputMaybe<Scalars['String']>;
  welkin_email_address_inbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_email_intake_enabled?: InputMaybe<Scalars['String']>;
  welkin_event_intake_enabled?: InputMaybe<Scalars['String']>;
  welkin_event_outbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_patient_inbound_enabled?: InputMaybe<Scalars['String']>;
  welkin_phone_number_inbound_enabled?: InputMaybe<Scalars['String']>;
  wheel_ers_post_update_enabled?: InputMaybe<Scalars['String']>;
  wheel_parameters?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "ehr_consulttool" */
export type Ehr_Consulttool = {
  __typename?: 'ehr_consulttool';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  address_confirmed?: Maybe<Scalars['String']>;
  address_location?: Maybe<Scalars['jsonb']>;
  assessment_plan?: Maybe<Scalars['jsonb']>;
  assessment_tab_data?: Maybe<Scalars['jsonb']>;
  assessments?: Maybe<Scalars['jsonb']>;
  assessments_completed_at?: Maybe<Scalars['timestamptz']>;
  assessments_started_at?: Maybe<Scalars['timestamptz']>;
  client_id: Scalars['Int'];
  clinician_id?: Maybe<Scalars['Int']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  consent_confidentiality_confirmed?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  emergency_contact_confirmed?: Maybe<Scalars['String']>;
  event_id: Scalars['uuid'];
  generated_copy?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  identity_contact_status?: Maybe<Scalars['String']>;
  is_high_acuity?: Maybe<Scalars['Boolean']>;
  is_test_data: Scalars['Boolean'];
  mbc_raw_data?: Maybe<Scalars['jsonb']>;
  physical_location_confirmed?: Maybe<Scalars['String']>;
  primary_problem?: Maybe<Scalars['String']>;
  problems?: Maybe<Scalars['jsonb']>;
  risks?: Maybe<Scalars['jsonb']>;
  secondary_problem?: Maybe<Scalars['String']>;
  skip_therapy_match_queue: Scalars['Boolean'];
  terminated_early: Scalars['Boolean'];
  termination_reason?: Maybe<Scalars['String']>;
  treatment_goal_one?: Maybe<Scalars['String']>;
  treatment_goal_two?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolAddress_LocationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolAssessment_PlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolAssessment_Tab_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolAssessmentsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolMbc_Raw_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolProblemsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_consulttool" */
export type Ehr_ConsulttoolRisksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_consulttool" */
export type Ehr_Consulttool_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Consulttool_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Consulttool_Max_Order_By>;
  min?: InputMaybe<Ehr_Consulttool_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Consulttool_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Consulttool_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Consulttool_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Consulttool_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Consulttool_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Consulttool_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Consulttool_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_consulttool". All fields are combined with a logical 'AND'. */
export type Ehr_Consulttool_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Consulttool_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Consulttool_Bool_Exp>>;
  address_confirmed?: InputMaybe<String_Comparison_Exp>;
  address_location?: InputMaybe<Jsonb_Comparison_Exp>;
  assessment_plan?: InputMaybe<Jsonb_Comparison_Exp>;
  assessment_tab_data?: InputMaybe<Jsonb_Comparison_Exp>;
  assessments?: InputMaybe<Jsonb_Comparison_Exp>;
  assessments_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  assessments_started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  consent_confidentiality_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emergency_contact_confirmed?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  generated_copy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identity_contact_status?: InputMaybe<String_Comparison_Exp>;
  is_high_acuity?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  mbc_raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  physical_location_confirmed?: InputMaybe<String_Comparison_Exp>;
  primary_problem?: InputMaybe<String_Comparison_Exp>;
  problems?: InputMaybe<Jsonb_Comparison_Exp>;
  risks?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_problem?: InputMaybe<String_Comparison_Exp>;
  skip_therapy_match_queue?: InputMaybe<Boolean_Comparison_Exp>;
  terminated_early?: InputMaybe<Boolean_Comparison_Exp>;
  termination_reason?: InputMaybe<String_Comparison_Exp>;
  treatment_goal_one?: InputMaybe<String_Comparison_Exp>;
  treatment_goal_two?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  address_confirmed?: InputMaybe<Order_By>;
  assessments_completed_at?: InputMaybe<Order_By>;
  assessments_started_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emergency_contact_confirmed?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  generated_copy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_contact_status?: InputMaybe<Order_By>;
  physical_location_confirmed?: InputMaybe<Order_By>;
  primary_problem?: InputMaybe<Order_By>;
  secondary_problem?: InputMaybe<Order_By>;
  termination_reason?: InputMaybe<Order_By>;
  treatment_goal_one?: InputMaybe<Order_By>;
  treatment_goal_two?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  address_confirmed?: InputMaybe<Order_By>;
  assessments_completed_at?: InputMaybe<Order_By>;
  assessments_started_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emergency_contact_confirmed?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  generated_copy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_contact_status?: InputMaybe<Order_By>;
  physical_location_confirmed?: InputMaybe<Order_By>;
  primary_problem?: InputMaybe<Order_By>;
  secondary_problem?: InputMaybe<Order_By>;
  termination_reason?: InputMaybe<Order_By>;
  treatment_goal_one?: InputMaybe<Order_By>;
  treatment_goal_two?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_consulttool". */
export type Ehr_Consulttool_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  address_confirmed?: InputMaybe<Order_By>;
  address_location?: InputMaybe<Order_By>;
  assessment_plan?: InputMaybe<Order_By>;
  assessment_tab_data?: InputMaybe<Order_By>;
  assessments?: InputMaybe<Order_By>;
  assessments_completed_at?: InputMaybe<Order_By>;
  assessments_started_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  consent_confidentiality_confirmed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emergency_contact_confirmed?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  generated_copy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_contact_status?: InputMaybe<Order_By>;
  is_high_acuity?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  mbc_raw_data?: InputMaybe<Order_By>;
  physical_location_confirmed?: InputMaybe<Order_By>;
  primary_problem?: InputMaybe<Order_By>;
  problems?: InputMaybe<Order_By>;
  risks?: InputMaybe<Order_By>;
  secondary_problem?: InputMaybe<Order_By>;
  skip_therapy_match_queue?: InputMaybe<Order_By>;
  terminated_early?: InputMaybe<Order_By>;
  termination_reason?: InputMaybe<Order_By>;
  treatment_goal_one?: InputMaybe<Order_By>;
  treatment_goal_two?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_consulttool" */
export enum Ehr_Consulttool_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AddressConfirmed = 'address_confirmed',
  /** column name */
  AddressLocation = 'address_location',
  /** column name */
  AssessmentPlan = 'assessment_plan',
  /** column name */
  AssessmentTabData = 'assessment_tab_data',
  /** column name */
  Assessments = 'assessments',
  /** column name */
  AssessmentsCompletedAt = 'assessments_completed_at',
  /** column name */
  AssessmentsStartedAt = 'assessments_started_at',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  ConsentConfidentialityConfirmed = 'consent_confidentiality_confirmed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmergencyContactConfirmed = 'emergency_contact_confirmed',
  /** column name */
  EventId = 'event_id',
  /** column name */
  GeneratedCopy = 'generated_copy',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityContactStatus = 'identity_contact_status',
  /** column name */
  IsHighAcuity = 'is_high_acuity',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  MbcRawData = 'mbc_raw_data',
  /** column name */
  PhysicalLocationConfirmed = 'physical_location_confirmed',
  /** column name */
  PrimaryProblem = 'primary_problem',
  /** column name */
  Problems = 'problems',
  /** column name */
  Risks = 'risks',
  /** column name */
  SecondaryProblem = 'secondary_problem',
  /** column name */
  SkipTherapyMatchQueue = 'skip_therapy_match_queue',
  /** column name */
  TerminatedEarly = 'terminated_early',
  /** column name */
  TerminationReason = 'termination_reason',
  /** column name */
  TreatmentGoalOne = 'treatment_goal_one',
  /** column name */
  TreatmentGoalTwo = 'treatment_goal_two',
  /** column name */
  Version = 'version'
}

/** order by stddev() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_consulttool" */
export type Ehr_Consulttool_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Consulttool_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Consulttool_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  address_confirmed?: InputMaybe<Scalars['String']>;
  address_location?: InputMaybe<Scalars['jsonb']>;
  assessment_plan?: InputMaybe<Scalars['jsonb']>;
  assessment_tab_data?: InputMaybe<Scalars['jsonb']>;
  assessments?: InputMaybe<Scalars['jsonb']>;
  assessments_completed_at?: InputMaybe<Scalars['timestamptz']>;
  assessments_started_at?: InputMaybe<Scalars['timestamptz']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  consent_confidentiality_confirmed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  emergency_contact_confirmed?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  generated_copy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  identity_contact_status?: InputMaybe<Scalars['String']>;
  is_high_acuity?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  mbc_raw_data?: InputMaybe<Scalars['jsonb']>;
  physical_location_confirmed?: InputMaybe<Scalars['String']>;
  primary_problem?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Scalars['jsonb']>;
  risks?: InputMaybe<Scalars['jsonb']>;
  secondary_problem?: InputMaybe<Scalars['String']>;
  skip_therapy_match_queue?: InputMaybe<Scalars['Boolean']>;
  terminated_early?: InputMaybe<Scalars['Boolean']>;
  termination_reason?: InputMaybe<Scalars['String']>;
  treatment_goal_one?: InputMaybe<Scalars['String']>;
  treatment_goal_two?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_consulttool" */
export type Ehr_Consulttool_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord = {
  __typename?: 'ehr_diagnosisrecord';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  couple_id?: Maybe<Scalars['uuid']>;
  diagnosis_codes?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  imported_client_name?: Maybe<Scalars['String']>;
  primary_diagnosis_code?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_diagnosisrecord" */
export type Ehr_DiagnosisrecordDiagnosis_CodesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Diagnosisrecord_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Diagnosisrecord_Max_Order_By>;
  min?: InputMaybe<Ehr_Diagnosisrecord_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Diagnosisrecord_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Diagnosisrecord_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Diagnosisrecord_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Diagnosisrecord_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Diagnosisrecord_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Diagnosisrecord_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Diagnosisrecord_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_diagnosisrecord". All fields are combined with a logical 'AND'. */
export type Ehr_Diagnosisrecord_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Diagnosisrecord_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Diagnosisrecord_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  diagnosis_codes?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_client_name?: InputMaybe<String_Comparison_Exp>;
  primary_diagnosis_code?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  primary_diagnosis_code?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  primary_diagnosis_code?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_diagnosisrecord". */
export type Ehr_Diagnosisrecord_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  diagnosis_codes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  primary_diagnosis_code?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_diagnosisrecord" */
export enum Ehr_Diagnosisrecord_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  DiagnosisCodes = 'diagnosis_codes',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedClientName = 'imported_client_name',
  /** column name */
  PrimaryDiagnosisCode = 'primary_diagnosis_code'
}

/** order by stddev() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Diagnosisrecord_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Diagnosisrecord_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  diagnosis_codes?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  imported_client_name?: InputMaybe<Scalars['String']>;
  primary_diagnosis_code?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_diagnosisrecord" */
export type Ehr_Diagnosisrecord_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_event" */
export type Ehr_Event = {
  __typename?: 'ehr_event';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  acuity_id?: Maybe<Scalars['Int']>;
  acuity_notes?: Maybe<Scalars['String']>;
  acuity_tombstone_id?: Maybe<Scalars['uuid']>;
  amount_paid_online?: Maybe<Scalars['numeric']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  certificate_code?: Maybe<Scalars['String']>;
  /** An object relationship */
  client?: Maybe<Ehr_Client>;
  client_id?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  clinician?: Maybe<Ehr_Clinician>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_week_id?: Maybe<Scalars['uuid']>;
  conferencing_provider?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  cost_client_rate?: Maybe<Scalars['numeric']>;
  cost_contracted_payer_rate?: Maybe<Scalars['numeric']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery?: Maybe<Scalars['String']>;
  do_not_bill?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  ehr_clientgroupevents: Array<Ehr_Clientgroupevent>;
  /** An array relationship */
  ehr_consulttools: Array<Ehr_Consulttool>;
  /** An array relationship */
  ehr_eventmbcstatus: Array<Ehr_Eventmbcstatus>;
  /** An array relationship */
  ehr_identitytokens: Array<Ehr_Identitytoken>;
  /** An array relationship */
  ehr_matches: Array<Ehr_Match>;
  end_time?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  gcal_unique_id?: Maybe<Scalars['String']>;
  gross_price?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  group?: Maybe<Ehr_Group>;
  group_id?: Maybe<Scalars['uuid']>;
  healthie_note_id?: Maybe<Scalars['String']>;
  hybrid_preference?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_appointment: Scalars['Boolean'];
  is_session: Scalars['Boolean'];
  is_test_data: Scalars['Boolean'];
  legacy_superbilled?: Maybe<Scalars['Boolean']>;
  managed_by_autoschedule?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  mbc_assessment_question_scores: Array<Mbc_Assessment_Question_Scores>;
  /** An object relationship */
  mbc_score?: Maybe<Mbc_Distinct_Scores_By_Client>;
  /** An object relationship */
  meta?: Maybe<Ehr_Eventmeta>;
  modified_at?: Maybe<Scalars['timestamptz']>;
  net_price?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  notifications: Array<Ehr_Notification>;
  paid?: Maybe<Scalars['Boolean']>;
  parent_event_id?: Maybe<Scalars['uuid']>;
  payer_billing_queue_status?: Maybe<Scalars['String']>;
  payer_id?: Maybe<Scalars['uuid']>;
  price_id?: Maybe<Scalars['uuid']>;
  procedure_id?: Maybe<Scalars['Int']>;
  reconciled_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  recurrence_data?: Maybe<Hasura_Cwa__Event_Recurrence_Data>;
  scheduled_by_source?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  slot_id?: Maybe<Scalars['uuid']>;
  slot_week?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  superbill_id?: Maybe<Scalars['uuid']>;
  time_canceled?: Maybe<Scalars['timestamptz']>;
  time_scheduled?: Maybe<Scalars['timestamptz']>;
  tombstone_timestamp?: Maybe<Scalars['timestamptz']>;
  welkin8_id?: Maybe<Scalars['String']>;
  welkin_id?: Maybe<Scalars['String']>;
  welkin_tombstone_id?: Maybe<Scalars['uuid']>;
  zoom_conference_data_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventEhr_ClientgroupeventsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupevent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupevent_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventEhr_ConsulttoolsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Consulttool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Consulttool_Order_By>>;
  where?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventEhr_EventmbcstatusArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmbcstatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmbcstatus_Order_By>>;
  where?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventEhr_IdentitytokensArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Identitytoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Identitytoken_Order_By>>;
  where?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventEhr_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Order_By>>;
  where?: InputMaybe<Ehr_Match_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventMbc_Assessment_Question_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


/** columns and relationships of "ehr_event" */
export type Ehr_EventNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Notification_Bool_Exp>;
};

/** aggregated selection of "ehr_event" */
export type Ehr_Event_Aggregate = {
  __typename?: 'ehr_event_aggregate';
  aggregate?: Maybe<Ehr_Event_Aggregate_Fields>;
  nodes: Array<Ehr_Event>;
};

export type Ehr_Event_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ehr_Event_Select_Column_Ehr_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ehr_Event_Select_Column_Ehr_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_event" */
export type Ehr_Event_Aggregate_Fields = {
  __typename?: 'ehr_event_aggregate_fields';
  avg?: Maybe<Ehr_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Event_Max_Fields>;
  min?: Maybe<Ehr_Event_Min_Fields>;
  stddev?: Maybe<Ehr_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Event_Sum_Fields>;
  var_pop?: Maybe<Ehr_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Event_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Event_Variance_Fields>;
};


/** aggregate fields of "ehr_event" */
export type Ehr_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_event" */
export type Ehr_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Event_Max_Order_By>;
  min?: InputMaybe<Ehr_Event_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Event_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ehr_Event_Avg_Fields = {
  __typename?: 'ehr_event_avg_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ehr_event" */
export type Ehr_Event_Avg_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_event". All fields are combined with a logical 'AND'. */
export type Ehr_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Event_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Event_Bool_Exp>>;
  acuity_id?: InputMaybe<Int_Comparison_Exp>;
  acuity_notes?: InputMaybe<String_Comparison_Exp>;
  acuity_tombstone_id?: InputMaybe<Uuid_Comparison_Exp>;
  amount_paid_online?: InputMaybe<Numeric_Comparison_Exp>;
  appointment_status?: InputMaybe<String_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_Comparison_Exp>;
  cancellation_type?: InputMaybe<String_Comparison_Exp>;
  certificate_code?: InputMaybe<String_Comparison_Exp>;
  client?: InputMaybe<Ehr_Client_Bool_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinic_id?: InputMaybe<Int_Comparison_Exp>;
  clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_week_id?: InputMaybe<Uuid_Comparison_Exp>;
  conferencing_provider?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  cost_client_rate?: InputMaybe<Numeric_Comparison_Exp>;
  cost_contracted_payer_rate?: InputMaybe<Numeric_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery?: InputMaybe<String_Comparison_Exp>;
  do_not_bill?: InputMaybe<Boolean_Comparison_Exp>;
  ehr_clientgroupevents?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
  ehr_consulttools?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
  ehr_eventmbcstatus?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
  ehr_identitytokens?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
  ehr_matches?: InputMaybe<Ehr_Match_Bool_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  gcal_unique_id?: InputMaybe<String_Comparison_Exp>;
  gross_price?: InputMaybe<Numeric_Comparison_Exp>;
  group?: InputMaybe<Ehr_Group_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  healthie_note_id?: InputMaybe<String_Comparison_Exp>;
  hybrid_preference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_appointment?: InputMaybe<Boolean_Comparison_Exp>;
  is_session?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  legacy_superbilled?: InputMaybe<Boolean_Comparison_Exp>;
  managed_by_autoschedule?: InputMaybe<Boolean_Comparison_Exp>;
  mbc_assessment_question_scores?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
  mbc_score?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
  meta?: InputMaybe<Ehr_Eventmeta_Bool_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  net_price?: InputMaybe<Numeric_Comparison_Exp>;
  notifications?: InputMaybe<Ehr_Notification_Bool_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  parent_event_id?: InputMaybe<Uuid_Comparison_Exp>;
  payer_billing_queue_status?: InputMaybe<String_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_id?: InputMaybe<Uuid_Comparison_Exp>;
  procedure_id?: InputMaybe<Int_Comparison_Exp>;
  reconciled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  recurrence_data?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>;
  scheduled_by_source?: InputMaybe<String_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  slot_id?: InputMaybe<Uuid_Comparison_Exp>;
  slot_week?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  superbill_id?: InputMaybe<Uuid_Comparison_Exp>;
  time_canceled?: InputMaybe<Timestamptz_Comparison_Exp>;
  time_scheduled?: InputMaybe<Timestamptz_Comparison_Exp>;
  tombstone_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  welkin8_id?: InputMaybe<String_Comparison_Exp>;
  welkin_id?: InputMaybe<String_Comparison_Exp>;
  welkin_tombstone_id?: InputMaybe<Uuid_Comparison_Exp>;
  zoom_conference_data_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ehr_Event_Max_Fields = {
  __typename?: 'ehr_event_max_fields';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  acuity_id?: Maybe<Scalars['Int']>;
  acuity_notes?: Maybe<Scalars['String']>;
  acuity_tombstone_id?: Maybe<Scalars['uuid']>;
  amount_paid_online?: Maybe<Scalars['numeric']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  certificate_code?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_week_id?: Maybe<Scalars['uuid']>;
  conferencing_provider?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  cost_client_rate?: Maybe<Scalars['numeric']>;
  cost_contracted_payer_rate?: Maybe<Scalars['numeric']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  gcal_unique_id?: Maybe<Scalars['String']>;
  gross_price?: Maybe<Scalars['numeric']>;
  group_id?: Maybe<Scalars['uuid']>;
  healthie_note_id?: Maybe<Scalars['String']>;
  hybrid_preference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  modified_at?: Maybe<Scalars['timestamptz']>;
  net_price?: Maybe<Scalars['numeric']>;
  parent_event_id?: Maybe<Scalars['uuid']>;
  payer_billing_queue_status?: Maybe<Scalars['String']>;
  payer_id?: Maybe<Scalars['uuid']>;
  price_id?: Maybe<Scalars['uuid']>;
  procedure_id?: Maybe<Scalars['Int']>;
  reconciled_at?: Maybe<Scalars['timestamptz']>;
  scheduled_by_source?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  slot_id?: Maybe<Scalars['uuid']>;
  slot_week?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  superbill_id?: Maybe<Scalars['uuid']>;
  time_canceled?: Maybe<Scalars['timestamptz']>;
  time_scheduled?: Maybe<Scalars['timestamptz']>;
  tombstone_timestamp?: Maybe<Scalars['timestamptz']>;
  welkin8_id?: Maybe<Scalars['String']>;
  welkin_id?: Maybe<Scalars['String']>;
  welkin_tombstone_id?: Maybe<Scalars['uuid']>;
  zoom_conference_data_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_event" */
export type Ehr_Event_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  acuity_id?: InputMaybe<Order_By>;
  acuity_notes?: InputMaybe<Order_By>;
  acuity_tombstone_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  certificate_code?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_week_id?: InputMaybe<Order_By>;
  conferencing_provider?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gcal_unique_id?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  parent_event_id?: InputMaybe<Order_By>;
  payer_billing_queue_status?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  scheduled_by_source?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  slot_id?: InputMaybe<Order_By>;
  slot_week?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superbill_id?: InputMaybe<Order_By>;
  time_canceled?: InputMaybe<Order_By>;
  time_scheduled?: InputMaybe<Order_By>;
  tombstone_timestamp?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_id?: InputMaybe<Order_By>;
  welkin_tombstone_id?: InputMaybe<Order_By>;
  zoom_conference_data_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Event_Min_Fields = {
  __typename?: 'ehr_event_min_fields';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  acuity_id?: Maybe<Scalars['Int']>;
  acuity_notes?: Maybe<Scalars['String']>;
  acuity_tombstone_id?: Maybe<Scalars['uuid']>;
  amount_paid_online?: Maybe<Scalars['numeric']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  certificate_code?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_week_id?: Maybe<Scalars['uuid']>;
  conferencing_provider?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  cost_client_rate?: Maybe<Scalars['numeric']>;
  cost_contracted_payer_rate?: Maybe<Scalars['numeric']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  gcal_unique_id?: Maybe<Scalars['String']>;
  gross_price?: Maybe<Scalars['numeric']>;
  group_id?: Maybe<Scalars['uuid']>;
  healthie_note_id?: Maybe<Scalars['String']>;
  hybrid_preference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  modified_at?: Maybe<Scalars['timestamptz']>;
  net_price?: Maybe<Scalars['numeric']>;
  parent_event_id?: Maybe<Scalars['uuid']>;
  payer_billing_queue_status?: Maybe<Scalars['String']>;
  payer_id?: Maybe<Scalars['uuid']>;
  price_id?: Maybe<Scalars['uuid']>;
  procedure_id?: Maybe<Scalars['Int']>;
  reconciled_at?: Maybe<Scalars['timestamptz']>;
  scheduled_by_source?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  slot_id?: Maybe<Scalars['uuid']>;
  slot_week?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  superbill_id?: Maybe<Scalars['uuid']>;
  time_canceled?: Maybe<Scalars['timestamptz']>;
  time_scheduled?: Maybe<Scalars['timestamptz']>;
  tombstone_timestamp?: Maybe<Scalars['timestamptz']>;
  welkin8_id?: Maybe<Scalars['String']>;
  welkin_id?: Maybe<Scalars['String']>;
  welkin_tombstone_id?: Maybe<Scalars['uuid']>;
  zoom_conference_data_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_event" */
export type Ehr_Event_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  acuity_id?: InputMaybe<Order_By>;
  acuity_notes?: InputMaybe<Order_By>;
  acuity_tombstone_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  certificate_code?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_week_id?: InputMaybe<Order_By>;
  conferencing_provider?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gcal_unique_id?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  parent_event_id?: InputMaybe<Order_By>;
  payer_billing_queue_status?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  scheduled_by_source?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  slot_id?: InputMaybe<Order_By>;
  slot_week?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superbill_id?: InputMaybe<Order_By>;
  time_canceled?: InputMaybe<Order_By>;
  time_scheduled?: InputMaybe<Order_By>;
  tombstone_timestamp?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_id?: InputMaybe<Order_By>;
  welkin_tombstone_id?: InputMaybe<Order_By>;
  zoom_conference_data_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_event". */
export type Ehr_Event_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  acuity_id?: InputMaybe<Order_By>;
  acuity_notes?: InputMaybe<Order_By>;
  acuity_tombstone_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  certificate_code?: InputMaybe<Order_By>;
  client?: InputMaybe<Ehr_Client_Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_week_id?: InputMaybe<Order_By>;
  conferencing_provider?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery?: InputMaybe<Order_By>;
  do_not_bill?: InputMaybe<Order_By>;
  ehr_clientgroupevents_aggregate?: InputMaybe<Ehr_Clientgroupevent_Aggregate_Order_By>;
  ehr_consulttools_aggregate?: InputMaybe<Ehr_Consulttool_Aggregate_Order_By>;
  ehr_eventmbcstatus_aggregate?: InputMaybe<Ehr_Eventmbcstatus_Aggregate_Order_By>;
  ehr_identitytokens_aggregate?: InputMaybe<Ehr_Identitytoken_Aggregate_Order_By>;
  ehr_matches_aggregate?: InputMaybe<Ehr_Match_Aggregate_Order_By>;
  end_time?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gcal_unique_id?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  group?: InputMaybe<Ehr_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  healthie_note_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_appointment?: InputMaybe<Order_By>;
  is_session?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  legacy_superbilled?: InputMaybe<Order_By>;
  managed_by_autoschedule?: InputMaybe<Order_By>;
  mbc_assessment_question_scores_aggregate?: InputMaybe<Mbc_Assessment_Question_Scores_Aggregate_Order_By>;
  mbc_score?: InputMaybe<Mbc_Distinct_Scores_By_Client_Order_By>;
  meta?: InputMaybe<Ehr_Eventmeta_Order_By>;
  modified_at?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Ehr_Notification_Aggregate_Order_By>;
  paid?: InputMaybe<Order_By>;
  parent_event_id?: InputMaybe<Order_By>;
  payer_billing_queue_status?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  recurrence_data?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Order_By>;
  scheduled_by_source?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  slot_id?: InputMaybe<Order_By>;
  slot_week?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superbill_id?: InputMaybe<Order_By>;
  time_canceled?: InputMaybe<Order_By>;
  time_scheduled?: InputMaybe<Order_By>;
  tombstone_timestamp?: InputMaybe<Order_By>;
  welkin8_id?: InputMaybe<Order_By>;
  welkin_id?: InputMaybe<Order_By>;
  welkin_tombstone_id?: InputMaybe<Order_By>;
  zoom_conference_data_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_event" */
export enum Ehr_Event_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AcuityId = 'acuity_id',
  /** column name */
  AcuityNotes = 'acuity_notes',
  /** column name */
  AcuityTombstoneId = 'acuity_tombstone_id',
  /** column name */
  AmountPaidOnline = 'amount_paid_online',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CancellationType = 'cancellation_type',
  /** column name */
  CertificateCode = 'certificate_code',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicId = 'clinic_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ClinicianWeekId = 'clinician_week_id',
  /** column name */
  ConferencingProvider = 'conferencing_provider',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostClientRate = 'cost_client_rate',
  /** column name */
  CostContractedPayerRate = 'cost_contracted_payer_rate',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Delivery = 'delivery',
  /** column name */
  DoNotBill = 'do_not_bill',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  EventType = 'event_type',
  /** column name */
  GcalUniqueId = 'gcal_unique_id',
  /** column name */
  GrossPrice = 'gross_price',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HealthieNoteId = 'healthie_note_id',
  /** column name */
  HybridPreference = 'hybrid_preference',
  /** column name */
  Id = 'id',
  /** column name */
  IsAppointment = 'is_appointment',
  /** column name */
  IsSession = 'is_session',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  LegacySuperbilled = 'legacy_superbilled',
  /** column name */
  ManagedByAutoschedule = 'managed_by_autoschedule',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  NetPrice = 'net_price',
  /** column name */
  Paid = 'paid',
  /** column name */
  ParentEventId = 'parent_event_id',
  /** column name */
  PayerBillingQueueStatus = 'payer_billing_queue_status',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  ProcedureId = 'procedure_id',
  /** column name */
  ReconciledAt = 'reconciled_at',
  /** column name */
  ScheduledBySource = 'scheduled_by_source',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SlotId = 'slot_id',
  /** column name */
  SlotWeek = 'slot_week',
  /** column name */
  Source = 'source',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  SuperbillId = 'superbill_id',
  /** column name */
  TimeCanceled = 'time_canceled',
  /** column name */
  TimeScheduled = 'time_scheduled',
  /** column name */
  TombstoneTimestamp = 'tombstone_timestamp',
  /** column name */
  Welkin8Id = 'welkin8_id',
  /** column name */
  WelkinId = 'welkin_id',
  /** column name */
  WelkinTombstoneId = 'welkin_tombstone_id',
  /** column name */
  ZoomConferenceDataId = 'zoom_conference_data_id'
}

/** select "ehr_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ehr_event" */
export enum Ehr_Event_Select_Column_Ehr_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = '_deleted',
  /** column name */
  DoNotBill = 'do_not_bill',
  /** column name */
  IsAppointment = 'is_appointment',
  /** column name */
  IsSession = 'is_session',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  LegacySuperbilled = 'legacy_superbilled',
  /** column name */
  ManagedByAutoschedule = 'managed_by_autoschedule',
  /** column name */
  Paid = 'paid'
}

/** select "ehr_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ehr_event" */
export enum Ehr_Event_Select_Column_Ehr_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = '_deleted',
  /** column name */
  DoNotBill = 'do_not_bill',
  /** column name */
  IsAppointment = 'is_appointment',
  /** column name */
  IsSession = 'is_session',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  LegacySuperbilled = 'legacy_superbilled',
  /** column name */
  ManagedByAutoschedule = 'managed_by_autoschedule',
  /** column name */
  Paid = 'paid'
}

/** aggregate stddev on columns */
export type Ehr_Event_Stddev_Fields = {
  __typename?: 'ehr_event_stddev_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ehr_event" */
export type Ehr_Event_Stddev_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Event_Stddev_Pop_Fields = {
  __typename?: 'ehr_event_stddev_pop_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ehr_event" */
export type Ehr_Event_Stddev_Pop_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Event_Stddev_Samp_Fields = {
  __typename?: 'ehr_event_stddev_samp_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ehr_event" */
export type Ehr_Event_Stddev_Samp_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_event" */
export type Ehr_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Event_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  acuity_id?: InputMaybe<Scalars['Int']>;
  acuity_notes?: InputMaybe<Scalars['String']>;
  acuity_tombstone_id?: InputMaybe<Scalars['uuid']>;
  amount_paid_online?: InputMaybe<Scalars['numeric']>;
  appointment_status?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  cancellation_type?: InputMaybe<Scalars['String']>;
  certificate_code?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  clinician_week_id?: InputMaybe<Scalars['uuid']>;
  conferencing_provider?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  cost_client_rate?: InputMaybe<Scalars['numeric']>;
  cost_contracted_payer_rate?: InputMaybe<Scalars['numeric']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery?: InputMaybe<Scalars['String']>;
  do_not_bill?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<Scalars['String']>;
  gcal_unique_id?: InputMaybe<Scalars['String']>;
  gross_price?: InputMaybe<Scalars['numeric']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  healthie_note_id?: InputMaybe<Scalars['String']>;
  hybrid_preference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_appointment?: InputMaybe<Scalars['Boolean']>;
  is_session?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  legacy_superbilled?: InputMaybe<Scalars['Boolean']>;
  managed_by_autoschedule?: InputMaybe<Scalars['Boolean']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  net_price?: InputMaybe<Scalars['numeric']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  parent_event_id?: InputMaybe<Scalars['uuid']>;
  payer_billing_queue_status?: InputMaybe<Scalars['String']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  price_id?: InputMaybe<Scalars['uuid']>;
  procedure_id?: InputMaybe<Scalars['Int']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']>;
  scheduled_by_source?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  slot_id?: InputMaybe<Scalars['uuid']>;
  slot_week?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  superbill_id?: InputMaybe<Scalars['uuid']>;
  time_canceled?: InputMaybe<Scalars['timestamptz']>;
  time_scheduled?: InputMaybe<Scalars['timestamptz']>;
  tombstone_timestamp?: InputMaybe<Scalars['timestamptz']>;
  welkin8_id?: InputMaybe<Scalars['String']>;
  welkin_id?: InputMaybe<Scalars['String']>;
  welkin_tombstone_id?: InputMaybe<Scalars['uuid']>;
  zoom_conference_data_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Ehr_Event_Sum_Fields = {
  __typename?: 'ehr_event_sum_fields';
  acuity_id?: Maybe<Scalars['Int']>;
  amount_paid_online?: Maybe<Scalars['numeric']>;
  client_id?: Maybe<Scalars['Int']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['numeric']>;
  cost_client_rate?: Maybe<Scalars['numeric']>;
  cost_contracted_payer_rate?: Maybe<Scalars['numeric']>;
  gross_price?: Maybe<Scalars['numeric']>;
  net_price?: Maybe<Scalars['numeric']>;
  procedure_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_event" */
export type Ehr_Event_Sum_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ehr_Event_Var_Pop_Fields = {
  __typename?: 'ehr_event_var_pop_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ehr_event" */
export type Ehr_Event_Var_Pop_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ehr_Event_Var_Samp_Fields = {
  __typename?: 'ehr_event_var_samp_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ehr_event" */
export type Ehr_Event_Var_Samp_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ehr_Event_Variance_Fields = {
  __typename?: 'ehr_event_variance_fields';
  acuity_id?: Maybe<Scalars['Float']>;
  amount_paid_online?: Maybe<Scalars['Float']>;
  client_id?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  cost_client_rate?: Maybe<Scalars['Float']>;
  cost_contracted_payer_rate?: Maybe<Scalars['Float']>;
  gross_price?: Maybe<Scalars['Float']>;
  net_price?: Maybe<Scalars['Float']>;
  procedure_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ehr_event" */
export type Ehr_Event_Variance_Order_By = {
  acuity_id?: InputMaybe<Order_By>;
  amount_paid_online?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_client_rate?: InputMaybe<Order_By>;
  cost_contracted_payer_rate?: InputMaybe<Order_By>;
  gross_price?: InputMaybe<Order_By>;
  net_price?: InputMaybe<Order_By>;
  procedure_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus = {
  __typename?: 'ehr_eventmbcstatus';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  assessment_email_id?: Maybe<Scalars['uuid']>;
  assessment_email_sent_at?: Maybe<Scalars['timestamptz']>;
  assessment_responded_at?: Maybe<Scalars['timestamptz']>;
  assessment_response_id?: Maybe<Scalars['uuid']>;
  assessment_send_failure?: Maybe<Scalars['String']>;
  assessment_send_started?: Maybe<Scalars['timestamptz']>;
  assessment_slug?: Maybe<Scalars['String']>;
  assessment_type: Scalars['String'];
  assessment_url?: Maybe<Scalars['String']>;
  client_group_event_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id: Scalars['Int'];
  couple_id?: Maybe<Scalars['uuid']>;
  deletion_reason?: Maybe<Scalars['String']>;
  /** An array relationship */
  ehr_assessmentscores: Array<Ehr_Assessmentscore>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_clientgroupevent?: Maybe<Ehr_Clientgroupevent>;
  /** An object relationship */
  ehr_event?: Maybe<Ehr_Event>;
  /** An array relationship */
  ehr_generalsurveyresponses: Array<Ehr_Generalsurveyresponse>;
  /** An array relationship */
  ehr_identitytokens: Array<Ehr_Identitytoken>;
  event_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_skipped: Scalars['Boolean'];
  mbc_track_id?: Maybe<Scalars['uuid']>;
  notification_assessment_email_id?: Maybe<Scalars['uuid']>;
  notification_reminder_email_id?: Maybe<Scalars['uuid']>;
  reminder_email_id?: Maybe<Scalars['uuid']>;
  reminder_email_sent_at?: Maybe<Scalars['timestamptz']>;
  reminder_send_failure?: Maybe<Scalars['String']>;
  send_attempts: Scalars['Int'];
};


/** columns and relationships of "ehr_eventmbcstatus" */
export type Ehr_EventmbcstatusEhr_AssessmentscoresArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Assessmentscore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Assessmentscore_Order_By>>;
  where?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
};


/** columns and relationships of "ehr_eventmbcstatus" */
export type Ehr_EventmbcstatusEhr_GeneralsurveyresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
};


/** columns and relationships of "ehr_eventmbcstatus" */
export type Ehr_EventmbcstatusEhr_IdentitytokensArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Identitytoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Identitytoken_Order_By>>;
  where?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
};

/** order by aggregate values of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Eventmbcstatus_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Eventmbcstatus_Max_Order_By>;
  min?: InputMaybe<Ehr_Eventmbcstatus_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Eventmbcstatus_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Eventmbcstatus_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Eventmbcstatus_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Eventmbcstatus_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Eventmbcstatus_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Eventmbcstatus_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Eventmbcstatus_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_eventmbcstatus". All fields are combined with a logical 'AND'. */
export type Ehr_Eventmbcstatus_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Eventmbcstatus_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Eventmbcstatus_Bool_Exp>>;
  assessment_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  assessment_email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  assessment_responded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  assessment_response_id?: InputMaybe<Uuid_Comparison_Exp>;
  assessment_send_failure?: InputMaybe<String_Comparison_Exp>;
  assessment_send_started?: InputMaybe<Timestamptz_Comparison_Exp>;
  assessment_slug?: InputMaybe<String_Comparison_Exp>;
  assessment_type?: InputMaybe<String_Comparison_Exp>;
  assessment_url?: InputMaybe<String_Comparison_Exp>;
  client_group_event_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  deletion_reason?: InputMaybe<String_Comparison_Exp>;
  ehr_assessmentscores?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clientgroupevent?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
  ehr_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  ehr_generalsurveyresponses?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
  ehr_identitytokens?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_skipped?: InputMaybe<Boolean_Comparison_Exp>;
  mbc_track_id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_assessment_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_reminder_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  reminder_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  reminder_email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reminder_send_failure?: InputMaybe<String_Comparison_Exp>;
  send_attempts?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_email_id?: InputMaybe<Order_By>;
  assessment_email_sent_at?: InputMaybe<Order_By>;
  assessment_responded_at?: InputMaybe<Order_By>;
  assessment_response_id?: InputMaybe<Order_By>;
  assessment_send_failure?: InputMaybe<Order_By>;
  assessment_send_started?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  assessment_type?: InputMaybe<Order_By>;
  assessment_url?: InputMaybe<Order_By>;
  client_group_event_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  deletion_reason?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbc_track_id?: InputMaybe<Order_By>;
  notification_assessment_email_id?: InputMaybe<Order_By>;
  notification_reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_sent_at?: InputMaybe<Order_By>;
  reminder_send_failure?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_email_id?: InputMaybe<Order_By>;
  assessment_email_sent_at?: InputMaybe<Order_By>;
  assessment_responded_at?: InputMaybe<Order_By>;
  assessment_response_id?: InputMaybe<Order_By>;
  assessment_send_failure?: InputMaybe<Order_By>;
  assessment_send_started?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  assessment_type?: InputMaybe<Order_By>;
  assessment_url?: InputMaybe<Order_By>;
  client_group_event_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  deletion_reason?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbc_track_id?: InputMaybe<Order_By>;
  notification_assessment_email_id?: InputMaybe<Order_By>;
  notification_reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_sent_at?: InputMaybe<Order_By>;
  reminder_send_failure?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_eventmbcstatus". */
export type Ehr_Eventmbcstatus_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_email_id?: InputMaybe<Order_By>;
  assessment_email_sent_at?: InputMaybe<Order_By>;
  assessment_responded_at?: InputMaybe<Order_By>;
  assessment_response_id?: InputMaybe<Order_By>;
  assessment_send_failure?: InputMaybe<Order_By>;
  assessment_send_started?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  assessment_type?: InputMaybe<Order_By>;
  assessment_url?: InputMaybe<Order_By>;
  client_group_event_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  deletion_reason?: InputMaybe<Order_By>;
  ehr_assessmentscores_aggregate?: InputMaybe<Ehr_Assessmentscore_Aggregate_Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clientgroupevent?: InputMaybe<Ehr_Clientgroupevent_Order_By>;
  ehr_event?: InputMaybe<Ehr_Event_Order_By>;
  ehr_generalsurveyresponses_aggregate?: InputMaybe<Ehr_Generalsurveyresponse_Aggregate_Order_By>;
  ehr_identitytokens_aggregate?: InputMaybe<Ehr_Identitytoken_Aggregate_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_skipped?: InputMaybe<Order_By>;
  mbc_track_id?: InputMaybe<Order_By>;
  notification_assessment_email_id?: InputMaybe<Order_By>;
  notification_reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_id?: InputMaybe<Order_By>;
  reminder_email_sent_at?: InputMaybe<Order_By>;
  reminder_send_failure?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_eventmbcstatus" */
export enum Ehr_Eventmbcstatus_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AssessmentEmailId = 'assessment_email_id',
  /** column name */
  AssessmentEmailSentAt = 'assessment_email_sent_at',
  /** column name */
  AssessmentRespondedAt = 'assessment_responded_at',
  /** column name */
  AssessmentResponseId = 'assessment_response_id',
  /** column name */
  AssessmentSendFailure = 'assessment_send_failure',
  /** column name */
  AssessmentSendStarted = 'assessment_send_started',
  /** column name */
  AssessmentSlug = 'assessment_slug',
  /** column name */
  AssessmentType = 'assessment_type',
  /** column name */
  AssessmentUrl = 'assessment_url',
  /** column name */
  ClientGroupEventId = 'client_group_event_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  DeletionReason = 'deletion_reason',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsSkipped = 'is_skipped',
  /** column name */
  MbcTrackId = 'mbc_track_id',
  /** column name */
  NotificationAssessmentEmailId = 'notification_assessment_email_id',
  /** column name */
  NotificationReminderEmailId = 'notification_reminder_email_id',
  /** column name */
  ReminderEmailId = 'reminder_email_id',
  /** column name */
  ReminderEmailSentAt = 'reminder_email_sent_at',
  /** column name */
  ReminderSendFailure = 'reminder_send_failure',
  /** column name */
  SendAttempts = 'send_attempts'
}

/** order by stddev() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Eventmbcstatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Eventmbcstatus_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  assessment_email_id?: InputMaybe<Scalars['uuid']>;
  assessment_email_sent_at?: InputMaybe<Scalars['timestamptz']>;
  assessment_responded_at?: InputMaybe<Scalars['timestamptz']>;
  assessment_response_id?: InputMaybe<Scalars['uuid']>;
  assessment_send_failure?: InputMaybe<Scalars['String']>;
  assessment_send_started?: InputMaybe<Scalars['timestamptz']>;
  assessment_slug?: InputMaybe<Scalars['String']>;
  assessment_type?: InputMaybe<Scalars['String']>;
  assessment_url?: InputMaybe<Scalars['String']>;
  client_group_event_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  deletion_reason?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_skipped?: InputMaybe<Scalars['Boolean']>;
  mbc_track_id?: InputMaybe<Scalars['uuid']>;
  notification_assessment_email_id?: InputMaybe<Scalars['uuid']>;
  notification_reminder_email_id?: InputMaybe<Scalars['uuid']>;
  reminder_email_id?: InputMaybe<Scalars['uuid']>;
  reminder_email_sent_at?: InputMaybe<Scalars['timestamptz']>;
  reminder_send_failure?: InputMaybe<Scalars['String']>;
  send_attempts?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_eventmbcstatus" */
export type Ehr_Eventmbcstatus_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  send_attempts?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_eventmeta" */
export type Ehr_Eventmeta = {
  __typename?: 'ehr_eventmeta';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  attendance_note?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_event: Ehr_Event;
  event_id: Scalars['uuid'];
  id: Scalars['Int'];
  modified_at: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "ehr_eventmeta". All fields are combined with a logical 'AND'. */
export type Ehr_Eventmeta_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Eventmeta_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Eventmeta_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Eventmeta_Bool_Exp>>;
  attendance_note?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_eventmeta". */
export type Ehr_Eventmeta_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  attendance_note?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_event?: InputMaybe<Ehr_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_eventmeta" */
export enum Ehr_Eventmeta_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AttendanceNote = 'attendance_note',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at'
}

/** Streaming cursor of the table "ehr_eventmeta" */
export type Ehr_Eventmeta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Eventmeta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Eventmeta_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  attendance_note?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "ehr_generalsurvey" */
export type Ehr_Generalsurvey = {
  __typename?: 'ehr_generalsurvey';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehr_generalsurveyquestions: Array<Ehr_Generalsurveyquestion>;
  /** An array relationship */
  ehr_generalsurveyresponses: Array<Ehr_Generalsurveyresponse>;
  id: Scalars['uuid'];
  modified_at: Scalars['timestamptz'];
  survey_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_generalsurvey" */
export type Ehr_GeneralsurveyEhr_GeneralsurveyquestionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestion_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
};


/** columns and relationships of "ehr_generalsurvey" */
export type Ehr_GeneralsurveyEhr_GeneralsurveyresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ehr_generalsurvey". All fields are combined with a logical 'AND'. */
export type Ehr_Generalsurvey_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Generalsurvey_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Generalsurvey_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_generalsurveyquestions?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
  ehr_generalsurveyresponses?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  survey_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_generalsurvey". */
export type Ehr_Generalsurvey_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_generalsurveyquestions_aggregate?: InputMaybe<Ehr_Generalsurveyquestion_Aggregate_Order_By>;
  ehr_generalsurveyresponses_aggregate?: InputMaybe<Ehr_Generalsurveyresponse_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  survey_name?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_generalsurvey" */
export enum Ehr_Generalsurvey_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  SurveyName = 'survey_name'
}

/** Streaming cursor of the table "ehr_generalsurvey" */
export type Ehr_Generalsurvey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Generalsurvey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Generalsurvey_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  survey_name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_generalsurveyquestion" */
export type Ehr_Generalsurveyquestion = {
  __typename?: 'ehr_generalsurveyquestion';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  add_text_box: Scalars['Boolean'];
  answer_options?: Maybe<Array<Scalars['String']>>;
  conditions?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  ehr_generalsurvey?: Maybe<Ehr_Generalsurvey>;
  general_survey_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_conditional: Scalars['Boolean'];
  is_deprecated: Scalars['Boolean'];
  is_optional: Scalars['Boolean'];
  lower_extreme?: Maybe<Scalars['String']>;
  question_text?: Maybe<Scalars['String']>;
  question_type?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tag_category?: Maybe<Scalars['String']>;
  upper_extreme?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ehr_generalsurveyquestion" */
export type Ehr_GeneralsurveyquestionConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_generalsurveyquestion" */
export type Ehr_Generalsurveyquestion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Generalsurveyquestion_Max_Order_By>;
  min?: InputMaybe<Ehr_Generalsurveyquestion_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_generalsurveyquestion". All fields are combined with a logical 'AND'. */
export type Ehr_Generalsurveyquestion_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Generalsurveyquestion_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Generalsurveyquestion_Bool_Exp>>;
  add_text_box?: InputMaybe<Boolean_Comparison_Exp>;
  answer_options?: InputMaybe<String_Array_Comparison_Exp>;
  conditions?: InputMaybe<Jsonb_Comparison_Exp>;
  ehr_generalsurvey?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
  general_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_conditional?: InputMaybe<Boolean_Comparison_Exp>;
  is_deprecated?: InputMaybe<Boolean_Comparison_Exp>;
  is_optional?: InputMaybe<Boolean_Comparison_Exp>;
  lower_extreme?: InputMaybe<String_Comparison_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  question_type?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  tag_category?: InputMaybe<String_Comparison_Exp>;
  upper_extreme?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_generalsurveyquestion" */
export type Ehr_Generalsurveyquestion_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  answer_options?: InputMaybe<Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_extreme?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tag_category?: InputMaybe<Order_By>;
  upper_extreme?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_generalsurveyquestion" */
export type Ehr_Generalsurveyquestion_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  answer_options?: InputMaybe<Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_extreme?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tag_category?: InputMaybe<Order_By>;
  upper_extreme?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_generalsurveyquestion". */
export type Ehr_Generalsurveyquestion_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  add_text_box?: InputMaybe<Order_By>;
  answer_options?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  ehr_generalsurvey?: InputMaybe<Ehr_Generalsurvey_Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_conditional?: InputMaybe<Order_By>;
  is_deprecated?: InputMaybe<Order_By>;
  is_optional?: InputMaybe<Order_By>;
  lower_extreme?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tag_category?: InputMaybe<Order_By>;
  upper_extreme?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_generalsurveyquestion" */
export enum Ehr_Generalsurveyquestion_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AddTextBox = 'add_text_box',
  /** column name */
  AnswerOptions = 'answer_options',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  GeneralSurveyId = 'general_survey_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsConditional = 'is_conditional',
  /** column name */
  IsDeprecated = 'is_deprecated',
  /** column name */
  IsOptional = 'is_optional',
  /** column name */
  LowerExtreme = 'lower_extreme',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Slug = 'slug',
  /** column name */
  TagCategory = 'tag_category',
  /** column name */
  UpperExtreme = 'upper_extreme'
}

/** Streaming cursor of the table "ehr_generalsurveyquestion" */
export type Ehr_Generalsurveyquestion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Generalsurveyquestion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Generalsurveyquestion_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  add_text_box?: InputMaybe<Scalars['Boolean']>;
  answer_options?: InputMaybe<Array<Scalars['String']>>;
  conditions?: InputMaybe<Scalars['jsonb']>;
  general_survey_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_conditional?: InputMaybe<Scalars['Boolean']>;
  is_deprecated?: InputMaybe<Scalars['Boolean']>;
  is_optional?: InputMaybe<Scalars['Boolean']>;
  lower_extreme?: InputMaybe<Scalars['String']>;
  question_text?: InputMaybe<Scalars['String']>;
  question_type?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tag_category?: InputMaybe<Scalars['String']>;
  upper_extreme?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_generalsurveyquestionresponse" */
export type Ehr_Generalsurveyquestionresponse = {
  __typename?: 'ehr_generalsurveyquestionresponse';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_generalsurveyquestion: Ehr_Generalsurveyquestion;
  /** An object relationship */
  ehr_generalsurveyresponse: Ehr_Generalsurveyresponse;
  general_survey_question_id: Scalars['uuid'];
  general_survey_response_id: Scalars['uuid'];
  id: Scalars['uuid'];
  modified_at: Scalars['timestamptz'];
  value: Scalars['jsonb'];
};


/** columns and relationships of "ehr_generalsurveyquestionresponse" */
export type Ehr_GeneralsurveyquestionresponseValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_generalsurveyquestionresponse" */
export type Ehr_Generalsurveyquestionresponse_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Generalsurveyquestionresponse_Max_Order_By>;
  min?: InputMaybe<Ehr_Generalsurveyquestionresponse_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_generalsurveyquestionresponse". All fields are combined with a logical 'AND'. */
export type Ehr_Generalsurveyquestionresponse_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_generalsurveyquestion?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
  ehr_generalsurveyresponse?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
  general_survey_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  general_survey_response_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_generalsurveyquestionresponse" */
export type Ehr_Generalsurveyquestionresponse_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  general_survey_question_id?: InputMaybe<Order_By>;
  general_survey_response_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_generalsurveyquestionresponse" */
export type Ehr_Generalsurveyquestionresponse_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  general_survey_question_id?: InputMaybe<Order_By>;
  general_survey_response_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_generalsurveyquestionresponse". */
export type Ehr_Generalsurveyquestionresponse_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_generalsurveyquestion?: InputMaybe<Ehr_Generalsurveyquestion_Order_By>;
  ehr_generalsurveyresponse?: InputMaybe<Ehr_Generalsurveyresponse_Order_By>;
  general_survey_question_id?: InputMaybe<Order_By>;
  general_survey_response_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_generalsurveyquestionresponse" */
export enum Ehr_Generalsurveyquestionresponse_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GeneralSurveyQuestionId = 'general_survey_question_id',
  /** column name */
  GeneralSurveyResponseId = 'general_survey_response_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "ehr_generalsurveyquestionresponse" */
export type Ehr_Generalsurveyquestionresponse_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Generalsurveyquestionresponse_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Generalsurveyquestionresponse_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  general_survey_question_id?: InputMaybe<Scalars['uuid']>;
  general_survey_response_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse = {
  __typename?: 'ehr_generalsurveyresponse';
  blob: Scalars['jsonb'];
  client_id?: Maybe<Scalars['Int']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehr_assessmentscores: Array<Ehr_Assessmentscore>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_eventmbcstatus?: Maybe<Ehr_Eventmbcstatus>;
  /** An object relationship */
  ehr_generalsurvey: Ehr_Generalsurvey;
  /** An array relationship */
  ehr_generalsurveyquestionresponses: Array<Ehr_Generalsurveyquestionresponse>;
  ems_id?: Maybe<Scalars['uuid']>;
  general_survey_id: Scalars['uuid'];
  id: Scalars['uuid'];
  modified_at: Scalars['timestamptz'];
};


/** columns and relationships of "ehr_generalsurveyresponse" */
export type Ehr_GeneralsurveyresponseBlobArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_generalsurveyresponse" */
export type Ehr_GeneralsurveyresponseEhr_AssessmentscoresArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Assessmentscore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Assessmentscore_Order_By>>;
  where?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
};


/** columns and relationships of "ehr_generalsurveyresponse" */
export type Ehr_GeneralsurveyresponseEhr_GeneralsurveyquestionresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
};

/** order by aggregate values of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Generalsurveyresponse_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Generalsurveyresponse_Max_Order_By>;
  min?: InputMaybe<Ehr_Generalsurveyresponse_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Generalsurveyresponse_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Generalsurveyresponse_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Generalsurveyresponse_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Generalsurveyresponse_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Generalsurveyresponse_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Generalsurveyresponse_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Generalsurveyresponse_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_generalsurveyresponse". All fields are combined with a logical 'AND'. */
export type Ehr_Generalsurveyresponse_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Generalsurveyresponse_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Generalsurveyresponse_Bool_Exp>>;
  blob?: InputMaybe<Jsonb_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_assessmentscores?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_eventmbcstatus?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
  ehr_generalsurvey?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
  ehr_generalsurveyquestionresponses?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
  ems_id?: InputMaybe<Uuid_Comparison_Exp>;
  general_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Max_Order_By = {
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Min_Order_By = {
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_generalsurveyresponse". */
export type Ehr_Generalsurveyresponse_Order_By = {
  blob?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_assessmentscores_aggregate?: InputMaybe<Ehr_Assessmentscore_Aggregate_Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_eventmbcstatus?: InputMaybe<Ehr_Eventmbcstatus_Order_By>;
  ehr_generalsurvey?: InputMaybe<Ehr_Generalsurvey_Order_By>;
  ehr_generalsurveyquestionresponses_aggregate?: InputMaybe<Ehr_Generalsurveyquestionresponse_Aggregate_Order_By>;
  ems_id?: InputMaybe<Order_By>;
  general_survey_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_generalsurveyresponse" */
export enum Ehr_Generalsurveyresponse_Select_Column {
  /** column name */
  Blob = 'blob',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EmsId = 'ems_id',
  /** column name */
  GeneralSurveyId = 'general_survey_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModifiedAt = 'modified_at'
}

/** order by stddev() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Generalsurveyresponse_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Generalsurveyresponse_Stream_Cursor_Value_Input = {
  blob?: InputMaybe<Scalars['jsonb']>;
  client_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ems_id?: InputMaybe<Scalars['uuid']>;
  general_survey_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_generalsurveyresponse" */
export type Ehr_Generalsurveyresponse_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_group" */
export type Ehr_Group = {
  __typename?: 'ehr_group';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['date']>;
  capacity: Scalars['smallint'];
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id: Scalars['Int'];
  /** An array relationship */
  ehr_clientgroups: Array<Ehr_Clientgroup>;
  /** An object relationship */
  ehr_clinician: Ehr_Clinician;
  /** An array relationship */
  ehr_events: Array<Ehr_Event>;
  /** An aggregate relationship */
  ehr_events_aggregate: Ehr_Event_Aggregate;
  end_time?: Maybe<Scalars['timestamptz']>;
  enrollment_close_date?: Maybe<Scalars['date']>;
  enrollment_open_date?: Maybe<Scalars['date']>;
  facilitator_bio?: Maybe<Scalars['String']>;
  facilitator_video_url?: Maybe<Scalars['String']>;
  gcal_event_description?: Maybe<Scalars['String']>;
  group_type_id: Scalars['uuid'];
  /** An object relationship */
  grouptype: Ehr_Grouptype;
  id: Scalars['uuid'];
  is_ready_to_schedule: Scalars['Boolean'];
  is_test_data: Scalars['Boolean'];
  session_url: Scalars['String'];
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ehr_group" */
export type Ehr_GroupEhr_ClientgroupsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroup_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
};


/** columns and relationships of "ehr_group" */
export type Ehr_GroupEhr_EventsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


/** columns and relationships of "ehr_group" */
export type Ehr_GroupEhr_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};

/** aggregated selection of "ehr_group" */
export type Ehr_Group_Aggregate = {
  __typename?: 'ehr_group_aggregate';
  aggregate?: Maybe<Ehr_Group_Aggregate_Fields>;
  nodes: Array<Ehr_Group>;
};

export type Ehr_Group_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ehr_Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ehr_Group_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ehr_Group_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ehr_Group_Select_Column_Ehr_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ehr_Group_Select_Column_Ehr_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_group" */
export type Ehr_Group_Aggregate_Fields = {
  __typename?: 'ehr_group_aggregate_fields';
  avg?: Maybe<Ehr_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Group_Max_Fields>;
  min?: Maybe<Ehr_Group_Min_Fields>;
  stddev?: Maybe<Ehr_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Group_Sum_Fields>;
  var_pop?: Maybe<Ehr_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Group_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Group_Variance_Fields>;
};


/** aggregate fields of "ehr_group" */
export type Ehr_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_group" */
export type Ehr_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Group_Max_Order_By>;
  min?: InputMaybe<Ehr_Group_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Group_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ehr_Group_Avg_Fields = {
  __typename?: 'ehr_group_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ehr_group" */
export type Ehr_Group_Avg_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_group". All fields are combined with a logical 'AND'. */
export type Ehr_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Group_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Group_Bool_Exp>>;
  canceled_at?: InputMaybe<Date_Comparison_Exp>;
  capacity?: InputMaybe<Smallint_Comparison_Exp>;
  clinic_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  ehr_clientgroups?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  ehr_events?: InputMaybe<Ehr_Event_Bool_Exp>;
  ehr_events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Bool_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  enrollment_close_date?: InputMaybe<Date_Comparison_Exp>;
  enrollment_open_date?: InputMaybe<Date_Comparison_Exp>;
  facilitator_bio?: InputMaybe<String_Comparison_Exp>;
  facilitator_video_url?: InputMaybe<String_Comparison_Exp>;
  gcal_event_description?: InputMaybe<String_Comparison_Exp>;
  group_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  grouptype?: InputMaybe<Ehr_Grouptype_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_ready_to_schedule?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  session_url?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ehr_Group_Max_Fields = {
  __typename?: 'ehr_group_max_fields';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['date']>;
  capacity?: Maybe<Scalars['smallint']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  enrollment_close_date?: Maybe<Scalars['date']>;
  enrollment_open_date?: Maybe<Scalars['date']>;
  facilitator_bio?: Maybe<Scalars['String']>;
  facilitator_video_url?: Maybe<Scalars['String']>;
  gcal_event_description?: Maybe<Scalars['String']>;
  group_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_url?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_group" */
export type Ehr_Group_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  enrollment_close_date?: InputMaybe<Order_By>;
  enrollment_open_date?: InputMaybe<Order_By>;
  facilitator_bio?: InputMaybe<Order_By>;
  facilitator_video_url?: InputMaybe<Order_By>;
  gcal_event_description?: InputMaybe<Order_By>;
  group_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_url?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Group_Min_Fields = {
  __typename?: 'ehr_group_min_fields';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['date']>;
  capacity?: Maybe<Scalars['smallint']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  enrollment_close_date?: Maybe<Scalars['date']>;
  enrollment_open_date?: Maybe<Scalars['date']>;
  facilitator_bio?: Maybe<Scalars['String']>;
  facilitator_video_url?: Maybe<Scalars['String']>;
  gcal_event_description?: Maybe<Scalars['String']>;
  group_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  session_url?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_group" */
export type Ehr_Group_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  enrollment_close_date?: InputMaybe<Order_By>;
  enrollment_open_date?: InputMaybe<Order_By>;
  facilitator_bio?: InputMaybe<Order_By>;
  facilitator_video_url?: InputMaybe<Order_By>;
  gcal_event_description?: InputMaybe<Order_By>;
  group_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_url?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_group". */
export type Ehr_Group_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  ehr_clientgroups_aggregate?: InputMaybe<Ehr_Clientgroup_Aggregate_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  ehr_events_aggregate?: InputMaybe<Ehr_Event_Aggregate_Order_By>;
  end_time?: InputMaybe<Order_By>;
  enrollment_close_date?: InputMaybe<Order_By>;
  enrollment_open_date?: InputMaybe<Order_By>;
  facilitator_bio?: InputMaybe<Order_By>;
  facilitator_video_url?: InputMaybe<Order_By>;
  gcal_event_description?: InputMaybe<Order_By>;
  group_type_id?: InputMaybe<Order_By>;
  grouptype?: InputMaybe<Ehr_Grouptype_Order_By>;
  id?: InputMaybe<Order_By>;
  is_ready_to_schedule?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  session_url?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_group" */
export enum Ehr_Group_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  ClinicId = 'clinic_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  EnrollmentCloseDate = 'enrollment_close_date',
  /** column name */
  EnrollmentOpenDate = 'enrollment_open_date',
  /** column name */
  FacilitatorBio = 'facilitator_bio',
  /** column name */
  FacilitatorVideoUrl = 'facilitator_video_url',
  /** column name */
  GcalEventDescription = 'gcal_event_description',
  /** column name */
  GroupTypeId = 'group_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsReadyToSchedule = 'is_ready_to_schedule',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  SessionUrl = 'session_url',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time'
}

/** select "ehr_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ehr_group" */
export enum Ehr_Group_Select_Column_Ehr_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = '_deleted',
  /** column name */
  IsReadyToSchedule = 'is_ready_to_schedule',
  /** column name */
  IsTestData = 'is_test_data'
}

/** select "ehr_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ehr_group" */
export enum Ehr_Group_Select_Column_Ehr_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = '_deleted',
  /** column name */
  IsReadyToSchedule = 'is_ready_to_schedule',
  /** column name */
  IsTestData = 'is_test_data'
}

/** aggregate stddev on columns */
export type Ehr_Group_Stddev_Fields = {
  __typename?: 'ehr_group_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ehr_group" */
export type Ehr_Group_Stddev_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Group_Stddev_Pop_Fields = {
  __typename?: 'ehr_group_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ehr_group" */
export type Ehr_Group_Stddev_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Group_Stddev_Samp_Fields = {
  __typename?: 'ehr_group_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ehr_group" */
export type Ehr_Group_Stddev_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_group" */
export type Ehr_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Group_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  canceled_at?: InputMaybe<Scalars['date']>;
  capacity?: InputMaybe<Scalars['smallint']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  end_time?: InputMaybe<Scalars['timestamptz']>;
  enrollment_close_date?: InputMaybe<Scalars['date']>;
  enrollment_open_date?: InputMaybe<Scalars['date']>;
  facilitator_bio?: InputMaybe<Scalars['String']>;
  facilitator_video_url?: InputMaybe<Scalars['String']>;
  gcal_event_description?: InputMaybe<Scalars['String']>;
  group_type_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_ready_to_schedule?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  session_url?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ehr_Group_Sum_Fields = {
  __typename?: 'ehr_group_sum_fields';
  capacity?: Maybe<Scalars['smallint']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_group" */
export type Ehr_Group_Sum_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ehr_Group_Var_Pop_Fields = {
  __typename?: 'ehr_group_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ehr_group" */
export type Ehr_Group_Var_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ehr_Group_Var_Samp_Fields = {
  __typename?: 'ehr_group_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ehr_group" */
export type Ehr_Group_Var_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ehr_Group_Variance_Fields = {
  __typename?: 'ehr_group_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  clinic_id?: Maybe<Scalars['Float']>;
  clinician_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ehr_group" */
export type Ehr_Group_Variance_Order_By = {
  capacity?: InputMaybe<Order_By>;
  clinic_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_grouptype" */
export type Ehr_Grouptype = {
  __typename?: 'ehr_grouptype';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  affinity: Scalars['String'];
  curriculum: Scalars['String'];
  curriculum_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  ehr_groups: Array<Ehr_Group>;
  /** An aggregate relationship */
  ehr_groups_aggregate: Ehr_Group_Aggregate;
  gcal_event_description: Scalars['String'];
  id: Scalars['uuid'];
  number_of_sessions: Scalars['Int'];
  title: Scalars['String'];
};


/** columns and relationships of "ehr_grouptype" */
export type Ehr_GrouptypeEhr_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


/** columns and relationships of "ehr_grouptype" */
export type Ehr_GrouptypeEhr_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ehr_grouptype". All fields are combined with a logical 'AND'. */
export type Ehr_Grouptype_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Grouptype_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Grouptype_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Grouptype_Bool_Exp>>;
  affinity?: InputMaybe<String_Comparison_Exp>;
  curriculum?: InputMaybe<String_Comparison_Exp>;
  curriculum_url?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  ehr_groups?: InputMaybe<Ehr_Group_Bool_Exp>;
  ehr_groups_aggregate?: InputMaybe<Ehr_Group_Aggregate_Bool_Exp>;
  gcal_event_description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_sessions?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_grouptype". */
export type Ehr_Grouptype_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  affinity?: InputMaybe<Order_By>;
  curriculum?: InputMaybe<Order_By>;
  curriculum_url?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ehr_groups_aggregate?: InputMaybe<Ehr_Group_Aggregate_Order_By>;
  gcal_event_description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number_of_sessions?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_grouptype" */
export enum Ehr_Grouptype_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  Affinity = 'affinity',
  /** column name */
  Curriculum = 'curriculum',
  /** column name */
  CurriculumUrl = 'curriculum_url',
  /** column name */
  Description = 'description',
  /** column name */
  GcalEventDescription = 'gcal_event_description',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfSessions = 'number_of_sessions',
  /** column name */
  Title = 'title'
}

/** Streaming cursor of the table "ehr_grouptype" */
export type Ehr_Grouptype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Grouptype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Grouptype_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  affinity?: InputMaybe<Scalars['String']>;
  curriculum?: InputMaybe<Scalars['String']>;
  curriculum_url?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  gcal_event_description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  number_of_sessions?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_identitytoken" */
export type Ehr_Identitytoken = {
  __typename?: 'ehr_identitytoken';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  additional_data?: Maybe<Scalars['jsonb']>;
  allowed_scopes: Array<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  context?: Maybe<Scalars['String']>;
  couple_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehr_event?: Maybe<Ehr_Event>;
  ems_id?: Maybe<Scalars['uuid']>;
  event_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  match_id?: Maybe<Scalars['Int']>;
  referral_id?: Maybe<Scalars['uuid']>;
  token: Scalars['String'];
  valid_before: Scalars['timestamptz'];
  valid_from: Scalars['timestamptz'];
};


/** columns and relationships of "ehr_identitytoken" */
export type Ehr_IdentitytokenAdditional_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Identitytoken_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Identitytoken_Max_Order_By>;
  min?: InputMaybe<Ehr_Identitytoken_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Identitytoken_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Identitytoken_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Identitytoken_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Identitytoken_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Identitytoken_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Identitytoken_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Identitytoken_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_identitytoken". All fields are combined with a logical 'AND'. */
export type Ehr_Identitytoken_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Identitytoken_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Identitytoken_Bool_Exp>>;
  additional_data?: InputMaybe<Jsonb_Comparison_Exp>;
  allowed_scopes?: InputMaybe<String_Array_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  context?: InputMaybe<String_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  ems_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  referral_id?: InputMaybe<Uuid_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  valid_before?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  allowed_scopes?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  context?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  valid_before?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  allowed_scopes?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  context?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  ems_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  valid_before?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_identitytoken". */
export type Ehr_Identitytoken_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  additional_data?: InputMaybe<Order_By>;
  allowed_scopes?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  context?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  ehr_event?: InputMaybe<Ehr_Event_Order_By>;
  ems_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  valid_before?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_identitytoken" */
export enum Ehr_Identitytoken_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  AllowedScopes = 'allowed_scopes',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Context = 'context',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  EmsId = 'ems_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  ReferralId = 'referral_id',
  /** column name */
  Token = 'token',
  /** column name */
  ValidBefore = 'valid_before',
  /** column name */
  ValidFrom = 'valid_from'
}

/** order by stddev() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_identitytoken" */
export type Ehr_Identitytoken_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Identitytoken_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Identitytoken_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  additional_data?: InputMaybe<Scalars['jsonb']>;
  allowed_scopes?: InputMaybe<Array<Scalars['String']>>;
  client_id?: InputMaybe<Scalars['Int']>;
  context?: InputMaybe<Scalars['String']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  ems_id?: InputMaybe<Scalars['uuid']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['Int']>;
  referral_id?: InputMaybe<Scalars['uuid']>;
  token?: InputMaybe<Scalars['String']>;
  valid_before?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_identitytoken" */
export type Ehr_Identitytoken_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_insurancerecord" */
export type Ehr_Insurancerecord = {
  __typename?: 'ehr_insurancerecord';
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  addr_city?: Maybe<Scalars['String']>;
  addr_line_1?: Maybe<Scalars['String']>;
  addr_line_2?: Maybe<Scalars['String']>;
  addr_state?: Maybe<Scalars['String']>;
  addr_zipcode?: Maybe<Scalars['String']>;
  client_dob?: Maybe<Scalars['date']>;
  client_id?: Maybe<Scalars['Int']>;
  client_payer_service_record_id?: Maybe<Scalars['uuid']>;
  coinsurance_rate?: Maybe<Scalars['numeric']>;
  comments_member_cost_share?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  deductible_reset_date?: Maybe<Scalars['date']>;
  effective_start_date?: Maybe<Scalars['timestamptz']>;
  effective_termination_date?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  full_name?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  imported_client_name?: Maybe<Scalars['String']>;
  insurance_assignment: Scalars['String'];
  insurance_company_id?: Maybe<Scalars['uuid']>;
  is_medical: Scalars['Boolean'];
  is_medicare: Scalars['Boolean'];
  is_primary_beneficiary?: Maybe<Scalars['Boolean']>;
  is_visiting_member: Scalars['Boolean'];
  member_cost_share?: Maybe<Scalars['numeric']>;
  member_cost_share_remote?: Maybe<Scalars['numeric']>;
  member_cost_share_remote_group_therapy?: Maybe<Scalars['numeric']>;
  member_id?: Maybe<Scalars['String']>;
  oon_allowed_amounts?: Maybe<Scalars['jsonb']>;
  oon_deductible?: Maybe<Scalars['numeric']>;
  oon_deductible_remaining?: Maybe<Scalars['numeric']>;
  plan?: Maybe<Scalars['String']>;
  plan_type?: Maybe<Scalars['String']>;
  primary_beneficiary_dob?: Maybe<Scalars['date']>;
  primary_beneficiary_gender?: Maybe<Scalars['String']>;
  primary_beneficiary_name?: Maybe<Scalars['String']>;
  primary_beneficiary_relationship?: Maybe<Scalars['String']>;
  sex_on_insurance_card?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  superbill_number?: Maybe<Scalars['Int']>;
  welkin_cdt_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "ehr_insurancerecord" */
export type Ehr_InsurancerecordOon_Allowed_AmountsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Insurancerecord_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Insurancerecord_Max_Order_By>;
  min?: InputMaybe<Ehr_Insurancerecord_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Insurancerecord_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Insurancerecord_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Insurancerecord_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Insurancerecord_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Insurancerecord_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Insurancerecord_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Insurancerecord_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_insurancerecord". All fields are combined with a logical 'AND'. */
export type Ehr_Insurancerecord_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Insurancerecord_Bool_Exp>>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Insurancerecord_Bool_Exp>>;
  addr_city?: InputMaybe<String_Comparison_Exp>;
  addr_line_1?: InputMaybe<String_Comparison_Exp>;
  addr_line_2?: InputMaybe<String_Comparison_Exp>;
  addr_state?: InputMaybe<String_Comparison_Exp>;
  addr_zipcode?: InputMaybe<String_Comparison_Exp>;
  client_dob?: InputMaybe<Date_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_payer_service_record_id?: InputMaybe<Uuid_Comparison_Exp>;
  coinsurance_rate?: InputMaybe<Numeric_Comparison_Exp>;
  comments_member_cost_share?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deductible_reset_date?: InputMaybe<Date_Comparison_Exp>;
  effective_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_termination_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_client_name?: InputMaybe<String_Comparison_Exp>;
  insurance_assignment?: InputMaybe<String_Comparison_Exp>;
  insurance_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_medical?: InputMaybe<Boolean_Comparison_Exp>;
  is_medicare?: InputMaybe<Boolean_Comparison_Exp>;
  is_primary_beneficiary?: InputMaybe<Boolean_Comparison_Exp>;
  is_visiting_member?: InputMaybe<Boolean_Comparison_Exp>;
  member_cost_share?: InputMaybe<Numeric_Comparison_Exp>;
  member_cost_share_remote?: InputMaybe<Numeric_Comparison_Exp>;
  member_cost_share_remote_group_therapy?: InputMaybe<Numeric_Comparison_Exp>;
  member_id?: InputMaybe<String_Comparison_Exp>;
  oon_allowed_amounts?: InputMaybe<Jsonb_Comparison_Exp>;
  oon_deductible?: InputMaybe<Numeric_Comparison_Exp>;
  oon_deductible_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  plan?: InputMaybe<String_Comparison_Exp>;
  plan_type?: InputMaybe<String_Comparison_Exp>;
  primary_beneficiary_dob?: InputMaybe<Date_Comparison_Exp>;
  primary_beneficiary_gender?: InputMaybe<String_Comparison_Exp>;
  primary_beneficiary_name?: InputMaybe<String_Comparison_Exp>;
  primary_beneficiary_relationship?: InputMaybe<String_Comparison_Exp>;
  sex_on_insurance_card?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  superbill_number?: InputMaybe<Int_Comparison_Exp>;
  welkin_cdt_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Max_Order_By = {
  _immutable_version_id?: InputMaybe<Order_By>;
  addr_city?: InputMaybe<Order_By>;
  addr_line_1?: InputMaybe<Order_By>;
  addr_line_2?: InputMaybe<Order_By>;
  addr_state?: InputMaybe<Order_By>;
  addr_zipcode?: InputMaybe<Order_By>;
  client_dob?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_payer_service_record_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  comments_member_cost_share?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deductible_reset_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_termination_date?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  insurance_assignment?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  member_id?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Order_By>;
  primary_beneficiary_dob?: InputMaybe<Order_By>;
  primary_beneficiary_gender?: InputMaybe<Order_By>;
  primary_beneficiary_name?: InputMaybe<Order_By>;
  primary_beneficiary_relationship?: InputMaybe<Order_By>;
  sex_on_insurance_card?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Min_Order_By = {
  _immutable_version_id?: InputMaybe<Order_By>;
  addr_city?: InputMaybe<Order_By>;
  addr_line_1?: InputMaybe<Order_By>;
  addr_line_2?: InputMaybe<Order_By>;
  addr_state?: InputMaybe<Order_By>;
  addr_zipcode?: InputMaybe<Order_By>;
  client_dob?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_payer_service_record_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  comments_member_cost_share?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deductible_reset_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_termination_date?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  insurance_assignment?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  member_id?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Order_By>;
  primary_beneficiary_dob?: InputMaybe<Order_By>;
  primary_beneficiary_gender?: InputMaybe<Order_By>;
  primary_beneficiary_name?: InputMaybe<Order_By>;
  primary_beneficiary_relationship?: InputMaybe<Order_By>;
  sex_on_insurance_card?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_insurancerecord". */
export type Ehr_Insurancerecord_Order_By = {
  _immutable_version_id?: InputMaybe<Order_By>;
  addr_city?: InputMaybe<Order_By>;
  addr_line_1?: InputMaybe<Order_By>;
  addr_line_2?: InputMaybe<Order_By>;
  addr_state?: InputMaybe<Order_By>;
  addr_zipcode?: InputMaybe<Order_By>;
  client_dob?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_payer_service_record_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  comments_member_cost_share?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deductible_reset_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_termination_date?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  full_name?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_client_name?: InputMaybe<Order_By>;
  insurance_assignment?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  is_medical?: InputMaybe<Order_By>;
  is_medicare?: InputMaybe<Order_By>;
  is_primary_beneficiary?: InputMaybe<Order_By>;
  is_visiting_member?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  member_id?: InputMaybe<Order_By>;
  oon_allowed_amounts?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Order_By>;
  primary_beneficiary_dob?: InputMaybe<Order_By>;
  primary_beneficiary_gender?: InputMaybe<Order_By>;
  primary_beneficiary_name?: InputMaybe<Order_By>;
  primary_beneficiary_relationship?: InputMaybe<Order_By>;
  sex_on_insurance_card?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
  welkin_cdt_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_insurancerecord" */
export enum Ehr_Insurancerecord_Select_Column {
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AddrCity = 'addr_city',
  /** column name */
  AddrLine_1 = 'addr_line_1',
  /** column name */
  AddrLine_2 = 'addr_line_2',
  /** column name */
  AddrState = 'addr_state',
  /** column name */
  AddrZipcode = 'addr_zipcode',
  /** column name */
  ClientDob = 'client_dob',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientPayerServiceRecordId = 'client_payer_service_record_id',
  /** column name */
  CoinsuranceRate = 'coinsurance_rate',
  /** column name */
  CommentsMemberCostShare = 'comments_member_cost_share',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeductibleResetDate = 'deductible_reset_date',
  /** column name */
  EffectiveStartDate = 'effective_start_date',
  /** column name */
  EffectiveTerminationDate = 'effective_termination_date',
  /** column name */
  FullName = 'full_name',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedClientName = 'imported_client_name',
  /** column name */
  InsuranceAssignment = 'insurance_assignment',
  /** column name */
  InsuranceCompanyId = 'insurance_company_id',
  /** column name */
  IsMedical = 'is_medical',
  /** column name */
  IsMedicare = 'is_medicare',
  /** column name */
  IsPrimaryBeneficiary = 'is_primary_beneficiary',
  /** column name */
  IsVisitingMember = 'is_visiting_member',
  /** column name */
  MemberCostShare = 'member_cost_share',
  /** column name */
  MemberCostShareRemote = 'member_cost_share_remote',
  /** column name */
  MemberCostShareRemoteGroupTherapy = 'member_cost_share_remote_group_therapy',
  /** column name */
  MemberId = 'member_id',
  /** column name */
  OonAllowedAmounts = 'oon_allowed_amounts',
  /** column name */
  OonDeductible = 'oon_deductible',
  /** column name */
  OonDeductibleRemaining = 'oon_deductible_remaining',
  /** column name */
  Plan = 'plan',
  /** column name */
  PlanType = 'plan_type',
  /** column name */
  PrimaryBeneficiaryDob = 'primary_beneficiary_dob',
  /** column name */
  PrimaryBeneficiaryGender = 'primary_beneficiary_gender',
  /** column name */
  PrimaryBeneficiaryName = 'primary_beneficiary_name',
  /** column name */
  PrimaryBeneficiaryRelationship = 'primary_beneficiary_relationship',
  /** column name */
  SexOnInsuranceCard = 'sex_on_insurance_card',
  /** column name */
  Source = 'source',
  /** column name */
  SuperbillNumber = 'superbill_number',
  /** column name */
  WelkinCdtId = 'welkin_cdt_id'
}

/** order by stddev() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Insurancerecord_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Insurancerecord_Stream_Cursor_Value_Input = {
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  addr_city?: InputMaybe<Scalars['String']>;
  addr_line_1?: InputMaybe<Scalars['String']>;
  addr_line_2?: InputMaybe<Scalars['String']>;
  addr_state?: InputMaybe<Scalars['String']>;
  addr_zipcode?: InputMaybe<Scalars['String']>;
  client_dob?: InputMaybe<Scalars['date']>;
  client_id?: InputMaybe<Scalars['Int']>;
  client_payer_service_record_id?: InputMaybe<Scalars['uuid']>;
  coinsurance_rate?: InputMaybe<Scalars['numeric']>;
  comments_member_cost_share?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deductible_reset_date?: InputMaybe<Scalars['date']>;
  effective_start_date?: InputMaybe<Scalars['timestamptz']>;
  effective_termination_date?: InputMaybe<Scalars['timestamptz']>;
  full_name?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  imported_client_name?: InputMaybe<Scalars['String']>;
  insurance_assignment?: InputMaybe<Scalars['String']>;
  insurance_company_id?: InputMaybe<Scalars['uuid']>;
  is_medical?: InputMaybe<Scalars['Boolean']>;
  is_medicare?: InputMaybe<Scalars['Boolean']>;
  is_primary_beneficiary?: InputMaybe<Scalars['Boolean']>;
  is_visiting_member?: InputMaybe<Scalars['Boolean']>;
  member_cost_share?: InputMaybe<Scalars['numeric']>;
  member_cost_share_remote?: InputMaybe<Scalars['numeric']>;
  member_cost_share_remote_group_therapy?: InputMaybe<Scalars['numeric']>;
  member_id?: InputMaybe<Scalars['String']>;
  oon_allowed_amounts?: InputMaybe<Scalars['jsonb']>;
  oon_deductible?: InputMaybe<Scalars['numeric']>;
  oon_deductible_remaining?: InputMaybe<Scalars['numeric']>;
  plan?: InputMaybe<Scalars['String']>;
  plan_type?: InputMaybe<Scalars['String']>;
  primary_beneficiary_dob?: InputMaybe<Scalars['date']>;
  primary_beneficiary_gender?: InputMaybe<Scalars['String']>;
  primary_beneficiary_name?: InputMaybe<Scalars['String']>;
  primary_beneficiary_relationship?: InputMaybe<Scalars['String']>;
  sex_on_insurance_card?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  superbill_number?: InputMaybe<Scalars['Int']>;
  welkin_cdt_id?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_insurancerecord" */
export type Ehr_Insurancerecord_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  coinsurance_rate?: InputMaybe<Order_By>;
  member_cost_share?: InputMaybe<Order_By>;
  member_cost_share_remote?: InputMaybe<Order_By>;
  member_cost_share_remote_group_therapy?: InputMaybe<Order_By>;
  oon_deductible?: InputMaybe<Order_By>;
  oon_deductible_remaining?: InputMaybe<Order_By>;
  superbill_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation = {
  __typename?: 'ehr_manualslotreservation';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id: Scalars['Int'];
  couple_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  even_or_odd?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  match_id?: Maybe<Scalars['Int']>;
  slot_day_of_week: Scalars['String'];
  slot_recurrence: Scalars['String'];
  slot_time_of_day?: Maybe<Scalars['time']>;
  slot_type: Scalars['String'];
  start_date: Scalars['date'];
  /** Returns the date after which this MSR is no longer valid. This differs from end_date in that this date is inclusive of the final session of the MSR, whereas the end_date describes an exclusive range bound. */
  valid_until_date?: Maybe<Scalars['date']>;
};

/** order by aggregate values of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Manualslotreservation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Manualslotreservation_Max_Order_By>;
  min?: InputMaybe<Ehr_Manualslotreservation_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Manualslotreservation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Manualslotreservation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Manualslotreservation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Manualslotreservation_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Manualslotreservation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Manualslotreservation_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Manualslotreservation_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_manualslotreservation". All fields are combined with a logical 'AND'. */
export type Ehr_Manualslotreservation_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Manualslotreservation_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Manualslotreservation_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  even_or_odd?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  slot_day_of_week?: InputMaybe<String_Comparison_Exp>;
  slot_recurrence?: InputMaybe<String_Comparison_Exp>;
  slot_time_of_day?: InputMaybe<Time_Comparison_Exp>;
  slot_type?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  valid_until_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_manualslotreservation". */
export type Ehr_Manualslotreservation_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_time_of_day?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  valid_until_date?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_manualslotreservation" */
export enum Ehr_Manualslotreservation_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EvenOrOdd = 'even_or_odd',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  SlotDayOfWeek = 'slot_day_of_week',
  /** column name */
  SlotRecurrence = 'slot_recurrence',
  /** column name */
  SlotTimeOfDay = 'slot_time_of_day',
  /** column name */
  SlotType = 'slot_type',
  /** column name */
  StartDate = 'start_date'
}

/** order by stddev() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Manualslotreservation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Manualslotreservation_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  end_date?: InputMaybe<Scalars['date']>;
  even_or_odd?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['Int']>;
  slot_day_of_week?: InputMaybe<Scalars['String']>;
  slot_recurrence?: InputMaybe<Scalars['String']>;
  slot_time_of_day?: InputMaybe<Scalars['time']>;
  slot_type?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** order by sum() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_manualslotreservation" */
export type Ehr_Manualslotreservation_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_match" */
export type Ehr_Match = {
  __typename?: 'ehr_match';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  appointment_id?: Maybe<Scalars['Int']>;
  assignee_id?: Maybe<Scalars['Int']>;
  cadence_pref_strength: Scalars['String'];
  client_id?: Maybe<Scalars['Int']>;
  client_prefers_ot: Scalars['Boolean'];
  clinician_approves_ot: Scalars['Boolean'];
  conflict_of_interest: Scalars['String'];
  consult_id?: Maybe<Scalars['uuid']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  delay_match_email: Scalars['Boolean'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery_preference?: Maybe<Scalars['String']>;
  /** An array relationship */
  ehr_manualslotreservations: Array<Ehr_Manualslotreservation>;
  /** An array relationship */
  ehr_matchageranges: Array<Ehr_Matchagerange>;
  /** An array relationship */
  ehr_matchauditlogs: Array<Ehr_Matchauditlog>;
  /** An array relationship */
  ehr_matchslotpreferences: Array<Ehr_Matchslotpreference>;
  exclude_from_aqm: Scalars['Boolean'];
  first_reservation_instance_id?: Maybe<Scalars['uuid']>;
  high_priority: Scalars['Boolean'];
  hybrid_preference?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_biweekly_fit: Scalars['Boolean'];
  is_match_to_timeslot: Scalars['Boolean'];
  is_rematch: Scalars['Boolean'];
  is_test_data: Scalars['Boolean'];
  match_after?: Maybe<Scalars['timestamptz']>;
  match_email_sent?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  match_metadata?: Maybe<Hasura_Cwa__Match_With_Status>;
  match_note: Scalars['String'];
  max_score: Scalars['float8'];
  methodology_version: Scalars['Int'];
  modified_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  queue_note: Scalars['String'];
  queue_update_email_sent?: Maybe<Scalars['timestamptz']>;
  referral_note: Scalars['String'];
  rematch_id?: Maybe<Scalars['Int']>;
  rematch_note: Scalars['String'];
  reminder_email_sent?: Maybe<Scalars['timestamptz']>;
  requeue_reason?: Maybe<Scalars['String']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by_id?: Maybe<Scalars['Int']>;
  resolved_modality?: Maybe<Scalars['String']>;
  resolved_recurrence?: Maybe<Scalars['String']>;
  returning_to_same_clinician: Scalars['Boolean'];
  scheduling_link?: Maybe<Scalars['String']>;
  selected_fit_id?: Maybe<Scalars['Int']>;
  service_type: Scalars['String'];
  status: Scalars['String'];
};


/** columns and relationships of "ehr_match" */
export type Ehr_MatchEhr_ManualslotreservationsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Manualslotreservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Manualslotreservation_Order_By>>;
  where?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
};


/** columns and relationships of "ehr_match" */
export type Ehr_MatchEhr_MatchagerangesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchagerange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchagerange_Order_By>>;
  where?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
};


/** columns and relationships of "ehr_match" */
export type Ehr_MatchEhr_MatchauditlogsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchauditlog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchauditlog_Order_By>>;
  where?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
};


/** columns and relationships of "ehr_match" */
export type Ehr_MatchEhr_MatchslotpreferencesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchslotpreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchslotpreference_Order_By>>;
  where?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
};

/** order by aggregate values of table "ehr_match" */
export type Ehr_Match_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Match_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Match_Max_Order_By>;
  min?: InputMaybe<Ehr_Match_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Match_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Match_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Match_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Match_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Match_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Match_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Match_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_match" */
export type Ehr_Match_Avg_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_match". All fields are combined with a logical 'AND'. */
export type Ehr_Match_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Match_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Match_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Match_Bool_Exp>>;
  appointment_id?: InputMaybe<Int_Comparison_Exp>;
  assignee_id?: InputMaybe<Int_Comparison_Exp>;
  cadence_pref_strength?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_prefers_ot?: InputMaybe<Boolean_Comparison_Exp>;
  clinician_approves_ot?: InputMaybe<Boolean_Comparison_Exp>;
  conflict_of_interest?: InputMaybe<String_Comparison_Exp>;
  consult_id?: InputMaybe<Uuid_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  delay_match_email?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_preference?: InputMaybe<String_Comparison_Exp>;
  ehr_manualslotreservations?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
  ehr_matchageranges?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
  ehr_matchauditlogs?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
  ehr_matchslotpreferences?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
  exclude_from_aqm?: InputMaybe<Boolean_Comparison_Exp>;
  first_reservation_instance_id?: InputMaybe<Uuid_Comparison_Exp>;
  high_priority?: InputMaybe<Boolean_Comparison_Exp>;
  hybrid_preference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_biweekly_fit?: InputMaybe<Boolean_Comparison_Exp>;
  is_match_to_timeslot?: InputMaybe<Boolean_Comparison_Exp>;
  is_rematch?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  match_after?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_metadata?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
  match_note?: InputMaybe<String_Comparison_Exp>;
  max_score?: InputMaybe<Float8_Comparison_Exp>;
  methodology_version?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  queue_note?: InputMaybe<String_Comparison_Exp>;
  queue_update_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  referral_note?: InputMaybe<String_Comparison_Exp>;
  rematch_id?: InputMaybe<Int_Comparison_Exp>;
  rematch_note?: InputMaybe<String_Comparison_Exp>;
  reminder_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  requeue_reason?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolved_by_id?: InputMaybe<Int_Comparison_Exp>;
  resolved_modality?: InputMaybe<String_Comparison_Exp>;
  resolved_recurrence?: InputMaybe<String_Comparison_Exp>;
  returning_to_same_clinician?: InputMaybe<Boolean_Comparison_Exp>;
  scheduling_link?: InputMaybe<String_Comparison_Exp>;
  selected_fit_id?: InputMaybe<Int_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_match" */
export type Ehr_Match_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_note?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_modality?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_match" */
export type Ehr_Match_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_note?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_modality?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_match". */
export type Ehr_Match_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_prefers_ot?: InputMaybe<Order_By>;
  clinician_approves_ot?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  delay_match_email?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  ehr_manualslotreservations_aggregate?: InputMaybe<Ehr_Manualslotreservation_Aggregate_Order_By>;
  ehr_matchageranges_aggregate?: InputMaybe<Ehr_Matchagerange_Aggregate_Order_By>;
  ehr_matchauditlogs_aggregate?: InputMaybe<Ehr_Matchauditlog_Aggregate_Order_By>;
  ehr_matchslotpreferences_aggregate?: InputMaybe<Ehr_Matchslotpreference_Aggregate_Order_By>;
  exclude_from_aqm?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  high_priority?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_biweekly_fit?: InputMaybe<Order_By>;
  is_match_to_timeslot?: InputMaybe<Order_By>;
  is_rematch?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_metadata?: InputMaybe<Hasura_Cwa__Match_With_Status_Order_By>;
  match_note?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_modality?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  returning_to_same_clinician?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

export type Ehr_Match_Requeue_Log = {
  __typename?: 'ehr_match_requeue_log';
  match_email_sent_before_requeue?: Maybe<Scalars['timestamptz']>;
  match_id: Scalars['Int'];
  match_resolved_at_before_requeue: Scalars['timestamptz'];
  requeue_reason: Scalars['String'];
  requeue_timestamp: Scalars['timestamptz'];
  status_before_requeue: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "ehr_match_requeue_log". All fields are combined with a logical 'AND'. */
export type Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp>>;
  match_email_sent_before_requeue?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  match_resolved_at_before_requeue?: InputMaybe<Timestamptz_Comparison_Exp>;
  requeue_reason?: InputMaybe<String_Comparison_Exp>;
  requeue_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  status_before_requeue?: InputMaybe<String_Comparison_Exp>;
};

export enum Ehr_Match_Requeue_Log_Enum_Name {
  /** column name */
  MatchEmailSentBeforeRequeue = 'match_email_sent_before_requeue',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  MatchResolvedAtBeforeRequeue = 'match_resolved_at_before_requeue',
  /** column name */
  RequeueReason = 'requeue_reason',
  /** column name */
  RequeueTimestamp = 'requeue_timestamp',
  /** column name */
  StatusBeforeRequeue = 'status_before_requeue'
}

/** Ordering options when selecting data from "ehr_match_requeue_log". */
export type Ehr_Match_Requeue_Log_Order_By = {
  match_email_sent_before_requeue?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_resolved_at_before_requeue?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  requeue_timestamp?: InputMaybe<Order_By>;
  status_before_requeue?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_match" */
export enum Ehr_Match_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  AssigneeId = 'assignee_id',
  /** column name */
  CadencePrefStrength = 'cadence_pref_strength',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientPrefersOt = 'client_prefers_ot',
  /** column name */
  ClinicianApprovesOt = 'clinician_approves_ot',
  /** column name */
  ConflictOfInterest = 'conflict_of_interest',
  /** column name */
  ConsultId = 'consult_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DelayMatchEmail = 'delay_match_email',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryPreference = 'delivery_preference',
  /** column name */
  ExcludeFromAqm = 'exclude_from_aqm',
  /** column name */
  FirstReservationInstanceId = 'first_reservation_instance_id',
  /** column name */
  HighPriority = 'high_priority',
  /** column name */
  HybridPreference = 'hybrid_preference',
  /** column name */
  Id = 'id',
  /** column name */
  IsBiweeklyFit = 'is_biweekly_fit',
  /** column name */
  IsMatchToTimeslot = 'is_match_to_timeslot',
  /** column name */
  IsRematch = 'is_rematch',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  MatchAfter = 'match_after',
  /** column name */
  MatchEmailSent = 'match_email_sent',
  /** column name */
  MatchNote = 'match_note',
  /** column name */
  MaxScore = 'max_score',
  /** column name */
  MethodologyVersion = 'methodology_version',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  QueueNote = 'queue_note',
  /** column name */
  QueueUpdateEmailSent = 'queue_update_email_sent',
  /** column name */
  ReferralNote = 'referral_note',
  /** column name */
  RematchId = 'rematch_id',
  /** column name */
  RematchNote = 'rematch_note',
  /** column name */
  ReminderEmailSent = 'reminder_email_sent',
  /** column name */
  RequeueReason = 'requeue_reason',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedById = 'resolved_by_id',
  /** column name */
  ResolvedModality = 'resolved_modality',
  /** column name */
  ResolvedRecurrence = 'resolved_recurrence',
  /** column name */
  ReturningToSameClinician = 'returning_to_same_clinician',
  /** column name */
  SchedulingLink = 'scheduling_link',
  /** column name */
  SelectedFitId = 'selected_fit_id',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Status = 'status'
}

/** order by stddev() on columns of table "ehr_match" */
export type Ehr_Match_Stddev_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_match" */
export type Ehr_Match_Stddev_Pop_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_match" */
export type Ehr_Match_Stddev_Samp_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_match" */
export type Ehr_Match_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Match_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Match_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  appointment_id?: InputMaybe<Scalars['Int']>;
  assignee_id?: InputMaybe<Scalars['Int']>;
  cadence_pref_strength?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  client_prefers_ot?: InputMaybe<Scalars['Boolean']>;
  clinician_approves_ot?: InputMaybe<Scalars['Boolean']>;
  conflict_of_interest?: InputMaybe<Scalars['String']>;
  consult_id?: InputMaybe<Scalars['uuid']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  delay_match_email?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_preference?: InputMaybe<Scalars['String']>;
  exclude_from_aqm?: InputMaybe<Scalars['Boolean']>;
  first_reservation_instance_id?: InputMaybe<Scalars['uuid']>;
  high_priority?: InputMaybe<Scalars['Boolean']>;
  hybrid_preference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_biweekly_fit?: InputMaybe<Scalars['Boolean']>;
  is_match_to_timeslot?: InputMaybe<Scalars['Boolean']>;
  is_rematch?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  match_after?: InputMaybe<Scalars['timestamptz']>;
  match_email_sent?: InputMaybe<Scalars['timestamptz']>;
  match_note?: InputMaybe<Scalars['String']>;
  max_score?: InputMaybe<Scalars['float8']>;
  methodology_version?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  priority?: InputMaybe<Scalars['String']>;
  queue_note?: InputMaybe<Scalars['String']>;
  queue_update_email_sent?: InputMaybe<Scalars['timestamptz']>;
  referral_note?: InputMaybe<Scalars['String']>;
  rematch_id?: InputMaybe<Scalars['Int']>;
  rematch_note?: InputMaybe<Scalars['String']>;
  reminder_email_sent?: InputMaybe<Scalars['timestamptz']>;
  requeue_reason?: InputMaybe<Scalars['String']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']>;
  resolved_by_id?: InputMaybe<Scalars['Int']>;
  resolved_modality?: InputMaybe<Scalars['String']>;
  resolved_recurrence?: InputMaybe<Scalars['String']>;
  returning_to_same_clinician?: InputMaybe<Scalars['Boolean']>;
  scheduling_link?: InputMaybe<Scalars['String']>;
  selected_fit_id?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_match" */
export type Ehr_Match_Sum_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_match" */
export type Ehr_Match_Var_Pop_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_match" */
export type Ehr_Match_Var_Samp_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_match" */
export type Ehr_Match_Variance_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_matchagerange" */
export type Ehr_Matchagerange = {
  __typename?: 'ehr_matchagerange';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_match: Ehr_Match;
  filter_clinical_fits: Scalars['Boolean'];
  match_id: Scalars['Int'];
  maximum_age?: Maybe<Scalars['Int']>;
  minimum_age?: Maybe<Scalars['Int']>;
  modified_at: Scalars['timestamptz'];
};

/** order by aggregate values of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Matchagerange_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Matchagerange_Max_Order_By>;
  min?: InputMaybe<Ehr_Matchagerange_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Matchagerange_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Matchagerange_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Matchagerange_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Matchagerange_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Matchagerange_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Matchagerange_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Matchagerange_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Avg_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_matchagerange". All fields are combined with a logical 'AND'. */
export type Ehr_Matchagerange_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Matchagerange_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Matchagerange_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_match?: InputMaybe<Ehr_Match_Bool_Exp>;
  filter_clinical_fits?: InputMaybe<Boolean_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  maximum_age?: InputMaybe<Int_Comparison_Exp>;
  minimum_age?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_matchagerange". */
export type Ehr_Matchagerange_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_match?: InputMaybe<Ehr_Match_Order_By>;
  filter_clinical_fits?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_matchagerange" */
export enum Ehr_Matchagerange_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FilterClinicalFits = 'filter_clinical_fits',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  MaximumAge = 'maximum_age',
  /** column name */
  MinimumAge = 'minimum_age',
  /** column name */
  ModifiedAt = 'modified_at'
}

/** order by stddev() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Stddev_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Stddev_Pop_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Stddev_Samp_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_matchagerange" */
export type Ehr_Matchagerange_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Matchagerange_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Matchagerange_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  filter_clinical_fits?: InputMaybe<Scalars['Boolean']>;
  match_id?: InputMaybe<Scalars['Int']>;
  maximum_age?: InputMaybe<Scalars['Int']>;
  minimum_age?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Sum_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Var_Pop_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Var_Samp_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_matchagerange" */
export type Ehr_Matchagerange_Variance_Order_By = {
  match_id?: InputMaybe<Order_By>;
  maximum_age?: InputMaybe<Order_By>;
  minimum_age?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_matchauditlog" */
export type Ehr_Matchauditlog = {
  __typename?: 'ehr_matchauditlog';
  action: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_match: Ehr_Match;
  id: Scalars['Int'];
  match_id: Scalars['Int'];
  match_immutable_version_id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  modified_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "ehr_matchauditlog" */
export type Ehr_MatchauditlogMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Matchauditlog_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Matchauditlog_Max_Order_By>;
  min?: InputMaybe<Ehr_Matchauditlog_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Matchauditlog_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Matchauditlog_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Matchauditlog_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Matchauditlog_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Matchauditlog_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Matchauditlog_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Matchauditlog_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_matchauditlog". All fields are combined with a logical 'AND'. */
export type Ehr_Matchauditlog_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Matchauditlog_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Matchauditlog_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_match?: InputMaybe<Ehr_Match_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  match_immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_immutable_version_id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_immutable_version_id?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_matchauditlog". */
export type Ehr_Matchauditlog_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_match?: InputMaybe<Ehr_Match_Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_immutable_version_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_matchauditlog" */
export enum Ehr_Matchauditlog_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  MatchImmutableVersionId = 'match_immutable_version_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Matchauditlog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Matchauditlog_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  match_id?: InputMaybe<Scalars['Int']>;
  match_immutable_version_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_matchauditlog" */
export type Ehr_Matchauditlog_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference = {
  __typename?: 'ehr_matchslotpreference';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  day_of_week: Scalars['String'];
  /** An object relationship */
  ehr_match: Ehr_Match;
  end_time: Scalars['time'];
  id: Scalars['uuid'];
  is_general: Scalars['Boolean'];
  is_maybe_slot: Scalars['Boolean'];
  location_preference_level?: Maybe<Scalars['String']>;
  match_id: Scalars['Int'];
  preference_origin: Scalars['String'];
  start_time: Scalars['time'];
  subregion_id?: Maybe<Scalars['Int']>;
};

/** order by aggregate values of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Matchslotpreference_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Matchslotpreference_Max_Order_By>;
  min?: InputMaybe<Ehr_Matchslotpreference_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Matchslotpreference_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Matchslotpreference_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Matchslotpreference_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Matchslotpreference_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Matchslotpreference_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Matchslotpreference_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Matchslotpreference_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Avg_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_matchslotpreference". All fields are combined with a logical 'AND'. */
export type Ehr_Matchslotpreference_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Matchslotpreference_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Matchslotpreference_Bool_Exp>>;
  day_of_week?: InputMaybe<String_Comparison_Exp>;
  ehr_match?: InputMaybe<Ehr_Match_Bool_Exp>;
  end_time?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_general?: InputMaybe<Boolean_Comparison_Exp>;
  is_maybe_slot?: InputMaybe<Boolean_Comparison_Exp>;
  location_preference_level?: InputMaybe<String_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  preference_origin?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Time_Comparison_Exp>;
  subregion_id?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_preference_level?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  preference_origin?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_preference_level?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  preference_origin?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_matchslotpreference". */
export type Ehr_Matchslotpreference_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  day_of_week?: InputMaybe<Order_By>;
  ehr_match?: InputMaybe<Ehr_Match_Order_By>;
  end_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_general?: InputMaybe<Order_By>;
  is_maybe_slot?: InputMaybe<Order_By>;
  location_preference_level?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  preference_origin?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_matchslotpreference" */
export enum Ehr_Matchslotpreference_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  DayOfWeek = 'day_of_week',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsGeneral = 'is_general',
  /** column name */
  IsMaybeSlot = 'is_maybe_slot',
  /** column name */
  LocationPreferenceLevel = 'location_preference_level',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  PreferenceOrigin = 'preference_origin',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  SubregionId = 'subregion_id'
}

/** order by stddev() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Stddev_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Stddev_Pop_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Stddev_Samp_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Matchslotpreference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Matchslotpreference_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  day_of_week?: InputMaybe<Scalars['String']>;
  end_time?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_general?: InputMaybe<Scalars['Boolean']>;
  is_maybe_slot?: InputMaybe<Scalars['Boolean']>;
  location_preference_level?: InputMaybe<Scalars['String']>;
  match_id?: InputMaybe<Scalars['Int']>;
  preference_origin?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['time']>;
  subregion_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Sum_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Var_Pop_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Var_Samp_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_matchslotpreference" */
export type Ehr_Matchslotpreference_Variance_Order_By = {
  match_id?: InputMaybe<Order_By>;
  subregion_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_matchtag". All fields are combined with a logical 'AND'. */
export type Ehr_Matchtag_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Matchtag_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Matchtag_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Matchtag_Bool_Exp>>;
};

/** unique or primary key constraints on table "ehr_matchtag" */
export enum Ehr_Matchtag_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrMatchtagPkey = 'ehr_matchtag_pkey'
}

/** input type for inserting data into table "ehr_matchtag" */
export type Ehr_Matchtag_Insert_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_inferred?: InputMaybe<Scalars['Boolean']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  match_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
  starred?: InputMaybe<Scalars['Boolean']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['float8']>;
};

/** response of any mutation on the table "ehr_matchtag" */
export type Ehr_Matchtag_Mutation_Response = {
  __typename?: 'ehr_matchtag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
};

/** on_conflict condition type for table "ehr_matchtag" */
export type Ehr_Matchtag_On_Conflict = {
  constraint: Ehr_Matchtag_Constraint;
  update_columns?: Array<Ehr_Matchtag_Update_Column>;
  where?: InputMaybe<Ehr_Matchtag_Bool_Exp>;
};

/** placeholder for update columns of table "ehr_matchtag" (current role has no relevant permissions) */
export enum Ehr_Matchtag_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "ehr_mbctrack" */
export type Ehr_Mbctrack = {
  __typename?: 'ehr_mbctrack';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  assessment_slug: Scalars['String'];
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  couple_id?: Maybe<Scalars['uuid']>;
  enrolled_in_length_of_care: Scalars['Boolean'];
  id: Scalars['uuid'];
  mbc_enabled: Scalars['Boolean'];
  primary_assessment?: Maybe<Scalars['String']>;
  service_type: Scalars['String'];
  session_count?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Mbctrack_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Mbctrack_Max_Order_By>;
  min?: InputMaybe<Ehr_Mbctrack_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Mbctrack_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Mbctrack_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Mbctrack_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Mbctrack_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Mbctrack_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Mbctrack_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Mbctrack_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_mbctrack". All fields are combined with a logical 'AND'. */
export type Ehr_Mbctrack_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Mbctrack_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Mbctrack_Bool_Exp>>;
  assessment_slug?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  enrolled_in_length_of_care?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mbc_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  primary_assessment?: InputMaybe<String_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  session_count?: InputMaybe<Int_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  primary_assessment?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  primary_assessment?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_mbctrack". */
export type Ehr_Mbctrack_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_slug?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  enrolled_in_length_of_care?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mbc_enabled?: InputMaybe<Order_By>;
  primary_assessment?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_mbctrack" */
export enum Ehr_Mbctrack_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AssessmentSlug = 'assessment_slug',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  EnrolledInLengthOfCare = 'enrolled_in_length_of_care',
  /** column name */
  Id = 'id',
  /** column name */
  MbcEnabled = 'mbc_enabled',
  /** column name */
  PrimaryAssessment = 'primary_assessment',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  SessionCount = 'session_count',
  /** column name */
  Severity = 'severity'
}

/** order by stddev() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_mbctrack" */
export type Ehr_Mbctrack_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Mbctrack_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Mbctrack_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  assessment_slug?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  enrolled_in_length_of_care?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mbc_enabled?: InputMaybe<Scalars['Boolean']>;
  primary_assessment?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  session_count?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_mbctrack" */
export type Ehr_Mbctrack_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_notification" */
export type Ehr_Notification = {
  __typename?: 'ehr_notification';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_type?: Maybe<Scalars['String']>;
  couple_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event?: Maybe<Ehr_Event>;
  event_claim_data_id?: Maybe<Scalars['uuid']>;
  event_id?: Maybe<Scalars['uuid']>;
  group_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  match_id?: Maybe<Scalars['Int']>;
  match_id_list_string?: Maybe<Scalars['String']>;
  match_session_date?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  reminder_time_key?: Maybe<Scalars['String']>;
  response_body?: Maybe<Scalars['jsonb']>;
  response_status?: Maybe<Scalars['Int']>;
  sent_status: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "ehr_notification" */
export type Ehr_NotificationResponse_BodyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_notification" */
export type Ehr_Notification_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Notification_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Notification_Max_Order_By>;
  min?: InputMaybe<Ehr_Notification_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Notification_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Notification_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Notification_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Notification_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Notification_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Notification_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Notification_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_notification" */
export type Ehr_Notification_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_notification". All fields are combined with a logical 'AND'. */
export type Ehr_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Notification_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Notification_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_type?: InputMaybe<String_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  event?: InputMaybe<Ehr_Event_Bool_Exp>;
  event_claim_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  match_id_list_string?: InputMaybe<String_Comparison_Exp>;
  match_session_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reminder_time_key?: InputMaybe<String_Comparison_Exp>;
  response_body?: InputMaybe<Jsonb_Comparison_Exp>;
  response_status?: InputMaybe<Int_Comparison_Exp>;
  sent_status?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_notification" */
export type Ehr_Notification_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_type?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  event_claim_data_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_id_list_string?: InputMaybe<Order_By>;
  match_session_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reminder_time_key?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  sent_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_notification" */
export type Ehr_Notification_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_type?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  event_claim_data_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_id_list_string?: InputMaybe<Order_By>;
  match_session_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reminder_time_key?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  sent_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_notification". */
export type Ehr_Notification_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_type?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  event?: InputMaybe<Ehr_Event_Order_By>;
  event_claim_data_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  match_id_list_string?: InputMaybe<Order_By>;
  match_session_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reminder_time_key?: InputMaybe<Order_By>;
  response_body?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  sent_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_notification" */
export enum Ehr_Notification_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ClinicianType = 'clinician_type',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  EventClaimDataId = 'event_claim_data_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  MatchIdListString = 'match_id_list_string',
  /** column name */
  MatchSessionDate = 'match_session_date',
  /** column name */
  Name = 'name',
  /** column name */
  ReminderTimeKey = 'reminder_time_key',
  /** column name */
  ResponseBody = 'response_body',
  /** column name */
  ResponseStatus = 'response_status',
  /** column name */
  SentStatus = 'sent_status',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "ehr_notification" */
export type Ehr_Notification_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_notification" */
export type Ehr_Notification_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_notification" */
export type Ehr_Notification_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_notification" */
export type Ehr_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Notification_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  clinician_type?: InputMaybe<Scalars['String']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  event_claim_data_id?: InputMaybe<Scalars['uuid']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['Int']>;
  match_id_list_string?: InputMaybe<Scalars['String']>;
  match_session_date?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  reminder_time_key?: InputMaybe<Scalars['String']>;
  response_body?: InputMaybe<Scalars['jsonb']>;
  response_status?: InputMaybe<Scalars['Int']>;
  sent_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_notification" */
export type Ehr_Notification_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_notification" */
export type Ehr_Notification_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_notification" */
export type Ehr_Notification_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_notification" */
export type Ehr_Notification_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  response_status?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_payer" */
export type Ehr_Payer = {
  __typename?: 'ehr_payer';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  acronym?: Maybe<Scalars['String']>;
  config_is_tos_displayed?: Maybe<Scalars['Boolean']>;
  config_is_zero_charge_for_noshows: Scalars['Boolean'];
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  insurance_company_id?: Maybe<Scalars['uuid']>;
  internal_name?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_payer". All fields are combined with a logical 'AND'. */
export type Ehr_Payer_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Payer_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Payer_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Payer_Bool_Exp>>;
  acronym?: InputMaybe<String_Comparison_Exp>;
  config_is_tos_displayed?: InputMaybe<Boolean_Comparison_Exp>;
  config_is_zero_charge_for_noshows?: InputMaybe<Boolean_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_payer". */
export type Ehr_Payer_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  acronym?: InputMaybe<Order_By>;
  config_is_tos_displayed?: InputMaybe<Order_By>;
  config_is_zero_charge_for_noshows?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_company_id?: InputMaybe<Order_By>;
  internal_name?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_payer" */
export enum Ehr_Payer_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  Acronym = 'acronym',
  /** column name */
  ConfigIsTosDisplayed = 'config_is_tos_displayed',
  /** column name */
  ConfigIsZeroChargeForNoshows = 'config_is_zero_charge_for_noshows',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceCompanyId = 'insurance_company_id',
  /** column name */
  InternalName = 'internal_name'
}

/** Streaming cursor of the table "ehr_payer" */
export type Ehr_Payer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Payer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Payer_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  acronym?: InputMaybe<Scalars['String']>;
  config_is_tos_displayed?: InputMaybe<Scalars['Boolean']>;
  config_is_zero_charge_for_noshows?: InputMaybe<Scalars['Boolean']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurance_company_id?: InputMaybe<Scalars['uuid']>;
  internal_name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_progressreview" */
export type Ehr_Progressreview = {
  __typename?: 'ehr_progressreview';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  assessment_metadata: Scalars['jsonb'];
  client_id: Scalars['Int'];
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_client: Ehr_Client;
  /** An object relationship */
  ehr_clinician: Ehr_Clinician;
  /** An array relationship */
  ehr_progressreviewclientresponses: Array<Ehr_Progressreviewclientresponses>;
  id: Scalars['Int'];
  mbc_data: Scalars['jsonb'];
  responses: Scalars['jsonb'];
  session_number: Scalars['Int'];
  survey_type: Scalars['String'];
};


/** columns and relationships of "ehr_progressreview" */
export type Ehr_ProgressreviewAssessment_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_progressreview" */
export type Ehr_ProgressreviewEhr_ProgressreviewclientresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Order_By>>;
  where?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
};


/** columns and relationships of "ehr_progressreview" */
export type Ehr_ProgressreviewMbc_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_progressreview" */
export type Ehr_ProgressreviewResponsesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_progressreview" */
export type Ehr_Progressreview_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Progressreview_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Progressreview_Max_Order_By>;
  min?: InputMaybe<Ehr_Progressreview_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Progressreview_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Progressreview_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Progressreview_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Progressreview_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Progressreview_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Progressreview_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Progressreview_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_progressreview". All fields are combined with a logical 'AND'. */
export type Ehr_Progressreview_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Progressreview_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Progressreview_Bool_Exp>>;
  assessment_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  ehr_progressreviewclientresponses?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mbc_data?: InputMaybe<Jsonb_Comparison_Exp>;
  responses?: InputMaybe<Jsonb_Comparison_Exp>;
  session_number?: InputMaybe<Int_Comparison_Exp>;
  survey_type?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  survey_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  survey_type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_progressreview". */
export type Ehr_Progressreview_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  assessment_metadata?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  ehr_progressreviewclientresponses_aggregate?: InputMaybe<Ehr_Progressreviewclientresponses_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  mbc_data?: InputMaybe<Order_By>;
  responses?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  survey_type?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_progressreview" */
export enum Ehr_Progressreview_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AssessmentMetadata = 'assessment_metadata',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MbcData = 'mbc_data',
  /** column name */
  Responses = 'responses',
  /** column name */
  SessionNumber = 'session_number',
  /** column name */
  SurveyType = 'survey_type'
}

/** order by stddev() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_progressreview" */
export type Ehr_Progressreview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Progressreview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Progressreview_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  assessment_metadata?: InputMaybe<Scalars['jsonb']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  mbc_data?: InputMaybe<Scalars['jsonb']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  session_number?: InputMaybe<Scalars['Int']>;
  survey_type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_progressreview" */
export type Ehr_Progressreview_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses = {
  __typename?: 'ehr_progressreviewclientresponses';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  client_id: Scalars['Int'];
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  progress_review_id: Scalars['Int'];
  responses?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "ehr_progressreviewclientresponses" */
export type Ehr_ProgressreviewclientresponsesResponsesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Progressreviewclientresponses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Progressreviewclientresponses_Max_Order_By>;
  min?: InputMaybe<Ehr_Progressreviewclientresponses_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Progressreviewclientresponses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Progressreviewclientresponses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Progressreviewclientresponses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Progressreviewclientresponses_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Progressreviewclientresponses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Progressreviewclientresponses_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Progressreviewclientresponses_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_progressreviewclientresponses". All fields are combined with a logical 'AND'. */
export type Ehr_Progressreviewclientresponses_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  progress_review_id?: InputMaybe<Int_Comparison_Exp>;
  responses?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_progressreviewclientresponses". */
export type Ehr_Progressreviewclientresponses_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
  responses?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_progressreviewclientresponses" */
export enum Ehr_Progressreviewclientresponses_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProgressReviewId = 'progress_review_id',
  /** column name */
  Responses = 'responses',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Progressreviewclientresponses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Progressreviewclientresponses_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  progress_review_id?: InputMaybe<Scalars['Int']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_progressreviewclientresponses" */
export type Ehr_Progressreviewclientresponses_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_review_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_questionnaire" */
export type Ehr_Questionnaire = {
  __typename?: 'ehr_questionnaire';
  _date_start: Scalars['timestamptz'];
  _deleted: Scalars['Boolean'];
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  auth_user_created_by?: Maybe<Auth_User>;
  /** An object relationship */
  auth_user_updated_by?: Maybe<Auth_User>;
  content: Scalars['jsonb'];
  created_by_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  questionnaire_tags: Array<Ehr_Questionnaire_Tags>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "ehr_questionnaire" */
export type Ehr_QuestionnaireContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ehr_questionnaire" */
export type Ehr_QuestionnaireQuestionnaire_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnaire_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnaire_Tags_Order_By>>;
  where?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "ehr_questionnaire". All fields are combined with a logical 'AND'. */
export type Ehr_Questionnaire_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Questionnaire_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Ehr_Questionnaire_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Questionnaire_Bool_Exp>>;
  auth_user_created_by?: InputMaybe<Auth_User_Bool_Exp>;
  auth_user_updated_by?: InputMaybe<Auth_User_Bool_Exp>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  questionnaire_tags?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_questionnaire". */
export type Ehr_Questionnaire_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  auth_user_created_by?: InputMaybe<Auth_User_Order_By>;
  auth_user_updated_by?: InputMaybe<Auth_User_Order_By>;
  content?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  questionnaire_tags_aggregate?: InputMaybe<Ehr_Questionnaire_Tags_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_questionnaire" */
export enum Ehr_Questionnaire_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** Streaming cursor of the table "ehr_questionnaire" */
export type Ehr_Questionnaire_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Questionnaire_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Questionnaire_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['jsonb']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags = {
  __typename?: 'ehr_questionnaire_tags';
  id: Scalars['Int'];
  questionnaire_id: Scalars['Int'];
  questionnairetag_id: Scalars['Int'];
  /** An object relationship */
  tag: Ehr_Questionnairetag;
};

/** order by aggregate values of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Questionnaire_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Questionnaire_Tags_Max_Order_By>;
  min?: InputMaybe<Ehr_Questionnaire_Tags_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Questionnaire_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Questionnaire_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Questionnaire_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Questionnaire_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Questionnaire_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Questionnaire_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Questionnaire_Tags_Variance_Order_By>;
};

/** order by avg() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_questionnaire_tags". All fields are combined with a logical 'AND'. */
export type Ehr_Questionnaire_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Questionnaire_Tags_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Questionnaire_Tags_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnairetag_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Ehr_Questionnairetag_Bool_Exp>;
};

/** order by max() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_questionnaire_tags". */
export type Ehr_Questionnaire_Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Ehr_Questionnairetag_Order_By>;
};

/** select columns of table "ehr_questionnaire_tags" */
export enum Ehr_Questionnaire_Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  QuestionnairetagId = 'questionnairetag_id'
}

/** order by stddev() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Questionnaire_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Questionnaire_Tags_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  questionnairetag_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "ehr_questionnaire_tags" */
export type Ehr_Questionnaire_Tags_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnairetag_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_questionnairetag" */
export type Ehr_Questionnairetag = {
  __typename?: 'ehr_questionnairetag';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "ehr_questionnairetag". All fields are combined with a logical 'AND'. */
export type Ehr_Questionnairetag_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Questionnairetag_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Questionnairetag_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Questionnairetag_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_questionnairetag". */
export type Ehr_Questionnairetag_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_questionnairetag" */
export enum Ehr_Questionnairetag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "ehr_questionnairetag" */
export type Ehr_Questionnairetag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Questionnairetag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Questionnairetag_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_referral" */
export type Ehr_Referral = {
  __typename?: 'ehr_referral';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_clientpayerservicerecord?: Maybe<Ehr_Clientpayerservicerecord>;
  /** An object relationship */
  ehr_group?: Maybe<Ehr_Group>;
  id: Scalars['uuid'];
  insurance_member_id?: Maybe<Scalars['String']>;
  language_needed?: Maybe<Scalars['String']>;
  needs_interpreter_services: Scalars['Boolean'];
};

/** order by aggregate values of table "ehr_referral" */
export type Ehr_Referral_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Referral_Max_Order_By>;
  min?: InputMaybe<Ehr_Referral_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_referral". All fields are combined with a logical 'AND'. */
export type Ehr_Referral_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Referral_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Referral_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Referral_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clientpayerservicerecord?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
  ehr_group?: InputMaybe<Ehr_Group_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insurance_member_id?: InputMaybe<String_Comparison_Exp>;
  language_needed?: InputMaybe<String_Comparison_Exp>;
  needs_interpreter_services?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_referral" */
export type Ehr_Referral_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_member_id?: InputMaybe<Order_By>;
  language_needed?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_referral" */
export type Ehr_Referral_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_member_id?: InputMaybe<Order_By>;
  language_needed?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_referral". */
export type Ehr_Referral_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clientpayerservicerecord?: InputMaybe<Ehr_Clientpayerservicerecord_Order_By>;
  ehr_group?: InputMaybe<Ehr_Group_Order_By>;
  id?: InputMaybe<Order_By>;
  insurance_member_id?: InputMaybe<Order_By>;
  language_needed?: InputMaybe<Order_By>;
  needs_interpreter_services?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_referral" */
export enum Ehr_Referral_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceMemberId = 'insurance_member_id',
  /** column name */
  LanguageNeeded = 'language_needed',
  /** column name */
  NeedsInterpreterServices = 'needs_interpreter_services'
}

/** Streaming cursor of the table "ehr_referral" */
export type Ehr_Referral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Referral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Referral_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurance_member_id?: InputMaybe<Scalars['String']>;
  language_needed?: InputMaybe<Scalars['String']>;
  needs_interpreter_services?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "ehr_referralauthorization" */
export type Ehr_Referralauthorization = {
  __typename?: 'ehr_referralauthorization';
  authorization_code: Scalars['String'];
  id: Scalars['uuid'];
};

/** order by aggregate values of table "ehr_referralauthorization" */
export type Ehr_Referralauthorization_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Referralauthorization_Max_Order_By>;
  min?: InputMaybe<Ehr_Referralauthorization_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_referralauthorization". All fields are combined with a logical 'AND'. */
export type Ehr_Referralauthorization_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Referralauthorization_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Referralauthorization_Bool_Exp>>;
  authorization_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "ehr_referralauthorization" */
export type Ehr_Referralauthorization_Max_Order_By = {
  authorization_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ehr_referralauthorization" */
export type Ehr_Referralauthorization_Min_Order_By = {
  authorization_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ehr_referralauthorization". */
export type Ehr_Referralauthorization_Order_By = {
  authorization_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_referralauthorization" */
export enum Ehr_Referralauthorization_Select_Column {
  /** column name */
  AuthorizationCode = 'authorization_code',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "ehr_referralauthorization" */
export type Ehr_Referralauthorization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Referralauthorization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Referralauthorization_Stream_Cursor_Value_Input = {
  authorization_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "ehr_tag" */
export type Ehr_Tag = {
  __typename?: 'ehr_tag';
  bucket: Scalars['String'];
  category: Scalars['String'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shown_in_matchtool: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  used_for_couples: Scalars['Boolean'];
  used_for_individual: Scalars['Boolean'];
  version: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "ehr_tag". All fields are combined with a logical 'AND'. */
export type Ehr_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Tag_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Tag_Bool_Exp>>;
  bucket?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shown_in_matchtool?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  used_for_couples?: InputMaybe<Boolean_Comparison_Exp>;
  used_for_individual?: InputMaybe<Boolean_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_tag". */
export type Ehr_Tag_Order_By = {
  bucket?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shown_in_matchtool?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  used_for_couples?: InputMaybe<Order_By>;
  used_for_individual?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_tag" */
export enum Ehr_Tag_Select_Column {
  /** column name */
  Bucket = 'bucket',
  /** column name */
  Category = 'category',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ShownInMatchtool = 'shown_in_matchtool',
  /** column name */
  Status = 'status',
  /** column name */
  UsedForCouples = 'used_for_couples',
  /** column name */
  UsedForIndividual = 'used_for_individual',
  /** column name */
  Version = 'version'
}

/** Streaming cursor of the table "ehr_tag" */
export type Ehr_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Tag_Stream_Cursor_Value_Input = {
  bucket?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  shown_in_matchtool?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  used_for_couples?: InputMaybe<Scalars['Boolean']>;
  used_for_individual?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "ehr_timeoff" */
export type Ehr_Timeoff = {
  __typename?: 'ehr_timeoff';
  clinician_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehr_clinician: Ehr_Clinician;
  end_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_paid: Scalars['Boolean'];
  modified_at: Scalars['timestamptz'];
  pto_type: Scalars['String'];
  start_at: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "ehr_timeoff". All fields are combined with a logical 'AND'. */
export type Ehr_Timeoff_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Timeoff_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Timeoff_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Timeoff_Bool_Exp>>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  pto_type?: InputMaybe<String_Comparison_Exp>;
  start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "ehr_timeoff". */
export type Ehr_Timeoff_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  end_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  pto_type?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_timeoff" */
export enum Ehr_Timeoff_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  PtoType = 'pto_type',
  /** column name */
  StartAt = 'start_at'
}

/** Streaming cursor of the table "ehr_timeoff" */
export type Ehr_Timeoff_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Timeoff_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Timeoff_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  end_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_paid?: InputMaybe<Scalars['Boolean']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  pto_type?: InputMaybe<Scalars['String']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "episode_of_care" */
export type Episode_Of_Care = {
  __typename?: 'episode_of_care';
  alliance?: Maybe<Scalars['float8']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  cancellation_type?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  client_session_number?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  clinician_session_number?: Maybe<Scalars['Int']>;
  ehr_clinician?: Maybe<Ehr_Clinician>;
  episode?: Maybe<Scalars['Int']>;
  event_id: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  gad?: Maybe<Scalars['float8']>;
  insert_ts?: Maybe<Scalars['timestamp']>;
  is_baseline?: Maybe<Scalars['Int']>;
  is_latest?: Maybe<Scalars['Int']>;
  is_latest_clinician_in_episode?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  payer_acronym?: Maybe<Scalars['String']>;
  payer_name?: Maybe<Scalars['String']>;
  phq?: Maybe<Scalars['float8']>;
  reason_for_new_episode?: Maybe<Scalars['String']>;
  row_hash?: Maybe<Scalars['String']>;
  same_clinician_over_60_days_last_session?: Maybe<Scalars['Int']>;
  service_type?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamp']>;
  track_primary_assessment?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "episode_of_care". All fields are combined with a logical 'AND'. */
export type Episode_Of_Care_Bool_Exp = {
  _and?: InputMaybe<Array<Episode_Of_Care_Bool_Exp>>;
  _not?: InputMaybe<Episode_Of_Care_Bool_Exp>;
  _or?: InputMaybe<Array<Episode_Of_Care_Bool_Exp>>;
  alliance?: InputMaybe<Float8_Comparison_Exp>;
  appointment_status?: InputMaybe<String_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_Comparison_Exp>;
  cancellation_type?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_session_number?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_session_number?: InputMaybe<Int_Comparison_Exp>;
  episode?: InputMaybe<Int_Comparison_Exp>;
  event_id?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gad?: InputMaybe<Float8_Comparison_Exp>;
  insert_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  is_baseline?: InputMaybe<Int_Comparison_Exp>;
  is_latest?: InputMaybe<Int_Comparison_Exp>;
  is_latest_clinician_in_episode?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  payer_acronym?: InputMaybe<String_Comparison_Exp>;
  payer_name?: InputMaybe<String_Comparison_Exp>;
  phq?: InputMaybe<Float8_Comparison_Exp>;
  reason_for_new_episode?: InputMaybe<String_Comparison_Exp>;
  row_hash?: InputMaybe<String_Comparison_Exp>;
  same_clinician_over_60_days_last_session?: InputMaybe<Int_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamp_Comparison_Exp>;
  track_primary_assessment?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "episode_of_care". */
export type Episode_Of_Care_Order_By = {
  alliance?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  cancellation_type?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_session_number?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  clinician_session_number?: InputMaybe<Order_By>;
  episode?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gad?: InputMaybe<Order_By>;
  insert_ts?: InputMaybe<Order_By>;
  is_baseline?: InputMaybe<Order_By>;
  is_latest?: InputMaybe<Order_By>;
  is_latest_clinician_in_episode?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  payer_acronym?: InputMaybe<Order_By>;
  payer_name?: InputMaybe<Order_By>;
  phq?: InputMaybe<Order_By>;
  reason_for_new_episode?: InputMaybe<Order_By>;
  row_hash?: InputMaybe<Order_By>;
  same_clinician_over_60_days_last_session?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  track_primary_assessment?: InputMaybe<Order_By>;
};

/** select columns of table "episode_of_care" */
export enum Episode_Of_Care_Select_Column {
  /** column name */
  Alliance = 'alliance',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CancellationType = 'cancellation_type',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientSessionNumber = 'client_session_number',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ClinicianSessionNumber = 'clinician_session_number',
  /** column name */
  Episode = 'episode',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gad = 'gad',
  /** column name */
  InsertTs = 'insert_ts',
  /** column name */
  IsBaseline = 'is_baseline',
  /** column name */
  IsLatest = 'is_latest',
  /** column name */
  IsLatestClinicianInEpisode = 'is_latest_clinician_in_episode',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PayerAcronym = 'payer_acronym',
  /** column name */
  PayerName = 'payer_name',
  /** column name */
  Phq = 'phq',
  /** column name */
  ReasonForNewEpisode = 'reason_for_new_episode',
  /** column name */
  RowHash = 'row_hash',
  /** column name */
  SameClinicianOver_60DaysLastSession = 'same_clinician_over_60_days_last_session',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TrackPrimaryAssessment = 'track_primary_assessment'
}

/** Streaming cursor of the table "episode_of_care" */
export type Episode_Of_Care_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Episode_Of_Care_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Episode_Of_Care_Stream_Cursor_Value_Input = {
  alliance?: InputMaybe<Scalars['float8']>;
  appointment_status?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  cancellation_type?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  client_session_number?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  clinician_session_number?: InputMaybe<Scalars['Int']>;
  episode?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  gad?: InputMaybe<Scalars['float8']>;
  insert_ts?: InputMaybe<Scalars['timestamp']>;
  is_baseline?: InputMaybe<Scalars['Int']>;
  is_latest?: InputMaybe<Scalars['Int']>;
  is_latest_clinician_in_episode?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  payer_acronym?: InputMaybe<Scalars['String']>;
  payer_name?: InputMaybe<Scalars['String']>;
  phq?: InputMaybe<Scalars['float8']>;
  reason_for_new_episode?: InputMaybe<Scalars['String']>;
  row_hash?: InputMaybe<Scalars['String']>;
  same_clinician_over_60_days_last_session?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamp']>;
  track_primary_assessment?: InputMaybe<Scalars['String']>;
};

export type F_Search_Clients_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** getClientServiceLinesNative Query Arguments */
export type GetClientServiceLines_Arguments = {
  client_id: Scalars['Int'];
};

/** getManySessionCountsFromLatestEoCNative Query Arguments */
export type GetManySessionCountsFromLatestEoC_Arguments = {
  client_ids: Scalars['String'];
};

/** getSessionCountFromLatestEpisodeOfCareNative Query Arguments */
export type GetSessionCountFromLatestEpisodeOfCare_Arguments = {
  client_id: Scalars['Int'];
};

/** columns and relationships of "hasura_cwa__event_recurrence_data" */
export type Hasura_Cwa__Event_Recurrence_Data = {
  __typename?: 'hasura_cwa__event_recurrence_data';
  event_id?: Maybe<Scalars['uuid']>;
  is_exception?: Maybe<Scalars['Boolean']>;
  isodow?: Maybe<Scalars['numeric']>;
  recurrence?: Maybe<Scalars['String']>;
  slot_id?: Maybe<Scalars['uuid']>;
};

/** Boolean expression to filter rows from the table "hasura_cwa__event_recurrence_data". All fields are combined with a logical 'AND'. */
export type Hasura_Cwa__Event_Recurrence_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>>;
  _not?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exception?: InputMaybe<Boolean_Comparison_Exp>;
  isodow?: InputMaybe<Numeric_Comparison_Exp>;
  recurrence?: InputMaybe<String_Comparison_Exp>;
  slot_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "hasura_cwa__event_recurrence_data". */
export type Hasura_Cwa__Event_Recurrence_Data_Order_By = {
  event_id?: InputMaybe<Order_By>;
  is_exception?: InputMaybe<Order_By>;
  isodow?: InputMaybe<Order_By>;
  recurrence?: InputMaybe<Order_By>;
  slot_id?: InputMaybe<Order_By>;
};

/** select columns of table "hasura_cwa__event_recurrence_data" */
export enum Hasura_Cwa__Event_Recurrence_Data_Select_Column {
  /** column name */
  EventId = 'event_id',
  /** column name */
  IsException = 'is_exception',
  /** column name */
  Isodow = 'isodow',
  /** column name */
  Recurrence = 'recurrence',
  /** column name */
  SlotId = 'slot_id'
}

/** Streaming cursor of the table "hasura_cwa__event_recurrence_data" */
export type Hasura_Cwa__Event_Recurrence_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hasura_Cwa__Event_Recurrence_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hasura_Cwa__Event_Recurrence_Data_Stream_Cursor_Value_Input = {
  event_id?: InputMaybe<Scalars['uuid']>;
  is_exception?: InputMaybe<Scalars['Boolean']>;
  isodow?: InputMaybe<Scalars['numeric']>;
  recurrence?: InputMaybe<Scalars['String']>;
  slot_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations = {
  __typename?: 'hasura_cwa__manual_slot_reservations';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _deleted?: Maybe<Scalars['Boolean']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  active?: Maybe<Scalars['Boolean']>;
  active_range?: Maybe<Scalars['daterange']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  couple_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  even_or_odd?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['Int']>;
  slot_day_of_week?: Maybe<Scalars['String']>;
  slot_recurrence?: Maybe<Scalars['String']>;
  slot_time_of_day?: Maybe<Scalars['time']>;
  slot_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  valid_until_date?: Maybe<Scalars['date']>;
};

/** order by aggregate values of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Aggregate_Order_By = {
  avg?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Max_Order_By>;
  min?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Min_Order_By>;
  stddev?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Sum_Order_By>;
  var_pop?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Var_Samp_Order_By>;
  variance?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Variance_Order_By>;
};

/** order by avg() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hasura_cwa__manual_slot_reservations". All fields are combined with a logical 'AND'. */
export type Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp = {
  _and?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
  _or?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  active_range?: InputMaybe<Daterange_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  even_or_odd?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Int_Comparison_Exp>;
  slot_day_of_week?: InputMaybe<String_Comparison_Exp>;
  slot_recurrence?: InputMaybe<String_Comparison_Exp>;
  slot_time_of_day?: InputMaybe<Time_Comparison_Exp>;
  slot_type?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  valid_until_date?: InputMaybe<Date_Comparison_Exp>;
};

/** order by max() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  valid_until_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  valid_until_date?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "hasura_cwa__manual_slot_reservations". */
export type Hasura_Cwa__Manual_Slot_Reservations_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  active_range?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  even_or_odd?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  slot_day_of_week?: InputMaybe<Order_By>;
  slot_recurrence?: InputMaybe<Order_By>;
  slot_time_of_day?: InputMaybe<Order_By>;
  slot_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  valid_until_date?: InputMaybe<Order_By>;
};

/** select columns of table "hasura_cwa__manual_slot_reservations" */
export enum Hasura_Cwa__Manual_Slot_Reservations_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  Active = 'active',
  /** column name */
  ActiveRange = 'active_range',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EvenOrOdd = 'even_or_odd',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  SlotDayOfWeek = 'slot_day_of_week',
  /** column name */
  SlotRecurrence = 'slot_recurrence',
  /** column name */
  SlotTimeOfDay = 'slot_time_of_day',
  /** column name */
  SlotType = 'slot_type',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  ValidUntilDate = 'valid_until_date'
}

/** order by stddev() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hasura_Cwa__Manual_Slot_Reservations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hasura_Cwa__Manual_Slot_Reservations_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_range?: InputMaybe<Scalars['daterange']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  end_date?: InputMaybe<Scalars['date']>;
  even_or_odd?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['Int']>;
  slot_day_of_week?: InputMaybe<Scalars['String']>;
  slot_recurrence?: InputMaybe<Scalars['String']>;
  slot_time_of_day?: InputMaybe<Scalars['time']>;
  slot_type?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
  valid_until_date?: InputMaybe<Scalars['date']>;
};

/** order by sum() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "hasura_cwa__manual_slot_reservations" */
export type Hasura_Cwa__Manual_Slot_Reservations_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status = {
  __typename?: 'hasura_cwa__match_with_status';
  _date_start?: Maybe<Scalars['timestamptz']>;
  _deleted?: Maybe<Scalars['Boolean']>;
  _immutable_version_id?: Maybe<Scalars['uuid']>;
  appointment_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  assignee_auth_user?: Maybe<Auth_User>;
  assignee_id?: Maybe<Scalars['Int']>;
  attended_appointments?: Maybe<Scalars['bigint']>;
  cadence_pref_strength?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  client_prefers_ot?: Maybe<Scalars['Boolean']>;
  client_status?: Maybe<Scalars['String']>;
  clinician_approves_ot?: Maybe<Scalars['Boolean']>;
  conflict_of_interest?: Maybe<Scalars['String']>;
  /** An object relationship */
  consult_event?: Maybe<Ehr_Event>;
  consult_id?: Maybe<Scalars['uuid']>;
  couple_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  delay_match_email?: Maybe<Scalars['Boolean']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery_preference?: Maybe<Scalars['String']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_match?: Maybe<Ehr_Match>;
  exclude_from_aqm?: Maybe<Scalars['Boolean']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  first_reservation_instance_id?: Maybe<Scalars['uuid']>;
  first_session_date?: Maybe<Scalars['date']>;
  first_session_datetime?: Maybe<Scalars['timestamptz']>;
  former_client?: Maybe<Scalars['Boolean']>;
  high_priority?: Maybe<Scalars['Boolean']>;
  hybrid_preference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_biweekly_fit?: Maybe<Scalars['Boolean']>;
  is_match_to_timeslot?: Maybe<Scalars['Boolean']>;
  is_rematch?: Maybe<Scalars['Boolean']>;
  is_test_data?: Maybe<Scalars['Boolean']>;
  match_after?: Maybe<Scalars['timestamptz']>;
  match_email_sent?: Maybe<Scalars['timestamptz']>;
  match_note?: Maybe<Scalars['String']>;
  matched_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  matched_clinician?: Maybe<Ehr_Clinician>;
  matched_clinician_id?: Maybe<Scalars['Int']>;
  max_score?: Maybe<Scalars['float8']>;
  methodology_version?: Maybe<Scalars['Int']>;
  modified_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  queue_note?: Maybe<Scalars['String']>;
  queue_update_email_sent?: Maybe<Scalars['timestamptz']>;
  referral_note?: Maybe<Scalars['String']>;
  rematch_id?: Maybe<Scalars['Int']>;
  rematch_note?: Maybe<Scalars['String']>;
  reminder_email_sent?: Maybe<Scalars['timestamptz']>;
  requeue_reason?: Maybe<Scalars['String']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by_id?: Maybe<Scalars['Int']>;
  resolved_recurrence?: Maybe<Scalars['String']>;
  returning_to_same_clinician?: Maybe<Scalars['Boolean']>;
  scheduled_appointments?: Maybe<Scalars['bigint']>;
  scheduling_link?: Maybe<Scalars['String']>;
  selected_fit_id?: Maybe<Scalars['Int']>;
  service_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Aggregate_Order_By = {
  avg?: InputMaybe<Hasura_Cwa__Match_With_Status_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Hasura_Cwa__Match_With_Status_Max_Order_By>;
  min?: InputMaybe<Hasura_Cwa__Match_With_Status_Min_Order_By>;
  stddev?: InputMaybe<Hasura_Cwa__Match_With_Status_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Hasura_Cwa__Match_With_Status_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Hasura_Cwa__Match_With_Status_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Hasura_Cwa__Match_With_Status_Sum_Order_By>;
  var_pop?: InputMaybe<Hasura_Cwa__Match_With_Status_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Hasura_Cwa__Match_With_Status_Var_Samp_Order_By>;
  variance?: InputMaybe<Hasura_Cwa__Match_With_Status_Variance_Order_By>;
};

/** order by avg() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Avg_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "hasura_cwa__match_with_status". All fields are combined with a logical 'AND'. */
export type Hasura_Cwa__Match_With_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Bool_Exp>>;
  _date_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  _deleted?: InputMaybe<Boolean_Comparison_Exp>;
  _immutable_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  _not?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Bool_Exp>>;
  appointment_id?: InputMaybe<Int_Comparison_Exp>;
  assignee_auth_user?: InputMaybe<Auth_User_Bool_Exp>;
  assignee_id?: InputMaybe<Int_Comparison_Exp>;
  attended_appointments?: InputMaybe<Bigint_Comparison_Exp>;
  cadence_pref_strength?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_prefers_ot?: InputMaybe<Boolean_Comparison_Exp>;
  client_status?: InputMaybe<String_Comparison_Exp>;
  clinician_approves_ot?: InputMaybe<Boolean_Comparison_Exp>;
  conflict_of_interest?: InputMaybe<String_Comparison_Exp>;
  consult_event?: InputMaybe<Ehr_Event_Bool_Exp>;
  consult_id?: InputMaybe<Uuid_Comparison_Exp>;
  couple_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  delay_match_email?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_preference?: InputMaybe<String_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_match?: InputMaybe<Ehr_Match_Bool_Exp>;
  exclude_from_aqm?: InputMaybe<Boolean_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_reservation_instance_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_session_date?: InputMaybe<Date_Comparison_Exp>;
  first_session_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  former_client?: InputMaybe<Boolean_Comparison_Exp>;
  high_priority?: InputMaybe<Boolean_Comparison_Exp>;
  hybrid_preference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_biweekly_fit?: InputMaybe<Boolean_Comparison_Exp>;
  is_match_to_timeslot?: InputMaybe<Boolean_Comparison_Exp>;
  is_rematch?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_data?: InputMaybe<Boolean_Comparison_Exp>;
  match_after?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_note?: InputMaybe<String_Comparison_Exp>;
  matched_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  matched_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  matched_clinician_id?: InputMaybe<Int_Comparison_Exp>;
  max_score?: InputMaybe<Float8_Comparison_Exp>;
  methodology_version?: InputMaybe<Int_Comparison_Exp>;
  modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  queue_note?: InputMaybe<String_Comparison_Exp>;
  queue_update_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  referral_note?: InputMaybe<String_Comparison_Exp>;
  rematch_id?: InputMaybe<Int_Comparison_Exp>;
  rematch_note?: InputMaybe<String_Comparison_Exp>;
  reminder_email_sent?: InputMaybe<Timestamptz_Comparison_Exp>;
  requeue_reason?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolved_by_id?: InputMaybe<Int_Comparison_Exp>;
  resolved_recurrence?: InputMaybe<String_Comparison_Exp>;
  returning_to_same_clinician?: InputMaybe<Boolean_Comparison_Exp>;
  scheduled_appointments?: InputMaybe<Bigint_Comparison_Exp>;
  scheduling_link?: InputMaybe<String_Comparison_Exp>;
  selected_fit_id?: InputMaybe<Int_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Max_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_status?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  first_session_date?: InputMaybe<Order_By>;
  first_session_datetime?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_note?: InputMaybe<Order_By>;
  matched_at?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Min_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_status?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  first_session_date?: InputMaybe<Order_By>;
  first_session_datetime?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_note?: InputMaybe<Order_By>;
  matched_at?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "hasura_cwa__match_with_status". */
export type Hasura_Cwa__Match_With_Status_Order_By = {
  _date_start?: InputMaybe<Order_By>;
  _deleted?: InputMaybe<Order_By>;
  _immutable_version_id?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  assignee_auth_user?: InputMaybe<Auth_User_Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  cadence_pref_strength?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_prefers_ot?: InputMaybe<Order_By>;
  client_status?: InputMaybe<Order_By>;
  clinician_approves_ot?: InputMaybe<Order_By>;
  conflict_of_interest?: InputMaybe<Order_By>;
  consult_event?: InputMaybe<Ehr_Event_Order_By>;
  consult_id?: InputMaybe<Order_By>;
  couple_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  delay_match_email?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_preference?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_match?: InputMaybe<Ehr_Match_Order_By>;
  exclude_from_aqm?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  first_reservation_instance_id?: InputMaybe<Order_By>;
  first_session_date?: InputMaybe<Order_By>;
  first_session_datetime?: InputMaybe<Order_By>;
  former_client?: InputMaybe<Order_By>;
  high_priority?: InputMaybe<Order_By>;
  hybrid_preference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_biweekly_fit?: InputMaybe<Order_By>;
  is_match_to_timeslot?: InputMaybe<Order_By>;
  is_rematch?: InputMaybe<Order_By>;
  is_test_data?: InputMaybe<Order_By>;
  match_after?: InputMaybe<Order_By>;
  match_email_sent?: InputMaybe<Order_By>;
  match_note?: InputMaybe<Order_By>;
  matched_at?: InputMaybe<Order_By>;
  matched_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  modified_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  queue_note?: InputMaybe<Order_By>;
  queue_update_email_sent?: InputMaybe<Order_By>;
  referral_note?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  rematch_note?: InputMaybe<Order_By>;
  reminder_email_sent?: InputMaybe<Order_By>;
  requeue_reason?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  resolved_recurrence?: InputMaybe<Order_By>;
  returning_to_same_clinician?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  scheduling_link?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "hasura_cwa__match_with_status" */
export enum Hasura_Cwa__Match_With_Status_Select_Column {
  /** column name */
  DateStart = '_date_start',
  /** column name */
  Deleted = '_deleted',
  /** column name */
  ImmutableVersionId = '_immutable_version_id',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  AssigneeId = 'assignee_id',
  /** column name */
  AttendedAppointments = 'attended_appointments',
  /** column name */
  CadencePrefStrength = 'cadence_pref_strength',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientPrefersOt = 'client_prefers_ot',
  /** column name */
  ClientStatus = 'client_status',
  /** column name */
  ClinicianApprovesOt = 'clinician_approves_ot',
  /** column name */
  ConflictOfInterest = 'conflict_of_interest',
  /** column name */
  ConsultId = 'consult_id',
  /** column name */
  CoupleId = 'couple_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DelayMatchEmail = 'delay_match_email',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryPreference = 'delivery_preference',
  /** column name */
  ExcludeFromAqm = 'exclude_from_aqm',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FirstReservationInstanceId = 'first_reservation_instance_id',
  /** column name */
  FirstSessionDate = 'first_session_date',
  /** column name */
  FirstSessionDatetime = 'first_session_datetime',
  /** column name */
  FormerClient = 'former_client',
  /** column name */
  HighPriority = 'high_priority',
  /** column name */
  HybridPreference = 'hybrid_preference',
  /** column name */
  Id = 'id',
  /** column name */
  IsBiweeklyFit = 'is_biweekly_fit',
  /** column name */
  IsMatchToTimeslot = 'is_match_to_timeslot',
  /** column name */
  IsRematch = 'is_rematch',
  /** column name */
  IsTestData = 'is_test_data',
  /** column name */
  MatchAfter = 'match_after',
  /** column name */
  MatchEmailSent = 'match_email_sent',
  /** column name */
  MatchNote = 'match_note',
  /** column name */
  MatchedAt = 'matched_at',
  /** column name */
  MatchedClinicianId = 'matched_clinician_id',
  /** column name */
  MaxScore = 'max_score',
  /** column name */
  MethodologyVersion = 'methodology_version',
  /** column name */
  ModifiedAt = 'modified_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  QueueNote = 'queue_note',
  /** column name */
  QueueUpdateEmailSent = 'queue_update_email_sent',
  /** column name */
  ReferralNote = 'referral_note',
  /** column name */
  RematchId = 'rematch_id',
  /** column name */
  RematchNote = 'rematch_note',
  /** column name */
  ReminderEmailSent = 'reminder_email_sent',
  /** column name */
  RequeueReason = 'requeue_reason',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedById = 'resolved_by_id',
  /** column name */
  ResolvedRecurrence = 'resolved_recurrence',
  /** column name */
  ReturningToSameClinician = 'returning_to_same_clinician',
  /** column name */
  ScheduledAppointments = 'scheduled_appointments',
  /** column name */
  SchedulingLink = 'scheduling_link',
  /** column name */
  SelectedFitId = 'selected_fit_id',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Status = 'status'
}

/** order by stddev() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Stddev_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Stddev_Pop_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Stddev_Samp_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hasura_Cwa__Match_With_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hasura_Cwa__Match_With_Status_Stream_Cursor_Value_Input = {
  _date_start?: InputMaybe<Scalars['timestamptz']>;
  _deleted?: InputMaybe<Scalars['Boolean']>;
  _immutable_version_id?: InputMaybe<Scalars['uuid']>;
  appointment_id?: InputMaybe<Scalars['Int']>;
  assignee_id?: InputMaybe<Scalars['Int']>;
  attended_appointments?: InputMaybe<Scalars['bigint']>;
  cadence_pref_strength?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  client_prefers_ot?: InputMaybe<Scalars['Boolean']>;
  client_status?: InputMaybe<Scalars['String']>;
  clinician_approves_ot?: InputMaybe<Scalars['Boolean']>;
  conflict_of_interest?: InputMaybe<Scalars['String']>;
  consult_id?: InputMaybe<Scalars['uuid']>;
  couple_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  delay_match_email?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_preference?: InputMaybe<Scalars['String']>;
  exclude_from_aqm?: InputMaybe<Scalars['Boolean']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  first_reservation_instance_id?: InputMaybe<Scalars['uuid']>;
  first_session_date?: InputMaybe<Scalars['date']>;
  first_session_datetime?: InputMaybe<Scalars['timestamptz']>;
  former_client?: InputMaybe<Scalars['Boolean']>;
  high_priority?: InputMaybe<Scalars['Boolean']>;
  hybrid_preference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_biweekly_fit?: InputMaybe<Scalars['Boolean']>;
  is_match_to_timeslot?: InputMaybe<Scalars['Boolean']>;
  is_rematch?: InputMaybe<Scalars['Boolean']>;
  is_test_data?: InputMaybe<Scalars['Boolean']>;
  match_after?: InputMaybe<Scalars['timestamptz']>;
  match_email_sent?: InputMaybe<Scalars['timestamptz']>;
  match_note?: InputMaybe<Scalars['String']>;
  matched_at?: InputMaybe<Scalars['timestamptz']>;
  matched_clinician_id?: InputMaybe<Scalars['Int']>;
  max_score?: InputMaybe<Scalars['float8']>;
  methodology_version?: InputMaybe<Scalars['Int']>;
  modified_at?: InputMaybe<Scalars['timestamptz']>;
  priority?: InputMaybe<Scalars['String']>;
  queue_note?: InputMaybe<Scalars['String']>;
  queue_update_email_sent?: InputMaybe<Scalars['timestamptz']>;
  referral_note?: InputMaybe<Scalars['String']>;
  rematch_id?: InputMaybe<Scalars['Int']>;
  rematch_note?: InputMaybe<Scalars['String']>;
  reminder_email_sent?: InputMaybe<Scalars['timestamptz']>;
  requeue_reason?: InputMaybe<Scalars['String']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']>;
  resolved_by_id?: InputMaybe<Scalars['Int']>;
  resolved_recurrence?: InputMaybe<Scalars['String']>;
  returning_to_same_clinician?: InputMaybe<Scalars['Boolean']>;
  scheduled_appointments?: InputMaybe<Scalars['bigint']>;
  scheduling_link?: InputMaybe<Scalars['String']>;
  selected_fit_id?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Sum_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Var_Pop_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Var_Samp_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "hasura_cwa__match_with_status" */
export type Hasura_Cwa__Match_With_Status_Variance_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  attended_appointments?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matched_clinician_id?: InputMaybe<Order_By>;
  max_score?: InputMaybe<Order_By>;
  methodology_version?: InputMaybe<Order_By>;
  rematch_id?: InputMaybe<Order_By>;
  resolved_by_id?: InputMaybe<Order_By>;
  scheduled_appointments?: InputMaybe<Order_By>;
  selected_fit_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['jsonb']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['jsonb']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']>>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

export type Many_Session_Count = {
  __typename?: 'many_session_count';
  client_id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the logical model for "many_session_count". All fields are combined with a logical 'AND'. */
export type Many_Session_Count_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Many_Session_Count_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Many_Session_Count_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Many_Session_Count_Bool_Exp_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Many_Session_Count_Enum_Name {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Count = 'count'
}

/** Ordering options when selecting data from "many_session_count". */
export type Many_Session_Count_Order_By = {
  client_id?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_adherence_data" */
export type Mbc_Adherence_Data = {
  __typename?: 'mbc_adherence_data';
  appt_week?: Maybe<Scalars['timestamptz']>;
  clinician_email?: Maybe<Scalars['citext']>;
  clinician_id?: Maybe<Scalars['Int']>;
  cnt_post_session?: Maybe<Scalars['bigint']>;
  cnt_pre_session?: Maybe<Scalars['bigint']>;
  isoweek?: Maybe<Scalars['String']>;
  isoyear?: Maybe<Scalars['String']>;
  post_session_adherence?: Maybe<Scalars['float8']>;
  pre_session_adherence?: Maybe<Scalars['float8']>;
  total_post_session_ems?: Maybe<Scalars['bigint']>;
  total_pre_session_ems?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "mbc_adherence_data". All fields are combined with a logical 'AND'. */
export type Mbc_Adherence_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Adherence_Data_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Adherence_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Adherence_Data_Bool_Exp>>;
  appt_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  clinician_email?: InputMaybe<Citext_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  cnt_post_session?: InputMaybe<Bigint_Comparison_Exp>;
  cnt_pre_session?: InputMaybe<Bigint_Comparison_Exp>;
  isoweek?: InputMaybe<String_Comparison_Exp>;
  isoyear?: InputMaybe<String_Comparison_Exp>;
  post_session_adherence?: InputMaybe<Float8_Comparison_Exp>;
  pre_session_adherence?: InputMaybe<Float8_Comparison_Exp>;
  total_post_session_ems?: InputMaybe<Bigint_Comparison_Exp>;
  total_pre_session_ems?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "mbc_adherence_data". */
export type Mbc_Adherence_Data_Order_By = {
  appt_week?: InputMaybe<Order_By>;
  clinician_email?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cnt_post_session?: InputMaybe<Order_By>;
  cnt_pre_session?: InputMaybe<Order_By>;
  isoweek?: InputMaybe<Order_By>;
  isoyear?: InputMaybe<Order_By>;
  post_session_adherence?: InputMaybe<Order_By>;
  pre_session_adherence?: InputMaybe<Order_By>;
  total_post_session_ems?: InputMaybe<Order_By>;
  total_pre_session_ems?: InputMaybe<Order_By>;
};

/** select columns of table "mbc_adherence_data" */
export enum Mbc_Adherence_Data_Select_Column {
  /** column name */
  ApptWeek = 'appt_week',
  /** column name */
  ClinicianEmail = 'clinician_email',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CntPostSession = 'cnt_post_session',
  /** column name */
  CntPreSession = 'cnt_pre_session',
  /** column name */
  Isoweek = 'isoweek',
  /** column name */
  Isoyear = 'isoyear',
  /** column name */
  PostSessionAdherence = 'post_session_adherence',
  /** column name */
  PreSessionAdherence = 'pre_session_adherence',
  /** column name */
  TotalPostSessionEms = 'total_post_session_ems',
  /** column name */
  TotalPreSessionEms = 'total_pre_session_ems'
}

/** Streaming cursor of the table "mbc_adherence_data" */
export type Mbc_Adherence_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Adherence_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Adherence_Data_Stream_Cursor_Value_Input = {
  appt_week?: InputMaybe<Scalars['timestamptz']>;
  clinician_email?: InputMaybe<Scalars['citext']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  cnt_post_session?: InputMaybe<Scalars['bigint']>;
  cnt_pre_session?: InputMaybe<Scalars['bigint']>;
  isoweek?: InputMaybe<Scalars['String']>;
  isoyear?: InputMaybe<Scalars['String']>;
  post_session_adherence?: InputMaybe<Scalars['float8']>;
  pre_session_adherence?: InputMaybe<Scalars['float8']>;
  total_post_session_ems?: InputMaybe<Scalars['bigint']>;
  total_pre_session_ems?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores = {
  __typename?: 'mbc_assessment_question_scores';
  answer_value?: Maybe<Scalars['Int']>;
  client_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  event_id?: Maybe<Scalars['uuid']>;
  question_text?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  survey_date_taken?: Maybe<Scalars['timestamptz']>;
  survey_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_ScoresValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Aggregate_Order_By = {
  avg?: InputMaybe<Mbc_Assessment_Question_Scores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mbc_Assessment_Question_Scores_Max_Order_By>;
  min?: InputMaybe<Mbc_Assessment_Question_Scores_Min_Order_By>;
  stddev?: InputMaybe<Mbc_Assessment_Question_Scores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mbc_Assessment_Question_Scores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mbc_Assessment_Question_Scores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mbc_Assessment_Question_Scores_Sum_Order_By>;
  var_pop?: InputMaybe<Mbc_Assessment_Question_Scores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mbc_Assessment_Question_Scores_Var_Samp_Order_By>;
  variance?: InputMaybe<Mbc_Assessment_Question_Scores_Variance_Order_By>;
};

/** order by avg() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Avg_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mbc_assessment_question_scores". All fields are combined with a logical 'AND'. */
export type Mbc_Assessment_Question_Scores_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Bool_Exp>>;
  answer_value?: InputMaybe<Int_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  question_text?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  survey_date_taken?: InputMaybe<Timestamptz_Comparison_Exp>;
  survey_name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Max_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  survey_date_taken?: InputMaybe<Order_By>;
  survey_name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Min_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  survey_date_taken?: InputMaybe<Order_By>;
  survey_name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mbc_assessment_question_scores". */
export type Mbc_Assessment_Question_Scores_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  event_id?: InputMaybe<Order_By>;
  question_text?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  survey_date_taken?: InputMaybe<Order_By>;
  survey_name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "mbc_assessment_question_scores" */
export enum Mbc_Assessment_Question_Scores_Select_Column {
  /** column name */
  AnswerValue = 'answer_value',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  QuestionText = 'question_text',
  /** column name */
  Slug = 'slug',
  /** column name */
  SurveyDateTaken = 'survey_date_taken',
  /** column name */
  SurveyName = 'survey_name',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Stddev_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Stddev_Pop_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Stddev_Samp_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Assessment_Question_Scores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Assessment_Question_Scores_Stream_Cursor_Value_Input = {
  answer_value?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  question_text?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  survey_date_taken?: InputMaybe<Scalars['timestamptz']>;
  survey_name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** order by sum() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Sum_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Var_Pop_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Var_Samp_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mbc_assessment_question_scores" */
export type Mbc_Assessment_Question_Scores_Variance_Order_By = {
  answer_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client = {
  __typename?: 'mbc_distinct_scores_by_client';
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  event?: Maybe<Ehr_Event>;
  event_id?: Maybe<Scalars['uuid']>;
  score_id?: Maybe<Scalars['uuid']>;
  score_name?: Maybe<Scalars['String']>;
  score_range?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by aggregate values of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Aggregate_Order_By = {
  avg?: InputMaybe<Mbc_Distinct_Scores_By_Client_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mbc_Distinct_Scores_By_Client_Max_Order_By>;
  min?: InputMaybe<Mbc_Distinct_Scores_By_Client_Min_Order_By>;
  stddev?: InputMaybe<Mbc_Distinct_Scores_By_Client_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mbc_Distinct_Scores_By_Client_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mbc_Distinct_Scores_By_Client_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mbc_Distinct_Scores_By_Client_Sum_Order_By>;
  var_pop?: InputMaybe<Mbc_Distinct_Scores_By_Client_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mbc_Distinct_Scores_By_Client_Var_Samp_Order_By>;
  variance?: InputMaybe<Mbc_Distinct_Scores_By_Client_Variance_Order_By>;
};

/** order by avg() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mbc_distinct_scores_by_client". All fields are combined with a logical 'AND'. */
export type Mbc_Distinct_Scores_By_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  event?: InputMaybe<Ehr_Event_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_name?: InputMaybe<String_Comparison_Exp>;
  score_range?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** order by max() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Max_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  score_range?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Min_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  score_range?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mbc_distinct_scores_by_client". */
export type Mbc_Distinct_Scores_By_Client_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  event?: InputMaybe<Ehr_Event_Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  score_range?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_distinct_scores_by_client_reliable_change" */
export type Mbc_Distinct_Scores_By_Client_Reliable_Change = {
  __typename?: 'mbc_distinct_scores_by_client_reliable_change';
  client_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  event_id?: Maybe<Scalars['uuid']>;
  score_id?: Maybe<Scalars['uuid']>;
  score_name?: Maybe<Scalars['String']>;
  score_range?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** Boolean expression to filter rows from the table "mbc_distinct_scores_by_client_reliable_change". All fields are combined with a logical 'AND'. */
export type Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_name?: InputMaybe<String_Comparison_Exp>;
  score_range?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "mbc_distinct_scores_by_client_reliable_change". */
export type Mbc_Distinct_Scores_By_Client_Reliable_Change_Order_By = {
  client_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  score_range?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "mbc_distinct_scores_by_client_reliable_change" */
export enum Mbc_Distinct_Scores_By_Client_Reliable_Change_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EventId = 'event_id',
  /** column name */
  ScoreId = 'score_id',
  /** column name */
  ScoreName = 'score_name',
  /** column name */
  ScoreRange = 'score_range',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "mbc_distinct_scores_by_client_reliable_change" */
export type Mbc_Distinct_Scores_By_Client_Reliable_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Distinct_Scores_By_Client_Reliable_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Distinct_Scores_By_Client_Reliable_Change_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  score_id?: InputMaybe<Scalars['uuid']>;
  score_name?: InputMaybe<Scalars['String']>;
  score_range?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** select columns of table "mbc_distinct_scores_by_client" */
export enum Mbc_Distinct_Scores_By_Client_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EventId = 'event_id',
  /** column name */
  ScoreId = 'score_id',
  /** column name */
  ScoreName = 'score_name',
  /** column name */
  ScoreRange = 'score_range',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Distinct_Scores_By_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Distinct_Scores_By_Client_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  score_id?: InputMaybe<Scalars['uuid']>;
  score_name?: InputMaybe<Scalars['String']>;
  score_range?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** order by sum() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mbc_distinct_scores_by_client" */
export type Mbc_Distinct_Scores_By_Client_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores = {
  __typename?: 'mbc_ems_joined_with_scores';
  client_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  gad7_id?: Maybe<Scalars['uuid']>;
  gad7_range?: Maybe<Scalars['String']>;
  gad7_status?: Maybe<Scalars['String']>;
  gad7_value?: Maybe<Scalars['float8']>;
  is_kp_referral?: Maybe<Scalars['Boolean']>;
  phq9_id?: Maybe<Scalars['uuid']>;
  phq9_range?: Maybe<Scalars['String']>;
  phq9_status?: Maybe<Scalars['String']>;
  phq9_value?: Maybe<Scalars['float8']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** order by aggregate values of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Aggregate_Order_By = {
  avg?: InputMaybe<Mbc_Ems_Joined_With_Scores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mbc_Ems_Joined_With_Scores_Max_Order_By>;
  min?: InputMaybe<Mbc_Ems_Joined_With_Scores_Min_Order_By>;
  stddev?: InputMaybe<Mbc_Ems_Joined_With_Scores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mbc_Ems_Joined_With_Scores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mbc_Ems_Joined_With_Scores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mbc_Ems_Joined_With_Scores_Sum_Order_By>;
  var_pop?: InputMaybe<Mbc_Ems_Joined_With_Scores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mbc_Ems_Joined_With_Scores_Var_Samp_Order_By>;
  variance?: InputMaybe<Mbc_Ems_Joined_With_Scores_Variance_Order_By>;
};

/** order by avg() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mbc_ems_joined_with_scores". All fields are combined with a logical 'AND'. */
export type Mbc_Ems_Joined_With_Scores_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  gad7_id?: InputMaybe<Uuid_Comparison_Exp>;
  gad7_range?: InputMaybe<String_Comparison_Exp>;
  gad7_status?: InputMaybe<String_Comparison_Exp>;
  gad7_value?: InputMaybe<Float8_Comparison_Exp>;
  is_kp_referral?: InputMaybe<Boolean_Comparison_Exp>;
  phq9_id?: InputMaybe<Uuid_Comparison_Exp>;
  phq9_range?: InputMaybe<String_Comparison_Exp>;
  phq9_status?: InputMaybe<String_Comparison_Exp>;
  phq9_value?: InputMaybe<Float8_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Max_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Min_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mbc_ems_joined_with_scores". */
export type Mbc_Ems_Joined_With_Scores_Order_By = {
  client_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  is_kp_referral?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_ems_joined_with_scores_reliable_change" */
export type Mbc_Ems_Joined_With_Scores_Reliable_Change = {
  __typename?: 'mbc_ems_joined_with_scores_reliable_change';
  client_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  gad7_first_session_score?: Maybe<Scalars['float8']>;
  gad7_highest_session_score?: Maybe<Scalars['float8']>;
  gad7_id?: Maybe<Scalars['uuid']>;
  gad7_range?: Maybe<Scalars['String']>;
  gad7_session_number?: Maybe<Scalars['bigint']>;
  gad7_status?: Maybe<Scalars['String']>;
  gad7_value?: Maybe<Scalars['float8']>;
  is_kp_referral?: Maybe<Scalars['Boolean']>;
  phq9_first_session_score?: Maybe<Scalars['float8']>;
  phq9_highest_session_score?: Maybe<Scalars['float8']>;
  phq9_id?: Maybe<Scalars['uuid']>;
  phq9_range?: Maybe<Scalars['String']>;
  phq9_session_number?: Maybe<Scalars['bigint']>;
  phq9_status?: Maybe<Scalars['String']>;
  phq9_value?: Maybe<Scalars['float8']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** Boolean expression to filter rows from the table "mbc_ems_joined_with_scores_reliable_change". All fields are combined with a logical 'AND'. */
export type Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  gad7_first_session_score?: InputMaybe<Float8_Comparison_Exp>;
  gad7_highest_session_score?: InputMaybe<Float8_Comparison_Exp>;
  gad7_id?: InputMaybe<Uuid_Comparison_Exp>;
  gad7_range?: InputMaybe<String_Comparison_Exp>;
  gad7_session_number?: InputMaybe<Bigint_Comparison_Exp>;
  gad7_status?: InputMaybe<String_Comparison_Exp>;
  gad7_value?: InputMaybe<Float8_Comparison_Exp>;
  is_kp_referral?: InputMaybe<Boolean_Comparison_Exp>;
  phq9_first_session_score?: InputMaybe<Float8_Comparison_Exp>;
  phq9_highest_session_score?: InputMaybe<Float8_Comparison_Exp>;
  phq9_id?: InputMaybe<Uuid_Comparison_Exp>;
  phq9_range?: InputMaybe<String_Comparison_Exp>;
  phq9_session_number?: InputMaybe<Bigint_Comparison_Exp>;
  phq9_status?: InputMaybe<String_Comparison_Exp>;
  phq9_value?: InputMaybe<Float8_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "mbc_ems_joined_with_scores_reliable_change". */
export type Mbc_Ems_Joined_With_Scores_Reliable_Change_Order_By = {
  client_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  gad7_first_session_score?: InputMaybe<Order_By>;
  gad7_highest_session_score?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_session_number?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  is_kp_referral?: InputMaybe<Order_By>;
  phq9_first_session_score?: InputMaybe<Order_By>;
  phq9_highest_session_score?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_session_number?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** select columns of table "mbc_ems_joined_with_scores_reliable_change" */
export enum Mbc_Ems_Joined_With_Scores_Reliable_Change_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  Gad7FirstSessionScore = 'gad7_first_session_score',
  /** column name */
  Gad7HighestSessionScore = 'gad7_highest_session_score',
  /** column name */
  Gad7Id = 'gad7_id',
  /** column name */
  Gad7Range = 'gad7_range',
  /** column name */
  Gad7SessionNumber = 'gad7_session_number',
  /** column name */
  Gad7Status = 'gad7_status',
  /** column name */
  Gad7Value = 'gad7_value',
  /** column name */
  IsKpReferral = 'is_kp_referral',
  /** column name */
  Phq9FirstSessionScore = 'phq9_first_session_score',
  /** column name */
  Phq9HighestSessionScore = 'phq9_highest_session_score',
  /** column name */
  Phq9Id = 'phq9_id',
  /** column name */
  Phq9Range = 'phq9_range',
  /** column name */
  Phq9SessionNumber = 'phq9_session_number',
  /** column name */
  Phq9Status = 'phq9_status',
  /** column name */
  Phq9Value = 'phq9_value',
  /** column name */
  StartTime = 'start_time'
}

/** Streaming cursor of the table "mbc_ems_joined_with_scores_reliable_change" */
export type Mbc_Ems_Joined_With_Scores_Reliable_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Ems_Joined_With_Scores_Reliable_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Ems_Joined_With_Scores_Reliable_Change_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  gad7_first_session_score?: InputMaybe<Scalars['float8']>;
  gad7_highest_session_score?: InputMaybe<Scalars['float8']>;
  gad7_id?: InputMaybe<Scalars['uuid']>;
  gad7_range?: InputMaybe<Scalars['String']>;
  gad7_session_number?: InputMaybe<Scalars['bigint']>;
  gad7_status?: InputMaybe<Scalars['String']>;
  gad7_value?: InputMaybe<Scalars['float8']>;
  is_kp_referral?: InputMaybe<Scalars['Boolean']>;
  phq9_first_session_score?: InputMaybe<Scalars['float8']>;
  phq9_highest_session_score?: InputMaybe<Scalars['float8']>;
  phq9_id?: InputMaybe<Scalars['uuid']>;
  phq9_range?: InputMaybe<Scalars['String']>;
  phq9_session_number?: InputMaybe<Scalars['bigint']>;
  phq9_status?: InputMaybe<Scalars['String']>;
  phq9_value?: InputMaybe<Scalars['float8']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** select columns of table "mbc_ems_joined_with_scores" */
export enum Mbc_Ems_Joined_With_Scores_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  Gad7Id = 'gad7_id',
  /** column name */
  Gad7Range = 'gad7_range',
  /** column name */
  Gad7Status = 'gad7_status',
  /** column name */
  Gad7Value = 'gad7_value',
  /** column name */
  IsKpReferral = 'is_kp_referral',
  /** column name */
  Phq9Id = 'phq9_id',
  /** column name */
  Phq9Range = 'phq9_range',
  /** column name */
  Phq9Status = 'phq9_status',
  /** column name */
  Phq9Value = 'phq9_value',
  /** column name */
  StartTime = 'start_time'
}

/** order by stddev() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Ems_Joined_With_Scores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Ems_Joined_With_Scores_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  gad7_id?: InputMaybe<Scalars['uuid']>;
  gad7_range?: InputMaybe<Scalars['String']>;
  gad7_status?: InputMaybe<Scalars['String']>;
  gad7_value?: InputMaybe<Scalars['float8']>;
  is_kp_referral?: InputMaybe<Scalars['Boolean']>;
  phq9_id?: InputMaybe<Scalars['uuid']>;
  phq9_range?: InputMaybe<Scalars['String']>;
  phq9_status?: InputMaybe<Scalars['String']>;
  phq9_value?: InputMaybe<Scalars['float8']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mbc_ems_joined_with_scores" */
export type Mbc_Ems_Joined_With_Scores_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client = {
  __typename?: 'mbc_partitioned_scores_by_client';
  client_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  event_id?: Maybe<Scalars['uuid']>;
  score_id?: Maybe<Scalars['uuid']>;
  score_name?: Maybe<Scalars['String']>;
  session_n_1_range?: Maybe<Scalars['String']>;
  session_n_2_range?: Maybe<Scalars['String']>;
  session_n_3_range?: Maybe<Scalars['String']>;
  session_n_4_range?: Maybe<Scalars['String']>;
  session_n_5_range?: Maybe<Scalars['String']>;
  session_n_range?: Maybe<Scalars['String']>;
  session_n_value?: Maybe<Scalars['float8']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** order by aggregate values of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Aggregate_Order_By = {
  avg?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Max_Order_By>;
  min?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Min_Order_By>;
  stddev?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Sum_Order_By>;
  var_pop?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Var_Samp_Order_By>;
  variance?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Variance_Order_By>;
};

/** order by avg() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mbc_partitioned_scores_by_client". All fields are combined with a logical 'AND'. */
export type Mbc_Partitioned_Scores_By_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_name?: InputMaybe<String_Comparison_Exp>;
  session_n_1_range?: InputMaybe<String_Comparison_Exp>;
  session_n_2_range?: InputMaybe<String_Comparison_Exp>;
  session_n_3_range?: InputMaybe<String_Comparison_Exp>;
  session_n_4_range?: InputMaybe<String_Comparison_Exp>;
  session_n_5_range?: InputMaybe<String_Comparison_Exp>;
  session_n_range?: InputMaybe<String_Comparison_Exp>;
  session_n_value?: InputMaybe<Float8_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Max_Order_By = {
  client_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  session_n_1_range?: InputMaybe<Order_By>;
  session_n_2_range?: InputMaybe<Order_By>;
  session_n_3_range?: InputMaybe<Order_By>;
  session_n_4_range?: InputMaybe<Order_By>;
  session_n_5_range?: InputMaybe<Order_By>;
  session_n_range?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Min_Order_By = {
  client_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  session_n_1_range?: InputMaybe<Order_By>;
  session_n_2_range?: InputMaybe<Order_By>;
  session_n_3_range?: InputMaybe<Order_By>;
  session_n_4_range?: InputMaybe<Order_By>;
  session_n_5_range?: InputMaybe<Order_By>;
  session_n_range?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mbc_partitioned_scores_by_client". */
export type Mbc_Partitioned_Scores_By_Client_Order_By = {
  client_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  session_n_1_range?: InputMaybe<Order_By>;
  session_n_2_range?: InputMaybe<Order_By>;
  session_n_3_range?: InputMaybe<Order_By>;
  session_n_4_range?: InputMaybe<Order_By>;
  session_n_5_range?: InputMaybe<Order_By>;
  session_n_range?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** columns and relationships of "mbc_partitioned_scores_by_client_reliable_change" */
export type Mbc_Partitioned_Scores_By_Client_Reliable_Change = {
  __typename?: 'mbc_partitioned_scores_by_client_reliable_change';
  client_id?: Maybe<Scalars['Int']>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  event_id?: Maybe<Scalars['uuid']>;
  first_session_score?: Maybe<Scalars['float8']>;
  highest_session_score?: Maybe<Scalars['float8']>;
  reliable_change_session_count?: Maybe<Scalars['Int']>;
  score_id?: Maybe<Scalars['uuid']>;
  score_name?: Maybe<Scalars['String']>;
  session_n_1_range?: Maybe<Scalars['String']>;
  session_n_1_value?: Maybe<Scalars['float8']>;
  session_n_2_range?: Maybe<Scalars['String']>;
  session_n_2_value?: Maybe<Scalars['float8']>;
  session_n_3_range?: Maybe<Scalars['String']>;
  session_n_3_value?: Maybe<Scalars['float8']>;
  session_n_4_range?: Maybe<Scalars['String']>;
  session_n_4_value?: Maybe<Scalars['float8']>;
  session_n_5_range?: Maybe<Scalars['String']>;
  session_n_5_value?: Maybe<Scalars['float8']>;
  session_n_range?: Maybe<Scalars['String']>;
  session_n_value?: Maybe<Scalars['float8']>;
  session_number?: Maybe<Scalars['bigint']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** Boolean expression to filter rows from the table "mbc_partitioned_scores_by_client_reliable_change". All fields are combined with a logical 'AND'. */
export type Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp = {
  _and?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>>;
  _not?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_session_score?: InputMaybe<Float8_Comparison_Exp>;
  highest_session_score?: InputMaybe<Float8_Comparison_Exp>;
  reliable_change_session_count?: InputMaybe<Int_Comparison_Exp>;
  score_id?: InputMaybe<Uuid_Comparison_Exp>;
  score_name?: InputMaybe<String_Comparison_Exp>;
  session_n_1_range?: InputMaybe<String_Comparison_Exp>;
  session_n_1_value?: InputMaybe<Float8_Comparison_Exp>;
  session_n_2_range?: InputMaybe<String_Comparison_Exp>;
  session_n_2_value?: InputMaybe<Float8_Comparison_Exp>;
  session_n_3_range?: InputMaybe<String_Comparison_Exp>;
  session_n_3_value?: InputMaybe<Float8_Comparison_Exp>;
  session_n_4_range?: InputMaybe<String_Comparison_Exp>;
  session_n_4_value?: InputMaybe<Float8_Comparison_Exp>;
  session_n_5_range?: InputMaybe<String_Comparison_Exp>;
  session_n_5_value?: InputMaybe<Float8_Comparison_Exp>;
  session_n_range?: InputMaybe<String_Comparison_Exp>;
  session_n_value?: InputMaybe<Float8_Comparison_Exp>;
  session_number?: InputMaybe<Bigint_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "mbc_partitioned_scores_by_client_reliable_change". */
export type Mbc_Partitioned_Scores_By_Client_Reliable_Change_Order_By = {
  client_id?: InputMaybe<Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_session_score?: InputMaybe<Order_By>;
  highest_session_score?: InputMaybe<Order_By>;
  reliable_change_session_count?: InputMaybe<Order_By>;
  score_id?: InputMaybe<Order_By>;
  score_name?: InputMaybe<Order_By>;
  session_n_1_range?: InputMaybe<Order_By>;
  session_n_1_value?: InputMaybe<Order_By>;
  session_n_2_range?: InputMaybe<Order_By>;
  session_n_2_value?: InputMaybe<Order_By>;
  session_n_3_range?: InputMaybe<Order_By>;
  session_n_3_value?: InputMaybe<Order_By>;
  session_n_4_range?: InputMaybe<Order_By>;
  session_n_4_value?: InputMaybe<Order_By>;
  session_n_5_range?: InputMaybe<Order_By>;
  session_n_5_value?: InputMaybe<Order_By>;
  session_n_range?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** select columns of table "mbc_partitioned_scores_by_client_reliable_change" */
export enum Mbc_Partitioned_Scores_By_Client_Reliable_Change_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FirstSessionScore = 'first_session_score',
  /** column name */
  HighestSessionScore = 'highest_session_score',
  /** column name */
  ReliableChangeSessionCount = 'reliable_change_session_count',
  /** column name */
  ScoreId = 'score_id',
  /** column name */
  ScoreName = 'score_name',
  /** column name */
  SessionN_1Range = 'session_n_1_range',
  /** column name */
  SessionN_1Value = 'session_n_1_value',
  /** column name */
  SessionN_2Range = 'session_n_2_range',
  /** column name */
  SessionN_2Value = 'session_n_2_value',
  /** column name */
  SessionN_3Range = 'session_n_3_range',
  /** column name */
  SessionN_3Value = 'session_n_3_value',
  /** column name */
  SessionN_4Range = 'session_n_4_range',
  /** column name */
  SessionN_4Value = 'session_n_4_value',
  /** column name */
  SessionN_5Range = 'session_n_5_range',
  /** column name */
  SessionN_5Value = 'session_n_5_value',
  /** column name */
  SessionNRange = 'session_n_range',
  /** column name */
  SessionNValue = 'session_n_value',
  /** column name */
  SessionNumber = 'session_number',
  /** column name */
  StartTime = 'start_time'
}

/** Streaming cursor of the table "mbc_partitioned_scores_by_client_reliable_change" */
export type Mbc_Partitioned_Scores_By_Client_Reliable_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Partitioned_Scores_By_Client_Reliable_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Partitioned_Scores_By_Client_Reliable_Change_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  first_session_score?: InputMaybe<Scalars['float8']>;
  highest_session_score?: InputMaybe<Scalars['float8']>;
  reliable_change_session_count?: InputMaybe<Scalars['Int']>;
  score_id?: InputMaybe<Scalars['uuid']>;
  score_name?: InputMaybe<Scalars['String']>;
  session_n_1_range?: InputMaybe<Scalars['String']>;
  session_n_1_value?: InputMaybe<Scalars['float8']>;
  session_n_2_range?: InputMaybe<Scalars['String']>;
  session_n_2_value?: InputMaybe<Scalars['float8']>;
  session_n_3_range?: InputMaybe<Scalars['String']>;
  session_n_3_value?: InputMaybe<Scalars['float8']>;
  session_n_4_range?: InputMaybe<Scalars['String']>;
  session_n_4_value?: InputMaybe<Scalars['float8']>;
  session_n_5_range?: InputMaybe<Scalars['String']>;
  session_n_5_value?: InputMaybe<Scalars['float8']>;
  session_n_range?: InputMaybe<Scalars['String']>;
  session_n_value?: InputMaybe<Scalars['float8']>;
  session_number?: InputMaybe<Scalars['bigint']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** select columns of table "mbc_partitioned_scores_by_client" */
export enum Mbc_Partitioned_Scores_By_Client_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EventId = 'event_id',
  /** column name */
  ScoreId = 'score_id',
  /** column name */
  ScoreName = 'score_name',
  /** column name */
  SessionN_1Range = 'session_n_1_range',
  /** column name */
  SessionN_2Range = 'session_n_2_range',
  /** column name */
  SessionN_3Range = 'session_n_3_range',
  /** column name */
  SessionN_4Range = 'session_n_4_range',
  /** column name */
  SessionN_5Range = 'session_n_5_range',
  /** column name */
  SessionNRange = 'session_n_range',
  /** column name */
  SessionNValue = 'session_n_value',
  /** column name */
  StartTime = 'start_time'
}

/** order by stddev() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mbc_Partitioned_Scores_By_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mbc_Partitioned_Scores_By_Client_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  score_id?: InputMaybe<Scalars['uuid']>;
  score_name?: InputMaybe<Scalars['String']>;
  session_n_1_range?: InputMaybe<Scalars['String']>;
  session_n_2_range?: InputMaybe<Scalars['String']>;
  session_n_3_range?: InputMaybe<Scalars['String']>;
  session_n_4_range?: InputMaybe<Scalars['String']>;
  session_n_5_range?: InputMaybe<Scalars['String']>;
  session_n_range?: InputMaybe<Scalars['String']>;
  session_n_value?: InputMaybe<Scalars['float8']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mbc_partitioned_scores_by_client" */
export type Mbc_Partitioned_Scores_By_Client_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  session_n_value?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** insert data into the table: "ehr_matchtag" */
  insert_ehr_matchtag?: Maybe<Ehr_Matchtag_Mutation_Response>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_MatchtagArgs = {
  objects: Array<Ehr_Matchtag_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Matchtag_On_Conflict>;
};

/** columns and relationships of "mv_alliance_scores_by_clinician_and_client_ids" */
export type Mv_Alliance_Scores_By_Clinician_And_Client_Ids = {
  __typename?: 'mv_alliance_scores_by_clinician_and_client_ids';
  acronyms?: Maybe<Array<Scalars['String']>>;
  alliance_id?: Maybe<Scalars['uuid']>;
  alliance_value?: Maybe<Scalars['float8']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  display_names?: Maybe<Array<Scalars['String']>>;
  event_id?: Maybe<Scalars['uuid']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  pr_client_id?: Maybe<Scalars['Int']>;
  preferred_name?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
};

/** Boolean expression to filter rows from the table "mv_alliance_scores_by_clinician_and_client_ids". All fields are combined with a logical 'AND'. */
export type Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>>;
  _not?: InputMaybe<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>>;
  acronyms?: InputMaybe<String_Array_Comparison_Exp>;
  alliance_id?: InputMaybe<Uuid_Comparison_Exp>;
  alliance_value?: InputMaybe<Float8_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  display_names?: InputMaybe<String_Array_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  pr_client_id?: InputMaybe<Int_Comparison_Exp>;
  preferred_name?: InputMaybe<String_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "mv_alliance_scores_by_clinician_and_client_ids". */
export type Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Order_By = {
  acronyms?: InputMaybe<Order_By>;
  alliance_id?: InputMaybe<Order_By>;
  alliance_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  display_names?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  pr_client_id?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
};

/** select columns of table "mv_alliance_scores_by_clinician_and_client_ids" */
export enum Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Select_Column {
  /** column name */
  Acronyms = 'acronyms',
  /** column name */
  AllianceId = 'alliance_id',
  /** column name */
  AllianceValue = 'alliance_value',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  DisplayNames = 'display_names',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PrClientId = 'pr_client_id',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  StartTime = 'start_time'
}

/** Streaming cursor of the table "mv_alliance_scores_by_clinician_and_client_ids" */
export type Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Stream_Cursor_Value_Input = {
  acronyms?: InputMaybe<Array<Scalars['String']>>;
  alliance_id?: InputMaybe<Scalars['uuid']>;
  alliance_value?: InputMaybe<Scalars['float8']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  display_names?: InputMaybe<Array<Scalars['String']>>;
  event_id?: InputMaybe<Scalars['uuid']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  pr_client_id?: InputMaybe<Scalars['Int']>;
  preferred_name?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "mv_clinical_utilization" */
export type Mv_Clinical_Utilization = {
  __typename?: 'mv_clinical_utilization';
  adjusted_timeoff_credit?: Maybe<Scalars['numeric']>;
  allocated_consult_billable_time?: Maybe<Scalars['float8']>;
  attended_consult_billable_time?: Maybe<Scalars['float8']>;
  attended_couples_billable_time?: Maybe<Scalars['float8']>;
  attended_therapy_billable_time?: Maybe<Scalars['float8']>;
  billable_time_utilization?: Maybe<Scalars['float8']>;
  clinician_id?: Maybe<Scalars['Int']>;
  consult_allocation?: Maybe<Scalars['numeric']>;
  consult_allocation_score?: Maybe<Scalars['numeric']>;
  consult_billable_time?: Maybe<Scalars['float8']>;
  consult_noshows?: Maybe<Scalars['bigint']>;
  consults_attended?: Maybe<Scalars['bigint']>;
  consults_scheduled?: Maybe<Scalars['bigint']>;
  couples_attended?: Maybe<Scalars['bigint']>;
  couples_billable_time?: Maybe<Scalars['float8']>;
  couples_noshow?: Maybe<Scalars['bigint']>;
  couples_scheduled?: Maybe<Scalars['bigint']>;
  discrete_hours_utilization?: Maybe<Scalars['numeric']>;
  full_name?: Maybe<Scalars['String']>;
  group_billable_time?: Maybe<Scalars['float8']>;
  hours_utilization?: Maybe<Scalars['numeric']>;
  hours_without_pto?: Maybe<Scalars['numeric']>;
  isoweek?: Maybe<Scalars['String']>;
  isoyear?: Maybe<Scalars['String']>;
  no_show_consult_billable_time?: Maybe<Scalars['float8']>;
  no_show_couples_billable_time?: Maybe<Scalars['float8']>;
  no_show_therapy_billable_time?: Maybe<Scalars['float8']>;
  pto_hours?: Maybe<Scalars['numeric']>;
  scheduled_consult_billable_time?: Maybe<Scalars['float8']>;
  scheduled_couples_billable_time?: Maybe<Scalars['float8']>;
  scheduled_therapy_billable_time?: Maybe<Scalars['float8']>;
  target_client_hours?: Maybe<Scalars['float8']>;
  therapy_attended?: Maybe<Scalars['bigint']>;
  therapy_billable_time?: Maybe<Scalars['float8']>;
  therapy_hours?: Maybe<Scalars['float8']>;
  therapy_noshows?: Maybe<Scalars['bigint']>;
  therapy_scheduled?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['String']>;
  week?: Maybe<Scalars['timestamptz']>;
  workweek_hours?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "mv_clinical_utilization". All fields are combined with a logical 'AND'. */
export type Mv_Clinical_Utilization_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Clinical_Utilization_Bool_Exp>>;
  _not?: InputMaybe<Mv_Clinical_Utilization_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Clinical_Utilization_Bool_Exp>>;
  adjusted_timeoff_credit?: InputMaybe<Numeric_Comparison_Exp>;
  allocated_consult_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  attended_consult_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  attended_couples_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  attended_therapy_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  billable_time_utilization?: InputMaybe<Float8_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  consult_allocation?: InputMaybe<Numeric_Comparison_Exp>;
  consult_allocation_score?: InputMaybe<Numeric_Comparison_Exp>;
  consult_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  consult_noshows?: InputMaybe<Bigint_Comparison_Exp>;
  consults_attended?: InputMaybe<Bigint_Comparison_Exp>;
  consults_scheduled?: InputMaybe<Bigint_Comparison_Exp>;
  couples_attended?: InputMaybe<Bigint_Comparison_Exp>;
  couples_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  couples_noshow?: InputMaybe<Bigint_Comparison_Exp>;
  couples_scheduled?: InputMaybe<Bigint_Comparison_Exp>;
  discrete_hours_utilization?: InputMaybe<Numeric_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  group_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  hours_utilization?: InputMaybe<Numeric_Comparison_Exp>;
  hours_without_pto?: InputMaybe<Numeric_Comparison_Exp>;
  isoweek?: InputMaybe<String_Comparison_Exp>;
  isoyear?: InputMaybe<String_Comparison_Exp>;
  no_show_consult_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  no_show_couples_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  no_show_therapy_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  pto_hours?: InputMaybe<Numeric_Comparison_Exp>;
  scheduled_consult_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  scheduled_couples_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  scheduled_therapy_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  target_client_hours?: InputMaybe<Float8_Comparison_Exp>;
  therapy_attended?: InputMaybe<Bigint_Comparison_Exp>;
  therapy_billable_time?: InputMaybe<Float8_Comparison_Exp>;
  therapy_hours?: InputMaybe<Float8_Comparison_Exp>;
  therapy_noshows?: InputMaybe<Bigint_Comparison_Exp>;
  therapy_scheduled?: InputMaybe<Bigint_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
  week?: InputMaybe<Timestamptz_Comparison_Exp>;
  workweek_hours?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "mv_clinical_utilization". */
export type Mv_Clinical_Utilization_Order_By = {
  adjusted_timeoff_credit?: InputMaybe<Order_By>;
  allocated_consult_billable_time?: InputMaybe<Order_By>;
  attended_consult_billable_time?: InputMaybe<Order_By>;
  attended_couples_billable_time?: InputMaybe<Order_By>;
  attended_therapy_billable_time?: InputMaybe<Order_By>;
  billable_time_utilization?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  consult_allocation?: InputMaybe<Order_By>;
  consult_allocation_score?: InputMaybe<Order_By>;
  consult_billable_time?: InputMaybe<Order_By>;
  consult_noshows?: InputMaybe<Order_By>;
  consults_attended?: InputMaybe<Order_By>;
  consults_scheduled?: InputMaybe<Order_By>;
  couples_attended?: InputMaybe<Order_By>;
  couples_billable_time?: InputMaybe<Order_By>;
  couples_noshow?: InputMaybe<Order_By>;
  couples_scheduled?: InputMaybe<Order_By>;
  discrete_hours_utilization?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  group_billable_time?: InputMaybe<Order_By>;
  hours_utilization?: InputMaybe<Order_By>;
  hours_without_pto?: InputMaybe<Order_By>;
  isoweek?: InputMaybe<Order_By>;
  isoyear?: InputMaybe<Order_By>;
  no_show_consult_billable_time?: InputMaybe<Order_By>;
  no_show_couples_billable_time?: InputMaybe<Order_By>;
  no_show_therapy_billable_time?: InputMaybe<Order_By>;
  pto_hours?: InputMaybe<Order_By>;
  scheduled_consult_billable_time?: InputMaybe<Order_By>;
  scheduled_couples_billable_time?: InputMaybe<Order_By>;
  scheduled_therapy_billable_time?: InputMaybe<Order_By>;
  target_client_hours?: InputMaybe<Order_By>;
  therapy_attended?: InputMaybe<Order_By>;
  therapy_billable_time?: InputMaybe<Order_By>;
  therapy_hours?: InputMaybe<Order_By>;
  therapy_noshows?: InputMaybe<Order_By>;
  therapy_scheduled?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
  workweek_hours?: InputMaybe<Order_By>;
};

/** select columns of table "mv_clinical_utilization" */
export enum Mv_Clinical_Utilization_Select_Column {
  /** column name */
  AdjustedTimeoffCredit = 'adjusted_timeoff_credit',
  /** column name */
  AllocatedConsultBillableTime = 'allocated_consult_billable_time',
  /** column name */
  AttendedConsultBillableTime = 'attended_consult_billable_time',
  /** column name */
  AttendedCouplesBillableTime = 'attended_couples_billable_time',
  /** column name */
  AttendedTherapyBillableTime = 'attended_therapy_billable_time',
  /** column name */
  BillableTimeUtilization = 'billable_time_utilization',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  ConsultAllocation = 'consult_allocation',
  /** column name */
  ConsultAllocationScore = 'consult_allocation_score',
  /** column name */
  ConsultBillableTime = 'consult_billable_time',
  /** column name */
  ConsultNoshows = 'consult_noshows',
  /** column name */
  ConsultsAttended = 'consults_attended',
  /** column name */
  ConsultsScheduled = 'consults_scheduled',
  /** column name */
  CouplesAttended = 'couples_attended',
  /** column name */
  CouplesBillableTime = 'couples_billable_time',
  /** column name */
  CouplesNoshow = 'couples_noshow',
  /** column name */
  CouplesScheduled = 'couples_scheduled',
  /** column name */
  DiscreteHoursUtilization = 'discrete_hours_utilization',
  /** column name */
  FullName = 'full_name',
  /** column name */
  GroupBillableTime = 'group_billable_time',
  /** column name */
  HoursUtilization = 'hours_utilization',
  /** column name */
  HoursWithoutPto = 'hours_without_pto',
  /** column name */
  Isoweek = 'isoweek',
  /** column name */
  Isoyear = 'isoyear',
  /** column name */
  NoShowConsultBillableTime = 'no_show_consult_billable_time',
  /** column name */
  NoShowCouplesBillableTime = 'no_show_couples_billable_time',
  /** column name */
  NoShowTherapyBillableTime = 'no_show_therapy_billable_time',
  /** column name */
  PtoHours = 'pto_hours',
  /** column name */
  ScheduledConsultBillableTime = 'scheduled_consult_billable_time',
  /** column name */
  ScheduledCouplesBillableTime = 'scheduled_couples_billable_time',
  /** column name */
  ScheduledTherapyBillableTime = 'scheduled_therapy_billable_time',
  /** column name */
  TargetClientHours = 'target_client_hours',
  /** column name */
  TherapyAttended = 'therapy_attended',
  /** column name */
  TherapyBillableTime = 'therapy_billable_time',
  /** column name */
  TherapyHours = 'therapy_hours',
  /** column name */
  TherapyNoshows = 'therapy_noshows',
  /** column name */
  TherapyScheduled = 'therapy_scheduled',
  /** column name */
  Version = 'version',
  /** column name */
  Week = 'week',
  /** column name */
  WorkweekHours = 'workweek_hours'
}

/** Streaming cursor of the table "mv_clinical_utilization" */
export type Mv_Clinical_Utilization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Clinical_Utilization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Clinical_Utilization_Stream_Cursor_Value_Input = {
  adjusted_timeoff_credit?: InputMaybe<Scalars['numeric']>;
  allocated_consult_billable_time?: InputMaybe<Scalars['float8']>;
  attended_consult_billable_time?: InputMaybe<Scalars['float8']>;
  attended_couples_billable_time?: InputMaybe<Scalars['float8']>;
  attended_therapy_billable_time?: InputMaybe<Scalars['float8']>;
  billable_time_utilization?: InputMaybe<Scalars['float8']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  consult_allocation?: InputMaybe<Scalars['numeric']>;
  consult_allocation_score?: InputMaybe<Scalars['numeric']>;
  consult_billable_time?: InputMaybe<Scalars['float8']>;
  consult_noshows?: InputMaybe<Scalars['bigint']>;
  consults_attended?: InputMaybe<Scalars['bigint']>;
  consults_scheduled?: InputMaybe<Scalars['bigint']>;
  couples_attended?: InputMaybe<Scalars['bigint']>;
  couples_billable_time?: InputMaybe<Scalars['float8']>;
  couples_noshow?: InputMaybe<Scalars['bigint']>;
  couples_scheduled?: InputMaybe<Scalars['bigint']>;
  discrete_hours_utilization?: InputMaybe<Scalars['numeric']>;
  full_name?: InputMaybe<Scalars['String']>;
  group_billable_time?: InputMaybe<Scalars['float8']>;
  hours_utilization?: InputMaybe<Scalars['numeric']>;
  hours_without_pto?: InputMaybe<Scalars['numeric']>;
  isoweek?: InputMaybe<Scalars['String']>;
  isoyear?: InputMaybe<Scalars['String']>;
  no_show_consult_billable_time?: InputMaybe<Scalars['float8']>;
  no_show_couples_billable_time?: InputMaybe<Scalars['float8']>;
  no_show_therapy_billable_time?: InputMaybe<Scalars['float8']>;
  pto_hours?: InputMaybe<Scalars['numeric']>;
  scheduled_consult_billable_time?: InputMaybe<Scalars['float8']>;
  scheduled_couples_billable_time?: InputMaybe<Scalars['float8']>;
  scheduled_therapy_billable_time?: InputMaybe<Scalars['float8']>;
  target_client_hours?: InputMaybe<Scalars['float8']>;
  therapy_attended?: InputMaybe<Scalars['bigint']>;
  therapy_billable_time?: InputMaybe<Scalars['float8']>;
  therapy_hours?: InputMaybe<Scalars['float8']>;
  therapy_noshows?: InputMaybe<Scalars['bigint']>;
  therapy_scheduled?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['String']>;
  week?: InputMaybe<Scalars['timestamptz']>;
  workweek_hours?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "mv_latest_client_scores_with_status" */
export type Mv_Latest_Client_Scores_With_Status = {
  __typename?: 'mv_latest_client_scores_with_status';
  alliance_id?: Maybe<Scalars['uuid']>;
  alliance_status?: Maybe<Scalars['String']>;
  alliance_value?: Maybe<Scalars['float8']>;
  appointment_status?: Maybe<Scalars['String']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  event_id?: Maybe<Scalars['uuid']>;
  gad7_endorsed_si?: Maybe<Scalars['Boolean']>;
  gad7_first_score?: Maybe<Scalars['float8']>;
  gad7_id?: Maybe<Scalars['uuid']>;
  gad7_range?: Maybe<Scalars['String']>;
  gad7_status?: Maybe<Scalars['String']>;
  gad7_value?: Maybe<Scalars['float8']>;
  mhqol_id?: Maybe<Scalars['uuid']>;
  mhqol_value?: Maybe<Scalars['float8']>;
  phq9_endorsed_si?: Maybe<Scalars['Boolean']>;
  phq9_first_score?: Maybe<Scalars['float8']>;
  phq9_id?: Maybe<Scalars['uuid']>;
  phq9_range?: Maybe<Scalars['String']>;
  phq9_status?: Maybe<Scalars['String']>;
  phq9_value?: Maybe<Scalars['float8']>;
  row_num?: Maybe<Scalars['bigint']>;
  service_type?: Maybe<Scalars['String']>;
  session_number?: Maybe<Scalars['bigint']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  swls_id?: Maybe<Scalars['uuid']>;
  swls_value?: Maybe<Scalars['float8']>;
};

/** Boolean expression to filter rows from the table "mv_latest_client_scores_with_status". All fields are combined with a logical 'AND'. */
export type Mv_Latest_Client_Scores_With_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Bool_Exp>>;
  _not?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Bool_Exp>>;
  alliance_id?: InputMaybe<Uuid_Comparison_Exp>;
  alliance_status?: InputMaybe<String_Comparison_Exp>;
  alliance_value?: InputMaybe<Float8_Comparison_Exp>;
  appointment_status?: InputMaybe<String_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  gad7_endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  gad7_first_score?: InputMaybe<Float8_Comparison_Exp>;
  gad7_id?: InputMaybe<Uuid_Comparison_Exp>;
  gad7_range?: InputMaybe<String_Comparison_Exp>;
  gad7_status?: InputMaybe<String_Comparison_Exp>;
  gad7_value?: InputMaybe<Float8_Comparison_Exp>;
  mhqol_id?: InputMaybe<Uuid_Comparison_Exp>;
  mhqol_value?: InputMaybe<Float8_Comparison_Exp>;
  phq9_endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  phq9_first_score?: InputMaybe<Float8_Comparison_Exp>;
  phq9_id?: InputMaybe<Uuid_Comparison_Exp>;
  phq9_range?: InputMaybe<String_Comparison_Exp>;
  phq9_status?: InputMaybe<String_Comparison_Exp>;
  phq9_value?: InputMaybe<Float8_Comparison_Exp>;
  row_num?: InputMaybe<Bigint_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  session_number?: InputMaybe<Bigint_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  swls_id?: InputMaybe<Uuid_Comparison_Exp>;
  swls_value?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "mv_latest_client_scores_with_status". */
export type Mv_Latest_Client_Scores_With_Status_Order_By = {
  alliance_id?: InputMaybe<Order_By>;
  alliance_status?: InputMaybe<Order_By>;
  alliance_value?: InputMaybe<Order_By>;
  appointment_status?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  gad7_endorsed_si?: InputMaybe<Order_By>;
  gad7_first_score?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  mhqol_id?: InputMaybe<Order_By>;
  mhqol_value?: InputMaybe<Order_By>;
  phq9_endorsed_si?: InputMaybe<Order_By>;
  phq9_first_score?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  row_num?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  swls_id?: InputMaybe<Order_By>;
  swls_value?: InputMaybe<Order_By>;
};

/** select columns of table "mv_latest_client_scores_with_status" */
export enum Mv_Latest_Client_Scores_With_Status_Select_Column {
  /** column name */
  AllianceId = 'alliance_id',
  /** column name */
  AllianceStatus = 'alliance_status',
  /** column name */
  AllianceValue = 'alliance_value',
  /** column name */
  AppointmentStatus = 'appointment_status',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Gad7EndorsedSi = 'gad7_endorsed_si',
  /** column name */
  Gad7FirstScore = 'gad7_first_score',
  /** column name */
  Gad7Id = 'gad7_id',
  /** column name */
  Gad7Range = 'gad7_range',
  /** column name */
  Gad7Status = 'gad7_status',
  /** column name */
  Gad7Value = 'gad7_value',
  /** column name */
  MhqolId = 'mhqol_id',
  /** column name */
  MhqolValue = 'mhqol_value',
  /** column name */
  Phq9EndorsedSi = 'phq9_endorsed_si',
  /** column name */
  Phq9FirstScore = 'phq9_first_score',
  /** column name */
  Phq9Id = 'phq9_id',
  /** column name */
  Phq9Range = 'phq9_range',
  /** column name */
  Phq9Status = 'phq9_status',
  /** column name */
  Phq9Value = 'phq9_value',
  /** column name */
  RowNum = 'row_num',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  SessionNumber = 'session_number',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  SwlsId = 'swls_id',
  /** column name */
  SwlsValue = 'swls_value'
}

/** Streaming cursor of the table "mv_latest_client_scores_with_status" */
export type Mv_Latest_Client_Scores_With_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Latest_Client_Scores_With_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Latest_Client_Scores_With_Status_Stream_Cursor_Value_Input = {
  alliance_id?: InputMaybe<Scalars['uuid']>;
  alliance_status?: InputMaybe<Scalars['String']>;
  alliance_value?: InputMaybe<Scalars['float8']>;
  appointment_status?: InputMaybe<Scalars['String']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  gad7_endorsed_si?: InputMaybe<Scalars['Boolean']>;
  gad7_first_score?: InputMaybe<Scalars['float8']>;
  gad7_id?: InputMaybe<Scalars['uuid']>;
  gad7_range?: InputMaybe<Scalars['String']>;
  gad7_status?: InputMaybe<Scalars['String']>;
  gad7_value?: InputMaybe<Scalars['float8']>;
  mhqol_id?: InputMaybe<Scalars['uuid']>;
  mhqol_value?: InputMaybe<Scalars['float8']>;
  phq9_endorsed_si?: InputMaybe<Scalars['Boolean']>;
  phq9_first_score?: InputMaybe<Scalars['float8']>;
  phq9_id?: InputMaybe<Scalars['uuid']>;
  phq9_range?: InputMaybe<Scalars['String']>;
  phq9_status?: InputMaybe<Scalars['String']>;
  phq9_value?: InputMaybe<Scalars['float8']>;
  row_num?: InputMaybe<Scalars['bigint']>;
  service_type?: InputMaybe<Scalars['String']>;
  session_number?: InputMaybe<Scalars['bigint']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  swls_id?: InputMaybe<Scalars['uuid']>;
  swls_value?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "mv_mbc_adherence_data_by_client_and_clinician" */
export type Mv_Mbc_Adherence_Data_By_Client_And_Clinician = {
  __typename?: 'mv_mbc_adherence_data_by_client_and_clinician';
  acronym?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  client_name?: Maybe<Scalars['String']>;
  clinician_id?: Maybe<Scalars['Int']>;
  cnt_post_session?: Maybe<Scalars['bigint']>;
  cnt_pre_session?: Maybe<Scalars['bigint']>;
  display_name?: Maybe<Scalars['String']>;
  event_date?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  total_post_session_ems?: Maybe<Scalars['bigint']>;
  total_pre_session_ems?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "mv_mbc_adherence_data_by_client_and_clinician". All fields are combined with a logical 'AND'. */
export type Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>>;
  _not?: InputMaybe<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>>;
  acronym?: InputMaybe<String_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_name?: InputMaybe<String_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  cnt_post_session?: InputMaybe<Bigint_Comparison_Exp>;
  cnt_pre_session?: InputMaybe<Bigint_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_post_session_ems?: InputMaybe<Bigint_Comparison_Exp>;
  total_pre_session_ems?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "mv_mbc_adherence_data_by_client_and_clinician". */
export type Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Order_By = {
  acronym?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  client_name?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  cnt_post_session?: InputMaybe<Order_By>;
  cnt_pre_session?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  event_date?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  total_post_session_ems?: InputMaybe<Order_By>;
  total_pre_session_ems?: InputMaybe<Order_By>;
};

/** select columns of table "mv_mbc_adherence_data_by_client_and_clinician" */
export enum Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Select_Column {
  /** column name */
  Acronym = 'acronym',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CntPostSession = 'cnt_post_session',
  /** column name */
  CntPreSession = 'cnt_pre_session',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EventDate = 'event_date',
  /** column name */
  EventId = 'event_id',
  /** column name */
  TotalPostSessionEms = 'total_post_session_ems',
  /** column name */
  TotalPreSessionEms = 'total_pre_session_ems'
}

/** Streaming cursor of the table "mv_mbc_adherence_data_by_client_and_clinician" */
export type Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Stream_Cursor_Value_Input = {
  acronym?: InputMaybe<Scalars['String']>;
  client_id?: InputMaybe<Scalars['Int']>;
  client_name?: InputMaybe<Scalars['String']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  cnt_post_session?: InputMaybe<Scalars['bigint']>;
  cnt_pre_session?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  event_date?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  total_post_session_ems?: InputMaybe<Scalars['bigint']>;
  total_pre_session_ems?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "my_clients_overview" */
export type My_Clients_Overview = {
  __typename?: 'my_clients_overview';
  client_id?: Maybe<Scalars['Int']>;
  client_initials?: Maybe<Scalars['String']>;
  clinician_email?: Maybe<Scalars['citext']>;
  clinician_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_clinician?: Maybe<Ehr_Clinician>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  enrolled_in_length_of_care?: Maybe<Scalars['Boolean']>;
  future_events?: Maybe<Scalars['bigint']>;
  healthie_id?: Maybe<Scalars['String']>;
  healthie_link?: Maybe<Scalars['String']>;
  mbc_enabled?: Maybe<Scalars['Boolean']>;
  mbc_track_status?: Maybe<Scalars['String']>;
  mbc_track_status_beta?: Maybe<Scalars['String']>;
  primary_assessment?: Maybe<Scalars['String']>;
  session_count?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  suggested_range?: Maybe<Scalars['String']>;
  therapist_name?: Maybe<Scalars['String']>;
  welkin_link?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "my_clients_overview". All fields are combined with a logical 'AND'. */
export type My_Clients_Overview_Bool_Exp = {
  _and?: InputMaybe<Array<My_Clients_Overview_Bool_Exp>>;
  _not?: InputMaybe<My_Clients_Overview_Bool_Exp>;
  _or?: InputMaybe<Array<My_Clients_Overview_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_initials?: InputMaybe<String_Comparison_Exp>;
  clinician_email?: InputMaybe<Citext_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  enrolled_in_length_of_care?: InputMaybe<Boolean_Comparison_Exp>;
  future_events?: InputMaybe<Bigint_Comparison_Exp>;
  healthie_id?: InputMaybe<String_Comparison_Exp>;
  healthie_link?: InputMaybe<String_Comparison_Exp>;
  mbc_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  mbc_track_status?: InputMaybe<String_Comparison_Exp>;
  mbc_track_status_beta?: InputMaybe<String_Comparison_Exp>;
  primary_assessment?: InputMaybe<String_Comparison_Exp>;
  session_count?: InputMaybe<Int_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  suggested_range?: InputMaybe<String_Comparison_Exp>;
  therapist_name?: InputMaybe<String_Comparison_Exp>;
  welkin_link?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "my_clients_overview". */
export type My_Clients_Overview_Order_By = {
  client_id?: InputMaybe<Order_By>;
  client_initials?: InputMaybe<Order_By>;
  clinician_email?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  enrolled_in_length_of_care?: InputMaybe<Order_By>;
  future_events?: InputMaybe<Order_By>;
  healthie_id?: InputMaybe<Order_By>;
  healthie_link?: InputMaybe<Order_By>;
  mbc_enabled?: InputMaybe<Order_By>;
  mbc_track_status?: InputMaybe<Order_By>;
  mbc_track_status_beta?: InputMaybe<Order_By>;
  primary_assessment?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  suggested_range?: InputMaybe<Order_By>;
  therapist_name?: InputMaybe<Order_By>;
  welkin_link?: InputMaybe<Order_By>;
};

/** columns and relationships of "my_clients_overview_reliable_change" */
export type My_Clients_Overview_Reliable_Change = {
  __typename?: 'my_clients_overview_reliable_change';
  client_id?: Maybe<Scalars['Int']>;
  client_initials?: Maybe<Scalars['String']>;
  clinician_email?: Maybe<Scalars['citext']>;
  clinician_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  ehr_client?: Maybe<Ehr_Client>;
  /** An object relationship */
  ehr_clinician?: Maybe<Ehr_Clinician>;
  endorsed_si?: Maybe<Scalars['Boolean']>;
  enrolled_in_length_of_care?: Maybe<Scalars['Boolean']>;
  future_events?: Maybe<Scalars['bigint']>;
  mbc_enabled?: Maybe<Scalars['Boolean']>;
  mbc_track_status?: Maybe<Scalars['String']>;
  primary_assessment?: Maybe<Scalars['String']>;
  session_count?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  suggested_range?: Maybe<Scalars['String']>;
  therapist_name?: Maybe<Scalars['String']>;
  welkin_link?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "my_clients_overview_reliable_change". All fields are combined with a logical 'AND'. */
export type My_Clients_Overview_Reliable_Change_Bool_Exp = {
  _and?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Bool_Exp>>;
  _not?: InputMaybe<My_Clients_Overview_Reliable_Change_Bool_Exp>;
  _or?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  client_initials?: InputMaybe<String_Comparison_Exp>;
  clinician_email?: InputMaybe<Citext_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  ehr_client?: InputMaybe<Ehr_Client_Bool_Exp>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Bool_Exp>;
  endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  enrolled_in_length_of_care?: InputMaybe<Boolean_Comparison_Exp>;
  future_events?: InputMaybe<Bigint_Comparison_Exp>;
  mbc_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  mbc_track_status?: InputMaybe<String_Comparison_Exp>;
  primary_assessment?: InputMaybe<String_Comparison_Exp>;
  session_count?: InputMaybe<Int_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  suggested_range?: InputMaybe<String_Comparison_Exp>;
  therapist_name?: InputMaybe<String_Comparison_Exp>;
  welkin_link?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "my_clients_overview_reliable_change". */
export type My_Clients_Overview_Reliable_Change_Order_By = {
  client_id?: InputMaybe<Order_By>;
  client_initials?: InputMaybe<Order_By>;
  clinician_email?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  ehr_client?: InputMaybe<Ehr_Client_Order_By>;
  ehr_clinician?: InputMaybe<Ehr_Clinician_Order_By>;
  endorsed_si?: InputMaybe<Order_By>;
  enrolled_in_length_of_care?: InputMaybe<Order_By>;
  future_events?: InputMaybe<Order_By>;
  mbc_enabled?: InputMaybe<Order_By>;
  mbc_track_status?: InputMaybe<Order_By>;
  primary_assessment?: InputMaybe<Order_By>;
  session_count?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  suggested_range?: InputMaybe<Order_By>;
  therapist_name?: InputMaybe<Order_By>;
  welkin_link?: InputMaybe<Order_By>;
};

/** select columns of table "my_clients_overview_reliable_change" */
export enum My_Clients_Overview_Reliable_Change_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientInitials = 'client_initials',
  /** column name */
  ClinicianEmail = 'clinician_email',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EnrolledInLengthOfCare = 'enrolled_in_length_of_care',
  /** column name */
  FutureEvents = 'future_events',
  /** column name */
  MbcEnabled = 'mbc_enabled',
  /** column name */
  MbcTrackStatus = 'mbc_track_status',
  /** column name */
  PrimaryAssessment = 'primary_assessment',
  /** column name */
  SessionCount = 'session_count',
  /** column name */
  Severity = 'severity',
  /** column name */
  SuggestedRange = 'suggested_range',
  /** column name */
  TherapistName = 'therapist_name',
  /** column name */
  WelkinLink = 'welkin_link'
}

/** Streaming cursor of the table "my_clients_overview_reliable_change" */
export type My_Clients_Overview_Reliable_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: My_Clients_Overview_Reliable_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type My_Clients_Overview_Reliable_Change_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  client_initials?: InputMaybe<Scalars['String']>;
  clinician_email?: InputMaybe<Scalars['citext']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  enrolled_in_length_of_care?: InputMaybe<Scalars['Boolean']>;
  future_events?: InputMaybe<Scalars['bigint']>;
  mbc_enabled?: InputMaybe<Scalars['Boolean']>;
  mbc_track_status?: InputMaybe<Scalars['String']>;
  primary_assessment?: InputMaybe<Scalars['String']>;
  session_count?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Scalars['String']>;
  suggested_range?: InputMaybe<Scalars['String']>;
  therapist_name?: InputMaybe<Scalars['String']>;
  welkin_link?: InputMaybe<Scalars['String']>;
};

/** select columns of table "my_clients_overview" */
export enum My_Clients_Overview_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientInitials = 'client_initials',
  /** column name */
  ClinicianEmail = 'clinician_email',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndorsedSi = 'endorsed_si',
  /** column name */
  EnrolledInLengthOfCare = 'enrolled_in_length_of_care',
  /** column name */
  FutureEvents = 'future_events',
  /** column name */
  HealthieId = 'healthie_id',
  /** column name */
  HealthieLink = 'healthie_link',
  /** column name */
  MbcEnabled = 'mbc_enabled',
  /** column name */
  MbcTrackStatus = 'mbc_track_status',
  /** column name */
  MbcTrackStatusBeta = 'mbc_track_status_beta',
  /** column name */
  PrimaryAssessment = 'primary_assessment',
  /** column name */
  SessionCount = 'session_count',
  /** column name */
  Severity = 'severity',
  /** column name */
  SuggestedRange = 'suggested_range',
  /** column name */
  TherapistName = 'therapist_name',
  /** column name */
  WelkinLink = 'welkin_link'
}

/** Streaming cursor of the table "my_clients_overview" */
export type My_Clients_Overview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: My_Clients_Overview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type My_Clients_Overview_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['Int']>;
  client_initials?: InputMaybe<Scalars['String']>;
  clinician_email?: InputMaybe<Scalars['citext']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  endorsed_si?: InputMaybe<Scalars['Boolean']>;
  enrolled_in_length_of_care?: InputMaybe<Scalars['Boolean']>;
  future_events?: InputMaybe<Scalars['bigint']>;
  healthie_id?: InputMaybe<Scalars['String']>;
  healthie_link?: InputMaybe<Scalars['String']>;
  mbc_enabled?: InputMaybe<Scalars['Boolean']>;
  mbc_track_status?: InputMaybe<Scalars['String']>;
  mbc_track_status_beta?: InputMaybe<Scalars['String']>;
  primary_assessment?: InputMaybe<Scalars['String']>;
  session_count?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Scalars['String']>;
  suggested_range?: InputMaybe<Scalars['String']>;
  therapist_name?: InputMaybe<Scalars['String']>;
  welkin_link?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "auth_user" */
  auth_user: Array<Auth_User>;
  /** fetch data from the table: "auth_user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  /** An array relationship */
  auth_user_groups: Array<Auth_User_Groups>;
  /** fetch data from the table: "cwa_active_clients_by_clinician" */
  cwa_active_clients_by_clinician: Array<Cwa_Active_Clients_By_Clinician>;
  /** fetch data from the table: "dw_export.episode_of_care" */
  dw_export_episode_of_care: Array<Dw_Export_Episode_Of_Care>;
  /** fetch data from the table: "dwe_client_metrics" */
  dwe_client_metrics: Array<Dwe_Client_Metrics>;
  /** fetch data from the table: "dwe_client_metrics" using primary key columns */
  dwe_client_metrics_by_pk?: Maybe<Dwe_Client_Metrics>;
  /** fetch data from the table: "dwe_clinician_metrics" */
  dwe_clinician_metrics: Array<Dwe_Clinician_Metrics>;
  /** fetch data from the table: "dwe_clinician_metrics" using primary key columns */
  dwe_clinician_metrics_by_pk?: Maybe<Dwe_Clinician_Metrics>;
  /** fetch data from the table: "ehr_aitask" */
  ehr_aitask: Array<Ehr_Aitask>;
  /** fetch data from the table: "ehr_aitask" using primary key columns */
  ehr_aitask_by_pk?: Maybe<Ehr_Aitask>;
  /** fetch data from the table: "ehr_assessmentscore" */
  ehr_assessmentscore: Array<Ehr_Assessmentscore>;
  /** fetch data from the table: "ehr_assessmentscore" using primary key columns */
  ehr_assessmentscore_by_pk?: Maybe<Ehr_Assessmentscore>;
  /** An array relationship */
  ehr_booking: Array<Ehr_Booking>;
  /** fetch data from the table: "ehr_booking" using primary key columns */
  ehr_booking_by_pk?: Maybe<Ehr_Booking>;
  /** fetch data from the table: "ehr_client" */
  ehr_client: Array<Ehr_Client>;
  /** fetch data from the table: "ehr_client" using primary key columns */
  ehr_client_by_pk?: Maybe<Ehr_Client>;
  /** fetch data from the table: "ehr_clientaddress" */
  ehr_clientaddress: Array<Ehr_Clientaddress>;
  /** fetch data from the table: "ehr_clientaddress" using primary key columns */
  ehr_clientaddress_by_pk?: Maybe<Ehr_Clientaddress>;
  /** fetch data from the table: "ehr_clientdocument" */
  ehr_clientdocument: Array<Ehr_Clientdocument>;
  /** fetch data from the table: "ehr_clientdocument" using primary key columns */
  ehr_clientdocument_by_pk?: Maybe<Ehr_Clientdocument>;
  /** fetch data from the table: "ehr_clientemergencycontact" */
  ehr_clientemergencycontact: Array<Ehr_Clientemergencycontact>;
  /** fetch data from the table: "ehr_clientemergencycontact" using primary key columns */
  ehr_clientemergencycontact_by_pk?: Maybe<Ehr_Clientemergencycontact>;
  /** fetch data from the table: "ehr_clientgroup" */
  ehr_clientgroup: Array<Ehr_Clientgroup>;
  /** fetch data from the table: "ehr_clientgroup" using primary key columns */
  ehr_clientgroup_by_pk?: Maybe<Ehr_Clientgroup>;
  /** fetch data from the table: "ehr_clientgroupbooking" */
  ehr_clientgroupbooking: Array<Ehr_Clientgroupbooking>;
  /** fetch data from the table: "ehr_clientgroupbooking" using primary key columns */
  ehr_clientgroupbooking_by_pk?: Maybe<Ehr_Clientgroupbooking>;
  /** fetch data from the table: "ehr_clientgroupevent" */
  ehr_clientgroupevent: Array<Ehr_Clientgroupevent>;
  /** fetch data from the table: "ehr_clientgroupevent" using primary key columns */
  ehr_clientgroupevent_by_pk?: Maybe<Ehr_Clientgroupevent>;
  /** fetch data from the table: "ehr_clientgroupeventmeta" */
  ehr_clientgroupeventmeta: Array<Ehr_Clientgroupeventmeta>;
  /** fetch data from the table: "ehr_clientgroupeventmeta" using primary key columns */
  ehr_clientgroupeventmeta_by_pk?: Maybe<Ehr_Clientgroupeventmeta>;
  /** fetch data from the table: "ehr_clientpayerservicerecord" */
  ehr_clientpayerservicerecord: Array<Ehr_Clientpayerservicerecord>;
  /** fetch data from the table: "ehr_clientpayerservicerecord" using primary key columns */
  ehr_clientpayerservicerecord_by_pk?: Maybe<Ehr_Clientpayerservicerecord>;
  /** An array relationship */
  ehr_clientprofile: Array<Ehr_Clientprofile>;
  /** fetch data from the table: "ehr_clientprofile" using primary key columns */
  ehr_clientprofile_by_pk?: Maybe<Ehr_Clientprofile>;
  /** An array relationship */
  ehr_clientscreeningquestions: Array<Ehr_Clientscreeningquestions>;
  /** fetch data from the table: "ehr_clientscreeningquestions" using primary key columns */
  ehr_clientscreeningquestions_by_pk?: Maybe<Ehr_Clientscreeningquestions>;
  /** fetch data from the table: "ehr_clinician" */
  ehr_clinician: Array<Ehr_Clinician>;
  /** fetch data from the table: "ehr_clinician" using primary key columns */
  ehr_clinician_by_pk?: Maybe<Ehr_Clinician>;
  /** fetch data from the table: "ehr_clinicianclassification" */
  ehr_clinicianclassification: Array<Ehr_Clinicianclassification>;
  /** fetch data from the table: "ehr_clinicianclassification" using primary key columns */
  ehr_clinicianclassification_by_pk?: Maybe<Ehr_Clinicianclassification>;
  /** fetch data from the table: "ehr_clinicianconfiguration" */
  ehr_clinicianconfiguration: Array<Ehr_Clinicianconfiguration>;
  /** fetch data from the table: "ehr_clinicianconfiguration" using primary key columns */
  ehr_clinicianconfiguration_by_pk?: Maybe<Ehr_Clinicianconfiguration>;
  /** fetch data from the table: "ehr_clinicianschedule" */
  ehr_clinicianschedule: Array<Ehr_Clinicianschedule>;
  /** fetch data from the table: "ehr_clinicianschedule" using primary key columns */
  ehr_clinicianschedule_by_pk?: Maybe<Ehr_Clinicianschedule>;
  /** fetch data from the table: "ehr_cliniciantag" */
  ehr_cliniciantag: Array<Ehr_Cliniciantag>;
  /** fetch data from the table: "ehr_cliniciantag" using primary key columns */
  ehr_cliniciantag_by_pk?: Maybe<Ehr_Cliniciantag>;
  /** fetch data from the table: "ehr_cliniciantask" */
  ehr_cliniciantask: Array<Ehr_Cliniciantask>;
  /** fetch data from the table: "ehr_cliniciantask" using primary key columns */
  ehr_cliniciantask_by_pk?: Maybe<Ehr_Cliniciantask>;
  /** fetch data from the table: "ehr_configuration" */
  ehr_configuration: Array<Ehr_Configuration>;
  /** fetch data from the table: "ehr_configuration" using primary key columns */
  ehr_configuration_by_pk?: Maybe<Ehr_Configuration>;
  /** fetch data from the table: "ehr_consulttool" */
  ehr_consulttool: Array<Ehr_Consulttool>;
  /** fetch data from the table: "ehr_consulttool" using primary key columns */
  ehr_consulttool_by_pk?: Maybe<Ehr_Consulttool>;
  /** fetch data from the table: "ehr_diagnosisrecord" */
  ehr_diagnosisrecord: Array<Ehr_Diagnosisrecord>;
  /** fetch data from the table: "ehr_diagnosisrecord" using primary key columns */
  ehr_diagnosisrecord_by_pk?: Maybe<Ehr_Diagnosisrecord>;
  /** fetch data from the table: "ehr_event" */
  ehr_event: Array<Ehr_Event>;
  /** fetch aggregated fields from the table: "ehr_event" */
  ehr_event_aggregate: Ehr_Event_Aggregate;
  /** fetch data from the table: "ehr_event" using primary key columns */
  ehr_event_by_pk?: Maybe<Ehr_Event>;
  /** An array relationship */
  ehr_eventmbcstatus: Array<Ehr_Eventmbcstatus>;
  /** fetch data from the table: "ehr_eventmbcstatus" using primary key columns */
  ehr_eventmbcstatus_by_pk?: Maybe<Ehr_Eventmbcstatus>;
  /** fetch data from the table: "ehr_eventmeta" */
  ehr_eventmeta: Array<Ehr_Eventmeta>;
  /** fetch data from the table: "ehr_eventmeta" using primary key columns */
  ehr_eventmeta_by_pk?: Maybe<Ehr_Eventmeta>;
  /** fetch data from the table: "ehr_generalsurvey" */
  ehr_generalsurvey: Array<Ehr_Generalsurvey>;
  /** fetch data from the table: "ehr_generalsurvey" using primary key columns */
  ehr_generalsurvey_by_pk?: Maybe<Ehr_Generalsurvey>;
  /** fetch data from the table: "ehr_generalsurveyquestion" */
  ehr_generalsurveyquestion: Array<Ehr_Generalsurveyquestion>;
  /** fetch data from the table: "ehr_generalsurveyquestion" using primary key columns */
  ehr_generalsurveyquestion_by_pk?: Maybe<Ehr_Generalsurveyquestion>;
  /** fetch data from the table: "ehr_generalsurveyquestionresponse" */
  ehr_generalsurveyquestionresponse: Array<Ehr_Generalsurveyquestionresponse>;
  /** fetch data from the table: "ehr_generalsurveyquestionresponse" using primary key columns */
  ehr_generalsurveyquestionresponse_by_pk?: Maybe<Ehr_Generalsurveyquestionresponse>;
  /** fetch data from the table: "ehr_generalsurveyresponse" */
  ehr_generalsurveyresponse: Array<Ehr_Generalsurveyresponse>;
  /** fetch data from the table: "ehr_generalsurveyresponse" using primary key columns */
  ehr_generalsurveyresponse_by_pk?: Maybe<Ehr_Generalsurveyresponse>;
  /** fetch data from the table: "ehr_group" */
  ehr_group: Array<Ehr_Group>;
  /** fetch aggregated fields from the table: "ehr_group" */
  ehr_group_aggregate: Ehr_Group_Aggregate;
  /** fetch data from the table: "ehr_group" using primary key columns */
  ehr_group_by_pk?: Maybe<Ehr_Group>;
  /** fetch data from the table: "ehr_grouptype" */
  ehr_grouptype: Array<Ehr_Grouptype>;
  /** fetch data from the table: "ehr_grouptype" using primary key columns */
  ehr_grouptype_by_pk?: Maybe<Ehr_Grouptype>;
  /** fetch data from the table: "ehr_identitytoken" */
  ehr_identitytoken: Array<Ehr_Identitytoken>;
  /** fetch data from the table: "ehr_identitytoken" using primary key columns */
  ehr_identitytoken_by_pk?: Maybe<Ehr_Identitytoken>;
  /** fetch data from the table: "ehr_insurancerecord" */
  ehr_insurancerecord: Array<Ehr_Insurancerecord>;
  /** fetch data from the table: "ehr_insurancerecord" using primary key columns */
  ehr_insurancerecord_by_pk?: Maybe<Ehr_Insurancerecord>;
  /** fetch data from the table: "ehr_manualslotreservation" */
  ehr_manualslotreservation: Array<Ehr_Manualslotreservation>;
  /** fetch data from the table: "ehr_manualslotreservation" using primary key columns */
  ehr_manualslotreservation_by_pk?: Maybe<Ehr_Manualslotreservation>;
  /** fetch data from the table: "ehr_match" */
  ehr_match: Array<Ehr_Match>;
  /** fetch data from the table: "ehr_match" using primary key columns */
  ehr_match_by_pk?: Maybe<Ehr_Match>;
  ehr_match_requeue_log: Array<Ehr_Match_Requeue_Log>;
  /** fetch data from the table: "ehr_matchagerange" */
  ehr_matchagerange: Array<Ehr_Matchagerange>;
  /** fetch data from the table: "ehr_matchagerange" using primary key columns */
  ehr_matchagerange_by_pk?: Maybe<Ehr_Matchagerange>;
  /** fetch data from the table: "ehr_matchauditlog" */
  ehr_matchauditlog: Array<Ehr_Matchauditlog>;
  /** fetch data from the table: "ehr_matchauditlog" using primary key columns */
  ehr_matchauditlog_by_pk?: Maybe<Ehr_Matchauditlog>;
  /** fetch data from the table: "ehr_matchslotpreference" */
  ehr_matchslotpreference: Array<Ehr_Matchslotpreference>;
  /** fetch data from the table: "ehr_matchslotpreference" using primary key columns */
  ehr_matchslotpreference_by_pk?: Maybe<Ehr_Matchslotpreference>;
  /** fetch data from the table: "ehr_mbctrack" */
  ehr_mbctrack: Array<Ehr_Mbctrack>;
  /** fetch data from the table: "ehr_mbctrack" using primary key columns */
  ehr_mbctrack_by_pk?: Maybe<Ehr_Mbctrack>;
  /** fetch data from the table: "ehr_notification" */
  ehr_notification: Array<Ehr_Notification>;
  /** fetch data from the table: "ehr_notification" using primary key columns */
  ehr_notification_by_pk?: Maybe<Ehr_Notification>;
  /** fetch data from the table: "ehr_payer" */
  ehr_payer: Array<Ehr_Payer>;
  /** fetch data from the table: "ehr_payer" using primary key columns */
  ehr_payer_by_pk?: Maybe<Ehr_Payer>;
  /** fetch data from the table: "ehr_progressreview" */
  ehr_progressreview: Array<Ehr_Progressreview>;
  /** fetch data from the table: "ehr_progressreview" using primary key columns */
  ehr_progressreview_by_pk?: Maybe<Ehr_Progressreview>;
  /** An array relationship */
  ehr_progressreviewclientresponses: Array<Ehr_Progressreviewclientresponses>;
  /** fetch data from the table: "ehr_progressreviewclientresponses" using primary key columns */
  ehr_progressreviewclientresponses_by_pk?: Maybe<Ehr_Progressreviewclientresponses>;
  /** fetch data from the table: "ehr_questionnaire" */
  ehr_questionnaire: Array<Ehr_Questionnaire>;
  /** fetch data from the table: "ehr_questionnaire" using primary key columns */
  ehr_questionnaire_by_pk?: Maybe<Ehr_Questionnaire>;
  /** fetch data from the table: "ehr_questionnaire_tags" */
  ehr_questionnaire_tags: Array<Ehr_Questionnaire_Tags>;
  /** fetch data from the table: "ehr_questionnaire_tags" using primary key columns */
  ehr_questionnaire_tags_by_pk?: Maybe<Ehr_Questionnaire_Tags>;
  /** fetch data from the table: "ehr_questionnairetag" */
  ehr_questionnairetag: Array<Ehr_Questionnairetag>;
  /** fetch data from the table: "ehr_questionnairetag" using primary key columns */
  ehr_questionnairetag_by_pk?: Maybe<Ehr_Questionnairetag>;
  /** fetch data from the table: "ehr_referral" */
  ehr_referral: Array<Ehr_Referral>;
  /** fetch data from the table: "ehr_referral" using primary key columns */
  ehr_referral_by_pk?: Maybe<Ehr_Referral>;
  /** fetch data from the table: "ehr_referralauthorization" */
  ehr_referralauthorization: Array<Ehr_Referralauthorization>;
  /** fetch data from the table: "ehr_referralauthorization" using primary key columns */
  ehr_referralauthorization_by_pk?: Maybe<Ehr_Referralauthorization>;
  /** fetch data from the table: "ehr_tag" */
  ehr_tag: Array<Ehr_Tag>;
  /** fetch data from the table: "ehr_tag" using primary key columns */
  ehr_tag_by_pk?: Maybe<Ehr_Tag>;
  /** fetch data from the table: "ehr_timeoff" */
  ehr_timeoff: Array<Ehr_Timeoff>;
  /** fetch data from the table: "ehr_timeoff" using primary key columns */
  ehr_timeoff_by_pk?: Maybe<Ehr_Timeoff>;
  /** fetch data from the table: "episode_of_care" */
  episode_of_care: Array<Episode_Of_Care>;
  /** fetch data from the table: "episode_of_care" using primary key columns */
  episode_of_care_by_pk?: Maybe<Episode_Of_Care>;
  /** execute function "f_search_clients" which returns "ehr_client" */
  f_search_clients: Array<Ehr_Client>;
  getClientServiceLines: Array<Service_Lines>;
  getManySessionCountsFromLatestEoC: Array<Many_Session_Count>;
  getSessionCountFromLatestEpisodeOfCare: Array<Session_Count_Int>;
  /** fetch data from the table: "hasura_cwa__event_recurrence_data" */
  hasura_cwa__event_recurrence_data: Array<Hasura_Cwa__Event_Recurrence_Data>;
  /** fetch data from the table: "hasura_cwa__manual_slot_reservations" */
  hasura_cwa__manual_slot_reservations: Array<Hasura_Cwa__Manual_Slot_Reservations>;
  /** fetch data from the table: "hasura_cwa__match_with_status" */
  hasura_cwa__match_with_status: Array<Hasura_Cwa__Match_With_Status>;
  mbcScoresByClientListSessions?: Maybe<Array<Maybe<MbcScoresByClientSessionOutput>>>;
  mbcScoresByClientSession?: Maybe<Array<Maybe<MbcScoresByClientSessionOutput>>>;
  /** fetch data from the table: "mbc_adherence_data" */
  mbc_adherence_data: Array<Mbc_Adherence_Data>;
  /** An array relationship */
  mbc_assessment_question_scores: Array<Mbc_Assessment_Question_Scores>;
  /** fetch data from the table: "mbc_distinct_scores_by_client" */
  mbc_distinct_scores_by_client: Array<Mbc_Distinct_Scores_By_Client>;
  /** fetch data from the table: "mbc_distinct_scores_by_client_reliable_change" */
  mbc_distinct_scores_by_client_reliable_change: Array<Mbc_Distinct_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table: "mbc_ems_joined_with_scores" */
  mbc_ems_joined_with_scores: Array<Mbc_Ems_Joined_With_Scores>;
  /** fetch data from the table: "mbc_ems_joined_with_scores_reliable_change" */
  mbc_ems_joined_with_scores_reliable_change: Array<Mbc_Ems_Joined_With_Scores_Reliable_Change>;
  /** fetch data from the table: "mbc_partitioned_scores_by_client" */
  mbc_partitioned_scores_by_client: Array<Mbc_Partitioned_Scores_By_Client>;
  /** fetch data from the table: "mbc_partitioned_scores_by_client_reliable_change" */
  mbc_partitioned_scores_by_client_reliable_change: Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table: "mv_alliance_scores_by_clinician_and_client_ids" */
  mv_alliance_scores_by_clinician_and_client_ids: Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids>;
  /** fetch data from the table: "mv_clinical_utilization" */
  mv_clinical_utilization: Array<Mv_Clinical_Utilization>;
  /** fetch data from the table: "mv_latest_client_scores_with_status" */
  mv_latest_client_scores_with_status: Array<Mv_Latest_Client_Scores_With_Status>;
  /** fetch data from the table: "mv_mbc_adherence_data_by_client_and_clinician" */
  mv_mbc_adherence_data_by_client_and_clinician: Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician>;
  /** fetch data from the table: "my_clients_overview" */
  my_clients_overview: Array<My_Clients_Overview>;
  /** fetch data from the table: "my_clients_overview_reliable_change" */
  my_clients_overview_reliable_change: Array<My_Clients_Overview_Reliable_Change>;
  /** fetch data from the table: "scores_by_client_session_with_status" */
  scores_by_client_session_with_status: Array<Scores_By_Client_Session_With_Status>;
};


export type Query_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Query_RootAuth_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Groups_Order_By>>;
  where?: InputMaybe<Auth_User_Groups_Bool_Exp>;
};


export type Query_RootCwa_Active_Clients_By_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Order_By>>;
  where?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
};


export type Query_RootDw_Export_Episode_Of_CareArgs = {
  distinct_on?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Order_By>>;
  where?: InputMaybe<Dw_Export_Episode_Of_Care_Bool_Exp>;
};


export type Query_RootDwe_Client_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Dwe_Client_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dwe_Client_Metrics_Order_By>>;
  where?: InputMaybe<Dwe_Client_Metrics_Bool_Exp>;
};


export type Query_RootDwe_Client_Metrics_By_PkArgs = {
  client_id: Scalars['Int'];
};


export type Query_RootDwe_Clinician_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Dwe_Clinician_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dwe_Clinician_Metrics_Order_By>>;
  where?: InputMaybe<Dwe_Clinician_Metrics_Bool_Exp>;
};


export type Query_RootDwe_Clinician_Metrics_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_AitaskArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Aitask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Aitask_Order_By>>;
  where?: InputMaybe<Ehr_Aitask_Bool_Exp>;
};


export type Query_RootEhr_Aitask_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_AssessmentscoreArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Assessmentscore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Assessmentscore_Order_By>>;
  where?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
};


export type Query_RootEhr_Assessmentscore_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_BookingArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Booking_Order_By>>;
  where?: InputMaybe<Ehr_Booking_Bool_Exp>;
};


export type Query_RootEhr_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Client_Order_By>>;
  where?: InputMaybe<Ehr_Client_Bool_Exp>;
};


export type Query_RootEhr_Client_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ClientaddressArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientaddress_Order_By>>;
  where?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
};


export type Query_RootEhr_Clientaddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientdocumentArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientdocument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientdocument_Order_By>>;
  where?: InputMaybe<Ehr_Clientdocument_Bool_Exp>;
};


export type Query_RootEhr_Clientdocument_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientemergencycontactArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientemergencycontact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientemergencycontact_Order_By>>;
  where?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
};


export type Query_RootEhr_Clientemergencycontact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientgroupArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroup_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
};


export type Query_RootEhr_Clientgroup_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientgroupbookingArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupbooking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupbooking_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
};


export type Query_RootEhr_Clientgroupbooking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientgroupeventArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupevent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupevent_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
};


export type Query_RootEhr_Clientgroupevent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientgroupeventmetaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupeventmeta_Bool_Exp>;
};


export type Query_RootEhr_Clientgroupeventmeta_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ClientpayerservicerecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Order_By>>;
  where?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
};


export type Query_RootEhr_Clientpayerservicerecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientprofileArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientprofile_Order_By>>;
  where?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
};


export type Query_RootEhr_Clientprofile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClientscreeningquestionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientscreeningquestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientscreeningquestions_Order_By>>;
  where?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
};


export type Query_RootEhr_Clientscreeningquestions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinician_Order_By>>;
  where?: InputMaybe<Ehr_Clinician_Bool_Exp>;
};


export type Query_RootEhr_Clinician_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ClinicianclassificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianclassification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianclassification_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianclassification_Bool_Exp>;
};


export type Query_RootEhr_Clinicianclassification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ClinicianconfigurationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianconfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianconfiguration_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
};


export type Query_RootEhr_Clinicianconfiguration_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ClinicianscheduleArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianschedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianschedule_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
};


export type Query_RootEhr_Clinicianschedule_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_CliniciantagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Cliniciantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Cliniciantag_Order_By>>;
  where?: InputMaybe<Ehr_Cliniciantag_Bool_Exp>;
};


export type Query_RootEhr_Cliniciantag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_CliniciantaskArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Cliniciantask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Cliniciantask_Order_By>>;
  where?: InputMaybe<Ehr_Cliniciantask_Bool_Exp>;
};


export type Query_RootEhr_Cliniciantask_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Configuration_Order_By>>;
  where?: InputMaybe<Ehr_Configuration_Bool_Exp>;
};


export type Query_RootEhr_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ConsulttoolArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Consulttool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Consulttool_Order_By>>;
  where?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
};


export type Query_RootEhr_Consulttool_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_DiagnosisrecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Diagnosisrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Diagnosisrecord_Order_By>>;
  where?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
};


export type Query_RootEhr_Diagnosisrecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_EventArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


export type Query_RootEhr_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


export type Query_RootEhr_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_EventmbcstatusArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmbcstatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmbcstatus_Order_By>>;
  where?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
};


export type Query_RootEhr_Eventmbcstatus_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_EventmetaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmeta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmeta_Order_By>>;
  where?: InputMaybe<Ehr_Eventmeta_Bool_Exp>;
};


export type Query_RootEhr_Eventmeta_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_GeneralsurveyArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurvey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurvey_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
};


export type Query_RootEhr_Generalsurvey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_GeneralsurveyquestionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestion_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
};


export type Query_RootEhr_Generalsurveyquestion_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_GeneralsurveyquestionresponseArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
};


export type Query_RootEhr_Generalsurveyquestionresponse_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_GeneralsurveyresponseArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
};


export type Query_RootEhr_Generalsurveyresponse_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_GroupArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


export type Query_RootEhr_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


export type Query_RootEhr_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_GrouptypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Grouptype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Grouptype_Order_By>>;
  where?: InputMaybe<Ehr_Grouptype_Bool_Exp>;
};


export type Query_RootEhr_Grouptype_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_IdentitytokenArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Identitytoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Identitytoken_Order_By>>;
  where?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
};


export type Query_RootEhr_Identitytoken_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_InsurancerecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Insurancerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Insurancerecord_Order_By>>;
  where?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
};


export type Query_RootEhr_Insurancerecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ManualslotreservationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Manualslotreservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Manualslotreservation_Order_By>>;
  where?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
};


export type Query_RootEhr_Manualslotreservation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_MatchArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Order_By>>;
  where?: InputMaybe<Ehr_Match_Bool_Exp>;
};


export type Query_RootEhr_Match_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_Match_Requeue_LogArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Requeue_Log_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Requeue_Log_Order_By>>;
  where?: InputMaybe<Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp>;
};


export type Query_RootEhr_MatchagerangeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchagerange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchagerange_Order_By>>;
  where?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
};


export type Query_RootEhr_Matchagerange_By_PkArgs = {
  match_id: Scalars['Int'];
};


export type Query_RootEhr_MatchauditlogArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchauditlog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchauditlog_Order_By>>;
  where?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
};


export type Query_RootEhr_Matchauditlog_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_MatchslotpreferenceArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchslotpreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchslotpreference_Order_By>>;
  where?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
};


export type Query_RootEhr_Matchslotpreference_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_MbctrackArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Mbctrack_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Mbctrack_Order_By>>;
  where?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
};


export type Query_RootEhr_Mbctrack_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Notification_Bool_Exp>;
};


export type Query_RootEhr_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_PayerArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Payer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Payer_Order_By>>;
  where?: InputMaybe<Ehr_Payer_Bool_Exp>;
};


export type Query_RootEhr_Payer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ProgressreviewArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreview_Order_By>>;
  where?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
};


export type Query_RootEhr_Progressreview_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ProgressreviewclientresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Order_By>>;
  where?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
};


export type Query_RootEhr_Progressreviewclientresponses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_QuestionnaireArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnaire_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnaire_Order_By>>;
  where?: InputMaybe<Ehr_Questionnaire_Bool_Exp>;
};


export type Query_RootEhr_Questionnaire_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_Questionnaire_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnaire_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnaire_Tags_Order_By>>;
  where?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
};


export type Query_RootEhr_Questionnaire_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_QuestionnairetagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnairetag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnairetag_Order_By>>;
  where?: InputMaybe<Ehr_Questionnairetag_Bool_Exp>;
};


export type Query_RootEhr_Questionnairetag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referral_Order_By>>;
  where?: InputMaybe<Ehr_Referral_Bool_Exp>;
};


export type Query_RootEhr_Referral_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_ReferralauthorizationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referralauthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referralauthorization_Order_By>>;
  where?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
};


export type Query_RootEhr_Referralauthorization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_TagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Tag_Order_By>>;
  where?: InputMaybe<Ehr_Tag_Bool_Exp>;
};


export type Query_RootEhr_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEhr_TimeoffArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Timeoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Timeoff_Order_By>>;
  where?: InputMaybe<Ehr_Timeoff_Bool_Exp>;
};


export type Query_RootEhr_Timeoff_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEpisode_Of_CareArgs = {
  distinct_on?: InputMaybe<Array<Episode_Of_Care_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Episode_Of_Care_Order_By>>;
  where?: InputMaybe<Episode_Of_Care_Bool_Exp>;
};


export type Query_RootEpisode_Of_Care_By_PkArgs = {
  event_id: Scalars['String'];
};


export type Query_RootF_Search_ClientsArgs = {
  args: F_Search_Clients_Args;
  distinct_on?: InputMaybe<Array<Ehr_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Client_Order_By>>;
  where?: InputMaybe<Ehr_Client_Bool_Exp>;
};


export type Query_RootGetClientServiceLinesArgs = {
  args: GetClientServiceLines_Arguments;
  distinct_on?: InputMaybe<Array<Service_Lines_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Lines_Order_By>>;
  where?: InputMaybe<Service_Lines_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetManySessionCountsFromLatestEoCArgs = {
  args: GetManySessionCountsFromLatestEoC_Arguments;
  distinct_on?: InputMaybe<Array<Many_Session_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Many_Session_Count_Order_By>>;
  where?: InputMaybe<Many_Session_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetSessionCountFromLatestEpisodeOfCareArgs = {
  args: GetSessionCountFromLatestEpisodeOfCare_Arguments;
  distinct_on?: InputMaybe<Array<Session_Count_Int_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Session_Count_Int_Order_By>>;
  where?: InputMaybe<Session_Count_Int_Bool_Exp_Bool_Exp>;
};


export type Query_RootHasura_Cwa__Event_Recurrence_DataArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>;
};


export type Query_RootHasura_Cwa__Manual_Slot_ReservationsArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
};


export type Query_RootHasura_Cwa__Match_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
};


export type Query_RootMbcScoresByClientListSessionsArgs = {
  client_ids: Scalars['String'];
};


export type Query_RootMbcScoresByClientSessionArgs = {
  client_id: Scalars['Int'];
  compare?: InputMaybe<Scalars['Boolean']>;
  use_python?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootMbc_Adherence_DataArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Adherence_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Adherence_Data_Order_By>>;
  where?: InputMaybe<Mbc_Adherence_Data_Bool_Exp>;
};


export type Query_RootMbc_Assessment_Question_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


export type Query_RootMbc_Distinct_Scores_By_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
};


export type Query_RootMbc_Distinct_Scores_By_Client_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Query_RootMbc_Ems_Joined_With_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
};


export type Query_RootMbc_Ems_Joined_With_Scores_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>;
};


export type Query_RootMbc_Partitioned_Scores_By_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
};


export type Query_RootMbc_Partitioned_Scores_By_Client_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Query_RootMv_Alliance_Scores_By_Clinician_And_Client_IdsArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Order_By>>;
  where?: InputMaybe<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>;
};


export type Query_RootMv_Clinical_UtilizationArgs = {
  distinct_on?: InputMaybe<Array<Mv_Clinical_Utilization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Clinical_Utilization_Order_By>>;
  where?: InputMaybe<Mv_Clinical_Utilization_Bool_Exp>;
};


export type Query_RootMv_Latest_Client_Scores_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Order_By>>;
  where?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
};


export type Query_RootMv_Mbc_Adherence_Data_By_Client_And_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Order_By>>;
  where?: InputMaybe<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>;
};


export type Query_RootMy_Clients_OverviewArgs = {
  distinct_on?: InputMaybe<Array<My_Clients_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<My_Clients_Overview_Order_By>>;
  where?: InputMaybe<My_Clients_Overview_Bool_Exp>;
};


export type Query_RootMy_Clients_Overview_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Order_By>>;
  where?: InputMaybe<My_Clients_Overview_Reliable_Change_Bool_Exp>;
};


export type Query_RootScores_By_Client_Session_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Order_By>>;
  where?: InputMaybe<Scores_By_Client_Session_With_Status_Bool_Exp>;
};

/** columns and relationships of "scores_by_client_session_with_status" */
export type Scores_By_Client_Session_With_Status = {
  __typename?: 'scores_by_client_session_with_status';
  alliance_id?: Maybe<Scalars['uuid']>;
  alliance_value?: Maybe<Scalars['float8']>;
  client_id?: Maybe<Scalars['Int']>;
  clinician_id?: Maybe<Scalars['Int']>;
  event_id?: Maybe<Scalars['uuid']>;
  first_name?: Maybe<Scalars['String']>;
  gad7_endorsed_si?: Maybe<Scalars['Boolean']>;
  gad7_first_score?: Maybe<Scalars['float8']>;
  gad7_id?: Maybe<Scalars['uuid']>;
  gad7_range?: Maybe<Scalars['String']>;
  gad7_status?: Maybe<Scalars['String']>;
  gad7_value?: Maybe<Scalars['float8']>;
  last_name?: Maybe<Scalars['String']>;
  phq9_endorsed_si?: Maybe<Scalars['Boolean']>;
  phq9_first_score?: Maybe<Scalars['float8']>;
  phq9_id?: Maybe<Scalars['uuid']>;
  phq9_range?: Maybe<Scalars['String']>;
  phq9_status?: Maybe<Scalars['String']>;
  phq9_value?: Maybe<Scalars['float8']>;
  preferred_name?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  session_number?: Maybe<Scalars['bigint']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  swls_id?: Maybe<Scalars['uuid']>;
  swls_value?: Maybe<Scalars['float8']>;
};

/** Boolean expression to filter rows from the table "scores_by_client_session_with_status". All fields are combined with a logical 'AND'. */
export type Scores_By_Client_Session_With_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Bool_Exp>>;
  _not?: InputMaybe<Scores_By_Client_Session_With_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Bool_Exp>>;
  alliance_id?: InputMaybe<Uuid_Comparison_Exp>;
  alliance_value?: InputMaybe<Float8_Comparison_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  clinician_id?: InputMaybe<Int_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gad7_endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  gad7_first_score?: InputMaybe<Float8_Comparison_Exp>;
  gad7_id?: InputMaybe<Uuid_Comparison_Exp>;
  gad7_range?: InputMaybe<String_Comparison_Exp>;
  gad7_status?: InputMaybe<String_Comparison_Exp>;
  gad7_value?: InputMaybe<Float8_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  phq9_endorsed_si?: InputMaybe<Boolean_Comparison_Exp>;
  phq9_first_score?: InputMaybe<Float8_Comparison_Exp>;
  phq9_id?: InputMaybe<Uuid_Comparison_Exp>;
  phq9_range?: InputMaybe<String_Comparison_Exp>;
  phq9_status?: InputMaybe<String_Comparison_Exp>;
  phq9_value?: InputMaybe<Float8_Comparison_Exp>;
  preferred_name?: InputMaybe<String_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  session_number?: InputMaybe<Bigint_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  swls_id?: InputMaybe<Uuid_Comparison_Exp>;
  swls_value?: InputMaybe<Float8_Comparison_Exp>;
};

/** Ordering options when selecting data from "scores_by_client_session_with_status". */
export type Scores_By_Client_Session_With_Status_Order_By = {
  alliance_id?: InputMaybe<Order_By>;
  alliance_value?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gad7_endorsed_si?: InputMaybe<Order_By>;
  gad7_first_score?: InputMaybe<Order_By>;
  gad7_id?: InputMaybe<Order_By>;
  gad7_range?: InputMaybe<Order_By>;
  gad7_status?: InputMaybe<Order_By>;
  gad7_value?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phq9_endorsed_si?: InputMaybe<Order_By>;
  phq9_first_score?: InputMaybe<Order_By>;
  phq9_id?: InputMaybe<Order_By>;
  phq9_range?: InputMaybe<Order_By>;
  phq9_status?: InputMaybe<Order_By>;
  phq9_value?: InputMaybe<Order_By>;
  preferred_name?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  session_number?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  swls_id?: InputMaybe<Order_By>;
  swls_value?: InputMaybe<Order_By>;
};

/** select columns of table "scores_by_client_session_with_status" */
export enum Scores_By_Client_Session_With_Status_Select_Column {
  /** column name */
  AllianceId = 'alliance_id',
  /** column name */
  AllianceValue = 'alliance_value',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gad7EndorsedSi = 'gad7_endorsed_si',
  /** column name */
  Gad7FirstScore = 'gad7_first_score',
  /** column name */
  Gad7Id = 'gad7_id',
  /** column name */
  Gad7Range = 'gad7_range',
  /** column name */
  Gad7Status = 'gad7_status',
  /** column name */
  Gad7Value = 'gad7_value',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Phq9EndorsedSi = 'phq9_endorsed_si',
  /** column name */
  Phq9FirstScore = 'phq9_first_score',
  /** column name */
  Phq9Id = 'phq9_id',
  /** column name */
  Phq9Range = 'phq9_range',
  /** column name */
  Phq9Status = 'phq9_status',
  /** column name */
  Phq9Value = 'phq9_value',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  SessionNumber = 'session_number',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  SwlsId = 'swls_id',
  /** column name */
  SwlsValue = 'swls_value'
}

/** Streaming cursor of the table "scores_by_client_session_with_status" */
export type Scores_By_Client_Session_With_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scores_By_Client_Session_With_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scores_By_Client_Session_With_Status_Stream_Cursor_Value_Input = {
  alliance_id?: InputMaybe<Scalars['uuid']>;
  alliance_value?: InputMaybe<Scalars['float8']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  first_name?: InputMaybe<Scalars['String']>;
  gad7_endorsed_si?: InputMaybe<Scalars['Boolean']>;
  gad7_first_score?: InputMaybe<Scalars['float8']>;
  gad7_id?: InputMaybe<Scalars['uuid']>;
  gad7_range?: InputMaybe<Scalars['String']>;
  gad7_status?: InputMaybe<Scalars['String']>;
  gad7_value?: InputMaybe<Scalars['float8']>;
  last_name?: InputMaybe<Scalars['String']>;
  phq9_endorsed_si?: InputMaybe<Scalars['Boolean']>;
  phq9_first_score?: InputMaybe<Scalars['float8']>;
  phq9_id?: InputMaybe<Scalars['uuid']>;
  phq9_range?: InputMaybe<Scalars['String']>;
  phq9_status?: InputMaybe<Scalars['String']>;
  phq9_value?: InputMaybe<Scalars['float8']>;
  preferred_name?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  session_number?: InputMaybe<Scalars['bigint']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  swls_id?: InputMaybe<Scalars['uuid']>;
  swls_value?: InputMaybe<Scalars['float8']>;
};

export type Service_Lines = {
  __typename?: 'service_lines';
  client_id?: Maybe<Scalars['Int']>;
  service_lines?: Maybe<Scalars['jsonb']>;
};


export type Service_LinesService_LinesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "service_lines". All fields are combined with a logical 'AND'. */
export type Service_Lines_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Lines_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Service_Lines_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Lines_Bool_Exp_Bool_Exp>>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  service_lines?: InputMaybe<Jsonb_Comparison_Exp>;
};

export enum Service_Lines_Enum_Name {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ServiceLines = 'service_lines'
}

/** Ordering options when selecting data from "service_lines". */
export type Service_Lines_Order_By = {
  client_id?: InputMaybe<Order_By>;
  service_lines?: InputMaybe<Order_By>;
};

export type Session_Count_Int = {
  __typename?: 'session_count_int';
  count?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the logical model for "session_count_int". All fields are combined with a logical 'AND'. */
export type Session_Count_Int_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Session_Count_Int_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Session_Count_Int_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Session_Count_Int_Bool_Exp_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Session_Count_Int_Enum_Name {
  /** column name */
  Count = 'count'
}

/** Ordering options when selecting data from "session_count_int". */
export type Session_Count_Int_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table in a streaming manner: "auth_group" */
  auth_group_stream: Array<Auth_Group>;
  /** fetch data from the table: "auth_user" */
  auth_user: Array<Auth_User>;
  /** fetch data from the table: "auth_user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  /** An array relationship */
  auth_user_groups: Array<Auth_User_Groups>;
  /** fetch data from the table in a streaming manner: "auth_user_groups" */
  auth_user_groups_stream: Array<Auth_User_Groups>;
  /** fetch data from the table in a streaming manner: "auth_user" */
  auth_user_stream: Array<Auth_User>;
  /** fetch data from the table: "cwa_active_clients_by_clinician" */
  cwa_active_clients_by_clinician: Array<Cwa_Active_Clients_By_Clinician>;
  /** fetch data from the table in a streaming manner: "cwa_active_clients_by_clinician" */
  cwa_active_clients_by_clinician_stream: Array<Cwa_Active_Clients_By_Clinician>;
  /** fetch data from the table: "dw_export.episode_of_care" */
  dw_export_episode_of_care: Array<Dw_Export_Episode_Of_Care>;
  /** fetch data from the table: "dwe_client_metrics" */
  dwe_client_metrics: Array<Dwe_Client_Metrics>;
  /** fetch data from the table: "dwe_client_metrics" using primary key columns */
  dwe_client_metrics_by_pk?: Maybe<Dwe_Client_Metrics>;
  /** fetch data from the table in a streaming manner: "dwe_client_metrics" */
  dwe_client_metrics_stream: Array<Dwe_Client_Metrics>;
  /** fetch data from the table: "dwe_clinician_metrics" */
  dwe_clinician_metrics: Array<Dwe_Clinician_Metrics>;
  /** fetch data from the table: "dwe_clinician_metrics" using primary key columns */
  dwe_clinician_metrics_by_pk?: Maybe<Dwe_Clinician_Metrics>;
  /** fetch data from the table in a streaming manner: "dwe_clinician_metrics" */
  dwe_clinician_metrics_stream: Array<Dwe_Clinician_Metrics>;
  /** fetch data from the table: "ehr_aitask" */
  ehr_aitask: Array<Ehr_Aitask>;
  /** fetch data from the table: "ehr_aitask" using primary key columns */
  ehr_aitask_by_pk?: Maybe<Ehr_Aitask>;
  /** fetch data from the table in a streaming manner: "ehr_aitask" */
  ehr_aitask_stream: Array<Ehr_Aitask>;
  /** fetch data from the table: "ehr_assessmentscore" */
  ehr_assessmentscore: Array<Ehr_Assessmentscore>;
  /** fetch data from the table: "ehr_assessmentscore" using primary key columns */
  ehr_assessmentscore_by_pk?: Maybe<Ehr_Assessmentscore>;
  /** fetch data from the table in a streaming manner: "ehr_assessmentscore" */
  ehr_assessmentscore_stream: Array<Ehr_Assessmentscore>;
  /** An array relationship */
  ehr_booking: Array<Ehr_Booking>;
  /** fetch data from the table: "ehr_booking" using primary key columns */
  ehr_booking_by_pk?: Maybe<Ehr_Booking>;
  /** fetch data from the table in a streaming manner: "ehr_booking" */
  ehr_booking_stream: Array<Ehr_Booking>;
  /** fetch data from the table: "ehr_client" */
  ehr_client: Array<Ehr_Client>;
  /** fetch data from the table: "ehr_client" using primary key columns */
  ehr_client_by_pk?: Maybe<Ehr_Client>;
  /** fetch data from the table in a streaming manner: "ehr_client" */
  ehr_client_stream: Array<Ehr_Client>;
  /** fetch data from the table: "ehr_clientaddress" */
  ehr_clientaddress: Array<Ehr_Clientaddress>;
  /** fetch data from the table: "ehr_clientaddress" using primary key columns */
  ehr_clientaddress_by_pk?: Maybe<Ehr_Clientaddress>;
  /** fetch data from the table in a streaming manner: "ehr_clientaddress" */
  ehr_clientaddress_stream: Array<Ehr_Clientaddress>;
  /** fetch data from the table: "ehr_clientdocument" */
  ehr_clientdocument: Array<Ehr_Clientdocument>;
  /** fetch data from the table: "ehr_clientdocument" using primary key columns */
  ehr_clientdocument_by_pk?: Maybe<Ehr_Clientdocument>;
  /** fetch data from the table in a streaming manner: "ehr_clientdocument" */
  ehr_clientdocument_stream: Array<Ehr_Clientdocument>;
  /** fetch data from the table: "ehr_clientemergencycontact" */
  ehr_clientemergencycontact: Array<Ehr_Clientemergencycontact>;
  /** fetch data from the table: "ehr_clientemergencycontact" using primary key columns */
  ehr_clientemergencycontact_by_pk?: Maybe<Ehr_Clientemergencycontact>;
  /** fetch data from the table in a streaming manner: "ehr_clientemergencycontact" */
  ehr_clientemergencycontact_stream: Array<Ehr_Clientemergencycontact>;
  /** fetch data from the table: "ehr_clientgroup" */
  ehr_clientgroup: Array<Ehr_Clientgroup>;
  /** fetch data from the table: "ehr_clientgroup" using primary key columns */
  ehr_clientgroup_by_pk?: Maybe<Ehr_Clientgroup>;
  /** fetch data from the table in a streaming manner: "ehr_clientgroup" */
  ehr_clientgroup_stream: Array<Ehr_Clientgroup>;
  /** fetch data from the table: "ehr_clientgroupbooking" */
  ehr_clientgroupbooking: Array<Ehr_Clientgroupbooking>;
  /** fetch data from the table: "ehr_clientgroupbooking" using primary key columns */
  ehr_clientgroupbooking_by_pk?: Maybe<Ehr_Clientgroupbooking>;
  /** fetch data from the table in a streaming manner: "ehr_clientgroupbooking" */
  ehr_clientgroupbooking_stream: Array<Ehr_Clientgroupbooking>;
  /** fetch data from the table: "ehr_clientgroupevent" */
  ehr_clientgroupevent: Array<Ehr_Clientgroupevent>;
  /** fetch data from the table: "ehr_clientgroupevent" using primary key columns */
  ehr_clientgroupevent_by_pk?: Maybe<Ehr_Clientgroupevent>;
  /** fetch data from the table in a streaming manner: "ehr_clientgroupevent" */
  ehr_clientgroupevent_stream: Array<Ehr_Clientgroupevent>;
  /** fetch data from the table: "ehr_clientgroupeventmeta" */
  ehr_clientgroupeventmeta: Array<Ehr_Clientgroupeventmeta>;
  /** fetch data from the table: "ehr_clientgroupeventmeta" using primary key columns */
  ehr_clientgroupeventmeta_by_pk?: Maybe<Ehr_Clientgroupeventmeta>;
  /** fetch data from the table in a streaming manner: "ehr_clientgroupeventmeta" */
  ehr_clientgroupeventmeta_stream: Array<Ehr_Clientgroupeventmeta>;
  /** fetch data from the table: "ehr_clientpayerservicerecord" */
  ehr_clientpayerservicerecord: Array<Ehr_Clientpayerservicerecord>;
  /** fetch data from the table: "ehr_clientpayerservicerecord" using primary key columns */
  ehr_clientpayerservicerecord_by_pk?: Maybe<Ehr_Clientpayerservicerecord>;
  /** fetch data from the table in a streaming manner: "ehr_clientpayerservicerecord" */
  ehr_clientpayerservicerecord_stream: Array<Ehr_Clientpayerservicerecord>;
  /** An array relationship */
  ehr_clientprofile: Array<Ehr_Clientprofile>;
  /** fetch data from the table: "ehr_clientprofile" using primary key columns */
  ehr_clientprofile_by_pk?: Maybe<Ehr_Clientprofile>;
  /** fetch data from the table in a streaming manner: "ehr_clientprofile" */
  ehr_clientprofile_stream: Array<Ehr_Clientprofile>;
  /** An array relationship */
  ehr_clientscreeningquestions: Array<Ehr_Clientscreeningquestions>;
  /** fetch data from the table: "ehr_clientscreeningquestions" using primary key columns */
  ehr_clientscreeningquestions_by_pk?: Maybe<Ehr_Clientscreeningquestions>;
  /** fetch data from the table in a streaming manner: "ehr_clientscreeningquestions" */
  ehr_clientscreeningquestions_stream: Array<Ehr_Clientscreeningquestions>;
  /** fetch data from the table: "ehr_clinician" */
  ehr_clinician: Array<Ehr_Clinician>;
  /** fetch data from the table: "ehr_clinician" using primary key columns */
  ehr_clinician_by_pk?: Maybe<Ehr_Clinician>;
  /** fetch data from the table in a streaming manner: "ehr_clinician" */
  ehr_clinician_stream: Array<Ehr_Clinician>;
  /** fetch data from the table: "ehr_clinicianclassification" */
  ehr_clinicianclassification: Array<Ehr_Clinicianclassification>;
  /** fetch data from the table: "ehr_clinicianclassification" using primary key columns */
  ehr_clinicianclassification_by_pk?: Maybe<Ehr_Clinicianclassification>;
  /** fetch data from the table in a streaming manner: "ehr_clinicianclassification" */
  ehr_clinicianclassification_stream: Array<Ehr_Clinicianclassification>;
  /** fetch data from the table: "ehr_clinicianconfiguration" */
  ehr_clinicianconfiguration: Array<Ehr_Clinicianconfiguration>;
  /** fetch data from the table: "ehr_clinicianconfiguration" using primary key columns */
  ehr_clinicianconfiguration_by_pk?: Maybe<Ehr_Clinicianconfiguration>;
  /** fetch data from the table in a streaming manner: "ehr_clinicianconfiguration" */
  ehr_clinicianconfiguration_stream: Array<Ehr_Clinicianconfiguration>;
  /** fetch data from the table: "ehr_clinicianschedule" */
  ehr_clinicianschedule: Array<Ehr_Clinicianschedule>;
  /** fetch data from the table: "ehr_clinicianschedule" using primary key columns */
  ehr_clinicianschedule_by_pk?: Maybe<Ehr_Clinicianschedule>;
  /** fetch data from the table in a streaming manner: "ehr_clinicianschedule" */
  ehr_clinicianschedule_stream: Array<Ehr_Clinicianschedule>;
  /** fetch data from the table: "ehr_cliniciantag" */
  ehr_cliniciantag: Array<Ehr_Cliniciantag>;
  /** fetch data from the table: "ehr_cliniciantag" using primary key columns */
  ehr_cliniciantag_by_pk?: Maybe<Ehr_Cliniciantag>;
  /** fetch data from the table in a streaming manner: "ehr_cliniciantag" */
  ehr_cliniciantag_stream: Array<Ehr_Cliniciantag>;
  /** fetch data from the table: "ehr_cliniciantask" */
  ehr_cliniciantask: Array<Ehr_Cliniciantask>;
  /** fetch data from the table: "ehr_cliniciantask" using primary key columns */
  ehr_cliniciantask_by_pk?: Maybe<Ehr_Cliniciantask>;
  /** fetch data from the table in a streaming manner: "ehr_cliniciantask" */
  ehr_cliniciantask_stream: Array<Ehr_Cliniciantask>;
  /** fetch data from the table: "ehr_configuration" */
  ehr_configuration: Array<Ehr_Configuration>;
  /** fetch data from the table: "ehr_configuration" using primary key columns */
  ehr_configuration_by_pk?: Maybe<Ehr_Configuration>;
  /** fetch data from the table in a streaming manner: "ehr_configuration" */
  ehr_configuration_stream: Array<Ehr_Configuration>;
  /** fetch data from the table: "ehr_consulttool" */
  ehr_consulttool: Array<Ehr_Consulttool>;
  /** fetch data from the table: "ehr_consulttool" using primary key columns */
  ehr_consulttool_by_pk?: Maybe<Ehr_Consulttool>;
  /** fetch data from the table in a streaming manner: "ehr_consulttool" */
  ehr_consulttool_stream: Array<Ehr_Consulttool>;
  /** fetch data from the table: "ehr_diagnosisrecord" */
  ehr_diagnosisrecord: Array<Ehr_Diagnosisrecord>;
  /** fetch data from the table: "ehr_diagnosisrecord" using primary key columns */
  ehr_diagnosisrecord_by_pk?: Maybe<Ehr_Diagnosisrecord>;
  /** fetch data from the table in a streaming manner: "ehr_diagnosisrecord" */
  ehr_diagnosisrecord_stream: Array<Ehr_Diagnosisrecord>;
  /** fetch data from the table: "ehr_event" */
  ehr_event: Array<Ehr_Event>;
  /** fetch aggregated fields from the table: "ehr_event" */
  ehr_event_aggregate: Ehr_Event_Aggregate;
  /** fetch data from the table: "ehr_event" using primary key columns */
  ehr_event_by_pk?: Maybe<Ehr_Event>;
  /** fetch data from the table in a streaming manner: "ehr_event" */
  ehr_event_stream: Array<Ehr_Event>;
  /** An array relationship */
  ehr_eventmbcstatus: Array<Ehr_Eventmbcstatus>;
  /** fetch data from the table: "ehr_eventmbcstatus" using primary key columns */
  ehr_eventmbcstatus_by_pk?: Maybe<Ehr_Eventmbcstatus>;
  /** fetch data from the table in a streaming manner: "ehr_eventmbcstatus" */
  ehr_eventmbcstatus_stream: Array<Ehr_Eventmbcstatus>;
  /** fetch data from the table: "ehr_eventmeta" */
  ehr_eventmeta: Array<Ehr_Eventmeta>;
  /** fetch data from the table: "ehr_eventmeta" using primary key columns */
  ehr_eventmeta_by_pk?: Maybe<Ehr_Eventmeta>;
  /** fetch data from the table in a streaming manner: "ehr_eventmeta" */
  ehr_eventmeta_stream: Array<Ehr_Eventmeta>;
  /** fetch data from the table: "ehr_generalsurvey" */
  ehr_generalsurvey: Array<Ehr_Generalsurvey>;
  /** fetch data from the table: "ehr_generalsurvey" using primary key columns */
  ehr_generalsurvey_by_pk?: Maybe<Ehr_Generalsurvey>;
  /** fetch data from the table in a streaming manner: "ehr_generalsurvey" */
  ehr_generalsurvey_stream: Array<Ehr_Generalsurvey>;
  /** fetch data from the table: "ehr_generalsurveyquestion" */
  ehr_generalsurveyquestion: Array<Ehr_Generalsurveyquestion>;
  /** fetch data from the table: "ehr_generalsurveyquestion" using primary key columns */
  ehr_generalsurveyquestion_by_pk?: Maybe<Ehr_Generalsurveyquestion>;
  /** fetch data from the table in a streaming manner: "ehr_generalsurveyquestion" */
  ehr_generalsurveyquestion_stream: Array<Ehr_Generalsurveyquestion>;
  /** fetch data from the table: "ehr_generalsurveyquestionresponse" */
  ehr_generalsurveyquestionresponse: Array<Ehr_Generalsurveyquestionresponse>;
  /** fetch data from the table: "ehr_generalsurveyquestionresponse" using primary key columns */
  ehr_generalsurveyquestionresponse_by_pk?: Maybe<Ehr_Generalsurveyquestionresponse>;
  /** fetch data from the table in a streaming manner: "ehr_generalsurveyquestionresponse" */
  ehr_generalsurveyquestionresponse_stream: Array<Ehr_Generalsurveyquestionresponse>;
  /** fetch data from the table: "ehr_generalsurveyresponse" */
  ehr_generalsurveyresponse: Array<Ehr_Generalsurveyresponse>;
  /** fetch data from the table: "ehr_generalsurveyresponse" using primary key columns */
  ehr_generalsurveyresponse_by_pk?: Maybe<Ehr_Generalsurveyresponse>;
  /** fetch data from the table in a streaming manner: "ehr_generalsurveyresponse" */
  ehr_generalsurveyresponse_stream: Array<Ehr_Generalsurveyresponse>;
  /** fetch data from the table: "ehr_group" */
  ehr_group: Array<Ehr_Group>;
  /** fetch aggregated fields from the table: "ehr_group" */
  ehr_group_aggregate: Ehr_Group_Aggregate;
  /** fetch data from the table: "ehr_group" using primary key columns */
  ehr_group_by_pk?: Maybe<Ehr_Group>;
  /** fetch data from the table in a streaming manner: "ehr_group" */
  ehr_group_stream: Array<Ehr_Group>;
  /** fetch data from the table: "ehr_grouptype" */
  ehr_grouptype: Array<Ehr_Grouptype>;
  /** fetch data from the table: "ehr_grouptype" using primary key columns */
  ehr_grouptype_by_pk?: Maybe<Ehr_Grouptype>;
  /** fetch data from the table in a streaming manner: "ehr_grouptype" */
  ehr_grouptype_stream: Array<Ehr_Grouptype>;
  /** fetch data from the table: "ehr_identitytoken" */
  ehr_identitytoken: Array<Ehr_Identitytoken>;
  /** fetch data from the table: "ehr_identitytoken" using primary key columns */
  ehr_identitytoken_by_pk?: Maybe<Ehr_Identitytoken>;
  /** fetch data from the table in a streaming manner: "ehr_identitytoken" */
  ehr_identitytoken_stream: Array<Ehr_Identitytoken>;
  /** fetch data from the table: "ehr_insurancerecord" */
  ehr_insurancerecord: Array<Ehr_Insurancerecord>;
  /** fetch data from the table: "ehr_insurancerecord" using primary key columns */
  ehr_insurancerecord_by_pk?: Maybe<Ehr_Insurancerecord>;
  /** fetch data from the table in a streaming manner: "ehr_insurancerecord" */
  ehr_insurancerecord_stream: Array<Ehr_Insurancerecord>;
  /** fetch data from the table: "ehr_manualslotreservation" */
  ehr_manualslotreservation: Array<Ehr_Manualslotreservation>;
  /** fetch data from the table: "ehr_manualslotreservation" using primary key columns */
  ehr_manualslotreservation_by_pk?: Maybe<Ehr_Manualslotreservation>;
  /** fetch data from the table in a streaming manner: "ehr_manualslotreservation" */
  ehr_manualslotreservation_stream: Array<Ehr_Manualslotreservation>;
  /** fetch data from the table: "ehr_match" */
  ehr_match: Array<Ehr_Match>;
  /** fetch data from the table: "ehr_match" using primary key columns */
  ehr_match_by_pk?: Maybe<Ehr_Match>;
  ehr_match_requeue_log: Array<Ehr_Match_Requeue_Log>;
  /** fetch data from the table in a streaming manner: "ehr_match" */
  ehr_match_stream: Array<Ehr_Match>;
  /** fetch data from the table: "ehr_matchagerange" */
  ehr_matchagerange: Array<Ehr_Matchagerange>;
  /** fetch data from the table: "ehr_matchagerange" using primary key columns */
  ehr_matchagerange_by_pk?: Maybe<Ehr_Matchagerange>;
  /** fetch data from the table in a streaming manner: "ehr_matchagerange" */
  ehr_matchagerange_stream: Array<Ehr_Matchagerange>;
  /** fetch data from the table: "ehr_matchauditlog" */
  ehr_matchauditlog: Array<Ehr_Matchauditlog>;
  /** fetch data from the table: "ehr_matchauditlog" using primary key columns */
  ehr_matchauditlog_by_pk?: Maybe<Ehr_Matchauditlog>;
  /** fetch data from the table in a streaming manner: "ehr_matchauditlog" */
  ehr_matchauditlog_stream: Array<Ehr_Matchauditlog>;
  /** fetch data from the table: "ehr_matchslotpreference" */
  ehr_matchslotpreference: Array<Ehr_Matchslotpreference>;
  /** fetch data from the table: "ehr_matchslotpreference" using primary key columns */
  ehr_matchslotpreference_by_pk?: Maybe<Ehr_Matchslotpreference>;
  /** fetch data from the table in a streaming manner: "ehr_matchslotpreference" */
  ehr_matchslotpreference_stream: Array<Ehr_Matchslotpreference>;
  /** fetch data from the table: "ehr_mbctrack" */
  ehr_mbctrack: Array<Ehr_Mbctrack>;
  /** fetch data from the table: "ehr_mbctrack" using primary key columns */
  ehr_mbctrack_by_pk?: Maybe<Ehr_Mbctrack>;
  /** fetch data from the table in a streaming manner: "ehr_mbctrack" */
  ehr_mbctrack_stream: Array<Ehr_Mbctrack>;
  /** fetch data from the table: "ehr_notification" */
  ehr_notification: Array<Ehr_Notification>;
  /** fetch data from the table: "ehr_notification" using primary key columns */
  ehr_notification_by_pk?: Maybe<Ehr_Notification>;
  /** fetch data from the table in a streaming manner: "ehr_notification" */
  ehr_notification_stream: Array<Ehr_Notification>;
  /** fetch data from the table: "ehr_payer" */
  ehr_payer: Array<Ehr_Payer>;
  /** fetch data from the table: "ehr_payer" using primary key columns */
  ehr_payer_by_pk?: Maybe<Ehr_Payer>;
  /** fetch data from the table in a streaming manner: "ehr_payer" */
  ehr_payer_stream: Array<Ehr_Payer>;
  /** fetch data from the table: "ehr_progressreview" */
  ehr_progressreview: Array<Ehr_Progressreview>;
  /** fetch data from the table: "ehr_progressreview" using primary key columns */
  ehr_progressreview_by_pk?: Maybe<Ehr_Progressreview>;
  /** fetch data from the table in a streaming manner: "ehr_progressreview" */
  ehr_progressreview_stream: Array<Ehr_Progressreview>;
  /** An array relationship */
  ehr_progressreviewclientresponses: Array<Ehr_Progressreviewclientresponses>;
  /** fetch data from the table: "ehr_progressreviewclientresponses" using primary key columns */
  ehr_progressreviewclientresponses_by_pk?: Maybe<Ehr_Progressreviewclientresponses>;
  /** fetch data from the table in a streaming manner: "ehr_progressreviewclientresponses" */
  ehr_progressreviewclientresponses_stream: Array<Ehr_Progressreviewclientresponses>;
  /** fetch data from the table: "ehr_questionnaire" */
  ehr_questionnaire: Array<Ehr_Questionnaire>;
  /** fetch data from the table: "ehr_questionnaire" using primary key columns */
  ehr_questionnaire_by_pk?: Maybe<Ehr_Questionnaire>;
  /** fetch data from the table in a streaming manner: "ehr_questionnaire" */
  ehr_questionnaire_stream: Array<Ehr_Questionnaire>;
  /** fetch data from the table: "ehr_questionnaire_tags" */
  ehr_questionnaire_tags: Array<Ehr_Questionnaire_Tags>;
  /** fetch data from the table: "ehr_questionnaire_tags" using primary key columns */
  ehr_questionnaire_tags_by_pk?: Maybe<Ehr_Questionnaire_Tags>;
  /** fetch data from the table in a streaming manner: "ehr_questionnaire_tags" */
  ehr_questionnaire_tags_stream: Array<Ehr_Questionnaire_Tags>;
  /** fetch data from the table: "ehr_questionnairetag" */
  ehr_questionnairetag: Array<Ehr_Questionnairetag>;
  /** fetch data from the table: "ehr_questionnairetag" using primary key columns */
  ehr_questionnairetag_by_pk?: Maybe<Ehr_Questionnairetag>;
  /** fetch data from the table in a streaming manner: "ehr_questionnairetag" */
  ehr_questionnairetag_stream: Array<Ehr_Questionnairetag>;
  /** fetch data from the table: "ehr_referral" */
  ehr_referral: Array<Ehr_Referral>;
  /** fetch data from the table: "ehr_referral" using primary key columns */
  ehr_referral_by_pk?: Maybe<Ehr_Referral>;
  /** fetch data from the table in a streaming manner: "ehr_referral" */
  ehr_referral_stream: Array<Ehr_Referral>;
  /** fetch data from the table: "ehr_referralauthorization" */
  ehr_referralauthorization: Array<Ehr_Referralauthorization>;
  /** fetch data from the table: "ehr_referralauthorization" using primary key columns */
  ehr_referralauthorization_by_pk?: Maybe<Ehr_Referralauthorization>;
  /** fetch data from the table in a streaming manner: "ehr_referralauthorization" */
  ehr_referralauthorization_stream: Array<Ehr_Referralauthorization>;
  /** fetch data from the table: "ehr_tag" */
  ehr_tag: Array<Ehr_Tag>;
  /** fetch data from the table: "ehr_tag" using primary key columns */
  ehr_tag_by_pk?: Maybe<Ehr_Tag>;
  /** fetch data from the table in a streaming manner: "ehr_tag" */
  ehr_tag_stream: Array<Ehr_Tag>;
  /** fetch data from the table: "ehr_timeoff" */
  ehr_timeoff: Array<Ehr_Timeoff>;
  /** fetch data from the table: "ehr_timeoff" using primary key columns */
  ehr_timeoff_by_pk?: Maybe<Ehr_Timeoff>;
  /** fetch data from the table in a streaming manner: "ehr_timeoff" */
  ehr_timeoff_stream: Array<Ehr_Timeoff>;
  /** fetch data from the table: "episode_of_care" */
  episode_of_care: Array<Episode_Of_Care>;
  /** fetch data from the table: "episode_of_care" using primary key columns */
  episode_of_care_by_pk?: Maybe<Episode_Of_Care>;
  /** fetch data from the table in a streaming manner: "episode_of_care" */
  episode_of_care_stream: Array<Episode_Of_Care>;
  /** execute function "f_search_clients" which returns "ehr_client" */
  f_search_clients: Array<Ehr_Client>;
  getClientServiceLines: Array<Service_Lines>;
  getManySessionCountsFromLatestEoC: Array<Many_Session_Count>;
  getSessionCountFromLatestEpisodeOfCare: Array<Session_Count_Int>;
  /** fetch data from the table: "hasura_cwa__event_recurrence_data" */
  hasura_cwa__event_recurrence_data: Array<Hasura_Cwa__Event_Recurrence_Data>;
  /** fetch data from the table in a streaming manner: "hasura_cwa__event_recurrence_data" */
  hasura_cwa__event_recurrence_data_stream: Array<Hasura_Cwa__Event_Recurrence_Data>;
  /** fetch data from the table: "hasura_cwa__manual_slot_reservations" */
  hasura_cwa__manual_slot_reservations: Array<Hasura_Cwa__Manual_Slot_Reservations>;
  /** fetch data from the table in a streaming manner: "hasura_cwa__manual_slot_reservations" */
  hasura_cwa__manual_slot_reservations_stream: Array<Hasura_Cwa__Manual_Slot_Reservations>;
  /** fetch data from the table: "hasura_cwa__match_with_status" */
  hasura_cwa__match_with_status: Array<Hasura_Cwa__Match_With_Status>;
  /** fetch data from the table in a streaming manner: "hasura_cwa__match_with_status" */
  hasura_cwa__match_with_status_stream: Array<Hasura_Cwa__Match_With_Status>;
  /** fetch data from the table: "mbc_adherence_data" */
  mbc_adherence_data: Array<Mbc_Adherence_Data>;
  /** fetch data from the table in a streaming manner: "mbc_adherence_data" */
  mbc_adherence_data_stream: Array<Mbc_Adherence_Data>;
  /** An array relationship */
  mbc_assessment_question_scores: Array<Mbc_Assessment_Question_Scores>;
  /** fetch data from the table in a streaming manner: "mbc_assessment_question_scores" */
  mbc_assessment_question_scores_stream: Array<Mbc_Assessment_Question_Scores>;
  /** fetch data from the table: "mbc_distinct_scores_by_client" */
  mbc_distinct_scores_by_client: Array<Mbc_Distinct_Scores_By_Client>;
  /** fetch data from the table: "mbc_distinct_scores_by_client_reliable_change" */
  mbc_distinct_scores_by_client_reliable_change: Array<Mbc_Distinct_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_distinct_scores_by_client_reliable_change" */
  mbc_distinct_scores_by_client_reliable_change_stream: Array<Mbc_Distinct_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_distinct_scores_by_client" */
  mbc_distinct_scores_by_client_stream: Array<Mbc_Distinct_Scores_By_Client>;
  /** fetch data from the table: "mbc_ems_joined_with_scores" */
  mbc_ems_joined_with_scores: Array<Mbc_Ems_Joined_With_Scores>;
  /** fetch data from the table: "mbc_ems_joined_with_scores_reliable_change" */
  mbc_ems_joined_with_scores_reliable_change: Array<Mbc_Ems_Joined_With_Scores_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_ems_joined_with_scores_reliable_change" */
  mbc_ems_joined_with_scores_reliable_change_stream: Array<Mbc_Ems_Joined_With_Scores_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_ems_joined_with_scores" */
  mbc_ems_joined_with_scores_stream: Array<Mbc_Ems_Joined_With_Scores>;
  /** fetch data from the table: "mbc_partitioned_scores_by_client" */
  mbc_partitioned_scores_by_client: Array<Mbc_Partitioned_Scores_By_Client>;
  /** fetch data from the table: "mbc_partitioned_scores_by_client_reliable_change" */
  mbc_partitioned_scores_by_client_reliable_change: Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_partitioned_scores_by_client_reliable_change" */
  mbc_partitioned_scores_by_client_reliable_change_stream: Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "mbc_partitioned_scores_by_client" */
  mbc_partitioned_scores_by_client_stream: Array<Mbc_Partitioned_Scores_By_Client>;
  /** fetch data from the table: "mv_alliance_scores_by_clinician_and_client_ids" */
  mv_alliance_scores_by_clinician_and_client_ids: Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids>;
  /** fetch data from the table in a streaming manner: "mv_alliance_scores_by_clinician_and_client_ids" */
  mv_alliance_scores_by_clinician_and_client_ids_stream: Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids>;
  /** fetch data from the table: "mv_clinical_utilization" */
  mv_clinical_utilization: Array<Mv_Clinical_Utilization>;
  /** fetch data from the table in a streaming manner: "mv_clinical_utilization" */
  mv_clinical_utilization_stream: Array<Mv_Clinical_Utilization>;
  /** fetch data from the table: "mv_latest_client_scores_with_status" */
  mv_latest_client_scores_with_status: Array<Mv_Latest_Client_Scores_With_Status>;
  /** fetch data from the table in a streaming manner: "mv_latest_client_scores_with_status" */
  mv_latest_client_scores_with_status_stream: Array<Mv_Latest_Client_Scores_With_Status>;
  /** fetch data from the table: "mv_mbc_adherence_data_by_client_and_clinician" */
  mv_mbc_adherence_data_by_client_and_clinician: Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician>;
  /** fetch data from the table in a streaming manner: "mv_mbc_adherence_data_by_client_and_clinician" */
  mv_mbc_adherence_data_by_client_and_clinician_stream: Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician>;
  /** fetch data from the table: "my_clients_overview" */
  my_clients_overview: Array<My_Clients_Overview>;
  /** fetch data from the table: "my_clients_overview_reliable_change" */
  my_clients_overview_reliable_change: Array<My_Clients_Overview_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "my_clients_overview_reliable_change" */
  my_clients_overview_reliable_change_stream: Array<My_Clients_Overview_Reliable_Change>;
  /** fetch data from the table in a streaming manner: "my_clients_overview" */
  my_clients_overview_stream: Array<My_Clients_Overview>;
  /** fetch data from the table: "scores_by_client_session_with_status" */
  scores_by_client_session_with_status: Array<Scores_By_Client_Session_With_Status>;
  /** fetch data from the table in a streaming manner: "scores_by_client_session_with_status" */
  scores_by_client_session_with_status_stream: Array<Scores_By_Client_Session_With_Status>;
};


export type Subscription_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootAuth_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Groups_Order_By>>;
  where?: InputMaybe<Auth_User_Groups_Bool_Exp>;
};


export type Subscription_RootAuth_User_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_User_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Groups_Bool_Exp>;
};


export type Subscription_RootAuth_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootCwa_Active_Clients_By_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cwa_Active_Clients_By_Clinician_Order_By>>;
  where?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
};


export type Subscription_RootCwa_Active_Clients_By_Clinician_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cwa_Active_Clients_By_Clinician_Stream_Cursor_Input>>;
  where?: InputMaybe<Cwa_Active_Clients_By_Clinician_Bool_Exp>;
};


export type Subscription_RootDw_Export_Episode_Of_CareArgs = {
  distinct_on?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dw_Export_Episode_Of_Care_Order_By>>;
  where?: InputMaybe<Dw_Export_Episode_Of_Care_Bool_Exp>;
};


export type Subscription_RootDwe_Client_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Dwe_Client_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dwe_Client_Metrics_Order_By>>;
  where?: InputMaybe<Dwe_Client_Metrics_Bool_Exp>;
};


export type Subscription_RootDwe_Client_Metrics_By_PkArgs = {
  client_id: Scalars['Int'];
};


export type Subscription_RootDwe_Client_Metrics_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dwe_Client_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Dwe_Client_Metrics_Bool_Exp>;
};


export type Subscription_RootDwe_Clinician_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Dwe_Clinician_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dwe_Clinician_Metrics_Order_By>>;
  where?: InputMaybe<Dwe_Clinician_Metrics_Bool_Exp>;
};


export type Subscription_RootDwe_Clinician_Metrics_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDwe_Clinician_Metrics_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dwe_Clinician_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Dwe_Clinician_Metrics_Bool_Exp>;
};


export type Subscription_RootEhr_AitaskArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Aitask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Aitask_Order_By>>;
  where?: InputMaybe<Ehr_Aitask_Bool_Exp>;
};


export type Subscription_RootEhr_Aitask_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Aitask_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Aitask_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Aitask_Bool_Exp>;
};


export type Subscription_RootEhr_AssessmentscoreArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Assessmentscore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Assessmentscore_Order_By>>;
  where?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
};


export type Subscription_RootEhr_Assessmentscore_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Assessmentscore_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Assessmentscore_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Assessmentscore_Bool_Exp>;
};


export type Subscription_RootEhr_BookingArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Booking_Order_By>>;
  where?: InputMaybe<Ehr_Booking_Bool_Exp>;
};


export type Subscription_RootEhr_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Booking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Booking_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Booking_Bool_Exp>;
};


export type Subscription_RootEhr_ClientArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Client_Order_By>>;
  where?: InputMaybe<Ehr_Client_Bool_Exp>;
};


export type Subscription_RootEhr_Client_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Client_Bool_Exp>;
};


export type Subscription_RootEhr_ClientaddressArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientaddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientaddress_Order_By>>;
  where?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
};


export type Subscription_RootEhr_Clientaddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientaddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientaddress_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientaddress_Bool_Exp>;
};


export type Subscription_RootEhr_ClientdocumentArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientdocument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientdocument_Order_By>>;
  where?: InputMaybe<Ehr_Clientdocument_Bool_Exp>;
};


export type Subscription_RootEhr_Clientdocument_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientdocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientdocument_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientdocument_Bool_Exp>;
};


export type Subscription_RootEhr_ClientemergencycontactArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientemergencycontact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientemergencycontact_Order_By>>;
  where?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
};


export type Subscription_RootEhr_Clientemergencycontact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientemergencycontact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientemergencycontact_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientemergencycontact_Bool_Exp>;
};


export type Subscription_RootEhr_ClientgroupArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroup_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
};


export type Subscription_RootEhr_Clientgroup_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientgroup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientgroup_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientgroup_Bool_Exp>;
};


export type Subscription_RootEhr_ClientgroupbookingArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupbooking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupbooking_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
};


export type Subscription_RootEhr_Clientgroupbooking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientgroupbooking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientgroupbooking_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientgroupbooking_Bool_Exp>;
};


export type Subscription_RootEhr_ClientgroupeventArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupevent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupevent_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
};


export type Subscription_RootEhr_Clientgroupevent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientgroupevent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientgroupevent_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientgroupevent_Bool_Exp>;
};


export type Subscription_RootEhr_ClientgroupeventmetaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientgroupeventmeta_Order_By>>;
  where?: InputMaybe<Ehr_Clientgroupeventmeta_Bool_Exp>;
};


export type Subscription_RootEhr_Clientgroupeventmeta_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Clientgroupeventmeta_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientgroupeventmeta_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientgroupeventmeta_Bool_Exp>;
};


export type Subscription_RootEhr_ClientpayerservicerecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientpayerservicerecord_Order_By>>;
  where?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
};


export type Subscription_RootEhr_Clientpayerservicerecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientpayerservicerecord_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientpayerservicerecord_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientpayerservicerecord_Bool_Exp>;
};


export type Subscription_RootEhr_ClientprofileArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientprofile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientprofile_Order_By>>;
  where?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
};


export type Subscription_RootEhr_Clientprofile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientprofile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientprofile_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientprofile_Bool_Exp>;
};


export type Subscription_RootEhr_ClientscreeningquestionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clientscreeningquestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clientscreeningquestions_Order_By>>;
  where?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
};


export type Subscription_RootEhr_Clientscreeningquestions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Clientscreeningquestions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clientscreeningquestions_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clientscreeningquestions_Bool_Exp>;
};


export type Subscription_RootEhr_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinician_Order_By>>;
  where?: InputMaybe<Ehr_Clinician_Bool_Exp>;
};


export type Subscription_RootEhr_Clinician_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Clinician_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clinician_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clinician_Bool_Exp>;
};


export type Subscription_RootEhr_ClinicianclassificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianclassification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianclassification_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianclassification_Bool_Exp>;
};


export type Subscription_RootEhr_Clinicianclassification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Clinicianclassification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clinicianclassification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clinicianclassification_Bool_Exp>;
};


export type Subscription_RootEhr_ClinicianconfigurationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianconfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianconfiguration_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
};


export type Subscription_RootEhr_Clinicianconfiguration_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Clinicianconfiguration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clinicianconfiguration_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clinicianconfiguration_Bool_Exp>;
};


export type Subscription_RootEhr_ClinicianscheduleArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Clinicianschedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Clinicianschedule_Order_By>>;
  where?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
};


export type Subscription_RootEhr_Clinicianschedule_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Clinicianschedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Clinicianschedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Clinicianschedule_Bool_Exp>;
};


export type Subscription_RootEhr_CliniciantagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Cliniciantag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Cliniciantag_Order_By>>;
  where?: InputMaybe<Ehr_Cliniciantag_Bool_Exp>;
};


export type Subscription_RootEhr_Cliniciantag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Cliniciantag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Cliniciantag_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Cliniciantag_Bool_Exp>;
};


export type Subscription_RootEhr_CliniciantaskArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Cliniciantask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Cliniciantask_Order_By>>;
  where?: InputMaybe<Ehr_Cliniciantask_Bool_Exp>;
};


export type Subscription_RootEhr_Cliniciantask_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Cliniciantask_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Cliniciantask_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Cliniciantask_Bool_Exp>;
};


export type Subscription_RootEhr_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Configuration_Order_By>>;
  where?: InputMaybe<Ehr_Configuration_Bool_Exp>;
};


export type Subscription_RootEhr_Configuration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Configuration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Configuration_Bool_Exp>;
};


export type Subscription_RootEhr_ConsulttoolArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Consulttool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Consulttool_Order_By>>;
  where?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
};


export type Subscription_RootEhr_Consulttool_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Consulttool_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Consulttool_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Consulttool_Bool_Exp>;
};


export type Subscription_RootEhr_DiagnosisrecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Diagnosisrecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Diagnosisrecord_Order_By>>;
  where?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
};


export type Subscription_RootEhr_Diagnosisrecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Diagnosisrecord_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Diagnosisrecord_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Diagnosisrecord_Bool_Exp>;
};


export type Subscription_RootEhr_EventArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


export type Subscription_RootEhr_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Event_Order_By>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


export type Subscription_RootEhr_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Event_Bool_Exp>;
};


export type Subscription_RootEhr_EventmbcstatusArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmbcstatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmbcstatus_Order_By>>;
  where?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
};


export type Subscription_RootEhr_Eventmbcstatus_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Eventmbcstatus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Eventmbcstatus_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Eventmbcstatus_Bool_Exp>;
};


export type Subscription_RootEhr_EventmetaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Eventmeta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Eventmeta_Order_By>>;
  where?: InputMaybe<Ehr_Eventmeta_Bool_Exp>;
};


export type Subscription_RootEhr_Eventmeta_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Eventmeta_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Eventmeta_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Eventmeta_Bool_Exp>;
};


export type Subscription_RootEhr_GeneralsurveyArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurvey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurvey_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
};


export type Subscription_RootEhr_Generalsurvey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Generalsurvey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Generalsurvey_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Generalsurvey_Bool_Exp>;
};


export type Subscription_RootEhr_GeneralsurveyquestionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestion_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
};


export type Subscription_RootEhr_Generalsurveyquestion_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Generalsurveyquestion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Generalsurveyquestion_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Generalsurveyquestion_Bool_Exp>;
};


export type Subscription_RootEhr_GeneralsurveyquestionresponseArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyquestionresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
};


export type Subscription_RootEhr_Generalsurveyquestionresponse_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Generalsurveyquestionresponse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Generalsurveyquestionresponse_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Generalsurveyquestionresponse_Bool_Exp>;
};


export type Subscription_RootEhr_GeneralsurveyresponseArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Generalsurveyresponse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Generalsurveyresponse_Order_By>>;
  where?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
};


export type Subscription_RootEhr_Generalsurveyresponse_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Generalsurveyresponse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Generalsurveyresponse_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Generalsurveyresponse_Bool_Exp>;
};


export type Subscription_RootEhr_GroupArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


export type Subscription_RootEhr_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Group_Order_By>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


export type Subscription_RootEhr_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Group_Bool_Exp>;
};


export type Subscription_RootEhr_GrouptypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Grouptype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Grouptype_Order_By>>;
  where?: InputMaybe<Ehr_Grouptype_Bool_Exp>;
};


export type Subscription_RootEhr_Grouptype_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Grouptype_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Grouptype_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Grouptype_Bool_Exp>;
};


export type Subscription_RootEhr_IdentitytokenArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Identitytoken_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Identitytoken_Order_By>>;
  where?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
};


export type Subscription_RootEhr_Identitytoken_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Identitytoken_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Identitytoken_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Identitytoken_Bool_Exp>;
};


export type Subscription_RootEhr_InsurancerecordArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Insurancerecord_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Insurancerecord_Order_By>>;
  where?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
};


export type Subscription_RootEhr_Insurancerecord_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Insurancerecord_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Insurancerecord_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Insurancerecord_Bool_Exp>;
};


export type Subscription_RootEhr_ManualslotreservationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Manualslotreservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Manualslotreservation_Order_By>>;
  where?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
};


export type Subscription_RootEhr_Manualslotreservation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Manualslotreservation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Manualslotreservation_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Manualslotreservation_Bool_Exp>;
};


export type Subscription_RootEhr_MatchArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Order_By>>;
  where?: InputMaybe<Ehr_Match_Bool_Exp>;
};


export type Subscription_RootEhr_Match_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Match_Requeue_LogArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Match_Requeue_Log_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Match_Requeue_Log_Order_By>>;
  where?: InputMaybe<Ehr_Match_Requeue_Log_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootEhr_Match_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Match_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Match_Bool_Exp>;
};


export type Subscription_RootEhr_MatchagerangeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchagerange_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchagerange_Order_By>>;
  where?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
};


export type Subscription_RootEhr_Matchagerange_By_PkArgs = {
  match_id: Scalars['Int'];
};


export type Subscription_RootEhr_Matchagerange_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Matchagerange_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Matchagerange_Bool_Exp>;
};


export type Subscription_RootEhr_MatchauditlogArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchauditlog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchauditlog_Order_By>>;
  where?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
};


export type Subscription_RootEhr_Matchauditlog_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Matchauditlog_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Matchauditlog_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Matchauditlog_Bool_Exp>;
};


export type Subscription_RootEhr_MatchslotpreferenceArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Matchslotpreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Matchslotpreference_Order_By>>;
  where?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
};


export type Subscription_RootEhr_Matchslotpreference_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Matchslotpreference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Matchslotpreference_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Matchslotpreference_Bool_Exp>;
};


export type Subscription_RootEhr_MbctrackArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Mbctrack_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Mbctrack_Order_By>>;
  where?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
};


export type Subscription_RootEhr_Mbctrack_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Mbctrack_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Mbctrack_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Mbctrack_Bool_Exp>;
};


export type Subscription_RootEhr_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Notification_Bool_Exp>;
};


export type Subscription_RootEhr_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Notification_Bool_Exp>;
};


export type Subscription_RootEhr_PayerArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Payer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Payer_Order_By>>;
  where?: InputMaybe<Ehr_Payer_Bool_Exp>;
};


export type Subscription_RootEhr_Payer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Payer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Payer_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Payer_Bool_Exp>;
};


export type Subscription_RootEhr_ProgressreviewArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreview_Order_By>>;
  where?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
};


export type Subscription_RootEhr_Progressreview_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Progressreview_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Progressreview_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Progressreview_Bool_Exp>;
};


export type Subscription_RootEhr_ProgressreviewclientresponsesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Progressreviewclientresponses_Order_By>>;
  where?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
};


export type Subscription_RootEhr_Progressreviewclientresponses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Progressreviewclientresponses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Progressreviewclientresponses_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Progressreviewclientresponses_Bool_Exp>;
};


export type Subscription_RootEhr_QuestionnaireArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnaire_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnaire_Order_By>>;
  where?: InputMaybe<Ehr_Questionnaire_Bool_Exp>;
};


export type Subscription_RootEhr_Questionnaire_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Questionnaire_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Questionnaire_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Questionnaire_Bool_Exp>;
};


export type Subscription_RootEhr_Questionnaire_TagsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnaire_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnaire_Tags_Order_By>>;
  where?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
};


export type Subscription_RootEhr_Questionnaire_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Questionnaire_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Questionnaire_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Questionnaire_Tags_Bool_Exp>;
};


export type Subscription_RootEhr_QuestionnairetagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Questionnairetag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Questionnairetag_Order_By>>;
  where?: InputMaybe<Ehr_Questionnairetag_Bool_Exp>;
};


export type Subscription_RootEhr_Questionnairetag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Questionnairetag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Questionnairetag_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Questionnairetag_Bool_Exp>;
};


export type Subscription_RootEhr_ReferralArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referral_Order_By>>;
  where?: InputMaybe<Ehr_Referral_Bool_Exp>;
};


export type Subscription_RootEhr_Referral_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Referral_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Referral_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Referral_Bool_Exp>;
};


export type Subscription_RootEhr_ReferralauthorizationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Referralauthorization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Referralauthorization_Order_By>>;
  where?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
};


export type Subscription_RootEhr_Referralauthorization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Referralauthorization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Referralauthorization_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Referralauthorization_Bool_Exp>;
};


export type Subscription_RootEhr_TagArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Tag_Order_By>>;
  where?: InputMaybe<Ehr_Tag_Bool_Exp>;
};


export type Subscription_RootEhr_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Tag_Bool_Exp>;
};


export type Subscription_RootEhr_TimeoffArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Timeoff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Timeoff_Order_By>>;
  where?: InputMaybe<Ehr_Timeoff_Bool_Exp>;
};


export type Subscription_RootEhr_Timeoff_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEhr_Timeoff_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Timeoff_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Timeoff_Bool_Exp>;
};


export type Subscription_RootEpisode_Of_CareArgs = {
  distinct_on?: InputMaybe<Array<Episode_Of_Care_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Episode_Of_Care_Order_By>>;
  where?: InputMaybe<Episode_Of_Care_Bool_Exp>;
};


export type Subscription_RootEpisode_Of_Care_By_PkArgs = {
  event_id: Scalars['String'];
};


export type Subscription_RootEpisode_Of_Care_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Episode_Of_Care_Stream_Cursor_Input>>;
  where?: InputMaybe<Episode_Of_Care_Bool_Exp>;
};


export type Subscription_RootF_Search_ClientsArgs = {
  args: F_Search_Clients_Args;
  distinct_on?: InputMaybe<Array<Ehr_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Client_Order_By>>;
  where?: InputMaybe<Ehr_Client_Bool_Exp>;
};


export type Subscription_RootGetClientServiceLinesArgs = {
  args: GetClientServiceLines_Arguments;
  distinct_on?: InputMaybe<Array<Service_Lines_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Lines_Order_By>>;
  where?: InputMaybe<Service_Lines_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootGetManySessionCountsFromLatestEoCArgs = {
  args: GetManySessionCountsFromLatestEoC_Arguments;
  distinct_on?: InputMaybe<Array<Many_Session_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Many_Session_Count_Order_By>>;
  where?: InputMaybe<Many_Session_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootGetSessionCountFromLatestEpisodeOfCareArgs = {
  args: GetSessionCountFromLatestEpisodeOfCare_Arguments;
  distinct_on?: InputMaybe<Array<Session_Count_Int_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Session_Count_Int_Order_By>>;
  where?: InputMaybe<Session_Count_Int_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Event_Recurrence_DataArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Event_Recurrence_Data_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Event_Recurrence_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Hasura_Cwa__Event_Recurrence_Data_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Manual_Slot_ReservationsArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Manual_Slot_Reservations_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Manual_Slot_Reservations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Stream_Cursor_Input>>;
  where?: InputMaybe<Hasura_Cwa__Manual_Slot_Reservations_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Match_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hasura_Cwa__Match_With_Status_Order_By>>;
  where?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
};


export type Subscription_RootHasura_Cwa__Match_With_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hasura_Cwa__Match_With_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Hasura_Cwa__Match_With_Status_Bool_Exp>;
};


export type Subscription_RootMbc_Adherence_DataArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Adherence_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Adherence_Data_Order_By>>;
  where?: InputMaybe<Mbc_Adherence_Data_Bool_Exp>;
};


export type Subscription_RootMbc_Adherence_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Adherence_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Adherence_Data_Bool_Exp>;
};


export type Subscription_RootMbc_Assessment_Question_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Assessment_Question_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


export type Subscription_RootMbc_Assessment_Question_Scores_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Assessment_Question_Scores_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Assessment_Question_Scores_Bool_Exp>;
};


export type Subscription_RootMbc_Distinct_Scores_By_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
};


export type Subscription_RootMbc_Distinct_Scores_By_Client_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Distinct_Scores_By_Client_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Distinct_Scores_By_Client_Reliable_Change_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Distinct_Scores_By_Client_Reliable_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Distinct_Scores_By_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Distinct_Scores_By_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Distinct_Scores_By_Client_Bool_Exp>;
};


export type Subscription_RootMbc_Ems_Joined_With_ScoresArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Order_By>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
};


export type Subscription_RootMbc_Ems_Joined_With_Scores_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Ems_Joined_With_Scores_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Ems_Joined_With_Scores_Reliable_Change_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Ems_Joined_With_Scores_Reliable_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Ems_Joined_With_Scores_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Ems_Joined_With_Scores_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Ems_Joined_With_Scores_Bool_Exp>;
};


export type Subscription_RootMbc_Partitioned_Scores_By_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Order_By>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
};


export type Subscription_RootMbc_Partitioned_Scores_By_Client_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Order_By>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Partitioned_Scores_By_Client_Reliable_Change_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMbc_Partitioned_Scores_By_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mbc_Partitioned_Scores_By_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Mbc_Partitioned_Scores_By_Client_Bool_Exp>;
};


export type Subscription_RootMv_Alliance_Scores_By_Clinician_And_Client_IdsArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Order_By>>;
  where?: InputMaybe<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>;
};


export type Subscription_RootMv_Alliance_Scores_By_Clinician_And_Client_Ids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Alliance_Scores_By_Clinician_And_Client_Ids_Bool_Exp>;
};


export type Subscription_RootMv_Clinical_UtilizationArgs = {
  distinct_on?: InputMaybe<Array<Mv_Clinical_Utilization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Clinical_Utilization_Order_By>>;
  where?: InputMaybe<Mv_Clinical_Utilization_Bool_Exp>;
};


export type Subscription_RootMv_Clinical_Utilization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Clinical_Utilization_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Clinical_Utilization_Bool_Exp>;
};


export type Subscription_RootMv_Latest_Client_Scores_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Latest_Client_Scores_With_Status_Order_By>>;
  where?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
};


export type Subscription_RootMv_Latest_Client_Scores_With_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Latest_Client_Scores_With_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Latest_Client_Scores_With_Status_Bool_Exp>;
};


export type Subscription_RootMv_Mbc_Adherence_Data_By_Client_And_ClinicianArgs = {
  distinct_on?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Order_By>>;
  where?: InputMaybe<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>;
};


export type Subscription_RootMv_Mbc_Adherence_Data_By_Client_And_Clinician_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Mbc_Adherence_Data_By_Client_And_Clinician_Bool_Exp>;
};


export type Subscription_RootMy_Clients_OverviewArgs = {
  distinct_on?: InputMaybe<Array<My_Clients_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<My_Clients_Overview_Order_By>>;
  where?: InputMaybe<My_Clients_Overview_Bool_Exp>;
};


export type Subscription_RootMy_Clients_Overview_Reliable_ChangeArgs = {
  distinct_on?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<My_Clients_Overview_Reliable_Change_Order_By>>;
  where?: InputMaybe<My_Clients_Overview_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMy_Clients_Overview_Reliable_Change_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<My_Clients_Overview_Reliable_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<My_Clients_Overview_Reliable_Change_Bool_Exp>;
};


export type Subscription_RootMy_Clients_Overview_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<My_Clients_Overview_Stream_Cursor_Input>>;
  where?: InputMaybe<My_Clients_Overview_Bool_Exp>;
};


export type Subscription_RootScores_By_Client_Session_With_StatusArgs = {
  distinct_on?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scores_By_Client_Session_With_Status_Order_By>>;
  where?: InputMaybe<Scores_By_Client_Session_With_Status_Bool_Exp>;
};


export type Subscription_RootScores_By_Client_Session_With_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scores_By_Client_Session_With_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Scores_By_Client_Session_With_Status_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type GetClinicianAuthGroupsQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetClinicianAuthGroupsQuery = { __typename?: 'query_root', ehr_clinician: Array<{ __typename?: 'ehr_clinician', auth_user?: { __typename?: 'auth_user', auth_user_groups: Array<{ __typename?: 'auth_user_groups', auth_group: { __typename?: 'auth_group', id: number, name: string } }> } | null }> };

export type GetClinicianTagsQueryVariables = Exact<{
  clinician_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetClinicianTagsQuery = { __typename?: 'query_root', ehr_cliniciantag: Array<{ __typename?: 'ehr_cliniciantag', id: number, weight: any, version: number, tag_id: number, clinician_id: number, ehr_cliniciantag_ehr_tag: { __typename?: 'ehr_tag', bucket: string, category: string, name: string, shown_in_matchtool: boolean, version: number } }> };

export type GetCliniciansByAuthGroupQueryVariables = Exact<{
  group_name: Scalars['String'];
}>;


export type GetCliniciansByAuthGroupQuery = { __typename?: 'query_root', ehr_clinician: Array<{ __typename?: 'ehr_clinician', id: number }> };

export type GetClinicianQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicianQuery = { __typename?: 'query_root', ehr_clinician: Array<{ __typename?: 'ehr_clinician', id: number, primary_timezone: string, email?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, degree?: string | null, dob?: any | null, director_of_id?: number | null, is_remote: boolean, is_wheel: boolean, people_manager_id?: number | null }> };

export type GetConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigQuery = { __typename?: 'query_root', ehr_configuration: Array<{ __typename?: 'ehr_configuration', healthie_care_team_sync: boolean, healthie_client_address_broadcast: boolean, healthie_clinician_incremental_sync_enabled: boolean, healthie_emergency_contact_broadcast: boolean, healthie_patient_broadcast_enabled: boolean, healthie_patient_incremental_sync_enabled: boolean, healthie_ui_enabled: boolean, healthie_disable_client_field_editing: boolean, healthie_send_clinician_tasks: boolean, roofdog_enabled: boolean, mhqol_enabled: boolean, cfa_feature_flag: any }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'query_root', ehr_tag: Array<{ __typename?: 'ehr_tag', bucket: string, id: number, category: string, name: string, shown_in_matchtool: boolean, used_for_couples: boolean, used_for_individual: boolean, status?: string | null, version: number }> };

export type MyClientsOverviewFragment = { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null };

export type MyClientsOverviewReliableChangeFragment = { __typename?: 'my_clients_overview_reliable_change', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, endorsedSi?: boolean | null };

export type ReservationsFragment = { __typename?: 'ehr_client', manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }> };

export type CareClientInfoFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null } | null, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }>, matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }> };

export type SortedMatchesFragment = { __typename?: 'ehr_client', matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }> };

export type CareClientInfoReliableChangeFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview_reliable_change', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, endorsedSi?: boolean | null } | null, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> };

export type CareClientFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> };

export type ActiveClientFragment = { __typename?: 'cwa_active_clients_by_clinician', client?: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }>, matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }> } | null };

export type ActiveClientReliableChangeFragment = { __typename?: 'cwa_active_clients_by_clinician', client?: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview_reliable_change', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> } | null };

export type MyClientsOverviewQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
}>;


export type MyClientsOverviewQuery = { __typename?: 'query_root', cwaActiveClientsByClinician: Array<{ __typename?: 'cwa_active_clients_by_clinician', sources?: Array<string> | null, clinicianId?: number | null, client?: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }>, matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }> } | null }> };

export type MyClientsOverviewReliableChangeQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
}>;


export type MyClientsOverviewReliableChangeQuery = { __typename?: 'query_root', cwaActiveClientsByClinician: Array<{ __typename?: 'cwa_active_clients_by_clinician', sources?: Array<string> | null, clinicianId?: number | null, client?: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview_reliable_change', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> } | null }> };

export type DefaultEocDataFragment = { __typename?: 'dw_export_episode_of_care', alliance?: number | null, appointment_status?: string | null, cancellation_reason?: string | null, cancellation_type?: string | null, client_id?: number | null, client_first_name?: string | null, client_last_name?: string | null, client_session_number?: number | null, clinician_id?: number | null, clinician_session_number?: number | null, episode?: number | null, event_id?: string | null, full_name?: string | null, gad?: number | null, insert_ts?: any | null, is_baseline?: number | null, is_latest?: number | null, is_latest_clinician_in_episode?: number | null, last_name?: string | null, payer_acronym?: string | null, payer_name?: string | null, phq?: number | null, reason_for_new_episode?: string | null, same_clinician_over_60_days_last_session?: number | null, service_type?: string | null, start_time?: any | null, track_primary_assessment?: string | null };

export type GetEpisodesOfCareQueryVariables = Exact<{
  client_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
  start_time?: InputMaybe<Scalars['Timestamp']>;
}>;


export type GetEpisodesOfCareQuery = { __typename?: 'query_root', dw_export_episode_of_care: Array<{ __typename?: 'dw_export_episode_of_care', alliance?: number | null, appointment_status?: string | null, cancellation_reason?: string | null, cancellation_type?: string | null, client_id?: number | null, client_first_name?: string | null, client_last_name?: string | null, client_session_number?: number | null, clinician_id?: number | null, clinician_session_number?: number | null, episode?: number | null, event_id?: string | null, full_name?: string | null, gad?: number | null, insert_ts?: any | null, is_baseline?: number | null, is_latest?: number | null, is_latest_clinician_in_episode?: number | null, last_name?: string | null, payer_acronym?: string | null, payer_name?: string | null, phq?: number | null, reason_for_new_episode?: string | null, same_clinician_over_60_days_last_session?: number | null, service_type?: string | null, start_time?: any | null, track_primary_assessment?: string | null }> };

export type GetLatestClinicianEpisodeOfCareQueryVariables = Exact<{
  client_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  clinician_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetLatestClinicianEpisodeOfCareQuery = { __typename?: 'query_root', dw_export_episode_of_care: Array<{ __typename?: 'dw_export_episode_of_care', alliance?: number | null, appointment_status?: string | null, cancellation_reason?: string | null, cancellation_type?: string | null, client_id?: number | null, client_first_name?: string | null, client_last_name?: string | null, client_session_number?: number | null, clinician_id?: number | null, clinician_session_number?: number | null, episode?: number | null, event_id?: string | null, full_name?: string | null, gad?: number | null, insert_ts?: any | null, is_baseline?: number | null, is_latest?: number | null, is_latest_clinician_in_episode?: number | null, last_name?: string | null, payer_acronym?: string | null, payer_name?: string | null, phq?: number | null, reason_for_new_episode?: string | null, same_clinician_over_60_days_last_session?: number | null, service_type?: string | null, start_time?: any | null, track_primary_assessment?: string | null }> };

export type GetMatchRequeueLogQueryVariables = Exact<{
  matchIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetMatchRequeueLogQuery = { __typename?: 'query_root', ehr_match_requeue_log: Array<{ __typename?: 'ehr_match_requeue_log', match_id: number, requeue_reason: string, requeue_timestamp: any, match_email_sent_before_requeue?: any | null, match_resolved_at_before_requeue: any }> };

export type MatchesByClientIdQueryVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type MatchesByClientIdQuery = { __typename?: 'query_root', matches: Array<{ __typename?: 'hasura_cwa__match_with_status', id?: number | null, consult_id?: any | null, client_status?: string | null, former_client?: boolean | null, high_priority?: boolean | null, is_rematch?: boolean | null, queue_note?: string | null, created_at?: any | null, match_after?: any | null, conflict_of_interest?: string | null, delivery_preference?: string | null, returning_to_same_clinician?: boolean | null, clinician_approves_ot?: boolean | null, service_type?: string | null, max_score?: any | null, methodology_version?: number | null, priority?: string | null, match_note?: string | null, assignee_id?: number | null, cadence_pref_strength?: string | null, match_email_sent?: any | null, is_biweekly_fit?: boolean | null, _date_start?: any | null, ehr_client?: { __typename?: 'ehr_client', id: number, first_name?: string | null, last_name?: string | null, email?: any | null, phone_number?: string | null, primary_timezone: string, healthie_id?: string | null, ehr_referrals: Array<{ __typename?: 'ehr_referral', needs_interpreter_services: boolean }>, ehr_insurancerecords: Array<{ __typename?: 'ehr_insurancerecord', is_medical: boolean, is_medicare: boolean, effective_start_date?: any | null, effective_termination_date?: any | null }>, client_payer_service_records: Array<{ __typename?: 'ehr_clientpayerservicerecord', payer_id?: any | null, payer?: { __typename?: 'ehr_payer', acronym?: string | null, display_name?: string | null } | null }>, ehr_booking: Array<{ __typename?: 'ehr_booking', has_accepted_informed_consent?: boolean | null, has_accepted_practice_policy: boolean, has_accepted_privacy_policy: boolean, id: any, created_at?: any | null }> } | null, consult_event?: { __typename?: 'ehr_event', start_time?: any | null, healthie_note_id?: string | null, service_type?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number } | null } | null }> };

export type MyConsultsPageQueryVariables = Exact<{
  clinician_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  lowerDate: Scalars['timestamptz'];
  upperDate: Scalars['timestamptz'];
  pastLowerDate: Scalars['timestamptz'];
  pastUpperDate: Scalars['timestamptz'];
  appointmentType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type MyConsultsPageQuery = { __typename?: 'query_root', my_matches: Array<{ __typename?: 'hasura_cwa__match_with_status', id?: number | null, consult_id?: any | null, client_status?: string | null, former_client?: boolean | null, high_priority?: boolean | null, is_rematch?: boolean | null, queue_note?: string | null, created_at?: any | null, match_after?: any | null, conflict_of_interest?: string | null, delivery_preference?: string | null, returning_to_same_clinician?: boolean | null, clinician_approves_ot?: boolean | null, service_type?: string | null, max_score?: any | null, methodology_version?: number | null, priority?: string | null, match_note?: string | null, assignee_id?: number | null, cadence_pref_strength?: string | null, match_email_sent?: any | null, is_biweekly_fit?: boolean | null, _date_start?: any | null, ehr_client?: { __typename?: 'ehr_client', id: number, first_name?: string | null, last_name?: string | null, email?: any | null, phone_number?: string | null, primary_timezone: string, healthie_id?: string | null, ehr_referrals: Array<{ __typename?: 'ehr_referral', needs_interpreter_services: boolean }>, ehr_insurancerecords: Array<{ __typename?: 'ehr_insurancerecord', is_medical: boolean, is_medicare: boolean, effective_start_date?: any | null, effective_termination_date?: any | null }>, client_payer_service_records: Array<{ __typename?: 'ehr_clientpayerservicerecord', payer_id?: any | null, payer?: { __typename?: 'ehr_payer', acronym?: string | null, display_name?: string | null } | null }>, ehr_booking: Array<{ __typename?: 'ehr_booking', has_accepted_informed_consent?: boolean | null, has_accepted_practice_policy: boolean, has_accepted_privacy_policy: boolean, id: any, created_at?: any | null }> } | null, consult_event?: { __typename?: 'ehr_event', start_time?: any | null, healthie_note_id?: string | null, service_type?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number } | null } | null }>, past_consults: Array<{ __typename?: 'ehr_event', id: any, start_time?: any | null, time_scheduled?: any | null, healthie_note_id?: string | null, service_type?: string | null, clinician_id?: number | null, ehr_matches: Array<{ __typename?: 'ehr_match', id: number }>, client?: { __typename?: 'ehr_client', id: number, first_name?: string | null, last_name?: string | null, email?: any | null, phone_number?: string | null, primary_timezone: string, healthie_id?: string | null, ehr_referrals: Array<{ __typename?: 'ehr_referral', needs_interpreter_services: boolean }>, client_payer_service_records: Array<{ __typename?: 'ehr_clientpayerservicerecord', payer_id?: any | null, payer?: { __typename?: 'ehr_payer', acronym?: string | null, display_name?: string | null } | null }>, ehr_booking: Array<{ __typename?: 'ehr_booking', has_accepted_informed_consent?: boolean | null, has_accepted_practice_policy: boolean, has_accepted_privacy_policy: boolean, id: any, created_at?: any | null, appointment_type: string }> } | null }>, recent_consults: Array<{ __typename?: 'ehr_event', id: any, start_time?: any | null, time_scheduled?: any | null, healthie_note_id?: string | null, service_type?: string | null, clinician_id?: number | null, client?: { __typename?: 'ehr_client', id: number, last_name?: string | null, first_name?: string | null, email?: any | null, healthie_id?: string | null, client_payer_service_records: Array<{ __typename?: 'ehr_clientpayerservicerecord', payer_id?: any | null, payer?: { __typename?: 'ehr_payer', acronym?: string | null, display_name?: string | null } | null }>, ehr_referrals: Array<{ __typename?: 'ehr_referral', needs_interpreter_services: boolean }>, ehr_booking: Array<{ __typename?: 'ehr_booking', has_accepted_informed_consent?: boolean | null, has_accepted_practice_policy: boolean, has_accepted_privacy_policy: boolean, id: any, created_at?: any | null, appointment_type: string }> } | null, ehr_matches: Array<{ __typename?: 'ehr_match', id: number }> }> };

export type MyPastConsultsSearchResultsQueryVariables = Exact<{
  client_id: Scalars['Int'];
}>;


export type MyPastConsultsSearchResultsQuery = { __typename?: 'query_root', my_matches: Array<{ __typename?: 'hasura_cwa__match_with_status', id?: number | null, consult_id?: any | null, client_status?: string | null, former_client?: boolean | null, high_priority?: boolean | null, is_rematch?: boolean | null, queue_note?: string | null, created_at?: any | null, match_after?: any | null, conflict_of_interest?: string | null, delivery_preference?: string | null, returning_to_same_clinician?: boolean | null, clinician_approves_ot?: boolean | null, service_type?: string | null, max_score?: any | null, methodology_version?: number | null, priority?: string | null, match_note?: string | null, assignee_id?: number | null, cadence_pref_strength?: string | null, match_email_sent?: any | null, is_biweekly_fit?: boolean | null, _date_start?: any | null, assignee_auth_user?: { __typename?: 'auth_user', ehr_clinician?: { __typename?: 'ehr_clinician', id: number } | null } | null, ehr_client?: { __typename?: 'ehr_client', id: number, first_name?: string | null, last_name?: string | null, email?: any | null, phone_number?: string | null, primary_timezone: string, healthie_id?: string | null, ehr_insurancerecords: Array<{ __typename?: 'ehr_insurancerecord', is_medical: boolean, is_medicare: boolean, effective_start_date?: any | null, effective_termination_date?: any | null }>, client_payer_service_records: Array<{ __typename?: 'ehr_clientpayerservicerecord', payer_id?: any | null, payer?: { __typename?: 'ehr_payer', acronym?: string | null, display_name?: string | null } | null }> } | null, consult_event?: { __typename?: 'ehr_event', start_time?: any | null, healthie_note_id?: string | null, service_type?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number } | null } | null }> };

export type GetAllLiveGroupsAfterDateQueryVariables = Exact<{
  date?: InputMaybe<Scalars['date']>;
}>;


export type GetAllLiveGroupsAfterDateQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'ehr_group', id: any, capacity: any, groupStartDate?: any | null, groupStartTime?: any | null, groupType: { __typename?: 'ehr_grouptype', title: string }, clinician: { __typename?: 'ehr_clinician', id: number, fullName?: string | null }, clientGroups: Array<{ __typename?: 'ehr_clientgroup', id: any }> }> };

export type GetAllLiveGroupsAfterDateGroupDataFragment = { __typename?: 'ehr_group', id: any, capacity: any, groupStartDate?: any | null, groupStartTime?: any | null, groupType: { __typename?: 'ehr_grouptype', title: string }, clinician: { __typename?: 'ehr_clinician', id: number, fullName?: string | null }, clientGroups: Array<{ __typename?: 'ehr_clientgroup', id: any }> };

export type GetClientGroupsAttendanceQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetClientGroupsAttendanceQuery = { __typename?: 'query_root', client: Array<{ __typename?: 'ehr_client', id: number, clientGroups: Array<{ __typename?: 'ehr_clientgroup', group: { __typename?: 'ehr_group', id: any, groupStartDate?: any | null, groupType: { __typename?: 'ehr_grouptype', title: string }, clinician: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } } }> }> };

export type ClientGroupsAttendanceDataFragment = { __typename?: 'ehr_group', id: any, groupStartDate?: any | null, groupType: { __typename?: 'ehr_grouptype', title: string }, clinician: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } };

export type GetIncompleteNotesQueryVariables = Exact<{
  clinician_id: Scalars['Int'];
  pastEndTime: Scalars['timestamptz'];
}>;


export type GetIncompleteNotesQuery = { __typename?: 'query_root', ehr_event: Array<{ __typename?: 'ehr_event', healthie_note_id?: string | null, end_time?: any | null, client?: { __typename?: 'ehr_client', healthie_id?: string | null, id: number, first_name?: string | null, last_name?: string | null } | null, ehr_clientgroupevents: Array<{ __typename?: 'ehr_clientgroupevent', id: any, healthie_note_id?: string | null, ehr_client: { __typename?: 'ehr_client', healthie_id?: string | null, id: number, first_name?: string | null, last_name?: string | null } }> }> };

export type GetClinicalUtilizationQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetClinicalUtilizationQuery = { __typename?: 'query_root', mv_clinical_utilization: Array<{ __typename?: 'mv_clinical_utilization', consult_noshows?: any | null, consults_attended?: any | null, consults_scheduled?: any | null, couples_attended?: any | null, couples_noshow?: any | null, couples_scheduled?: any | null, therapy_attended?: any | null, therapy_noshows?: any | null, therapy_scheduled?: any | null, adjusted_timeoff_credit?: any | null, allocated_consult_billable_time?: any | null, attended_consult_billable_time?: any | null, attended_couples_billable_time?: any | null, attended_therapy_billable_time?: any | null, billable_time_utilization?: any | null, consult_allocation_score?: any | null, consult_billable_time?: any | null, couples_billable_time?: any | null, discrete_hours_utilization?: any | null, group_billable_time?: any | null, hours_utilization?: any | null, hours_without_pto?: any | null, no_show_consult_billable_time?: any | null, no_show_couples_billable_time?: any | null, no_show_therapy_billable_time?: any | null, pto_hours?: any | null, scheduled_consult_billable_time?: any | null, scheduled_couples_billable_time?: any | null, scheduled_therapy_billable_time?: any | null, target_client_hours?: any | null, therapy_billable_time?: any | null, therapy_hours?: any | null, workweek_hours?: any | null, clinician_id?: number | null, consult_allocation?: any | null, full_name?: string | null, isoweek?: string | null, isoyear?: string | null, version?: string | null, week?: any | null }> };

export type GetScoresByClientSessionWithStatusQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
  client_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetScoresByClientSessionWithStatusQuery = { __typename?: 'query_root', mv_alliance_scores_by_clinician_and_client_ids: Array<{ __typename?: 'mv_alliance_scores_by_clinician_and_client_ids', alliance_id?: any | null, alliance_value?: any | null, client_id?: number | null, clinician_id?: number | null, event_id?: any | null, service_type?: string | null, start_time?: any | null, first_name?: string | null, last_name?: string | null, preferred_name?: string | null, pr_client_id?: number | null, acronyms?: Array<string> | null, display_names?: Array<string> | null }> };

export type GetMbcAdherenceDataByClinicianQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetMbcAdherenceDataByClinicianQuery = { __typename?: 'query_root', mv_mbc_adherence_data_by_client_and_clinician: Array<{ __typename?: 'mv_mbc_adherence_data_by_client_and_clinician', cnt_post_session?: any | null, cnt_pre_session?: any | null, total_post_session_ems?: any | null, total_pre_session_ems?: any | null, client_name?: string | null, client_id?: number | null, event_date?: any | null, acronym?: string | null, display_name?: string | null, event_id?: any | null }> };

export type MbcAdherenceDataQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
}>;


export type MbcAdherenceDataQuery = { __typename?: 'query_root', mbc_adherence_data: Array<{ __typename?: 'mbc_adherence_data', cnt_pre_session?: any | null, total_pre_session_ems?: any | null, pre_session_adherence?: any | null, clinician_id?: number | null, isoweek?: string | null, isoyear?: string | null, appt_week?: any | null }> };

export type GetNumClientsQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetNumClientsQuery = { __typename?: 'query_root', withScores: { __typename?: 'ehr_event_aggregate', aggregate?: { __typename?: 'ehr_event_aggregate_fields', count: number } | null }, totalClients: { __typename?: 'ehr_event_aggregate', aggregate?: { __typename?: 'ehr_event_aggregate_fields', count: number } | null } };

export type GetNumPriorWeekConsultsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetNumPriorWeekConsultsQuery = { __typename?: 'query_root', ehr_event_aggregate: { __typename?: 'ehr_event_aggregate', aggregate?: { __typename?: 'ehr_event_aggregate_fields', count: number } | null } };

export type GroupTherapyOverviewQueryVariables = Exact<{
  clinician_id?: InputMaybe<Scalars['Int']>;
}>;


export type GroupTherapyOverviewQuery = { __typename?: 'query_root', groupsByClinician: Array<{ __typename?: 'ehr_group', clinicianId: number, groupId: any, groupStartTime?: any | null, groupEndTime?: any | null, canceledAt?: any | null, groupType: { __typename?: 'ehr_grouptype', groupName: string, groupSessions: number }, clientGroups: Array<{ __typename?: 'ehr_clientgroup', clientId: number, clientUnenrolledDate?: any | null, client: { __typename?: 'ehr_client', is_test_client: boolean } }>, events: Array<{ __typename?: 'ehr_event', eventId: any, eventStartTime?: any | null, eventEndTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientId: number, client: { __typename?: 'ehr_client', isTestClient: boolean }, ems: Array<{ __typename?: 'ehr_eventmbcstatus', respondedAt?: any | null }> }> }> }> };

export type GroupDataFragment = { __typename?: 'ehr_group', groupId: any, clinicianId: number, groupStartTime?: any | null, groupEndTime?: any | null, canceledAt?: any | null, groupType: { __typename?: 'ehr_grouptype', groupName: string, groupSessions: number }, clientGroups: Array<{ __typename?: 'ehr_clientgroup', clientId: number, clientUnenrolledDate?: any | null, client: { __typename?: 'ehr_client', is_test_client: boolean } }>, events: Array<{ __typename?: 'ehr_event', eventId: any, eventStartTime?: any | null, eventEndTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientId: number, client: { __typename?: 'ehr_client', isTestClient: boolean }, ems: Array<{ __typename?: 'ehr_eventmbcstatus', respondedAt?: any | null }> }> }> };

export type ClientGroupDataFragment = { __typename?: 'ehr_clientgroup', clientId: number, clientUnenrolledDate?: any | null, client: { __typename?: 'ehr_client', is_test_client: boolean } };

export type EventDataFragment = { __typename?: 'ehr_event', eventId: any, eventStartTime?: any | null, eventEndTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientId: number, client: { __typename?: 'ehr_client', isTestClient: boolean }, ems: Array<{ __typename?: 'ehr_eventmbcstatus', respondedAt?: any | null }> }> };

export type GroupTherapyClientNavInfoQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type GroupTherapyClientNavInfoQuery = { __typename?: 'query_root', client: Array<{ __typename?: 'ehr_client', email?: any | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, addresses: Array<{ __typename?: 'ehr_clientaddress', address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, dateCreated: any }>, payerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, clientGroups: Array<{ __typename?: 'ehr_clientgroup', group: { __typename?: 'ehr_group', groupId: any, groupType: { __typename?: 'ehr_grouptype', curriculum: string, affinity: string, groupSessions: number }, events: Array<{ __typename?: 'ehr_event', eventId: any, appointmentStatus?: string | null, startTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', id: any, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> }> }> } }> }> };

export type GroupTherapyClientNavClientAddressDataFragment = { __typename?: 'ehr_clientaddress', address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, dateCreated: any };

export type GroupTherapyClientNavClientPayerRecordsDataFragment = { __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null };

export type GroupTherapyClientNavEventDataFragment = { __typename?: 'ehr_event', eventId: any, appointmentStatus?: string | null, startTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', id: any, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> }> };

export type GroupTherapyClientNavEmsDataFragment = { __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> };

export type GroupTherapyClientNavScoreDataFragment = { __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null };

export type GroupTherapyNavInfoQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
}>;


export type GroupTherapyNavInfoQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', startTime?: any | null, grouptype: { __typename?: 'ehr_grouptype', affinity: string, curriculum: string, groupSessions: number }, events: Array<{ __typename?: 'ehr_event', id: any, startTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientId: number, appointmentStatus?: string | null }> }>, clientGroups: Array<{ __typename?: 'ehr_clientgroup', clientId: number, unenrolledDate?: any | null }> }> };

export type GroupTherapyNavInfoEventFragment = { __typename?: 'ehr_event', id: any, startTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientId: number, appointmentStatus?: string | null }> };

export type GroupTherapyNavInfoClientGroupFragment = { __typename?: 'ehr_clientgroup', clientId: number, unenrolledDate?: any | null };

export type GroupTherapyClientsQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
}>;


export type GroupTherapyClientsQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', clientGroups: Array<{ __typename?: 'ehr_clientgroup', client: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }> } }> }> };

export type GroupTherapyClientGroupsDataFragment = { __typename?: 'ehr_clientgroup', client: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }> } };

export type GroupTherapyClientsDataFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }> };

export type GroupTherapyClientMbcSurveyAnswersQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type GroupTherapyClientMbcSurveyAnswersQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', groupId: any, events: Array<{ __typename?: 'ehr_event', eventId: any, eventStartTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', ems: Array<{ __typename?: 'ehr_eventmbcstatus', score: Array<{ __typename?: 'ehr_assessmentscore', scoreName: string, isEndorsedSI?: boolean | null, surveyResponse?: { __typename?: 'ehr_generalsurveyresponse', generalSurveyQuestionResponses: Array<{ __typename?: 'ehr_generalsurveyquestionresponse', response: any, generalSurveyQuestion: { __typename?: 'ehr_generalsurveyquestion', slug?: string | null, questionText?: string | null } }> } | null }> }> }> }> }> };

export type GroupTherapySurveyResponseEventDataFragment = { __typename?: 'ehr_event', eventId: any, eventStartTime?: any | null, appointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', ems: Array<{ __typename?: 'ehr_eventmbcstatus', score: Array<{ __typename?: 'ehr_assessmentscore', scoreName: string, isEndorsedSI?: boolean | null, surveyResponse?: { __typename?: 'ehr_generalsurveyresponse', generalSurveyQuestionResponses: Array<{ __typename?: 'ehr_generalsurveyquestionresponse', response: any, generalSurveyQuestion: { __typename?: 'ehr_generalsurveyquestion', slug?: string | null, questionText?: string | null } }> } | null }> }> }> };

export type GroupTherapySurveyResponseDataFragment = { __typename?: 'ehr_generalsurveyresponse', generalSurveyQuestionResponses: Array<{ __typename?: 'ehr_generalsurveyquestionresponse', response: any, generalSurveyQuestion: { __typename?: 'ehr_generalsurveyquestion', slug?: string | null, questionText?: string | null } }> };

export type GroupTherapyClientNotesQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type GroupTherapyClientNotesQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', events: Array<{ __typename?: 'ehr_event', eventStartTime?: any | null, eventAppointmentStatus?: string | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', cgeAppointmentStatus?: string | null, cancellationType?: string | null, cancellationReason?: string | null, client: { __typename?: 'ehr_client', welkin8Id?: string | null, healthieId?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', clientUnenrolledDate?: any | null }> }, meta?: { __typename?: 'ehr_clientgroupeventmeta', attendanceNote?: string | null } | null }> }> }> };

export type GroupTherapyAttendanceEventDataFragment = { __typename?: 'ehr_event', eventStartTime?: any | null, eventAppointmentStatus?: string | null };

export type GroupTherapyAttendanceClientGroupEventDataFragment = { __typename?: 'ehr_clientgroupevent', cgeAppointmentStatus?: string | null, cancellationType?: string | null, cancellationReason?: string | null, client: { __typename?: 'ehr_client', welkin8Id?: string | null, healthieId?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', clientUnenrolledDate?: any | null }> }, meta?: { __typename?: 'ehr_clientgroupeventmeta', attendanceNote?: string | null } | null };

export type GroupTherapyAttendanceClientDataFragment = { __typename?: 'ehr_client', welkin8Id?: string | null, healthieId?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', clientUnenrolledDate?: any | null }> };

export type GroupTherapyAttendanceClientGroupDataFragment = { __typename?: 'ehr_clientgroup', clientUnenrolledDate?: any | null };

export type GroupTherapyClientQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type GroupTherapyClientQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', clientGroups: Array<{ __typename?: 'ehr_clientgroup', client: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }>, emergencyContacts: Array<{ __typename?: 'ehr_clientemergencycontact', id: any, name?: string | null, phone?: string | null, email?: string | null, relationship?: string | null, date: any }>, insurance: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }> } }> }> };

export type GroupTherapyClientGroupDataFragment = { __typename?: 'ehr_clientgroup', client: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }>, emergencyContacts: Array<{ __typename?: 'ehr_clientemergencycontact', id: any, name?: string | null, phone?: string | null, email?: string | null, relationship?: string | null, date: any }>, insurance: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }> } };

export type GroupTherapyClientDataFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, bookingProfileData: Array<{ __typename?: 'ehr_clientgroupbooking', profileData?: any | null }>, emergencyContacts: Array<{ __typename?: 'ehr_clientemergencycontact', id: any, name?: string | null, phone?: string | null, email?: string | null, relationship?: string | null, date: any }>, insurance: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }> };

export type GroupTherapyClientPayerRecordsDataFragment = { __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null };

export type GroupTherapyEmergencyContactFragment = { __typename?: 'ehr_clientemergencycontact', id: any, name?: string | null, phone?: string | null, email?: string | null, relationship?: string | null, date: any };

export type GroupTherapyMbcEventsQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['uuid']>;
}>;


export type GroupTherapyMbcEventsQuery = { __typename?: 'query_root', group: Array<{ __typename?: 'ehr_group', groupId: any, events: Array<{ __typename?: 'ehr_event', eventId: any, appointmentStatus?: string | null, startTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', client: { __typename?: 'ehr_client', clientId: number, isTestClient: boolean, clientFirstName?: string | null, clientLastName?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> }, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, assessments?: string | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> }> }> }> };

export type GroupTherapyMbcGroupEventsDataFragment = { __typename?: 'ehr_group', groupId: any, events: Array<{ __typename?: 'ehr_event', eventId: any, appointmentStatus?: string | null, startTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', client: { __typename?: 'ehr_client', clientId: number, isTestClient: boolean, clientFirstName?: string | null, clientLastName?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> }, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, assessments?: string | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> }> }> };

export type GroupTherapyMbcEventDataFragment = { __typename?: 'ehr_event', eventId: any, appointmentStatus?: string | null, startTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', client: { __typename?: 'ehr_client', clientId: number, isTestClient: boolean, clientFirstName?: string | null, clientLastName?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> }, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, assessments?: string | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> }> };

export type GroupTherapyMbcClientGroupEventDataFragment = { __typename?: 'ehr_clientgroupevent', client: { __typename?: 'ehr_client', clientId: number, isTestClient: boolean, clientFirstName?: string | null, clientLastName?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> }, EMSes: Array<{ __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, assessments?: string | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> }> };

export type GroupTherapyMbcClientDataFragment = { __typename?: 'ehr_client', clientId: number, isTestClient: boolean, clientFirstName?: string | null, clientLastName?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> };

export type GroupTherapyMbcClientGroupDataFragment = { __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null };

export type GroupTherapyMbcEmsDataFragment = { __typename?: 'ehr_eventmbcstatus', emsId: any, emsRespondedAt?: any | null, notificationEmailId?: any | null, assessments?: string | null, scores: Array<{ __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null }> };

export type GroupTherapyMbcScoreDataFragment = { __typename?: 'ehr_assessmentscore', value: any, scoreName: string, endorsedSI?: boolean | null };

export type GroupTherapyNotesEventQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['uuid']>;
}>;


export type GroupTherapyNotesEventQuery = { __typename?: 'query_root', event: Array<{ __typename?: 'ehr_event', eventId: any, groupId?: any | null, eventStartTime?: any | null, eventEndTime?: any | null, clientGroupEvents: Array<{ __typename?: 'ehr_clientgroupevent', clientGroupEventId: any, eventId?: any | null, clientId: number, appointmentStatus?: string | null, cancellationType?: string | null, cancellationReason?: string | null, client: { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, welkin8Id?: string | null, healthieId?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> }, meta?: { __typename?: 'ehr_clientgroupeventmeta', attendanceNote?: string | null } | null }> }> };

export type GroupTherapyNotesEventDataFragment = { __typename?: 'ehr_event', eventId: any, groupId?: any | null, eventStartTime?: any | null, eventEndTime?: any | null };

export type GroupTherapyNotesClientGroupEventDataFragment = { __typename?: 'ehr_clientgroupevent', clientGroupEventId: any, eventId?: any | null, clientId: number, appointmentStatus?: string | null, cancellationType?: string | null, cancellationReason?: string | null };

export type GroupTherapyNotesClientDataFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, isTestClient: boolean, welkin8Id?: string | null, healthieId?: string | null, clientGroup: Array<{ __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null }> };

export type GroupTherapyNotesClientGroupDataFragment = { __typename?: 'ehr_clientgroup', cgGroupId: any, clientUnenrolledDate?: any | null };

export type GetActiveCliniciansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCliniciansQuery = { __typename?: 'query_root', ehr_clinician: Array<{ __typename?: 'ehr_clinician', first_name?: string | null, last_name?: string | null, full_name?: string | null, id: number }> };

export type MatchingInfoByClientIdsQueryVariables = Exact<{
  client_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type MatchingInfoByClientIdsQuery = { __typename?: 'query_root', client: Array<{ __typename?: 'ehr_client', clientId: number, events: Array<{ __typename?: 'ehr_event', id: any, startTime?: any | null, appointmentStatus?: string | null, serviceType?: string | null, clinicianId?: number | null }>, matches: Array<{ __typename?: 'ehr_match', matchMetaData?: { __typename?: 'hasura_cwa__match_with_status', status?: string | null, numAttendedAppointments?: any | null, clientId?: number | null, clientStatus?: string | null, matchedClinicianId?: number | null, firstSessionDatetime?: any | null, matchedAt?: any | null, isMatchToTimeslot?: boolean | null, matchEmailSent?: any | null, firstSessionDate?: any | null, serviceType?: string | null, numScheduledAppointments?: any | null, ehr_match?: { __typename?: 'ehr_match', resolvedModality?: string | null } | null } | null }> }> };

export type MatchesFragment = { __typename?: 'ehr_client', matches: Array<{ __typename?: 'ehr_match', matchMetaData?: { __typename?: 'hasura_cwa__match_with_status', status?: string | null, numAttendedAppointments?: any | null, clientId?: number | null, clientStatus?: string | null, matchedClinicianId?: number | null, firstSessionDatetime?: any | null, matchedAt?: any | null, isMatchToTimeslot?: boolean | null, matchEmailSent?: any | null, firstSessionDate?: any | null, serviceType?: string | null, numScheduledAppointments?: any | null, ehr_match?: { __typename?: 'ehr_match', resolvedModality?: string | null } | null } | null }> };

export type GetClientAssessmentScoresQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetClientAssessmentScoresQuery = { __typename?: 'query_root', mbc_assessment_question_scores: Array<{ __typename?: 'mbc_assessment_question_scores', answer_value?: number | null, client_id?: number | null, question_text?: string | null, slug?: string | null, survey_date_taken?: any | null, survey_name?: string | null, value?: any | null }> };

export type SearchClientsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchClientsQuery = { __typename?: 'query_root', f_search_clients: Array<{ __typename?: 'ehr_client', email?: any | null, clientId: number, firstName?: string | null, lastName?: string | null, matches: Array<{ __typename?: 'ehr_match', matchMetaData?: { __typename?: 'hasura_cwa__match_with_status', matchedClinicianId?: number | null } | null }> }> };

export type ClientOverviewQueryVariables = Exact<{
  client_ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ClientOverviewQuery = { __typename?: 'query_root', clients: Array<{ __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> }> };

export type ClientOverviewFragment = { __typename?: 'ehr_client', clientId: number, firstName?: string | null, lastName?: string | null, email?: any | null, preferredName?: string | null, phoneNumber?: string | null, serviceState?: string | null, careLocation: string, clientOverview?: { __typename?: 'my_clients_overview', clientInitials?: string | null, clinicianEmail?: any | null, clinicianId?: number | null, enrolledInLengthOfCare?: boolean | null, futureEvents?: any | null, mbcEnabled?: boolean | null, mbcTrackStatus?: string | null, mbcTrackStatusBeta?: string | null, primaryAssessment?: string | null, sessionCount?: number | null, severity?: string | null, suggestedRange?: string | null, therapistName?: string | null, welkinLink?: string | null, healthieLink?: string | null, healthieId?: string | null, endorsedSi?: boolean | null } | null, manualSlotReservations: Array<{ __typename?: 'hasura_cwa__manual_slot_reservations', id?: any | null, status?: string | null, active?: boolean | null, slotType?: string | null, slotDayOfWeek?: string | null, slotTimeOfDay?: any | null, startDate?: any | null, validUntilDate?: any | null, evenOrOdd?: string | null, recurrence?: string | null }>, matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }>, diagnosisRecords: Array<{ __typename?: 'ehr_diagnosisrecord', primaryDiagnosisCode?: string | null, diagnosisCode?: any | null }>, clientPayerServiceRecords: Array<{ __typename?: 'ehr_clientpayerservicerecord', id: any, coverageStartDate: any, coverageTerminationDate?: any | null, expectedCoverageTerminationDate?: any | null, payer?: { __typename?: 'ehr_payer', displayName?: string | null } | null }>, events: Array<{ __typename?: 'ehr_event', startTime?: any | null, eventId: any, eventType?: string | null, appointmentStatus?: string | null, clinicianId?: number | null, serviceType?: string | null, deliveryType?: string | null, cancellationReason?: string | null, cancellationType?: string | null, clinician?: { __typename?: 'ehr_clinician', id: number, fullName?: string | null } | null, recurrenceData?: { __typename?: 'hasura_cwa__event_recurrence_data', recurrence?: string | null, isException?: boolean | null, isoDayOfWeek?: any | null, slotId?: any | null } | null, meta?: { __typename?: 'ehr_eventmeta', attendanceNote?: string | null, modifiedAt: any } | null, eventMBCStatus: Array<{ __typename?: 'ehr_eventmbcstatus', id: any, assessmentUrl?: string | null, assessmentType: string, assessmentRespondedAt?: any | null, assessmentResponseId?: any | null }> }> };

export type MatchesWithPriorityFragment = { __typename?: 'ehr_client', matches: Array<{ __typename?: 'ehr_match', id: number, priority?: string | null, created_at: any }> };

export type GetTimeoffQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeoffQuery = { __typename?: 'query_root', ehr_timeoff: Array<{ __typename?: 'ehr_timeoff', id: number, is_paid: boolean, modified_at: any, pto_type: string, start_at: any, end_at: any, deleted_at?: any | null, created_at: any, clinician_id: number, ehr_clinician: { __typename?: 'ehr_clinician', full_name?: string | null, primary_timezone: string } }> };

export const CareClientFragmentDoc = `
    fragment CareClient on ehr_client {
  clientId: id
  firstName: first_name
  lastName: last_name
  email: email
  preferredName: preferred_name
  phoneNumber: phone_number
  serviceState: service_state
  diagnosisRecords: diagnosis_records {
    primaryDiagnosisCode: primary_diagnosis_code
    diagnosisCode: diagnosis_codes
  }
  clientPayerServiceRecords: client_payer_service_records {
    id
    coverageStartDate: coverage_start_date
    coverageTerminationDate: coverage_termination_date
    expectedCoverageTerminationDate: expected_coverage_termination_date
    payer {
      displayName: display_name
    }
  }
  careLocation: hybrid_preference
  events(order_by: {start_time: desc}, limit: 350) {
    startTime: start_time
    eventId: id
    eventType: event_type
    appointmentStatus: appointment_status
    clinicianId: clinician_id
    clinician {
      id
      fullName: full_name
    }
    serviceType: service_type
    deliveryType: delivery
    cancellationReason: cancellation_reason
    cancellationType: cancellation_type
    recurrenceData: recurrence_data {
      isException: is_exception
      isoDayOfWeek: isodow
      recurrence
      slotId: slot_id
    }
    meta {
      attendanceNote: attendance_note
      modifiedAt: modified_at
    }
    eventMBCStatus: ehr_eventmbcstatus {
      id
      assessmentUrl: assessment_url
      assessmentType: assessment_type
      assessmentRespondedAt: assessment_responded_at
      assessmentResponseId: assessment_response_id
    }
  }
}
    `;
export const SortedMatchesFragmentDoc = `
    fragment SortedMatches on ehr_client {
  matches(order_by: {created_at: desc}) {
    id
    priority
    created_at
  }
}
    `;
export const MyClientsOverviewFragmentDoc = `
    fragment MyClientsOverview on my_clients_overview {
  clientInitials: client_initials
  clinicianEmail: clinician_email
  clinicianId: clinician_id
  enrolledInLengthOfCare: enrolled_in_length_of_care
  futureEvents: future_events
  mbcEnabled: mbc_enabled
  mbcTrackStatus: mbc_track_status
  mbcTrackStatusBeta: mbc_track_status_beta
  primaryAssessment: primary_assessment
  sessionCount: session_count
  severity: severity
  suggestedRange: suggested_range
  therapistName: therapist_name
  welkinLink: welkin_link
  healthieLink: healthie_link
  healthieId: healthie_id
  endorsedSi: endorsed_si
}
    `;
export const CareClientInfoFragmentDoc = `
    fragment CareClientInfo on ehr_client {
  ...CareClient
  ...SortedMatches
  clientOverview: my_clients_overview {
    ...MyClientsOverview
  }
}
    ${CareClientFragmentDoc}
${SortedMatchesFragmentDoc}
${MyClientsOverviewFragmentDoc}`;
export const ReservationsFragmentDoc = `
    fragment Reservations on ehr_client {
  manualSlotReservations: manual_slot_reservations {
    id
    slotType: slot_type
    slotDayOfWeek: slot_day_of_week
    slotTimeOfDay: slot_time_of_day
    startDate: start_date
    validUntilDate: valid_until_date
    evenOrOdd: even_or_odd
    status
    active
    recurrence: slot_recurrence
  }
}
    `;
export const ActiveClientFragmentDoc = `
    fragment ActiveClient on cwa_active_clients_by_clinician {
  client {
    ...CareClientInfo
    ...Reservations
  }
}
    ${CareClientInfoFragmentDoc}
${ReservationsFragmentDoc}`;
export const MyClientsOverviewReliableChangeFragmentDoc = `
    fragment MyClientsOverviewReliableChange on my_clients_overview_reliable_change {
  clientInitials: client_initials
  clinicianEmail: clinician_email
  clinicianId: clinician_id
  enrolledInLengthOfCare: enrolled_in_length_of_care
  futureEvents: future_events
  mbcEnabled: mbc_enabled
  mbcTrackStatus: mbc_track_status
  primaryAssessment: primary_assessment
  sessionCount: session_count
  severity: severity
  suggestedRange: suggested_range
  therapistName: therapist_name
  welkinLink: welkin_link
  endorsedSi: endorsed_si
}
    `;
export const CareClientInfoReliableChangeFragmentDoc = `
    fragment CareClientInfoReliableChange on ehr_client {
  ...CareClient
  clientOverview: my_clients_overview_reliable_change {
    ...MyClientsOverviewReliableChange
  }
}
    ${CareClientFragmentDoc}
${MyClientsOverviewReliableChangeFragmentDoc}`;
export const ActiveClientReliableChangeFragmentDoc = `
    fragment ActiveClientReliableChange on cwa_active_clients_by_clinician {
  client {
    ...CareClientInfoReliableChange
    ...Reservations
  }
}
    ${CareClientInfoReliableChangeFragmentDoc}
${ReservationsFragmentDoc}`;
export const DefaultEocDataFragmentDoc = `
    fragment DefaultEOCData on dw_export_episode_of_care {
  alliance
  appointment_status
  cancellation_reason
  cancellation_type
  client_id
  client_first_name
  client_last_name
  client_session_number
  clinician_id
  clinician_session_number
  episode
  event_id
  full_name
  gad
  insert_ts
  is_baseline
  is_latest
  is_latest_clinician_in_episode
  last_name
  payer_acronym
  payer_name
  phq
  reason_for_new_episode
  same_clinician_over_60_days_last_session
  service_type
  start_time
  track_primary_assessment
}
    `;
export const GetAllLiveGroupsAfterDateGroupDataFragmentDoc = `
    fragment GetAllLiveGroupsAfterDateGroupData on ehr_group {
  id
  capacity
  groupStartDate: start_date
  groupStartTime: start_time
  groupType: grouptype {
    title
  }
  clinician: ehr_clinician {
    id
    fullName: full_name
  }
  clientGroups: ehr_clientgroups {
    id
  }
}
    `;
export const ClientGroupsAttendanceDataFragmentDoc = `
    fragment ClientGroupsAttendanceData on ehr_group {
  id
  groupStartDate: start_date
  groupType: grouptype {
    title
  }
  clinician: ehr_clinician {
    id
    fullName: full_name
  }
}
    `;
export const ClientGroupDataFragmentDoc = `
    fragment ClientGroupData on ehr_clientgroup {
  clientId: client_id
  clientUnenrolledDate: unenrolled_date
  client: ehr_client {
    is_test_client
  }
}
    `;
export const EventDataFragmentDoc = `
    fragment EventData on ehr_event {
  eventId: id
  eventStartTime: start_time
  eventEndTime: end_time
  appointmentStatus: appointment_status
  clientGroupEvents: ehr_clientgroupevents {
    clientId: client_id
    client: ehr_client {
      isTestClient: is_test_client
    }
    ems: ehr_eventmbcstatuses {
      respondedAt: assessment_responded_at
    }
  }
}
    `;
export const GroupDataFragmentDoc = `
    fragment GroupData on ehr_group {
  groupId: id
  clinicianId: clinician_id
  groupStartTime: start_time
  groupEndTime: end_time
  canceledAt: canceled_at
  groupType: grouptype {
    groupName: title
    groupSessions: number_of_sessions
  }
  clientGroups: ehr_clientgroups(
    distinct_on: client_id
    where: {_deleted: {_eq: false}}
  ) {
    ...ClientGroupData
  }
  events: ehr_events(order_by: {start_time: asc}) {
    ...EventData
  }
}
    ${ClientGroupDataFragmentDoc}
${EventDataFragmentDoc}`;
export const GroupTherapyClientNavClientAddressDataFragmentDoc = `
    fragment GroupTherapyClientNavClientAddressData on ehr_clientaddress {
  address: input_address_line_1
  city: input_city
  state: input_state
  zipcode: input_zipcode
  dateCreated: _date_start
}
    `;
export const GroupTherapyClientNavClientPayerRecordsDataFragmentDoc = `
    fragment GroupTherapyClientNavClientPayerRecordsData on ehr_clientpayerservicerecord {
  id
  coverageStartDate: coverage_start_date
  coverageTerminationDate: coverage_termination_date
  expectedCoverageTerminationDate: expected_coverage_termination_date
  payer {
    displayName: display_name
  }
}
    `;
export const GroupTherapyClientNavScoreDataFragmentDoc = `
    fragment GroupTherapyClientNavScoreData on ehr_assessmentscore {
  scoreName: score_name
  value
  endorsedSI: endorsed_si
}
    `;
export const GroupTherapyClientNavEmsDataFragmentDoc = `
    fragment GroupTherapyClientNavEmsData on ehr_eventmbcstatus {
  emsId: id
  emsRespondedAt: assessment_responded_at
  notificationEmailId: notification_assessment_email_id
  scores: ehr_assessmentscores {
    ...GroupTherapyClientNavScoreData
  }
}
    ${GroupTherapyClientNavScoreDataFragmentDoc}`;
export const GroupTherapyClientNavEventDataFragmentDoc = `
    fragment GroupTherapyClientNavEventData on ehr_event {
  eventId: id
  appointmentStatus: appointment_status
  startTime: start_time
  clientGroupEvents: ehr_clientgroupevents(where: {client_id: {_eq: $clientId}}) {
    id
    EMSes: ehr_eventmbcstatuses {
      ...GroupTherapyClientNavEmsData
    }
  }
}
    ${GroupTherapyClientNavEmsDataFragmentDoc}`;
export const GroupTherapyNavInfoEventFragmentDoc = `
    fragment GroupTherapyNavInfoEvent on ehr_event {
  id
  startTime: start_time
  appointmentStatus: appointment_status
  clientGroupEvents: ehr_clientgroupevents {
    clientId: client_id
    appointmentStatus: appointment_status
  }
}
    `;
export const GroupTherapyNavInfoClientGroupFragmentDoc = `
    fragment GroupTherapyNavInfoClientGroup on ehr_clientgroup {
  clientId: client_id
  unenrolledDate: unenrolled_date
}
    `;
export const GroupTherapyClientsDataFragmentDoc = `
    fragment GroupTherapyClientsData on ehr_client {
  clientId: id
  firstName: first_name
  lastName: last_name
  isTestClient: is_test_client
  bookingProfileData: ehr_clientgroupbookings {
    profileData: metadata
  }
}
    `;
export const GroupTherapyClientGroupsDataFragmentDoc = `
    fragment GroupTherapyClientGroupsData on ehr_clientgroup {
  client: ehr_client {
    ...GroupTherapyClientsData
  }
}
    ${GroupTherapyClientsDataFragmentDoc}`;
export const GroupTherapySurveyResponseDataFragmentDoc = `
    fragment GroupTherapySurveyResponseData on ehr_generalsurveyresponse {
  generalSurveyQuestionResponses: ehr_generalsurveyquestionresponses {
    response: value
    generalSurveyQuestion: ehr_generalsurveyquestion {
      questionText: question_text
      slug
    }
  }
}
    `;
export const GroupTherapySurveyResponseEventDataFragmentDoc = `
    fragment GroupTherapySurveyResponseEventData on ehr_event {
  eventId: id
  eventStartTime: start_time
  appointmentStatus: appointment_status
  clientGroupEvents: ehr_clientgroupevents(where: {client_id: {_eq: $clientId}}) {
    ems: ehr_eventmbcstatuses {
      score: ehr_assessmentscores {
        scoreName: score_name
        isEndorsedSI: endorsed_si
        surveyResponse: ehr_generalsurveyresponse {
          ...GroupTherapySurveyResponseData
        }
      }
    }
  }
}
    ${GroupTherapySurveyResponseDataFragmentDoc}`;
export const GroupTherapyAttendanceEventDataFragmentDoc = `
    fragment GroupTherapyAttendanceEventData on ehr_event {
  eventStartTime: start_time
  eventAppointmentStatus: appointment_status
}
    `;
export const GroupTherapyAttendanceClientGroupDataFragmentDoc = `
    fragment GroupTherapyAttendanceClientGroupData on ehr_clientgroup {
  clientUnenrolledDate: unenrolled_date
}
    `;
export const GroupTherapyAttendanceClientDataFragmentDoc = `
    fragment GroupTherapyAttendanceClientData on ehr_client {
  welkin8Id: welkin8_id
  healthieId: healthie_id
  clientGroup: ehr_clientgroups {
    ...GroupTherapyAttendanceClientGroupData
  }
}
    ${GroupTherapyAttendanceClientGroupDataFragmentDoc}`;
export const GroupTherapyAttendanceClientGroupEventDataFragmentDoc = `
    fragment GroupTherapyAttendanceClientGroupEventData on ehr_clientgroupevent {
  cgeAppointmentStatus: appointment_status
  cancellationType: cancellation_type
  cancellationReason: cancellation_reason
  client: ehr_client {
    ...GroupTherapyAttendanceClientData
  }
  meta: ehr_clientgroupeventmeta {
    attendanceNote: attendance_note
  }
}
    ${GroupTherapyAttendanceClientDataFragmentDoc}`;
export const GroupTherapyEmergencyContactFragmentDoc = `
    fragment GroupTherapyEmergencyContact on ehr_clientemergencycontact {
  id
  name
  phone
  email
  relationship
  date: _date_start
}
    `;
export const GroupTherapyClientPayerRecordsDataFragmentDoc = `
    fragment GroupTherapyClientPayerRecordsData on ehr_clientpayerservicerecord {
  id
  coverageStartDate: coverage_start_date
  coverageTerminationDate: coverage_termination_date
  expectedCoverageTerminationDate: expected_coverage_termination_date
  payer {
    displayName: display_name
  }
}
    `;
export const GroupTherapyClientDataFragmentDoc = `
    fragment GroupTherapyClientData on ehr_client {
  clientId: id
  firstName: first_name
  lastName: last_name
  isTestClient: is_test_client
  bookingProfileData: ehr_clientgroupbookings {
    profileData: metadata
  }
  emergencyContacts: ehr_clientemergencycontacts {
    ...GroupTherapyEmergencyContact
  }
  insurance: client_payer_service_records {
    ...GroupTherapyClientPayerRecordsData
  }
}
    ${GroupTherapyEmergencyContactFragmentDoc}
${GroupTherapyClientPayerRecordsDataFragmentDoc}`;
export const GroupTherapyClientGroupDataFragmentDoc = `
    fragment GroupTherapyClientGroupData on ehr_clientgroup {
  client: ehr_client {
    ...GroupTherapyClientData
  }
}
    ${GroupTherapyClientDataFragmentDoc}`;
export const GroupTherapyMbcClientGroupDataFragmentDoc = `
    fragment GroupTherapyMbcClientGroupData on ehr_clientgroup {
  cgGroupId: group_id
  clientUnenrolledDate: unenrolled_date
}
    `;
export const GroupTherapyMbcClientDataFragmentDoc = `
    fragment GroupTherapyMbcClientData on ehr_client {
  clientId: id
  isTestClient: is_test_client
  clientFirstName: first_name
  clientLastName: last_name
  clientGroup: ehr_clientgroups(where: {group_id: {_eq: $groupId}}) {
    ...GroupTherapyMbcClientGroupData
  }
}
    ${GroupTherapyMbcClientGroupDataFragmentDoc}`;
export const GroupTherapyMbcScoreDataFragmentDoc = `
    fragment GroupTherapyMbcScoreData on ehr_assessmentscore {
  scoreName: score_name
  value
  endorsedSI: endorsed_si
}
    `;
export const GroupTherapyMbcEmsDataFragmentDoc = `
    fragment GroupTherapyMbcEmsData on ehr_eventmbcstatus {
  emsId: id
  emsRespondedAt: assessment_responded_at
  notificationEmailId: notification_assessment_email_id
  assessments: assessment_slug
  scores: ehr_assessmentscores {
    ...GroupTherapyMbcScoreData
  }
}
    ${GroupTherapyMbcScoreDataFragmentDoc}`;
export const GroupTherapyMbcClientGroupEventDataFragmentDoc = `
    fragment GroupTherapyMbcClientGroupEventData on ehr_clientgroupevent {
  client: ehr_client {
    ...GroupTherapyMbcClientData
  }
  EMSes: ehr_eventmbcstatuses {
    ...GroupTherapyMbcEmsData
  }
}
    ${GroupTherapyMbcClientDataFragmentDoc}
${GroupTherapyMbcEmsDataFragmentDoc}`;
export const GroupTherapyMbcEventDataFragmentDoc = `
    fragment GroupTherapyMbcEventData on ehr_event {
  eventId: id
  appointmentStatus: appointment_status
  startTime: start_time
  clientGroupEvents: ehr_clientgroupevents(order_by: {client_id: desc}) {
    ...GroupTherapyMbcClientGroupEventData
  }
}
    ${GroupTherapyMbcClientGroupEventDataFragmentDoc}`;
export const GroupTherapyMbcGroupEventsDataFragmentDoc = `
    fragment GroupTherapyMbcGroupEventsData on ehr_group {
  groupId: id
  events: ehr_events(order_by: {start_time: asc}) {
    ...GroupTherapyMbcEventData
  }
}
    ${GroupTherapyMbcEventDataFragmentDoc}`;
export const GroupTherapyNotesEventDataFragmentDoc = `
    fragment GroupTherapyNotesEventData on ehr_event {
  eventId: id
  groupId: group_id
  eventStartTime: start_time
  eventEndTime: end_time
}
    `;
export const GroupTherapyNotesClientGroupEventDataFragmentDoc = `
    fragment GroupTherapyNotesClientGroupEventData on ehr_clientgroupevent {
  clientGroupEventId: id
  eventId: event_id
  clientId: client_id
  appointmentStatus: appointment_status
  cancellationType: cancellation_type
  cancellationReason: cancellation_reason
}
    `;
export const GroupTherapyNotesClientGroupDataFragmentDoc = `
    fragment GroupTherapyNotesClientGroupData on ehr_clientgroup {
  cgGroupId: group_id
  clientUnenrolledDate: unenrolled_date
}
    `;
export const GroupTherapyNotesClientDataFragmentDoc = `
    fragment GroupTherapyNotesClientData on ehr_client {
  clientId: id
  firstName: first_name
  lastName: last_name
  isTestClient: is_test_client
  welkin8Id: welkin8_id
  healthieId: healthie_id
  clientGroup: ehr_clientgroups {
    ...GroupTherapyNotesClientGroupData
  }
}
    ${GroupTherapyNotesClientGroupDataFragmentDoc}`;
export const MatchesFragmentDoc = `
    fragment Matches on ehr_client {
  matches {
    matchMetaData: match_metadata {
      numAttendedAppointments: attended_appointments
      clientId: client_id
      clientStatus: client_status
      matchedClinicianId: matched_clinician_id
      firstSessionDatetime: first_session_datetime
      matchedAt: matched_at
      isMatchToTimeslot: is_match_to_timeslot
      matchEmailSent: match_email_sent
      firstSessionDate: first_session_date
      status
      serviceType: service_type
      numScheduledAppointments: scheduled_appointments
      ehr_match {
        resolvedModality: resolved_modality
      }
    }
  }
}
    `;
export const MatchesWithPriorityFragmentDoc = `
    fragment MatchesWithPriority on ehr_client {
  matches(order_by: {created_at: desc}) {
    id
    priority
    created_at
  }
}
    `;
export const ClientOverviewFragmentDoc = `
    fragment ClientOverview on ehr_client {
  ...CareClientInfo
  ...Reservations
  ...MatchesWithPriority
}
    ${CareClientInfoFragmentDoc}
${ReservationsFragmentDoc}
${MatchesWithPriorityFragmentDoc}`;
export const GetClinicianAuthGroupsDocument = `
    query getClinicianAuthGroups($clinician_id: Int) {
  ehr_clinician(where: {id: {_eq: $clinician_id}}) {
    auth_user {
      auth_user_groups {
        auth_group {
          id
          name
        }
      }
    }
  }
}
    `;
export const useGetClinicianAuthGroupsQuery = <
      TData = GetClinicianAuthGroupsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClinicianAuthGroupsQueryVariables,
      options?: UseQueryOptions<GetClinicianAuthGroupsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicianAuthGroupsQuery, TError, TData>(
      variables === undefined ? ['getClinicianAuthGroups'] : ['getClinicianAuthGroups', variables],
      fetcher<GetClinicianAuthGroupsQuery, GetClinicianAuthGroupsQueryVariables>(client, GetClinicianAuthGroupsDocument, variables, headers),
      options
    );
export const GetClinicianTagsDocument = `
    query GetClinicianTags($clinician_ids: [Int!]) {
  ehr_cliniciantag(
    where: {clinician_id: {_in: $clinician_ids}, deleted_at: {_is_null: true}, _deleted: {_eq: false}}
  ) {
    id
    weight
    version
    tag_id
    ehr_cliniciantag_ehr_tag {
      bucket
      category
      name
      shown_in_matchtool
      version
    }
    clinician_id
  }
}
    `;
export const useGetClinicianTagsQuery = <
      TData = GetClinicianTagsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClinicianTagsQueryVariables,
      options?: UseQueryOptions<GetClinicianTagsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicianTagsQuery, TError, TData>(
      variables === undefined ? ['GetClinicianTags'] : ['GetClinicianTags', variables],
      fetcher<GetClinicianTagsQuery, GetClinicianTagsQueryVariables>(client, GetClinicianTagsDocument, variables, headers),
      options
    );
export const GetCliniciansByAuthGroupDocument = `
    query getCliniciansByAuthGroup($group_name: String!) {
  ehr_clinician(
    where: {auth_user: {auth_user_groups: {auth_group: {name: {_eq: $group_name}}}}}
  ) {
    id
  }
}
    `;
export const useGetCliniciansByAuthGroupQuery = <
      TData = GetCliniciansByAuthGroupQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCliniciansByAuthGroupQueryVariables,
      options?: UseQueryOptions<GetCliniciansByAuthGroupQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCliniciansByAuthGroupQuery, TError, TData>(
      ['getCliniciansByAuthGroup', variables],
      fetcher<GetCliniciansByAuthGroupQuery, GetCliniciansByAuthGroupQueryVariables>(client, GetCliniciansByAuthGroupDocument, variables, headers),
      options
    );
export const GetClinicianDocument = `
    query getClinician {
  ehr_clinician {
    id
    primary_timezone
    email
    first_name
    last_name
    full_name
    degree
    dob
    director_of_id
    is_remote
    is_wheel
    people_manager_id
  }
}
    `;
export const useGetClinicianQuery = <
      TData = GetClinicianQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClinicianQueryVariables,
      options?: UseQueryOptions<GetClinicianQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicianQuery, TError, TData>(
      variables === undefined ? ['getClinician'] : ['getClinician', variables],
      fetcher<GetClinicianQuery, GetClinicianQueryVariables>(client, GetClinicianDocument, variables, headers),
      options
    );
export const GetConfigDocument = `
    query getConfig {
  ehr_configuration(limit: 1) {
    healthie_care_team_sync
    healthie_client_address_broadcast
    healthie_clinician_incremental_sync_enabled
    healthie_emergency_contact_broadcast
    healthie_patient_broadcast_enabled
    healthie_patient_incremental_sync_enabled
    healthie_ui_enabled
    healthie_disable_client_field_editing
    healthie_send_clinician_tasks
    roofdog_enabled
    mhqol_enabled
    cfa_feature_flag
  }
}
    `;
export const useGetConfigQuery = <
      TData = GetConfigQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetConfigQueryVariables,
      options?: UseQueryOptions<GetConfigQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConfigQuery, TError, TData>(
      variables === undefined ? ['getConfig'] : ['getConfig', variables],
      fetcher<GetConfigQuery, GetConfigQueryVariables>(client, GetConfigDocument, variables, headers),
      options
    );
export const GetTagsDocument = `
    query getTags {
  ehr_tag(where: {deleted_at: {_is_null: true}, shown_in_matchtool: {_eq: true}}) {
    bucket
    id
    category
    name
    shown_in_matchtool
    used_for_couples
    used_for_individual
    status
    version
  }
}
    `;
export const useGetTagsQuery = <
      TData = GetTagsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTagsQueryVariables,
      options?: UseQueryOptions<GetTagsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTagsQuery, TError, TData>(
      variables === undefined ? ['getTags'] : ['getTags', variables],
      fetcher<GetTagsQuery, GetTagsQueryVariables>(client, GetTagsDocument, variables, headers),
      options
    );
export const MyClientsOverviewDocument = `
    query MyClientsOverview($clinician_id: Int) {
  cwaActiveClientsByClinician: cwa_active_clients_by_clinician(
    where: {clinician_id: {_eq: $clinician_id}}
  ) {
    sources
    clinicianId: clinician_id
    ...ActiveClient
  }
}
    ${ActiveClientFragmentDoc}`;
export const useMyClientsOverviewQuery = <
      TData = MyClientsOverviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MyClientsOverviewQueryVariables,
      options?: UseQueryOptions<MyClientsOverviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MyClientsOverviewQuery, TError, TData>(
      variables === undefined ? ['MyClientsOverview'] : ['MyClientsOverview', variables],
      fetcher<MyClientsOverviewQuery, MyClientsOverviewQueryVariables>(client, MyClientsOverviewDocument, variables, headers),
      options
    );
export const MyClientsOverviewReliableChangeDocument = `
    query MyClientsOverviewReliableChange($clinician_id: Int) {
  cwaActiveClientsByClinician: cwa_active_clients_by_clinician(
    where: {clinician_id: {_eq: $clinician_id}}
  ) {
    sources
    clinicianId: clinician_id
    ...ActiveClientReliableChange
  }
}
    ${ActiveClientReliableChangeFragmentDoc}`;
export const useMyClientsOverviewReliableChangeQuery = <
      TData = MyClientsOverviewReliableChangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MyClientsOverviewReliableChangeQueryVariables,
      options?: UseQueryOptions<MyClientsOverviewReliableChangeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MyClientsOverviewReliableChangeQuery, TError, TData>(
      variables === undefined ? ['MyClientsOverviewReliableChange'] : ['MyClientsOverviewReliableChange', variables],
      fetcher<MyClientsOverviewReliableChangeQuery, MyClientsOverviewReliableChangeQueryVariables>(client, MyClientsOverviewReliableChangeDocument, variables, headers),
      options
    );
export const GetEpisodesOfCareDocument = `
    query GetEpisodesOfCare($client_ids: [Int!] = [], $clinician_id: Int = 0, $start_time: Timestamp) {
  dw_export_episode_of_care(
    where: {_or: [{client_id: {_in: $client_ids}}, {clinician_id: {_eq: $clinician_id}}], _and: {start_time: {_lt: $start_time}}}
  ) {
    ...DefaultEOCData
  }
}
    ${DefaultEocDataFragmentDoc}`;
export const useGetEpisodesOfCareQuery = <
      TData = GetEpisodesOfCareQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetEpisodesOfCareQueryVariables,
      options?: UseQueryOptions<GetEpisodesOfCareQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEpisodesOfCareQuery, TError, TData>(
      variables === undefined ? ['GetEpisodesOfCare'] : ['GetEpisodesOfCare', variables],
      fetcher<GetEpisodesOfCareQuery, GetEpisodesOfCareQueryVariables>(client, GetEpisodesOfCareDocument, variables, headers),
      options
    );
export const GetLatestClinicianEpisodeOfCareDocument = `
    query GetLatestClinicianEpisodeOfCare($client_ids: [Int!] = [], $clinician_id: Int = 0) {
  dw_export_episode_of_care(
    where: {_and: {is_latest: {_eq: 1}, is_latest_clinician_in_episode: {_eq: 1}, _or: {clinician_id: {_eq: $clinician_id}, client_id: {_in: $client_ids}}}}
  ) {
    ...DefaultEOCData
  }
}
    ${DefaultEocDataFragmentDoc}`;
export const useGetLatestClinicianEpisodeOfCareQuery = <
      TData = GetLatestClinicianEpisodeOfCareQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetLatestClinicianEpisodeOfCareQueryVariables,
      options?: UseQueryOptions<GetLatestClinicianEpisodeOfCareQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetLatestClinicianEpisodeOfCareQuery, TError, TData>(
      variables === undefined ? ['GetLatestClinicianEpisodeOfCare'] : ['GetLatestClinicianEpisodeOfCare', variables],
      fetcher<GetLatestClinicianEpisodeOfCareQuery, GetLatestClinicianEpisodeOfCareQueryVariables>(client, GetLatestClinicianEpisodeOfCareDocument, variables, headers),
      options
    );
export const GetMatchRequeueLogDocument = `
    query GetMatchRequeueLog($matchIds: [Int!]) {
  ehr_match_requeue_log(where: {match_id: {_in: $matchIds}}) {
    match_id
    requeue_reason
    requeue_timestamp
    match_email_sent_before_requeue
    match_resolved_at_before_requeue
  }
}
    `;
export const useGetMatchRequeueLogQuery = <
      TData = GetMatchRequeueLogQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMatchRequeueLogQueryVariables,
      options?: UseQueryOptions<GetMatchRequeueLogQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMatchRequeueLogQuery, TError, TData>(
      variables === undefined ? ['GetMatchRequeueLog'] : ['GetMatchRequeueLog', variables],
      fetcher<GetMatchRequeueLogQuery, GetMatchRequeueLogQueryVariables>(client, GetMatchRequeueLogDocument, variables, headers),
      options
    );
export const MatchesByClientIdDocument = `
    query matchesByClientId($clientId: Int!) {
  matches: hasura_cwa__match_with_status(
    where: {client_id: {_eq: $clientId}}
    order_by: {consult_event: {start_time: desc_nulls_last}}
  ) {
    id
    consult_id
    ehr_client {
      id
      first_name
      last_name
      email
      phone_number
      primary_timezone
      healthie_id
      ehr_referrals {
        needs_interpreter_services
      }
      ehr_insurancerecords {
        is_medical
        is_medicare
        effective_start_date
        effective_termination_date
      }
      client_payer_service_records {
        payer_id
        payer {
          acronym
          display_name
        }
      }
      ehr_booking(
        where: {appointment_type: {_eq: "consult"}}
        order_by: {created_at: desc}
        limit: 1
      ) {
        has_accepted_informed_consent
        has_accepted_practice_policy
        has_accepted_privacy_policy
        id
        created_at
      }
      events(
        where: {event_type: {_eq: "procedure"}, service_type: {_in: ["consult", "psychiatry_assessment", "therapy_assessment"]}}
        order_by: {start_time: desc}
        limit: 30
      ) {
        id
        start_time
        healthie_note_id
        service_type
        clinician {
          id
        }
        ehr_consulttools(order_by: {created_at: desc}, limit: 5) {
          id
          event_id
          created_at
        }
      }
    }
    consult_event {
      start_time
      healthie_note_id
      clinician {
        id
      }
      service_type
    }
    client_status
    former_client
    high_priority
    is_rematch
    queue_note
    created_at
    match_after
    conflict_of_interest
    delivery_preference
    returning_to_same_clinician
    clinician_approves_ot
    service_type
    max_score
    methodology_version
    priority
    match_note
    assignee_id
    cadence_pref_strength
    match_email_sent
    is_biweekly_fit
    created_at
    _date_start
  }
}
    `;
export const useMatchesByClientIdQuery = <
      TData = MatchesByClientIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: MatchesByClientIdQueryVariables,
      options?: UseQueryOptions<MatchesByClientIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MatchesByClientIdQuery, TError, TData>(
      ['matchesByClientId', variables],
      fetcher<MatchesByClientIdQuery, MatchesByClientIdQueryVariables>(client, MatchesByClientIdDocument, variables, headers),
      options
    );
export const MyConsultsPageDocument = `
    query myConsultsPage($clinician_ids: [Int!], $lowerDate: timestamptz!, $upperDate: timestamptz!, $pastLowerDate: timestamptz!, $pastUpperDate: timestamptz!, $appointmentType: [String!]) {
  my_matches: hasura_cwa__match_with_status(
    where: {assignee_auth_user: {ehr_clinician: {id: {_in: $clinician_ids}}}}
    order_by: [{consult_event: {start_time: desc_nulls_last}}, {created_at: desc_nulls_last}]
  ) {
    id
    consult_id
    ehr_client {
      id
      first_name
      last_name
      email
      phone_number
      primary_timezone
      healthie_id
      ehr_referrals {
        needs_interpreter_services
      }
      ehr_insurancerecords {
        is_medical
        is_medicare
        effective_start_date
        effective_termination_date
      }
      client_payer_service_records {
        payer_id
        payer {
          acronym
          display_name
        }
      }
      ehr_booking(
        where: {appointment_type: {_in: $appointmentType}}
        order_by: {created_at: desc}
        limit: 1
      ) {
        has_accepted_informed_consent
        has_accepted_practice_policy
        has_accepted_privacy_policy
        id
        created_at
      }
      events(
        where: {event_type: {_eq: "procedure"}, service_type: {_in: $appointmentType}}
        order_by: {start_time: desc}
        limit: 30
      ) {
        id
        start_time
        healthie_note_id
        service_type
        clinician {
          id
        }
        ehr_consulttools(order_by: {created_at: desc}, limit: 5) {
          id
          event_id
          created_at
        }
      }
    }
    consult_event {
      start_time
      healthie_note_id
      clinician {
        id
      }
      service_type
    }
    client_status
    former_client
    high_priority
    is_rematch
    queue_note
    created_at
    match_after
    conflict_of_interest
    delivery_preference
    returning_to_same_clinician
    clinician_approves_ot
    service_type
    max_score
    methodology_version
    priority
    match_note
    assignee_id
    cadence_pref_strength
    match_email_sent
    is_biweekly_fit
    created_at
    _date_start
  }
  past_consults: ehr_event(
    order_by: {start_time: desc_nulls_last}
    limit: 100
    where: {clinician_id: {_in: $clinician_ids}, event_type: {_eq: "procedure"}, service_type: {_in: $appointmentType}, start_time: {_gt: $pastLowerDate, _lt: $pastUpperDate}, ehr_consulttools: {completed_at: {_is_null: false}}, _or: [{appointment_status: {_nin: ["canceled", "noshow"]}}, {appointment_status: {_is_null: true}}]}
  ) {
    id
    start_time
    time_scheduled
    healthie_note_id
    service_type
    clinician_id
    ehr_matches {
      id
    }
    client {
      id
      first_name
      last_name
      email
      phone_number
      primary_timezone
      healthie_id
      ehr_referrals {
        needs_interpreter_services
      }
      client_payer_service_records {
        payer_id
        payer {
          acronym
          display_name
        }
      }
      ehr_booking(
        where: {appointment_type: {_in: $appointmentType}}
        order_by: {created_at: desc}
        limit: 1
      ) {
        has_accepted_informed_consent
        has_accepted_practice_policy
        has_accepted_privacy_policy
        id
        created_at
        appointment_type
      }
    }
  }
  recent_consults: ehr_event(
    order_by: {start_time: asc_nulls_last}
    where: {clinician_id: {_in: $clinician_ids}, _or: [{_and: [{appointment_status: {_nin: ["canceled", "noshow"]}}, {event_type: {_eq: "procedure"}}, {service_type: {_in: $appointmentType}}, {start_time: {_gt: $lowerDate, _lt: $upperDate}}, {_or: [{healthie_note_id: {_is_null: true}}, {_not: {ehr_consulttools: {completed_at: {_is_null: false}}}}]}]}, {_and: [{appointment_status: {_is_null: true}}, {event_type: {_eq: "procedure"}}, {service_type: {_in: $appointmentType}}, {start_time: {_gt: $lowerDate, _lt: $upperDate}}, {_or: [{healthie_note_id: {_is_null: true}}, {_not: {ehr_consulttools: {completed_at: {_is_null: false}}}}]}]}]}
  ) {
    id
    start_time
    time_scheduled
    healthie_note_id
    service_type
    client {
      id
      last_name
      first_name
      email
      healthie_id
      client_payer_service_records {
        payer_id
        payer {
          acronym
          display_name
        }
      }
      ehr_referrals {
        needs_interpreter_services
      }
      ehr_booking(
        where: {appointment_type: {_in: $appointmentType}}
        order_by: {created_at: desc}
        limit: 1
      ) {
        has_accepted_informed_consent
        has_accepted_practice_policy
        has_accepted_privacy_policy
        id
        created_at
        appointment_type
      }
    }
    clinician_id
    ehr_matches {
      id
    }
  }
}
    `;
export const useMyConsultsPageQuery = <
      TData = MyConsultsPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: MyConsultsPageQueryVariables,
      options?: UseQueryOptions<MyConsultsPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MyConsultsPageQuery, TError, TData>(
      ['myConsultsPage', variables],
      fetcher<MyConsultsPageQuery, MyConsultsPageQueryVariables>(client, MyConsultsPageDocument, variables, headers),
      options
    );
export const MyPastConsultsSearchResultsDocument = `
    query myPastConsultsSearchResults($client_id: Int!) {
  my_matches: hasura_cwa__match_with_status(
    where: {ehr_client: {id: {_eq: $client_id}}}
    order_by: {consult_event: {start_time: desc_nulls_last}}
  ) {
    id
    consult_id
    assignee_auth_user {
      ehr_clinician {
        id
      }
    }
    ehr_client {
      id
      first_name
      last_name
      email
      phone_number
      primary_timezone
      healthie_id
      ehr_insurancerecords {
        is_medical
        is_medicare
        effective_start_date
        effective_termination_date
      }
      client_payer_service_records {
        payer_id
        payer {
          acronym
          display_name
        }
      }
      events(
        where: {event_type: {_eq: "procedure"}, service_type: {_in: ["consult", "psychiatry_assessment", "therapy_assessment"]}}
        order_by: {start_time: desc}
        limit: 30
      ) {
        id
        start_time
        healthie_note_id
        service_type
        clinician {
          id
        }
        ehr_consulttools(order_by: {created_at: desc}, limit: 5) {
          id
          event_id
          created_at
        }
      }
    }
    consult_event {
      start_time
      healthie_note_id
      clinician {
        id
      }
      service_type
    }
    client_status
    former_client
    high_priority
    is_rematch
    queue_note
    created_at
    match_after
    conflict_of_interest
    delivery_preference
    returning_to_same_clinician
    clinician_approves_ot
    service_type
    max_score
    methodology_version
    priority
    match_note
    assignee_id
    cadence_pref_strength
    match_email_sent
    is_biweekly_fit
    created_at
    _date_start
  }
}
    `;
export const useMyPastConsultsSearchResultsQuery = <
      TData = MyPastConsultsSearchResultsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: MyPastConsultsSearchResultsQueryVariables,
      options?: UseQueryOptions<MyPastConsultsSearchResultsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MyPastConsultsSearchResultsQuery, TError, TData>(
      ['myPastConsultsSearchResults', variables],
      fetcher<MyPastConsultsSearchResultsQuery, MyPastConsultsSearchResultsQueryVariables>(client, MyPastConsultsSearchResultsDocument, variables, headers),
      options
    );
export const GetAllLiveGroupsAfterDateDocument = `
    query GetAllLiveGroupsAfterDate($date: date) {
  groups: ehr_group(
    where: {_and: [{enrollment_close_date: {_gte: $date}}, {is_ready_to_schedule: {_eq: true}}, {is_test_data: {_eq: false}}]}
    order_by: {start_time: asc}
  ) {
    ...GetAllLiveGroupsAfterDateGroupData
  }
}
    ${GetAllLiveGroupsAfterDateGroupDataFragmentDoc}`;
export const useGetAllLiveGroupsAfterDateQuery = <
      TData = GetAllLiveGroupsAfterDateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllLiveGroupsAfterDateQueryVariables,
      options?: UseQueryOptions<GetAllLiveGroupsAfterDateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllLiveGroupsAfterDateQuery, TError, TData>(
      variables === undefined ? ['GetAllLiveGroupsAfterDate'] : ['GetAllLiveGroupsAfterDate', variables],
      fetcher<GetAllLiveGroupsAfterDateQuery, GetAllLiveGroupsAfterDateQueryVariables>(client, GetAllLiveGroupsAfterDateDocument, variables, headers),
      options
    );
export const GetClientGroupsAttendanceDocument = `
    query GetClientGroupsAttendance($client_id: Int) {
  client: ehr_client(where: {id: {_eq: $client_id}}) {
    id
    clientGroups: ehr_clientgroups {
      group: ehr_group {
        ...ClientGroupsAttendanceData
      }
    }
  }
}
    ${ClientGroupsAttendanceDataFragmentDoc}`;
export const useGetClientGroupsAttendanceQuery = <
      TData = GetClientGroupsAttendanceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClientGroupsAttendanceQueryVariables,
      options?: UseQueryOptions<GetClientGroupsAttendanceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClientGroupsAttendanceQuery, TError, TData>(
      variables === undefined ? ['GetClientGroupsAttendance'] : ['GetClientGroupsAttendance', variables],
      fetcher<GetClientGroupsAttendanceQuery, GetClientGroupsAttendanceQueryVariables>(client, GetClientGroupsAttendanceDocument, variables, headers),
      options
    );
export const GetIncompleteNotesDocument = `
    query getIncompleteNotes($clinician_id: Int!, $pastEndTime: timestamptz!) {
  ehr_event(
    where: {clinician_id: {_eq: $clinician_id}, _and: [{_or: [{appointment_status: {_eq: "attended"}}, {appointment_status: {_is_null: true}}]}, {_or: [{ehr_clientgroupevents: {healthie_note_id: {_is_null: true}}}, {healthie_note_id: {_is_null: true}}]}], event_type: {_eq: "procedure"}, end_time: {_lt: "now()", _gte: $pastEndTime}}
    order_by: {end_time: asc}
  ) {
    healthie_note_id
    end_time
    client {
      healthie_id
      id
      first_name
      last_name
    }
    ehr_clientgroupevents(
      where: {healthie_note_id: {_is_null: true}, _or: [{appointment_status: {_eq: "attended"}}, {appointment_status: {_is_null: true}}]}
    ) {
      id
      healthie_note_id
      ehr_client {
        healthie_id
        id
        first_name
        last_name
      }
    }
  }
}
    `;
export const useGetIncompleteNotesQuery = <
      TData = GetIncompleteNotesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetIncompleteNotesQueryVariables,
      options?: UseQueryOptions<GetIncompleteNotesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetIncompleteNotesQuery, TError, TData>(
      ['getIncompleteNotes', variables],
      fetcher<GetIncompleteNotesQuery, GetIncompleteNotesQueryVariables>(client, GetIncompleteNotesDocument, variables, headers),
      options
    );
export const GetClinicalUtilizationDocument = `
    query getClinicalUtilization($clinician_id: Int, $start: timestamptz, $end: timestamptz) {
  mv_clinical_utilization(
    where: {_and: [{clinician_id: {_eq: $clinician_id}}, {week: {_gte: $start}}, {week: {_lte: $end}}]}
  ) {
    consult_noshows
    consults_attended
    consults_scheduled
    couples_attended
    couples_noshow
    couples_scheduled
    therapy_attended
    therapy_noshows
    therapy_scheduled
    adjusted_timeoff_credit
    allocated_consult_billable_time
    attended_consult_billable_time
    attended_couples_billable_time
    attended_therapy_billable_time
    billable_time_utilization
    consult_allocation_score
    consult_billable_time
    couples_billable_time
    discrete_hours_utilization
    group_billable_time
    hours_utilization
    hours_without_pto
    no_show_consult_billable_time
    no_show_couples_billable_time
    no_show_therapy_billable_time
    pto_hours
    scheduled_consult_billable_time
    scheduled_couples_billable_time
    scheduled_therapy_billable_time
    target_client_hours
    therapy_billable_time
    therapy_hours
    workweek_hours
    clinician_id
    consult_allocation
    full_name
    isoweek
    isoyear
    version
    week
  }
}
    `;
export const useGetClinicalUtilizationQuery = <
      TData = GetClinicalUtilizationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClinicalUtilizationQueryVariables,
      options?: UseQueryOptions<GetClinicalUtilizationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClinicalUtilizationQuery, TError, TData>(
      variables === undefined ? ['getClinicalUtilization'] : ['getClinicalUtilization', variables],
      fetcher<GetClinicalUtilizationQuery, GetClinicalUtilizationQueryVariables>(client, GetClinicalUtilizationDocument, variables, headers),
      options
    );
export const GetScoresByClientSessionWithStatusDocument = `
    query GetScoresByClientSessionWithStatus($clinician_id: Int, $client_ids: [Int!]) {
  mv_alliance_scores_by_clinician_and_client_ids(
    where: {clinician_id: {_eq: $clinician_id}, client_id: {_in: $client_ids}, service_type: {_eq: "individual"}}
  ) {
    alliance_id
    alliance_value
    client_id
    clinician_id
    event_id
    service_type
    start_time
    first_name
    last_name
    preferred_name
    pr_client_id
    acronyms
    display_names
  }
}
    `;
export const useGetScoresByClientSessionWithStatusQuery = <
      TData = GetScoresByClientSessionWithStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetScoresByClientSessionWithStatusQueryVariables,
      options?: UseQueryOptions<GetScoresByClientSessionWithStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetScoresByClientSessionWithStatusQuery, TError, TData>(
      variables === undefined ? ['GetScoresByClientSessionWithStatus'] : ['GetScoresByClientSessionWithStatus', variables],
      fetcher<GetScoresByClientSessionWithStatusQuery, GetScoresByClientSessionWithStatusQueryVariables>(client, GetScoresByClientSessionWithStatusDocument, variables, headers),
      options
    );
export const GetMbcAdherenceDataByClinicianDocument = `
    query GetMbcAdherenceDataByClinician($clinician_id: Int, $start: timestamptz, $end: timestamptz) {
  mv_mbc_adherence_data_by_client_and_clinician(
    where: {_and: [{clinician_id: {_eq: $clinician_id}}, {event_date: {_gte: $start}}, {event_date: {_lte: $end}}]}
  ) {
    cnt_post_session
    cnt_pre_session
    total_post_session_ems
    total_pre_session_ems
    client_name
    client_id
    event_date
    acronym
    display_name
    event_id
  }
}
    `;
export const useGetMbcAdherenceDataByClinicianQuery = <
      TData = GetMbcAdherenceDataByClinicianQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMbcAdherenceDataByClinicianQueryVariables,
      options?: UseQueryOptions<GetMbcAdherenceDataByClinicianQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetMbcAdherenceDataByClinicianQuery, TError, TData>(
      variables === undefined ? ['GetMbcAdherenceDataByClinician'] : ['GetMbcAdherenceDataByClinician', variables],
      fetcher<GetMbcAdherenceDataByClinicianQuery, GetMbcAdherenceDataByClinicianQueryVariables>(client, GetMbcAdherenceDataByClinicianDocument, variables, headers),
      options
    );
export const MbcAdherenceDataDocument = `
    query MbcAdherenceData($clinician_id: Int, $start: timestamptz, $end: timestamptz) {
  mbc_adherence_data(
    where: {_and: [{clinician_id: {_eq: $clinician_id}}, {appt_week: {_gte: $start}}, {appt_week: {_lte: $end}}]}
  ) {
    cnt_pre_session
    total_pre_session_ems
    pre_session_adherence
    clinician_id
    isoweek
    isoyear
    appt_week
  }
}
    `;
export const useMbcAdherenceDataQuery = <
      TData = MbcAdherenceDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MbcAdherenceDataQueryVariables,
      options?: UseQueryOptions<MbcAdherenceDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MbcAdherenceDataQuery, TError, TData>(
      variables === undefined ? ['MbcAdherenceData'] : ['MbcAdherenceData', variables],
      fetcher<MbcAdherenceDataQuery, MbcAdherenceDataQueryVariables>(client, MbcAdherenceDataDocument, variables, headers),
      options
    );
export const GetNumClientsDocument = `
    query getNumClients($clinician_id: Int, $start: timestamptz, $end: timestamptz) {
  withScores: ehr_event_aggregate(
    distinct_on: client_id
    where: {start_time: {_gt: $start, _lt: $end}, client_id: {_is_null: false}, mbc_score: {value: {_is_null: false}, clinician_id: {_eq: $clinician_id}, start_time: {_gt: $start, _lt: $end}}, clinician_id: {_eq: $clinician_id}}
  ) {
    aggregate {
      count
    }
  }
  totalClients: ehr_event_aggregate(
    distinct_on: client_id
    where: {start_time: {_gt: $start, _lt: $end}, client_id: {_is_null: false}, clinician_id: {_eq: $clinician_id}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const useGetNumClientsQuery = <
      TData = GetNumClientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNumClientsQueryVariables,
      options?: UseQueryOptions<GetNumClientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNumClientsQuery, TError, TData>(
      variables === undefined ? ['getNumClients'] : ['getNumClients', variables],
      fetcher<GetNumClientsQuery, GetNumClientsQueryVariables>(client, GetNumClientsDocument, variables, headers),
      options
    );
export const GetNumPriorWeekConsultsDocument = `
    query getNumPriorWeekConsults($start: timestamptz, $end: timestamptz) {
  ehr_event_aggregate(
    distinct_on: client_id
    where: {_and: [{start_time: {_gte: $start}}, {end_time: {_lte: $end}}, {service_type: {_eq: "consult"}}, {is_test_data: {_eq: false}}, {event_type: {_eq: "procedure"}}, {delivery: {_eq: "teletherapy"}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const useGetNumPriorWeekConsultsQuery = <
      TData = GetNumPriorWeekConsultsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNumPriorWeekConsultsQueryVariables,
      options?: UseQueryOptions<GetNumPriorWeekConsultsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNumPriorWeekConsultsQuery, TError, TData>(
      variables === undefined ? ['getNumPriorWeekConsults'] : ['getNumPriorWeekConsults', variables],
      fetcher<GetNumPriorWeekConsultsQuery, GetNumPriorWeekConsultsQueryVariables>(client, GetNumPriorWeekConsultsDocument, variables, headers),
      options
    );
export const GroupTherapyOverviewDocument = `
    query GroupTherapyOverview($clinician_id: Int) {
  groupsByClinician: ehr_group(
    order_by: {start_time: desc}
    where: {clinician_id: {_eq: $clinician_id}, is_test_data: {_eq: false}}
  ) {
    clinicianId: clinician_id
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;
export const useGroupTherapyOverviewQuery = <
      TData = GroupTherapyOverviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyOverviewQueryVariables,
      options?: UseQueryOptions<GroupTherapyOverviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyOverviewQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyOverview'] : ['GroupTherapyOverview', variables],
      fetcher<GroupTherapyOverviewQuery, GroupTherapyOverviewQueryVariables>(client, GroupTherapyOverviewDocument, variables, headers),
      options
    );
export const GroupTherapyClientNavInfoDocument = `
    query GroupTherapyClientNavInfo($groupId: uuid, $clientId: Int) {
  client: ehr_client(where: {id: {_eq: $clientId}}) {
    firstName: first_name
    lastName: last_name
    email
    phoneNumber: phone_number
    addresses: ehr_clientaddresses {
      ...GroupTherapyClientNavClientAddressData
    }
    payerServiceRecords: client_payer_service_records {
      ...GroupTherapyClientNavClientPayerRecordsData
    }
    clientGroups: ehr_clientgroups(where: {group_id: {_eq: $groupId}}) {
      group: ehr_group {
        groupId: id
        groupType: grouptype {
          curriculum
          affinity
          groupSessions: number_of_sessions
        }
        events: ehr_events {
          ...GroupTherapyClientNavEventData
        }
      }
    }
  }
}
    ${GroupTherapyClientNavClientAddressDataFragmentDoc}
${GroupTherapyClientNavClientPayerRecordsDataFragmentDoc}
${GroupTherapyClientNavEventDataFragmentDoc}`;
export const useGroupTherapyClientNavInfoQuery = <
      TData = GroupTherapyClientNavInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyClientNavInfoQueryVariables,
      options?: UseQueryOptions<GroupTherapyClientNavInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyClientNavInfoQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyClientNavInfo'] : ['GroupTherapyClientNavInfo', variables],
      fetcher<GroupTherapyClientNavInfoQuery, GroupTherapyClientNavInfoQueryVariables>(client, GroupTherapyClientNavInfoDocument, variables, headers),
      options
    );
export const GroupTherapyNavInfoDocument = `
    query GroupTherapyNavInfo($groupId: uuid) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    startTime: start_time
    grouptype {
      affinity
      curriculum
      groupSessions: number_of_sessions
    }
    events: ehr_events(order_by: {start_time: asc}) {
      ...GroupTherapyNavInfoEvent
    }
    clientGroups: ehr_clientgroups {
      ...GroupTherapyNavInfoClientGroup
    }
  }
}
    ${GroupTherapyNavInfoEventFragmentDoc}
${GroupTherapyNavInfoClientGroupFragmentDoc}`;
export const useGroupTherapyNavInfoQuery = <
      TData = GroupTherapyNavInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyNavInfoQueryVariables,
      options?: UseQueryOptions<GroupTherapyNavInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyNavInfoQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyNavInfo'] : ['GroupTherapyNavInfo', variables],
      fetcher<GroupTherapyNavInfoQuery, GroupTherapyNavInfoQueryVariables>(client, GroupTherapyNavInfoDocument, variables, headers),
      options
    );
export const GroupTherapyClientsDocument = `
    query GroupTherapyClients($groupId: uuid) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    clientGroups: ehr_clientgroups {
      ...GroupTherapyClientGroupsData
    }
  }
}
    ${GroupTherapyClientGroupsDataFragmentDoc}`;
export const useGroupTherapyClientsQuery = <
      TData = GroupTherapyClientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyClientsQueryVariables,
      options?: UseQueryOptions<GroupTherapyClientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyClientsQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyClients'] : ['GroupTherapyClients', variables],
      fetcher<GroupTherapyClientsQuery, GroupTherapyClientsQueryVariables>(client, GroupTherapyClientsDocument, variables, headers),
      options
    );
export const GroupTherapyClientMbcSurveyAnswersDocument = `
    query GroupTherapyClientMBCSurveyAnswers($groupId: uuid, $clientId: Int) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    groupId: id
    events: ehr_events {
      ...GroupTherapySurveyResponseEventData
    }
  }
}
    ${GroupTherapySurveyResponseEventDataFragmentDoc}`;
export const useGroupTherapyClientMbcSurveyAnswersQuery = <
      TData = GroupTherapyClientMbcSurveyAnswersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyClientMbcSurveyAnswersQueryVariables,
      options?: UseQueryOptions<GroupTherapyClientMbcSurveyAnswersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyClientMbcSurveyAnswersQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyClientMBCSurveyAnswers'] : ['GroupTherapyClientMBCSurveyAnswers', variables],
      fetcher<GroupTherapyClientMbcSurveyAnswersQuery, GroupTherapyClientMbcSurveyAnswersQueryVariables>(client, GroupTherapyClientMbcSurveyAnswersDocument, variables, headers),
      options
    );
export const GroupTherapyClientNotesDocument = `
    query GroupTherapyClientNotes($groupId: uuid, $clientId: Int) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    events: ehr_events {
      ...GroupTherapyAttendanceEventData
      clientGroupEvents: ehr_clientgroupevents(where: {client_id: {_eq: $clientId}}) {
        ...GroupTherapyAttendanceClientGroupEventData
      }
    }
  }
}
    ${GroupTherapyAttendanceEventDataFragmentDoc}
${GroupTherapyAttendanceClientGroupEventDataFragmentDoc}`;
export const useGroupTherapyClientNotesQuery = <
      TData = GroupTherapyClientNotesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyClientNotesQueryVariables,
      options?: UseQueryOptions<GroupTherapyClientNotesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyClientNotesQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyClientNotes'] : ['GroupTherapyClientNotes', variables],
      fetcher<GroupTherapyClientNotesQuery, GroupTherapyClientNotesQueryVariables>(client, GroupTherapyClientNotesDocument, variables, headers),
      options
    );
export const GroupTherapyClientDocument = `
    query GroupTherapyClient($groupId: uuid, $clientId: Int) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    clientGroups: ehr_clientgroups(where: {client_id: {_eq: $clientId}}) {
      ...GroupTherapyClientGroupData
    }
  }
}
    ${GroupTherapyClientGroupDataFragmentDoc}`;
export const useGroupTherapyClientQuery = <
      TData = GroupTherapyClientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyClientQueryVariables,
      options?: UseQueryOptions<GroupTherapyClientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyClientQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyClient'] : ['GroupTherapyClient', variables],
      fetcher<GroupTherapyClientQuery, GroupTherapyClientQueryVariables>(client, GroupTherapyClientDocument, variables, headers),
      options
    );
export const GroupTherapyMbcEventsDocument = `
    query GroupTherapyMbcEvents($groupId: uuid) {
  group: ehr_group(where: {id: {_eq: $groupId}}) {
    ...GroupTherapyMbcGroupEventsData
  }
}
    ${GroupTherapyMbcGroupEventsDataFragmentDoc}`;
export const useGroupTherapyMbcEventsQuery = <
      TData = GroupTherapyMbcEventsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyMbcEventsQueryVariables,
      options?: UseQueryOptions<GroupTherapyMbcEventsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyMbcEventsQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyMbcEvents'] : ['GroupTherapyMbcEvents', variables],
      fetcher<GroupTherapyMbcEventsQuery, GroupTherapyMbcEventsQueryVariables>(client, GroupTherapyMbcEventsDocument, variables, headers),
      options
    );
export const GroupTherapyNotesEventDocument = `
    query GroupTherapyNotesEvent($eventId: uuid) {
  event: ehr_event(where: {id: {_eq: $eventId}}) {
    ...GroupTherapyNotesEventData
    clientGroupEvents: ehr_clientgroupevents(order_by: {client_id: desc}) {
      ...GroupTherapyNotesClientGroupEventData
      client: ehr_client {
        ...GroupTherapyNotesClientData
      }
      meta: ehr_clientgroupeventmeta {
        attendanceNote: attendance_note
      }
    }
  }
}
    ${GroupTherapyNotesEventDataFragmentDoc}
${GroupTherapyNotesClientGroupEventDataFragmentDoc}
${GroupTherapyNotesClientDataFragmentDoc}`;
export const useGroupTherapyNotesEventQuery = <
      TData = GroupTherapyNotesEventQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GroupTherapyNotesEventQueryVariables,
      options?: UseQueryOptions<GroupTherapyNotesEventQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GroupTherapyNotesEventQuery, TError, TData>(
      variables === undefined ? ['GroupTherapyNotesEvent'] : ['GroupTherapyNotesEvent', variables],
      fetcher<GroupTherapyNotesEventQuery, GroupTherapyNotesEventQueryVariables>(client, GroupTherapyNotesEventDocument, variables, headers),
      options
    );
export const GetActiveCliniciansDocument = `
    query getActiveClinicians {
  ehr_clinician(where: {auth_user: {is_active: {_eq: true}}}) {
    first_name
    last_name
    full_name
    id
  }
}
    `;
export const useGetActiveCliniciansQuery = <
      TData = GetActiveCliniciansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActiveCliniciansQueryVariables,
      options?: UseQueryOptions<GetActiveCliniciansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetActiveCliniciansQuery, TError, TData>(
      variables === undefined ? ['getActiveClinicians'] : ['getActiveClinicians', variables],
      fetcher<GetActiveCliniciansQuery, GetActiveCliniciansQueryVariables>(client, GetActiveCliniciansDocument, variables, headers),
      options
    );
export const MatchingInfoByClientIdsDocument = `
    query MatchingInfoByClientIds($client_ids: [Int!]) {
  client: ehr_client(where: {id: {_in: $client_ids}}) {
    clientId: id
    ...Matches
    events(where: {start_time: {_gte: "now()"}}, order_by: {start_time: asc}) {
      id
      startTime: start_time
      appointmentStatus: appointment_status
      serviceType: service_type
      clinicianId: clinician_id
    }
  }
}
    ${MatchesFragmentDoc}`;
export const useMatchingInfoByClientIdsQuery = <
      TData = MatchingInfoByClientIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MatchingInfoByClientIdsQueryVariables,
      options?: UseQueryOptions<MatchingInfoByClientIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MatchingInfoByClientIdsQuery, TError, TData>(
      variables === undefined ? ['MatchingInfoByClientIds'] : ['MatchingInfoByClientIds', variables],
      fetcher<MatchingInfoByClientIdsQuery, MatchingInfoByClientIdsQueryVariables>(client, MatchingInfoByClientIdsDocument, variables, headers),
      options
    );
export const GetClientAssessmentScoresDocument = `
    query getClientAssessmentScores($client_id: Int) {
  mbc_assessment_question_scores(where: {client_id: {_eq: $client_id}}) {
    answer_value
    client_id
    question_text
    slug
    survey_date_taken
    survey_name
    value
  }
}
    `;
export const useGetClientAssessmentScoresQuery = <
      TData = GetClientAssessmentScoresQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClientAssessmentScoresQueryVariables,
      options?: UseQueryOptions<GetClientAssessmentScoresQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClientAssessmentScoresQuery, TError, TData>(
      variables === undefined ? ['getClientAssessmentScores'] : ['getClientAssessmentScores', variables],
      fetcher<GetClientAssessmentScoresQuery, GetClientAssessmentScoresQueryVariables>(client, GetClientAssessmentScoresDocument, variables, headers),
      options
    );
export const SearchClientsDocument = `
    query SearchClients($search: String) {
  f_search_clients(args: {search: $search}) {
    clientId: id
    firstName: first_name
    lastName: last_name
    email
    matches {
      matchMetaData: match_metadata {
        matchedClinicianId: matched_clinician_id
      }
    }
  }
}
    `;
export const useSearchClientsQuery = <
      TData = SearchClientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SearchClientsQueryVariables,
      options?: UseQueryOptions<SearchClientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchClientsQuery, TError, TData>(
      variables === undefined ? ['SearchClients'] : ['SearchClients', variables],
      fetcher<SearchClientsQuery, SearchClientsQueryVariables>(client, SearchClientsDocument, variables, headers),
      options
    );
export const ClientOverviewDocument = `
    query ClientOverview($client_ids: [Int!]) {
  clients: ehr_client(where: {id: {_in: $client_ids}}) {
    ...ClientOverview
  }
}
    ${ClientOverviewFragmentDoc}`;
export const useClientOverviewQuery = <
      TData = ClientOverviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ClientOverviewQueryVariables,
      options?: UseQueryOptions<ClientOverviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientOverviewQuery, TError, TData>(
      variables === undefined ? ['ClientOverview'] : ['ClientOverview', variables],
      fetcher<ClientOverviewQuery, ClientOverviewQueryVariables>(client, ClientOverviewDocument, variables, headers),
      options
    );
export const GetTimeoffDocument = `
    query getTimeoff {
  ehr_timeoff(order_by: {created_at: desc}, where: {deleted_at: {_is_null: true}}) {
    id
    is_paid
    modified_at
    pto_type
    start_at
    end_at
    deleted_at
    created_at
    clinician_id
    ehr_clinician {
      full_name
      primary_timezone
    }
  }
}
    `;
export const useGetTimeoffQuery = <
      TData = GetTimeoffQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTimeoffQueryVariables,
      options?: UseQueryOptions<GetTimeoffQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTimeoffQuery, TError, TData>(
      variables === undefined ? ['getTimeoff'] : ['getTimeoff', variables],
      fetcher<GetTimeoffQuery, GetTimeoffQueryVariables>(client, GetTimeoffDocument, variables, headers),
      options
    );
